/*
  PDP de UNIT 1 (variante B): toda la logica del customizer, sin Liquid.
  Antes vivia inline en sections/pdp-customizer-b.liquid + snippets u1-pdp-customizer-js-b,
  u1-pdp-bundle-tooltips-b y u1-pdp-family-js-b. Los datos que necesita los arma la seccion
  en <script type="application/json" data-u1-pdp-b-config>; este archivo los lee y arranca la PDP.
*/
(() => {
const u1PdpBoot = (CFG) => {
(() => {
const root = document.getElementById('U1PdpCustomizer-' + CFG.sectionId);
if (!root) return;
/* Variante B, mobile/tablet: la galeria real reemplaza al hero fijo. La columna de galeria
   es display:none <= 1024, asi que movemos el nodo [data-u1-pdp-gallery] al hueco de la
   columna de capitulos (entre el titulo y el primer capitulo) y lo devolvemos en desktop.
   Es el mismo nodo: las referencias del JS (galleryEl, track, slides) siguen valiendo. */
const _u1BGalleryMq = (() => { try { return window.matchMedia('(max-width: 1024px)'); } catch (_e) { return null; } })();
const _u1BPlaceGallery = () => {
const gal = root.querySelector('[data-u1-pdp-gallery]');
const col = root.querySelector('[data-u1-pdp-gallery-col]');
const slot = root.querySelector('[data-u1-pdp-b-gallery-slot]');
if (!gal || !col || !slot) return;
const mobile = !!(_u1BGalleryMq && _u1BGalleryMq.matches);
if (mobile && gal.parentNode !== slot) slot.appendChild(gal);
else if (!mobile && gal.parentNode !== col) col.appendChild(gal);
};
_u1BPlaceGallery();
if (_u1BGalleryMq) { try { _u1BGalleryMq.addEventListener('change', _u1BPlaceGallery); } catch (_e) { try { _u1BGalleryMq.addListener(_u1BPlaceGallery); } catch (_e2) {} } }
const sectionId = CFG.sectionId;
const setStickyTopVar = () => {
const header =
document.querySelector('#shopify-section-header') ||
document.querySelector('header');
if (!header || !header.getBoundingClientRect) return;
const h = Math.round(header.getBoundingClientRect().height || 0);
root.style.setProperty('--u1-pdp-sticky-top', `${h}px`);
};
setStickyTopVar();
window.addEventListener('resize', () => setStickyTopVar(), { passive: true });
const _u1RawChapterOrder = root.getAttribute('data-u1-pdp-chapter-order');
const CHAPTER_ORDER = (_u1RawChapterOrder === null
? 'color,size'
: _u1RawChapterOrder
).split(',').map(s => s.trim().toLowerCase()).filter(Boolean);
const SILICONE_INSERTS_PDP = String(root.dataset.u1PdpSiliconeInserts || '') === '1';
const HAS_CHAPTER_MODEL = CHAPTER_ORDER.includes('model');
const HAS_CHAPTER_COLOR = CHAPTER_ORDER.includes('color');
const HAS_CHAPTER_SIZE = CHAPTER_ORDER.includes('size');
const HAS_HELMET_SIZE_CHAPTER = CHAPTER_ORDER.some((k) => k === 'helmet_size' || k === 'helmet-size');
const U1_BLOCKING_CHAPTER_KEYS = new Set(['model', 'color', 'size']);
const hasBlockingChaptersInOrder = CHAPTER_ORDER.some((k) => U1_BLOCKING_CHAPTER_KEYS.has(k));
const TEMPLATE = (HAS_CHAPTER_MODEL && !HAS_CHAPTER_COLOR && !HAS_CHAPTER_SIZE) ? 'light' : 'helmet';
const TEMPLATE_RAW = String(root.dataset.u1PdpTemplateRaw || TEMPLATE);
const INSERT_TORCH_ASSETS = String(root.dataset.u1PdpInsertTorchAssets || '') === '1';
const variantsEl = root.querySelector('[data-u1-pdp-variants]');
const mediaEl = root.querySelector('[data-u1-pdp-media]');
const defaultGalleryImgEl = root.querySelector('[data-u1-pdp-default-gallery-image]');
const defaultGalleryAltEl = root.querySelector('[data-u1-pdp-default-gallery-alt]');
const defaultGalleryLifeEl = root.querySelector('[data-u1-pdp-default-gallery-lifestyle]');
const defaultGalleryVideoEl = root.querySelector('[data-u1-pdp-default-gallery-video]');
const defaultGalleryVideoPosterEl = root.querySelector('[data-u1-pdp-default-gallery-video-poster]');
const defaultGalleryVideoModeEl = root.querySelector('[data-u1-pdp-default-gallery-video-mode]');
const simpleGalleryEl = root.querySelector('[data-u1-pdp-simple-gallery]');
const accessoriesEl = root.querySelector('[data-u1-pdp-accessories]');
const bundleDiscountRulesEl = root.querySelector('[data-u1-pdp-bundle-discount-rules]');
const colorBadgesEl = root.querySelector('[data-u1-pdp-color-badges]');
const colorGalleryEl = root.querySelector('[data-u1-pdp-color-gallery]');
const variantGalleryEl = root.querySelector('[data-u1-pdp-variant-gallery]');
const insideBoxEl = root.querySelector('[data-u1-pdp-inside-box]');
const insideBoxByVariantEl = root.querySelector('[data-u1-pdp-inside-box-by-variant]');
const restposBottleEl = root.querySelector('[data-u1-pdp-restpos-bottle]');
const restposConfigEl = root.querySelector('[data-u1-pdp-restpos-config]');
const safeJsonParse = (el, fallbackJson) => {
try {
const raw = (el && el.textContent ? el.textContent : '');
const s = (raw || '').toString().trim();
return JSON.parse(s || fallbackJson);
} catch (_e) {
try { return JSON.parse(fallbackJson); } catch (_e2) { return null; }
}
};
let variants = safeJsonParse(variantsEl, '[]') || [];

/* ── Stoq Pre-order: reads directly from _RestockRocketConfig ──
   Primary source: sellingPlans[].variant_ids (authoritative per-plan list).
   Fallback: cachedPreorderVariantIds.preorder_variant_ids (market-cached).
   Market gating: if a plan has markets_enabled + shopify_market_ids, only
   activate preorder when the current market is in that list. */
let _u1StoqPreorderIds = new Set();
let _u1StoqPlanVariantIds = new Set(); // membresia real en planes de preorder (fuente autoritativa, sin gating de mercado)
let _u1StoqPlanId = 0;
let _u1StoqReady = false;
const _u1ReadStoqConfig = () => {
  if (_u1StoqReady) return;
  try {
    const cfg = window._RestockRocketConfig;
    if (!cfg) return;
    const ids = new Set();
    const currentMarket = Number(cfg.marketId || 0);
    // 1. Selling plans — authoritative variant list per plan
    const plans = Array.isArray(cfg.sellingPlans) ? cfg.sellingPlans : [];
    plans.forEach((p) => {
      if (p && Array.isArray(p.variant_ids)) p.variant_ids.forEach((id) => _u1StoqPlanVariantIds.add(Number(id)));
    });
    const activePlan = plans.find(p => p.enabled !== false);
    if (activePlan) {
      // Market gating: skip plan if it's market-restricted and current market isn't in the list
      const mktsEnabled = activePlan.markets_enabled;
      const mkts = Array.isArray(activePlan.shopify_market_ids) ? activePlan.shopify_market_ids : [];
      const planAllowedForMarket = !mktsEnabled || !mkts.length || mkts.includes(currentMarket);
      if (planAllowedForMarket) {
        _u1StoqPlanId = Number(activePlan.shopify_selling_plan_id || 0) || 0;
        if (Array.isArray(activePlan.variant_ids)) {
          activePlan.variant_ids.forEach(id => ids.add(Number(id)));
        }
      }
    }
    // 2. Cached preorder IDs — only if market matches
    const cached = cfg.cachedPreorderVariantIds;
    if (cached && Array.isArray(cached.preorder_variant_ids)) {
      const cacheMarketOk = !cached.market_locations_enabled || Number(cached.market_id || 0) === currentMarket;
      if (cacheMarketOk) {
        cached.preorder_variant_ids.forEach(id => ids.add(Number(id)));
      }
    }
    _u1StoqPreorderIds = ids;
    _u1StoqReady = true;
  } catch (_e) { /* noop */ }
};
_u1ReadStoqConfig();
/* _u1RecalcPreorder kept as no-op stub — called on model switch in
   u1-pdp-customizer-js.liquid. Stoq config is global, doesn't change. */
const _u1RecalcPreorder = () => { _u1ReadStoqConfig(); };
/* Vendidas/límite de preorder por variante — fuente AUTORITATIVA: cachedVariantPreorderLimits
   .variant_preorder_limits[vid] = [unitsSold, limit] (coincide con "Units sold" del admin de Stoq).
   OJO: variantsPreorderCount(ForMarket) NO sirve — arrastra contadores viejos de campañas
   anteriores (visto en vivo: 22 en ese campo vs 0 reales en el admin).
   Devuelve null si no hay límite (>0) o no hay datos (fallo seguro: no bloquear, no mostrar barra). */
/* El cache embebido va con lag (visto: venta reciente ausente). Igual que el widget de Stoq,
   refrescamos contra su endpoint variant_preorder_limits.json (mismo formato [sold, limit],
   ya scoped al mercado) y preferimos esa data cuando llega. */
let _u1StoqLimitsLive = null;
let _u1StoqLimitsFetching = false;
const _u1RefreshStoqLimits = () => {
  if (_u1StoqLimitsLive || _u1StoqLimitsFetching) return;
  try {
    const cfg = window._RestockRocketConfig;
    if (!cfg || !cfg.shop || !cfg.marketId) return;
    _u1StoqLimitsFetching = true;
    fetch('https://app.restockrocket.io/api/v1/embed/variant_preorder_limits.json?shopify_market_id=' + encodeURIComponent(cfg.marketId), { headers: { 'X-Shopify-Shop-Domain': String(cfg.shop) } })
      .then((r) => (r && r.ok ? r.json() : null))
      .then((j) => {
        if (j && typeof j === 'object' && !Array.isArray(j)) {
          _u1StoqLimitsLive = j;
          try { updateVariant(); } catch (_e) { /* re-sync de la barra/CTA con data fresca */ }
        }
      })
      .catch(() => { /* nos quedamos con el cache */ });
  } catch (_e) { /* noop */ }
};
const _u1StoqSoldMax = (v) => {
  try {
    if (!v) return null;
    const cfg = window._RestockRocketConfig;
    if (!cfg) return null;
    _u1RefreshStoqLimits(); // lazy: primer uso dispara el refresh (una sola vez)
    let pairs = _u1StoqLimitsLive;
    if (!pairs) {
      const cl = cfg.cachedVariantPreorderLimits;
      if (!cl || !cl.variant_preorder_limits) return null;
      const mktOk = !cl.market_locations_enabled || Number(cl.shopify_market_id || 0) === Number(cfg.marketId || 0);
      if (!mktOk) return null;
      pairs = cl.variant_preorder_limits;
    }
    const pair = pairs[String(v.id)];
    if (!Array.isArray(pair)) return null;
    const max = pair[1] == null ? NaN : Number(pair[1]);
    if (isNaN(max) || max <= 0) return null; // sin límite de unidades
    const cnt = pair[0] == null ? 0 : Math.max(0, Math.min(Number(pair[0]) || 0, max));
    return { count: cnt, max: max };
  } catch (_e) { return null; }
};
const _forceAvailable = root.getAttribute('data-u1-pdp-force-available') === 'true'
  || /crash-replacement|gift-card/.test(window.location.pathname);
const isVariantPreorder = (v) => {
  if (!v || _forceAvailable) return false;
  _u1ReadStoqConfig(); // lazy retry if Stoq loaded late
  if (!_u1StoqPlanId) return false; // no active selling plan → no preorder possible
  if (!_u1StoqPreorderIds.has(Number(v.id))) return false;
  // Only preorder if actually out of stock — if there's stock, sell normally
  try {
    const cfg = window._RestockRocketConfig;
    if (cfg && cfg.variantsInventoryQuantity) {
      const qty = Number(cfg.variantsInventoryQuantity[String(v.id)]);
      if (!isNaN(qty) && qty > 0) return false;
    }
  } catch (_e) {}
  // Respetar el LÍMITE de unidades de preorder: al alcanzar el máximo, la variante deja
  // de ser preorder → cae a OOS → "Notify me". Fuente autoritativa (_u1StoqSoldMax);
  // FALLO SEGURO: sin datos → no bloquea.
  try {
    const pm = _u1StoqSoldMax(v);
    if (pm && pm.count >= pm.max) return false; // límite alcanzado → ya no es preorder
  } catch (_e) {}
  return true;
};
/* Check if variant is truly out of stock using Stoq's real inventory data.
   Needed because "continue selling when OOS" makes v.available always true.
   Returns true when stock ≤ 0 and the variant is NOT preorder in this market. */
const isVariantOosNonPreorder = (v) => {
  if (!v || _forceAvailable) return false;
  // Products without inventory tracking (gift cards, etc.) are never OOS
  if (!v.inventory_management) return false;
  try {
    const cfg = window._RestockRocketConfig;
    if (!cfg || !cfg.variantsInventoryQuantity) return false;
    const qty = Number(cfg.variantsInventoryQuantity[String(v.id)]);
    if (isNaN(qty) || qty > 0) return false; // in stock
    const policy = cfg.variantsInventoryPolicy ? cfg.variantsInventoryPolicy[String(v.id)] : 'deny';
    if (policy !== 'continue') return false; // deny policy — Shopify handles it
    if (isVariantPreorder(v)) return false; // preorder valido en este mercado → boton Pre-order
    const vid = Number(v.id);
    // Variante de OTRO producto embebida en esta pagina (visor/luz/accesorio en el PDP de un
    // casco): su continue selling es oversell deliberado (ej. visores con stock real en Dimass
    // que no sincroniza) → vender normal, nunca "Out of stock".
    const isPageVariant = (variants || []).some((x) => x && Number(x.id) === vid);
    if (!isPageVariant) return false;
    // Producto SIN programa de preorder (visores, crash replacement, etc.: ninguna de sus
    // variantes pertenece a un plan de Stoq): continue selling = vender normal.
    // OJO: se usa la membresia en PLANES (variant_ids), no _u1StoqPreorderIds — ese set
    // mezcla el cache de Stoq que flaggea variantes ajenas al preorder (ej. visores para
    // su Notify) y en mercados con qty<=0 (Dimass -9) las mandaba a Out of stock.
    const inProgram = (variants || []).some((x) => x && _u1StoqPlanVariantIds.has(Number(x.id)));
    if (!inProgram) return false;
    // Variante que pertenece a un plan pero sin plan valido en ESTE mercado (o limite
    // alcanzado): tratarla como agotada → Notify me. Antes se mostraba Add to cart y Stoq
    // bloqueaba el add con el toast "not available for preorder in your region".
    if (_u1StoqPlanVariantIds.has(vid)) return true;
    // Continue sin relacion con Stoq (oversell deliberado, sin plan) → vender normal
    if (!_u1StoqPlanId) return false;
    return true; // OOS + continue + producto en programa pero variante fuera → agotada
  } catch (_e) { return false; }
};
const getPreorderSellingPlanId = (v) => {
  if (!isVariantPreorder(v)) return 0;
  return _u1StoqPlanId;
};
/* Preorder progress ("X of Y claimed"): misma fuente autoritativa que el chequeo de límite. */
const _getPreorderProgress = (v) => _u1StoqSoldMax(v);
/* Stoq shipping text: per-variant, per-market */
const _getPreorderShippingText = () => {
  try {
    const cfg = window._RestockRocketConfig;
    if (!cfg) return '';
    // Try market-specific text first, fall back to global
    const vid = String(document.querySelector('[data-u1-pdp-variant-id]')?.value || '');
    if (vid && cfg.variantsShippingTextForMarket && cfg.variantsShippingTextForMarket[vid]) {
      const mkt = cfg.variantsShippingTextForMarket[vid];
      const txt = (typeof mkt === 'string' ? mkt : Object.values(mkt)[0] || '').toString().trim();
      if (txt) return txt;
    }
    if (vid && cfg.variantsShippingText && cfg.variantsShippingText[vid]) {
      return cfg.variantsShippingText[vid].toString().trim();
    }
    // Fallback to selling plan level
    const plans = Array.isArray(cfg.sellingPlans) ? cfg.sellingPlans : [];
    const plan = plans.find(p => p.enabled !== false);
    return plan ? (plan.shipping_text || '').toString().trim() : '';
  } catch (_e) { return ''; }
};

const media = safeJsonParse(mediaEl, '[]') || [];
const defaultGallerySrc = safeJsonParse(defaultGalleryImgEl, '""') || '';
const defaultGalleryAlt = safeJsonParse(defaultGalleryAltEl, '""') || '';
const defaultGalleryIsLifestyle = !!safeJsonParse(defaultGalleryLifeEl, 'false');
const defaultGalleryVideoSrc = safeJsonParse(defaultGalleryVideoEl, '""') || '';
const defaultGalleryVideoPoster = safeJsonParse(defaultGalleryVideoPosterEl, '""') || '';
const defaultGalleryVideoMode = (safeJsonParse(defaultGalleryVideoModeEl, '"contain"') || 'contain').toString();
const simpleGallerySlides = (() => {
const raw = safeJsonParse(simpleGalleryEl, '[]');
return Array.isArray(raw) ? raw : [];
})();
const accessoriesCatalog = safeJsonParse(accessoriesEl, '[]') || [];
const bundleDiscountRules = (() => {
const raw = safeJsonParse(bundleDiscountRulesEl, '[]') || [];
if (!Array.isArray(raw) || !raw.length) return [];
const normalizeHandle = (s) => (s || '').toString().trim().toLowerCase().replace(/\s+/g, '-');
const splitCsvHandles = (csv, opts) => {
const o = opts && typeof opts === 'object' ? opts : {};
const s = (csv || '').toString().trim();
if (!s) return [];
let tokens = s.split(',').map(x => normalizeHandle(String(x || '').trim())).filter(Boolean);
tokens = tokens.filter(t => t !== '-' && t !== 'none');
return tokens;
};
const splitCsvVariantIds = (csv) => {
const s = (csv || '').toString().trim();
if (!s) return [];
const outIds = [];
s.split(',').forEach((x) => {
const n = Math.max(0, Math.round(Number(String(x || '').trim()) || 0));
if (n > 0) outIds.push(n);
});
return outIds;
};
const out = [];
raw.forEach((r) => {
if (!r || typeof r !== 'object') return;
const enabled = (typeof r.enabled === 'boolean') ? r.enabled : true;
const code = (r.discountCode || '').toString().trim();
if (!enabled || !code) return;
const appliesToMainProductId = Math.max(0, Math.round(Number(r.appliesToMainProductId || 0) || 0));
const requiredAccessoryHandles = splitCsvHandles(r.requiredAccessoryHandlesCsv || '', { allowAny: false });
if (!requiredAccessoryHandles.length) return;
const allowedMainVariantIds = splitCsvVariantIds(r.allowedMainVariantIdsCsv || '');
out.push({
id: (r.id || '').toString(),
discountCode: code,
discountLabel: (r.discountLabel || '').toString().trim(),
bannerTitle: (r.bannerTitle || '').toString().trim(),
appliesToMainProductId,
requiredAccessoryHandles,
allowedMainVariantIds,
level: Math.max(0, Math.round(Number(r.level || 0) || 0)),
});
});
return out;
})();
const colorBadges = safeJsonParse(colorBadgesEl, '[]') || [];
const colorGalleryItems = safeJsonParse(colorGalleryEl, '[]') || [];
const variantGalleryItems = safeJsonParse(variantGalleryEl, '[]') || [];
const insideBoxItems = safeJsonParse(insideBoxEl, '[]') || [];
const insideBoxVariantItems = safeJsonParse(insideBoxByVariantEl, '[]') || [];
const restposBottle = safeJsonParse(restposBottleEl, 'null');
const restposConfig = safeJsonParse(restposConfigEl, '{}') || {};
let mainProductTitle = CFG.productTitle;
let mainProductHandle = CFG.productHandle;
const U1_BASE_PRODUCT_HANDLE = CFG.productHandle;
let mainProductId = CFG.productId;
/* Foto del producto propio de la pagina, para poder VOLVER a el. La rama que cambia de
   producto (capitulo Model) solo sabia ir HACIA otro producto: cuando en un mismo
   capitulo conviven variantes (Clear/Tinted de Helmet Visor) y un producto aparte
   (Adaptive), al tocar Clear la card se marcaba pero el producto y el precio se
   quedaban en el otro. La descripcion se toma del DOM porque es la que ya esta pintada. */
const U1_HOME_MODEL = {
  title: mainProductTitle,
  handle: mainProductHandle,
  id: mainProductId,
  variants: variants,
  descriptionHtml: (document.querySelector('[data-u1-pdp-desc]') || {}).innerHTML,
  images: CFG.images
};
const HIDDEN_COLOR_HANDLES = (() => {
try {
const raw = String(root.dataset.u1PdpHiddenColors || '').trim();
if (!raw) return new Set();
const tokens = raw.split(',')
  .map(s => optionNameHandle(String(s || '').trim()))
  .filter(Boolean)
  .filter(t => t !== 'none' && t !== '-' && t !== '—');
return new Set(tokens);
} catch (_e) { return new Set(); }
})();
const productModelsEl = root.querySelector('[data-u1-pdp-product-models]');
const productModels = (() => {
const raw = safeJsonParse(productModelsEl, '[]') || [];
const m = new Map();
try {
(Array.isArray(raw) ? raw : []).forEach((it) => {
if (!it || typeof it !== 'object') return;
const h = (it.handle || '').toString();
if (!h) return;
const vs = Array.isArray(it.variants) ? it.variants : [];
m.set(h, {
handle: h,
title: (it.title || '').toString(),
id: Number(it.id || 0) || 0,
descriptionHtml: (it.descriptionHtml || '').toString(),
variants: vs,
/* Las fotos del producto, para que la galeria lo siga al cambiar de modelo. */
images: Array.isArray(it.images) ? it.images : [],
});
});
} catch (_e) { /* noop */ }
return m;
})();
const accessoryVariantMeta = (() => {
const m = new Map();
try {
(Array.isArray(accessoriesCatalog) ? accessoriesCatalog : []).forEach((p) => {
if (!p || !Array.isArray(p.variants)) return;
const productTitle = String(p.title || '');
const handle = String(p.handle || '');
p.variants.forEach((v) => {
if (!v || !v.id) return;
const idNum = Number(v.id);
if (!idNum) return;
const vTitle = (v.title && v.title !== 'Default Title') ? String(v.title) : '';
const label = vTitle ? `${productTitle} — ${vTitle}` : productTitle || handle || String(idNum);
m.set(idNum, {
id: idNum,
handle,
productTitle,
variantTitle: vTitle,
label,
available: (typeof v.available === 'boolean' ? v.available : null),
priceCents: (typeof v.price === 'number' || /^\d+$/.test(String(v.price || ''))) ? Number(v.price) : 0,
});
});
});
} catch (_e) { /* noop */ }
return m;
})();
const crashOptionBtns = Array.from(root.querySelectorAll('[data-u1-pdp-crash-option]'));
const crashGroupEl = crashOptionBtns[0] && crashOptionBtns[0].closest
? crashOptionBtns[0].closest('[data-u1-pdp-crash-group]')
: root.querySelector('[data-u1-pdp-crash-group]');
const crashFootEl = crashGroupEl ? crashGroupEl.querySelector('.u1-pdp-crash__foot') : null;
const crashFreeOption = (crashGroupEl && crashGroupEl.dataset.u1PdpCrashFreeOption || 'none').toString().trim();
const crashFreeDiscountCode = (crashGroupEl && crashGroupEl.dataset.u1PdpCrashFreeDiscountCode || '').toString().trim();
const crashVariantMeta = (() => {
const m = new Map();
try {
crashOptionBtns.forEach((btn) => {
if (!btn || !btn.dataset) return;
const opt = String(btn.dataset.u1PdpCrashOption || '');
const idNum = Number(btn.dataset.u1PdpCrashVariantId || 0);
if (!idNum) return;
const priceCents = Number(btn.dataset.u1PdpCrashPriceCents || 0) || 0;
const availableRaw = btn.dataset.u1PdpCrashAvailable;
const available = (availableRaw === 'true') ? true : (availableRaw === 'false' ? false : null);
const label = opt ? `Crash Replacement — ${opt}` : `Crash Replacement (${idNum})`;
m.set(idNum, { id: idNum, option: opt, priceCents, available, label });
});
} catch (_e) { /* noop */ }
return m;
})();
const galleryEl = root.querySelector('[data-u1-pdp-gallery]');
const galleryTrack = root.querySelector('[data-u1-pdp-gallery-track]');
/* HTML original de la galeria, tal como lo dibuja el servidor. Sus slides traen
   data-media-id, que es lo que usa el theme para moverse a la foto de la variante al
   cambiarla. setGalleryToImages no emite ese atributo, asi que si la reconstruimos se
   pierde el cambio entre variantes (2026-09-30: volviendo de Adaptive, Clear y Tinted
   dejaban de cambiar la foto). Por eso al volver al producto de la pagina se restaura
   este HTML en vez de rearmarlo. */
const U1_HOME_GALLERY_HTML = galleryTrack ? galleryTrack.innerHTML : '';
let slides = Array.from(root.querySelectorAll('[data-u1-pdp-slide]'));
const btnPrev = root.querySelector('[data-u1-pdp-gallery-prev]');
const btnNext = root.querySelector('[data-u1-pdp-gallery-next]');
const mobileGalleries = Array.from(root.querySelectorAll('[data-u1-pdp-mobile-gallery]'));
const galleryC1El = root.querySelector('[data-u1-pdp-gallery-c1]');
const sizeStepEl = root.querySelector('[data-u1-pdp-step="size"]');
const modelStepEl = root.querySelector('[data-u1-pdp-step="model"]');
const accessoriesStepEl = root.querySelector('[data-u1-pdp-step="accessories"]');
const helmetSizeStepEl = root.querySelector('[data-u1-pdp-step="helmet_size"]');
const stickyBottomEl = root.querySelector('[data-u1-pdp-sticky-bottom]');
const stickyAtcNudgePx = (() => {
const raw = root.dataset.u1PdpStickyAtcNudgePx;
const n = Number(raw);
return Number.isFinite(n) ? n : 350;
})();
const showStickyBottom = () => {
if (!stickyBottomEl) return;
if (!stickyBottomEl.hidden) return;
stickyBottomEl.hidden = false;
stickyBottomEl.setAttribute('aria-hidden', 'false');
window.requestAnimationFrame(() => {
stickyBottomEl.classList.add('is-visible');
scheduleStickyCheck();
});
};
const colorStepEl = root.querySelector('[data-u1-pdp-step="color"]');
const getExtraItemsCount = () => {
let extras = 0;
try {
if (state && state.accessories && typeof state.accessories.size === 'number') extras += state.accessories.size;
if (state && Number(state.crashVariantId || 0)) extras += 1;
} catch (_e) { /* noop */ }
return extras;
};
const updateStickyChevron = () => {
if (!stickyBottomEl) return;
const isBundleActive = root.getAttribute('data-u1-pdp-bundle-active') === 'true';
stickyBottomEl.classList.toggle('has-breakdown', isBundleActive || getExtraItemsCount() > 0);
};
const desktopMq = (() => {
try { return window.matchMedia('(min-width: 1025px)'); } catch (_e) { return null; }
})();
let isDesktop = !!(desktopMq && desktopMq.matches);
let lastStepEl = null;
let lastStepInView = false;
let ioLastStep = null;
const getLastStepEl = () => {
try {
const steps = Array.from(root.querySelectorAll('[data-u1-pdp-step]'));
return steps.length ? steps[steps.length - 1] : null;
} catch (_e) { return null; }
};
const computeLastStepInView = () => {
if (!isDesktop) return false;
const el = lastStepEl || (lastStepEl = getLastStepEl());
if (!el || !el.getBoundingClientRect) return false;
const r = el.getBoundingClientRect();
const t = window.innerHeight * 0.15; // similar a threshold 0.15
return (r.top < (window.innerHeight - t)) && (r.bottom > t);
};
const setupLastStepObserver = () => {
lastStepInView = false;
if (ioLastStep) { try { ioLastStep.disconnect(); } catch (_e) {} }
ioLastStep = null;
lastStepEl = getLastStepEl();
if (!isDesktop || !('IntersectionObserver' in window) || !lastStepEl) return;
ioLastStep = new IntersectionObserver((entries) => {
const e = entries && entries[0];
lastStepInView = !!(e && e.isIntersecting);
updateGalleryC1Variant();
}, { threshold: 0.15 });
ioLastStep.observe(lastStepEl);
};
if (desktopMq) {
try {
desktopMq.addEventListener('change', () => {
isDesktop = !!desktopMq.matches;
setupLastStepObserver();
updateGalleryC1Variant();
});
} catch (_e) {
try {
desktopMq.addListener(() => {
isDesktop = !!desktopMq.matches;
setupLastStepObserver();
updateGalleryC1Variant();
});
} catch (_e2) { /* noop */ }
}
}
setupLastStepObserver();
let u1_finalScrollY = window.scrollY || 0;
root._u1FinalLatched = !!root._u1FinalLatched;
const updateStickyBottomVisibility = () => {
if (!stickyBottomEl) return;
showStickyBottom();
};
const updateStickyBottomBorder = () => {
if (!stickyBottomEl || stickyBottomEl.hidden || !stickyBottomEl.getBoundingClientRect) return;
const r = stickyBottomEl.getBoundingClientRect();
const stuck = Math.abs(r.bottom - window.innerHeight) <= 1;
stickyBottomEl.classList.toggle('is-at-end', !stuck);
};
const updateGalleryC1Variant = () => {
if (!galleryC1El) return;
if (!isDesktop) { galleryC1El.classList.remove('is-variant2'); return; }
const el = lastStepEl || (lastStepEl = getLastStepEl());
if (!el) return;
if (!(state && state.color && state.size)) {
root._u1FinalLatched = false;
galleryC1El.classList.remove('is-variant2');
applyFinalGalleryMode(false);
return;
}
const centerRatio = 0.55;
const yLine = window.innerHeight * centerRatio;
const r = el.getBoundingClientRect();
const crossed = (r.top <= yLine) && (r.bottom >= yLine);
const y = window.scrollY || 0;
const dirDown = y > (u1_finalScrollY + 0.5);
const dirUp = y < (u1_finalScrollY - 0.5);
u1_finalScrollY = y;
if (dirDown && crossed) root._u1FinalLatched = true;
if (dirUp && !crossed) root._u1FinalLatched = false;
const isVariant2 = !!(root._u1FinalLatched || crossed);
galleryC1El.classList.toggle('is-variant2', isVariant2);
applyFinalGalleryMode(isVariant2);
};
let stickyRaf = null;
const scheduleStickyCheck = () => {
if (stickyRaf) return;
stickyRaf = window.requestAnimationFrame(() => {
stickyRaf = null;
updateStickyBottomVisibility();
updateStickyBottomBorder();
updateStickyChevron();
updateGalleryC1Variant();
});
};
window.addEventListener('scroll', scheduleStickyCheck, { passive: true });
window.addEventListener('resize', scheduleStickyCheck, { passive: true });
scheduleStickyCheck();
const startScrollY = window.scrollY || 0;
let hasUserScrolled = false;
let didAutoNudge = false;
window.addEventListener('scroll', () => {
if (hasUserScrolled) return;
const dy = Math.abs((window.scrollY || 0) - startScrollY);
if (dy > 6) hasUserScrolled = true;
}, { passive: true });
const colorButtons = Array.from(root.querySelectorAll('[data-u1-pdp-color]'));
const sizeButtons = Array.from(root.querySelectorAll('[data-u1-pdp-size]'));
const modelButtons = Array.from(root.querySelectorAll('[data-u1-pdp-model]'));
/* Show "+ Free {product}" next to the price on a model card whose variant
   includes a variant-gated free product (read from the accessory blocks). Static. */
const applyModelCardFreeLabels = () => {
try {
if (!modelButtons || !modelButtons.length) return;
const freeByVariant = new Map();
root.querySelectorAll('[data-u1-pdp-accessory][data-u1-pdp-free-variant-ids]').forEach((acc) => {
const ids = (acc.dataset.u1PdpFreeVariantIds || '').split(',').map(s => Number(String(s).trim())).filter(n => n > 0);
const title = (acc.dataset.u1PdpInfoTitle || '').toString().trim();
const label = (acc.dataset.u1PdpFreeLabel || U1S.free).toString().trim();
if (!title) return;
ids.forEach((id) => { if (!freeByVariant.has(id)) freeByVariant.set(id, label + ' ' + title); });
});
if (!freeByVariant.size) return;
modelButtons.forEach((card) => {
if (!card) return;
const vid = Number(card.dataset.u1PdpModelVariantId || 0) || 0;
const old = card.querySelector('[data-u1-pdp-model-free-gift]');
if (old) old.remove();
const text = vid ? freeByVariant.get(vid) : null;
if (!text) return;
const priceEl = card.querySelector('[data-u1-pdp-card-price]') || card.querySelector('[data-u1-pdp-card-price-row]');
if (!priceEl) return;
const span = document.createElement('span');
span.className = 'u1-pdp-card__free-gift u1-text-body-xs';
span.setAttribute('data-u1-pdp-model-free-gift', '');
span.textContent = text;
priceEl.insertAdjacentElement('afterend', span);
});
} catch (_e) { /* noop */ }
};
try { applyModelCardFreeLabels(); } catch (_e) { /* noop */ }
const accessoryModelButtons = Array.from(root.querySelectorAll('[data-u1-pdp-accessory-model]'));
const helmetSizeButtons = Array.from(root.querySelectorAll('[data-u1-pdp-helmet-size]'));
const helmetModelButtons = Array.from(root.querySelectorAll('[data-u1-pdp-helmet-model]'));
const HELMET_MODEL_OPTION_RAW = String(root.dataset.u1PdpHelmetModelOption || 'Helmet');
const HELMET_MODEL_OPTION_HANDLE = String(HELMET_MODEL_OPTION_RAW || 'Helmet').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
const IS_VISOR_PDP = String(root.dataset.u1PdpIsVisorPdp || '0') === '1';
const VISOR_BYPASS_OOS = String(root.dataset.u1PdpVisorBypassOos || '0') === '1';
const colorNameEl = root.querySelector('[data-u1-pdp-color-name]');
const colorLabelEl = root.querySelector('[data-u1-pdp-color-label]');
const updateStepMobileTitle = (stepName, selectedValue) => {
const stepEl = root.querySelector(`[data-u1-pdp-step="${stepName}"]`);
if (!stepEl) return;
const els = stepEl.querySelectorAll('[data-u1-pdp-step-mobile-title]');
if (!els.length) return;
els.forEach(function(el) {
  const base = el.dataset.u1PdpMobileBase || '';
  /* Family Pack: el span del prefijo ("AURA ") viene del server y debe sobrevivir
     cada reescritura del titulo — se re-adjunta antes del texto */
  const famPref = el.querySelector('[data-u1-fam-prefix]');
  el.textContent = '';
  if (famPref) el.appendChild(famPref);
  if (selectedValue) {
    el.appendChild(document.createTextNode(base + ' – '));
    var valSpan = document.createElement('span');
    valSpan.className = 'u1-pdp-step__mobile-title-value';
    valSpan.textContent = selectedValue;
    el.appendChild(valSpan);
  } else {
    el.appendChild(document.createTextNode(base));
  }
});
};
const colorBadgeEl = root.querySelector('[data-u1-pdp-color-badge]');
const colorBadgeTextEl = colorBadgeEl ? colorBadgeEl.querySelector('[data-u1-pdp-color-badge-text]') : null;
const atcBtn = root.querySelector('[data-u1-pdp-add-to-cart]');
const summaryEl = root.querySelector('[data-u1-pdp-summary]');
const atcTotalEl = root.querySelector('[data-u1-pdp-atc-total]');
const atcTotalMsrpEl = root.querySelector('[data-u1-pdp-atc-total-msrp]');
const atcTotalWrapEl = root.querySelector('[data-u1-pdp-atc-total-wrap]');
const atcSaveEl = root.querySelector('[data-u1-pdp-atc-save]');
const errorEl = root.querySelector('[data-u1-pdp-error]');
const atcForm = root.querySelector('[data-u1-pdp-atc-form]');
const atcIdInput = root.querySelector('[data-u1-pdp-atc-id]');
const bundleSaveEl = root.querySelector('[data-u1-pdp-bundle-save]');
const bundleSaveSubtitleEl = root.querySelector('[data-u1-pdp-bundle-save-subtitle]');
const moneyLocale = (() => {
try {
const l = CFG.language;
const c = CFG.country;
const raw = `${l}-${c}`;
return raw && raw.includes('-') ? raw : 'en-US';
} catch (_e) { return 'en-US'; }
})();
const moneyCurrency = (() => {
try { return CFG.currency || 'USD'; }
catch (_e) { return 'USD'; }
})();
/* PDP: precios exactos, sin redondear (Fermin 2026-10-08). Simbolo y separadores salen
   del formato de Shopify del mercado, igual que money_without_trailing_zeros: $259.90,
   €259,90, £199.90; los enteros sin decimales ($260). parseMoneyCents lee ese mismo texto. */
const _u1MoneyFmt = (() => {
const m = String(CFG.moneySample).match(/^([^0-9]*)1(\D?)234\D?567(\D)89(.*)$/);
return m ? { pre: m[1], th: m[2], dec: m[3], suf: m[4] } : { pre: '$', th: ',', dec: '.', suf: '' };
})();
const formatMoneyCents = (cents) => {
const c = Math.round(Number(cents || 0)), a = Math.abs(c), fr = a % 100;
return (c < 0 ? '-' : '') + _u1MoneyFmt.pre + String(Math.floor(a / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, _u1MoneyFmt.th) + (fr ? _u1MoneyFmt.dec + String(fr).padStart(2, '0') : '') + _u1MoneyFmt.suf;
};
const parseMoneyCents = (str) => {
const s = String(str || '').replace(/[^0-9.,]/g, ''), i = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
if (i > -1 && s.length - i - 1 === 2) return (parseInt(s.slice(0, i).replace(/[.,]/g, ''), 10) || 0) * 100 + parseInt(s.slice(i + 1), 10);
return (parseInt(s.replace(/[.,]/g, ''), 10) || 0) * 100;
};
/* ── Bundle variant helper ─────────────────────────────────────── */
const _getBundleVariantNow = () => {
try {
const ps = root._packSelector;
if (!ps || typeof ps.findBundleVariant !== 'function') return null;
const bp = ps.getActiveBundlePack ? ps.getActiveBundlePack() : null;
if (!bp) return null;
/* Build visor style from selected visor accessory */
let visorStyle = null;
try {
if (state.accessories && state.accessories.size > 0) {
for (const [, entry] of state.accessories.entries()) {
if (entry && entry.filterOptions && entry.filterOptions.style) {
visorStyle = String(entry.filterOptions.style);
break;
}
}
}
} catch (_e) {}
return ps.findBundleVariant({ color: state.color || null, size: state.size || null, visorStyle: visorStyle });
} catch (_e) { return null; }
};
const _fallbackVariantForModel = () => {
try {
if (!state.variantModel) return null;
const idx = Number(String(root.dataset.u1PdpVariantModelOptionIndex ?? '').trim());
if (!Number.isFinite(idx) || idx < 0 || idx > 2) return null;
const mVal = state.variantModel;
const match = (v) => v && ((idx === 0 ? v.option1 : idx === 1 ? v.option2 : v.option3) === mVal);
return variants.find(v => v && v.available && match(v)) || variants.find(v => match(v)) || null;
} catch (_e) { return null; }
};
const getMainPriceCents = () => {
/* Bundle mode: use the bundle variant price */
const bv = _getBundleVariantNow();
if (bv && typeof bv.price !== 'undefined') return Number(bv.price) || 0;
const id = Number(state.variantId || 0);
const vv = id ? (variants.find(v => v && Number(v.id) === id) || null) : null;
if (vv && typeof vv.price !== 'undefined') return Number(vv.price) || 0;
/* Model fallback: use selected model's variant when no color/size yet */
const modelFb = _fallbackVariantForModel();
if (modelFb && typeof modelFb.price !== 'undefined') return Number(modelFb.price) || 0;
/* Light template, nothing selected yet: preview the FIRST model card's price
   (matches the previewed gallery) instead of the first AVAILABLE variant —
   otherwise an out-of-stock base model makes the placeholder jump to a pricier
   model (e.g. Smart Light → Pro Dual). */
if (TEMPLATE === 'light' && Array.isArray(modelButtons) && modelButtons.length) {
const fid = Number(modelButtons[0].dataset.u1PdpModelVariantId || 0) || 0;
const fv = fid ? (variants.find(v => v && Number(v.id) === fid) || null) : null;
if (fv && typeof fv.price !== 'undefined') return Number(fv.price) || 0;
}
const firstAvail = variants.find(v => v && v.available) || variants[0] || null;
return firstAvail && typeof firstAvail.price !== 'undefined' ? (Number(firstAvail.price) || 0) : 0;
};
const getMainQty = () => {
if (TEMPLATE === 'light') {
const id = Number(state.variantId || 0) || 0;
if (!id) return 1;
let q = 1;
try {
const m = state && state.modelQtyByVariantId ? state.modelQtyByVariantId : null;
if (m && typeof m.get === 'function' && m.has(id)) q = Number(m.get(id) || 1) || 1;
} catch (_e) { /* noop */ }
q = Math.max(1, Math.round(q));
return Math.min(q, Number(root.dataset.u1PdpMainQtyMax || 9) || 9);
}
const q = Number(state.mainQty || 1) || 1;
return Math.max(1, q);
};
const getMainQtyDiscountMeta = () => {
try {
const m = state && state.mainQtyDiscount ? state.mainQtyDiscount : null;
if (!m) return { code: '', percent: 0, minQty: 0 };
return {
code: (m.code || '').toString().trim(),
percent: Number(m.percent || 0) || 0,
minQty: Number(m.minQty || 0) || 0,
};
} catch (_e) {
return { code: '', percent: 0, minQty: 0 };
}
};
const getMainTotalCents = () => {
const unit = Number(getMainPriceCents() || 0) || 0;
const qty = getMainQty();
if (!unit || qty <= 1) return unit * qty;
const meta = getMainQtyDiscountMeta();
const pct = Number(meta.percent || 0) || 0;
const minQty = Number(meta.minQty || 0) || 0;
if (!pct || qty < Math.max(2, minQty)) return unit * qty;
if (TEMPLATE === 'light') {
const modeRaw = (root.dataset.u1PdpLightDiscountMode || '').toString().trim();
const mode = modeRaw || 'second_unit';
if (mode === 'total') {
return Math.round((unit * qty * (100 - pct)) / 100);
}
const discUnit = Math.round((unit * (100 - pct)) / 100);
return (unit * Math.max(0, qty - 1)) + discUnit;
}
const discountedUnits = Math.max(0, qty - 1);
const discUnit = Math.round((unit * (100 - pct)) / 100);
return unit + (discUnit * discountedUnits);
};
const getAccessoriesTotalCents = () => {
let sum = 0;
try {
state.accessories.forEach((entry) => {
if (!entry) return;
const vid = Number(entry.variantId || 0);
if (!vid) return;
const meta = accessoryVariantMeta.get(Number(vid)) || null;
let price = meta ? Number(meta.priceCents || 0) : 0;
const pct = Number(entry.discountPercent || 0) || 0;
if (pct > 0 && price > 0) {
price = Math.round((price * (100 - pct)) / 100);
}
const qty = Number(entry.qty || 1) || 1;
sum += price * qty;
});
} catch (_e) { /* noop */ }
return sum;
};
/* Total price (full, undiscounted) of accessories flagged as free.
   Used to show a crossed-out "with free gift" total + actual price on the CTA. */
const getFreeAccessoriesTotalCents = () => {
let sum = 0;
try {
state.accessories.forEach((entry) => {
if (!entry || !entry.free) return;
const vid = Number(entry.variantId || 0);
if (!vid) return;
const meta = accessoryVariantMeta.get(Number(vid)) || null;
const price = meta ? Number(meta.priceCents || 0) : 0;
const qty = Number(entry.qty || 1) || 1;
sum += price * qty;
});
} catch (_e) { /* noop */ }
return sum;
};
/* Like getAccessoriesTotalCents but skips accessories whose handle
   matches a component product of the active bundle. */
const getNonBundleAccessoriesTotalCents = () => {
let bundleHandles = null;
try {
  const ps = root._packSelector;
  const bp = ps && ps.getActiveBundlePack ? ps.getActiveBundlePack() : null;
  if (bp) {
    bundleHandles = new Set();
    (bp.componentProducts || []).forEach(function(cp) { if (cp && cp.handle) bundleHandles.add(cp.handle); });
  }
} catch (_e) {}
if (!bundleHandles || bundleHandles.size === 0) return getAccessoriesTotalCents();
let sum = 0;
try {
state.accessories.forEach((entry) => {
  if (!entry) return;
  const h = (entry.handle || '').toString();
  if (bundleHandles.has(h)) return; /* skip — already in bundle price */
  const vid = Number(entry.variantId || 0);
  if (!vid) return;
  const meta = accessoryVariantMeta.get(Number(vid)) || null;
  let price = meta ? Number(meta.priceCents || 0) : 0;
  const pct = Number(entry.discountPercent || 0) || 0;
  if (pct > 0 && price > 0) {
    price = Math.round((price * (100 - pct)) / 100);
  }
  const qty = Number(entry.qty || 1) || 1;
  sum += price * qty;
});
} catch (_e) { /* noop */ }
return sum;
};
const getCrashTotalCents = () => {
const id = Number(state.crashVariantId || 0);
if (!id) return 0;
const meta = crashVariantMeta.get(id) || null;
const price = meta ? (Number(meta.priceCents || 0) || 0) : 0;
const plan = (state.crashPlan || 'standard').toString().trim();
const freeOpt = (crashFreeOption || 'none').toString().trim();
if (freeOpt !== 'none' && plan === freeOpt && (plan === 'premium' || plan === 'unlimited')) {
return 0;
}
return price;
};
const ATC_DISCOUNT_ON = root.dataset.u1PdpAtcDiscount === 'true';
const ATC_DISCOUNT_CODE = (root.dataset.u1PdpAtcDiscountCode || '').trim();
const ATC_DISCOUNT_LABEL = (root.dataset.u1PdpAtcDiscountLabel || '').trim();
/* Promo % (e.g. Prime Week): visual-only discount on the sticky CTA price.
   Set per market via the section's "Promo discount %" setting. 0 = off. */
const PROMO_PCT = Math.max(0, Math.min(100, Number(root.dataset.u1PdpPromoPercent || 0) || 0));
const getMainCompareAtPriceCents = () => {
/* Bundle mode */
const bv = _getBundleVariantNow();
if (bv) {
if (bv.compare_at_price && Number(bv.compare_at_price) > Number(bv.price || 0)) return Number(bv.compare_at_price) || 0;
return 0;
}
const id = Number(state.variantId || 0);
let vv = id ? (variants.find(v => v && Number(v.id) === id) || null) : null;
if (!vv) vv = _fallbackVariantForModel() || variants.find(v => v && v.available) || variants[0] || null;
if (vv && vv.compare_at_price && Number(vv.compare_at_price) > Number(vv.price || 0)) {
return Number(vv.compare_at_price) || 0;
}
return 0;
};
const updateAtcTotal = () => {
if (!atcTotalEl) return;
const _activePack = root._packSelector && root._packSelector.getActiveBundlePack
  ? root._packSelector.getActiveBundlePack() : null;
const _bundleAttr = root.getAttribute('data-u1-pdp-bundle-active') === 'true';
const _isBundleMode = !!(_activePack && _bundleAttr && (Number(_activePack.discountPercent || 0) > 0 || (_activePack.componentProducts && _activePack.componentProducts.length > 0)));
/* In custom bundle mode: total = pack MSRP - discount% + non-bundle extras */
let total;
if (_isBundleMode) {
  /* Bundle mode: updateSummary handles CTA pricing — skip here */
  return;
} else {
  total = getMainTotalCents() + getAccessoriesTotalCents() + getCrashTotalCents();
}
try { root._u1AtcTotalCents = total; } catch (_e0) { /* noop */ }
/* Free product: `total` includes the free item at full price (that's the
   crossed-out "with gift" amount). The actual price subtracts the free value. */
const freeCents = getFreeAccessoriesTotalCents();
const finalCents = Math.max(0, total - freeCents);
/* Card solo elegida con % de la app de descuentos (ej. Light Only de Pro Dual, PRODUAL35): el % va solo sobre el
   producto principal (el codigo no toca accesorios), igual que muestra la card */
let _soloPct = 0;
try {
  const _mc = root.querySelector('[data-u1-pdp-model].is-selected[data-u1-model-camp-pct]');
  if (_mc) _soloPct = Number(_mc.getAttribute('data-u1-model-camp-pct') || 0) || 0;
  const _se = root.querySelector('.u1-pdp-bundle-card--solo.is-selected[data-u1-solo-code]');
  if (!_soloPct && _se && _se.offsetParent !== null) {
    const _sm = String(_se.getAttribute('data-pack-model') || '');
    const _sp = (_u1GetBundlePacks() || []).find(p => p && p.isSolo && String(p.model || '') === _sm);
    _soloPct = _sp ? (Number(_sp.discountPercent || 0) || 0) : 0;
  }
} catch (_eSp) { _soloPct = 0; }
if (PROMO_PCT <= 0 && _soloPct > 0) {
/* redondeo como Shopify: medio centavo al par (35% de $199.90 = 69.965 -> 69.96) */
const _sx = getMainTotalCents() * _soloPct;
let _soloDisc = Math.floor(_sx / 100);
const _sr = _sx - _soloDisc * 100;
if (_sr > 50 || (_sr === 50 && _soloDisc % 2 === 1)) _soloDisc += 1;
const _soloFinal = Math.max(0, finalCents - _soloDisc);
atcTotalEl.textContent = formatMoneyCents(_soloFinal);
root._u1AtcMsrpTotalCents = finalCents;
root._u1AtcFixedSavedCents = _soloDisc;
root._u1AtcFixedDiscountLabel = '';
root._u1AtcDisc = { kind: 'camp', pct: _soloPct, amt: _soloDisc };
} else if (PROMO_PCT > 0) {
/* Prime Week-style promo: show the price minus PROMO_PCT, struck original + Save */
const promoFinal = Math.round(finalCents * (100 - PROMO_PCT) / 100);
atcTotalEl.textContent = formatMoneyCents(promoFinal);
root._u1AtcMsrpTotalCents = finalCents;
root._u1AtcFixedSavedCents = Math.max(0, finalCents - promoFinal);
root._u1AtcFixedDiscountLabel = '';
root._u1AtcDisc = { kind: 'pct', pct: PROMO_PCT, amt: Math.max(0, finalCents - promoFinal) };
} else {
atcTotalEl.textContent = formatMoneyCents(finalCents);
root._u1AtcDisc = null;
{
const compareCents = ATC_DISCOUNT_ON ? getMainCompareAtPriceCents() : 0;
if (compareCents > 0) {
const extras = getAccessoriesTotalCents() + getCrashTotalCents();
const msrpTotal = (compareCents * getMainQty()) + extras;
const savedCents = msrpTotal - finalCents;
if (savedCents > 0) {
root._u1AtcMsrpTotalCents = msrpTotal;
root._u1AtcFixedSavedCents = savedCents;
root._u1AtcFixedDiscountLabel = ATC_DISCOUNT_LABEL;
/* el regalo va en su propia fila; aca solo lo del precio tachado */
const _cmpMain = compareCents * getMainQty();
const _cmpAmt = Math.max(0, savedCents - freeCents);
root._u1AtcDisc = { kind: 'compare', pct: _cmpMain > 0 ? Math.round(_cmpAmt * 100 / _cmpMain) : 0, amt: _cmpAmt, compareMain: _cmpMain };
} else {
root._u1AtcMsrpTotalCents = 0;
root._u1AtcFixedSavedCents = 0;
root._u1AtcFixedDiscountLabel = '';
}
} else if (freeCents > 0) {
/* Free gift only: crossed = total (with gift), actual = total - gift value */
root._u1AtcMsrpTotalCents = total;
root._u1AtcFixedSavedCents = freeCents;
root._u1AtcFixedDiscountLabel = '';
} else {
root._u1AtcMsrpTotalCents = 0;
root._u1AtcFixedSavedCents = 0;
root._u1AtcFixedDiscountLabel = '';
}
}
}
const hasPriorDiscount = root._u1AtcMsrpTotalCents > 0;
if (hasPriorDiscount) {
const msrp = root._u1AtcMsrpTotalCents;
const saved = root._u1AtcFixedSavedCents;
if (atcTotalMsrpEl) {
atcTotalMsrpEl.textContent = formatMoneyCents(msrp);
atcTotalMsrpEl.setAttribute('aria-hidden', 'false');
}
if (atcTotalWrapEl) atcTotalWrapEl.classList.add('is-discount-on');
if (atcSaveEl && saved > 0) {
const _discLabel = (root._u1AtcFixedDiscountLabel || ATC_DISCOUNT_LABEL || '').toString().trim();
atcSaveEl.textContent = U1S.save.replace('__A__', formatMoneyCents(saved));
atcSaveEl.hidden = false;
atcSaveEl.setAttribute('aria-hidden', 'false');
}
} else {
if (atcTotalMsrpEl) {
atcTotalMsrpEl.textContent = formatMoneyCents(total);
atcTotalMsrpEl.setAttribute('aria-hidden', 'true');
}
if (atcTotalWrapEl) atcTotalWrapEl.classList.remove('is-discount-on');
if (atcSaveEl) { atcSaveEl.hidden = true; atcSaveEl.setAttribute('aria-hidden', 'true'); atcSaveEl.textContent = ''; }
}
};
const productWrap = root.querySelector('.u1-pdp-product');
const descEl = root.querySelector('[data-u1-pdp-desc]');
const moreBtn = root.querySelector('[data-u1-pdp-more]');
const state = {
model: null, // template accessory: option value seleccionado (MODEL_HANDLE)
variantModel: null, // helmet_variant_model: variant option value seleccionado (ej: "NEON SE")
simpleModelOptionValue: null, // Model (Light) + Size: valor de la opción Model del variant elegido por card
helmetModel: null, // PDP helmet-visor: valor de la opción Helmet seleccionado (ej. "AURA", "NEON")
color: null,
size: null,
helmetSize: null, // template accessory: "fake" helmet size selection
restposBottleVariantId: 0,
restposBottleColor: null,
restposModalShown: false,
restposModalClosed: false,
variantId: 0,
mainQty: 1,
mainQtyDiscount: null, // {code, percent, minQty}
modelQtyByVariantId: new Map(), // variantId -> qty (solo template light)
accessories: new Map(), // handle -> {variantId, qty, syncSize}
crashPlan: 'standard', // standard (incluido), premium, unlimited
crashVariantId: 0, // variantId numérico (solo premium/unlimited)
galleryIndex: 0,
};
// Último color elegido por modelo (variantModel → colorValue); persiste en sesión de página
const colorMemory = new Map();
// Init: variant model mode — read current model from selected variant
// (inline logic: no usa IS_VARIANT_MODEL_MODE ni getVariantOptionByHandle
//  porque esas const se declaran más abajo y causarían TDZ)
if (String(root.dataset.u1PdpVariantModelMode || '') === '1') {
try {
const _vmIdxInit = Number(String(root.dataset.u1PdpVariantModelOptionIndex ?? '').trim());
const _vmIdxOk = (Number.isFinite(_vmIdxInit) && _vmIdxInit >= 0 && _vmIdxInit <= 2) ? _vmIdxInit : -1;
const vmValuesEl = root.querySelector('[data-u1-pdp-variant-model-values]');
const vmValues = (safeJsonParse(vmValuesEl, '[]') || []).filter(v => typeof v === 'string' && v);
const _defaultModelOverride = (root.dataset.u1PdpDefaultModel || '').trim().replace(/\s+/g, ' ');
const _dmoMatch = _defaultModelOverride ? vmValues.find(v => v.trim().replace(/\s+/g, ' ') === _defaultModelOverride) : '';
if (_dmoMatch && _vmIdxOk >= 0) {
state.variantModel = _dmoMatch;
const _dmVariant = variants.find(v => v && v.available !== false &&
((_vmIdxOk === 0 ? v.option1 : _vmIdxOk === 1 ? v.option2 : v.option3) === _dmoMatch));
if (_dmVariant) {
state.variantId = Number(_dmVariant.id);
}
} else {
const currentVId = CFG.initialVariantId;
const currentV = variants.find(v => v && Number(v.id) === Number(currentVId));
if (currentV && _vmIdxOk >= 0) {
const _vmVal = _vmIdxOk === 0 ? (currentV.option1 || null)
: _vmIdxOk === 1 ? (currentV.option2 || null)
: (currentV.option3 || null);
state.variantModel = _vmVal || null;
}
if (!state.variantModel && vmValues.length) {
state.variantModel = vmValues[0];
}
}
if (state.variantModel) {
/* Force Mips manda: aunque la variante de la URL sea SE, el badge/overlay Mips no se apaga */
root.dataset.u1PdpIsMips = (String(root.dataset.u1PdpMipsForce || '') === '1' || /mips/i.test(state.variantModel)) ? '1' : '0';
}
/* Auto-click the default model button after full init */
if (_defaultModelOverride && state.variantModel === _defaultModelOverride) {
requestAnimationFrame(() => { requestAnimationFrame(() => {
try {
const pmStep = root.querySelector('[data-u1-pdp-step="product_model"]');
if (pmStep) {
const btn = pmStep.querySelector('[data-u1-pdp-product-model-handle="' + CSS.escape(_defaultModelOverride) + '"]');
if (btn && !btn.classList.contains('is-selected')) btn.click();
}
} catch (_eDM) { /* noop */ }
}); });
}
} catch (_eVM) { /* noop */ }
}
const PLACEHOLDER_COLOR_TEXT = CFG.pickLabel;
const getRenderScale = () => {
/* Smart Light: foto apaisada, con 0.8 quedaba gigante en modo insert */
if (((root.dataset.u1PdpProductHandle || '').indexOf('smart-light') !== -1)) return 0.62;
if (!HAS_SIZE_OPTION) return 0.8;
const base = 0.69984; // 0.6 * 1.08 * 1.08
if (!state.size) return base;
const h = optionNameHandle(state.size);
if (h === 'small' || h === 's') return 0.676512; // 0.58 * 1.08 * 1.08
if (h === 'medium' || h === 'm') return base;
if (h === 'large' || h === 'l') return 0.723168; // 0.62 * 1.08 * 1.08
return base;
};
const updateRenderScale = () => {
root.style.setProperty('--u1-pdp-render-scale', String(getRenderScale()));
};
const buildColorGalleryMaps = (items) => {
const m = new Map();
const fin = new Map();
if (!Array.isArray(items)) return { gallery: m, final: fin };
items.forEach((it) => {
if (!it || !it.colorHandle || !it.src) return;
const h = String(it.colorHandle);
const isFinal = !!it.final;
if (isFinal) {
fin.set(h, { src: String(it.src), alt: String(it.alt || ''), lifestyle: false });
return;
}
if (!m.has(h)) m.set(h, []);
m.get(h).push({
src: String(it.src),
alt: String(it.alt || ''),
lifestyle: !!it.lifestyle,
});
});
return { gallery: m, final: fin };
};
const { gallery: colorGalleryMap, final: colorFinalMap } = buildColorGalleryMaps(colorGalleryItems);
const buildVariantGalleryMaps = (items) => {
const m = new Map();
const fin = new Map();
if (!Array.isArray(items)) return { gallery: m, final: fin };
const parseVariantIdLoose = (raw) => {
const s = (raw || '').toString().trim();
if (!s) return 0;
if (/^\d+$/.test(s)) return Number(s);
const m1 = s.match(/(\d+)\s*$/);
if (m1) return Number(m1[1]);
const m2 = s.match(/[?&]variant=(\d+)/);
if (m2) return Number(m2[1]);
try {
const decoded = atob(s);
const m3 = decoded.match(/(\d+)\s*$/) || decoded.match(/ProductVariant\/(\d+)/);
if (m3) return Number(m3[1]);
} catch (_e) { /* noop */ }
return 0;
};
items.forEach((it) => {
if (!it || !it.src) return;
const rawKey =
(typeof it.variantIdRaw !== 'undefined' && it.variantIdRaw !== null) ? it.variantIdRaw :
(typeof it.variantId !== 'undefined' && it.variantId !== null) ? it.variantId :
'';
const idNum = parseVariantIdLoose(rawKey) || Number(it.variantId || 0) || 0;
if (!idNum) return;
const isFinal = !!it.final;
if (isFinal) {
fin.set(idNum, { src: String(it.src), alt: String(it.alt || ''), lifestyle: false });
return;
}
if (!m.has(idNum)) m.set(idNum, []);
m.get(idNum).push({
src: String(it.src),
alt: String(it.alt || ''),
lifestyle: !!it.lifestyle,
});
});
return { gallery: m, final: fin };
};
const { gallery: variantGalleryMap, final: variantFinalMap } = buildVariantGalleryMaps(variantGalleryItems);
const hasCustomGallery = !!(
(simpleGallerySlides && simpleGallerySlides.length > 0) ||
defaultGalleryVideoSrc ||
defaultGallerySrc ||
(colorGalleryMap && colorGalleryMap.size > 0) ||
(colorFinalMap && colorFinalMap.size > 0) ||
(variantGalleryMap && variantGalleryMap.size > 0) ||
(variantFinalMap && variantFinalMap.size > 0)
);
const initialMediaColorValue = (() => {
try {
const firstBtn = (Array.isArray(colorButtons) ? colorButtons : []).find((b) => !!(b && b.dataset && b.dataset.u1PdpValue));
const v = firstBtn ? String(firstBtn.dataset.u1PdpValue || '') : '';
if (v) return v;
} catch (_e) { /* noop */ }
try {
const firstItem = (Array.isArray(colorGalleryItems) ? colorGalleryItems : [])[0];
return firstItem && firstItem.color ? String(firstItem.color) : '';
} catch (_e2) { return ''; }
})();
const insideBoxMap = (() => {
const m = new Map();
try {
(Array.isArray(insideBoxItems) ? insideBoxItems : []).forEach((it) => {
if (!it || !it.colorHandle || !it.src) return;
m.set(String(it.colorHandle), { src: String(it.src), alt: String(it.alt || '') });
});
} catch (_e) { /* noop */ }
return m;
})();
const insideBoxVariantMap = (() => {
const m = new Map();
try {
(Array.isArray(insideBoxVariantItems) ? insideBoxVariantItems : []).forEach((it) => {
const vid = Number(it && it.variantId ? it.variantId : 0) || 0;
if (!vid || !it || !it.src) return;
m.set(vid, { src: String(it.src), alt: String(it.alt || '') });
});
} catch (_e2) { /* noop */ }
return m;
})();
const getInsideBoxImageForVariant = (variantId) => {
const idNum = Number(variantId || 0) || 0;
if (!idNum) return null;
if (insideBoxVariantMap && insideBoxVariantMap.has(idNum)) return insideBoxVariantMap.get(idNum);
return null;
};
const getInsideBoxImageForColor = (colorValue) => {
const h = optionNameHandle(colorValue);
if (!h) return { src: '', alt: '' };
if (insideBoxMap && insideBoxMap.has(h)) return insideBoxMap.get(h);
const imgs = (colorGalleryMap && colorGalleryMap.has(h)) ? colorGalleryMap.get(h) : null;
const first = imgs && imgs.length ? imgs[0] : null;
if (first && first.src) return { src: String(first.src), alt: String(first.alt || '') };
return { src: '', alt: '' };
};
/* Bundle cards price sync: en templates con capítulo Model (ej. Smart Light),
   el precio base de las cards del bundle picker (card solo + bundles) se renderiza
   en Liquid con el modelo DEFAULT (ej. Smart Light $90). Cuando el usuario elige
   otro modelo (ej. Pro Dual $175) hay que recalcular el precio en JS: la card solo
   pasa a valer el precio del modelo, y en las cards de bundle el MSRP/final usan
   el precio del modelo + los componentes (delta = msrp - mainProductPriceMin). El
   % de descuento no cambia. Solo aplica cuando hay más de un modelo (varios precios). */
let _u1BundlePacksCache = null;
const _u1GetBundlePacks = () => {
  if (_u1BundlePacksCache) return _u1BundlePacksCache;
  try {
    const el = root.querySelector('[data-u1-pdp-bundle-packs]');
    _u1BundlePacksCache = el ? (JSON.parse(el.textContent || '[]') || []) : [];
  } catch (_e) { _u1BundlePacksCache = []; }
  return _u1BundlePacksCache;
};
const syncBundleCardPricesToModel = () => {
  try {
    const picker = root.querySelector('[data-u1-pdp-bundle-picker]');
    if (!picker) return;
    /* Solo tiene sentido cuando el precio base depende del modelo elegido
       (capítulo Model con varias variantes). Si no hay model buttons, no tocar. */
    if (!Array.isArray(modelButtons) || modelButtons.length < 2) return;
    /* Precio del modelo elegido = precio de la variante de la model card seleccionada
       (estable, no depende de qué bundle esté seleccionado). */
    const _selModel = root.querySelector('[data-u1-pdp-model].is-selected') || root.querySelector('[data-u1-pdp-model][aria-pressed="true"]');
    let modelUnit = 0;
    if (_selModel) {
      const _mvid = Number(_selModel.getAttribute('data-u1-pdp-model-variant-id') || 0) || 0;
      const _mv = _mvid ? variants.find(v => v && Number(v.id) === _mvid) : null;
      if (_mv && typeof _mv.price !== 'undefined') modelUnit = Number(_mv.price) || 0;
    }
    if (modelUnit <= 0) modelUnit = Number(getMainPriceCents() || 0) || 0;
    if (modelUnit <= 0) return;
    const byHandle = {};
    _u1GetBundlePacks().forEach(p => { if (p && p.packHandle) byHandle[p.packHandle] = p; });
    const cards = root.querySelectorAll('[data-u1-pdp-bundle-card]'); /* root: las cards del Flash Deal viven fuera del picker */
    cards.forEach(card => {
      const isSolo = card.classList.contains('u1-pdp-bundle-card--solo');
      if (isSolo) {
        /* La solo puede traer descuento visual (promo_percent, ej. labor day):
           msrp/final/save deben seguir al MODELO elegido, no al precio minimo */
        /* Con un solo por modelo (Smart Light / Pro Dual), el de ESTA card (data-pack-model) */
        const _cm = String(card.getAttribute('data-pack-model') || '');
        const sPk = _u1GetBundlePacks().find(p => p && p.isSolo && String(p.model || '') === _cm) || _u1GetBundlePacks().find(p => p && p.isSolo) || null;
        const sDisc = sPk ? (Number(sPk.discountPercent || 0) || 0) : 0;
        const sFinal = sDisc > 0 ? Math.round(modelUnit * (100 - sDisc) / 100) : modelUnit;
        const sMsrpEl = card.querySelector('.u1-pdp-card__price-msrp');
        if (sMsrpEl) sMsrpEl.textContent = formatMoneyCents(modelUnit);
        const sSaveEl = card.querySelector('.u1-pdp-bundle-card__save');
        if (sSaveEl && sDisc > 0) sSaveEl.textContent = U1S.save.replace('__A__', formatMoneyCents(modelUnit - sFinal));
        const finalEl = card.querySelector('.u1-pdp-card__price-final');
        if (finalEl) { finalEl.textContent = formatMoneyCents(sFinal); return; }
        const pe = card.querySelector('.u1-pdp-card__price');
        if (pe) pe.textContent = formatMoneyCents(sFinal);
        return;
      }
      const bp = byHandle[card.getAttribute('data-pack-handle') || ''];
      if (!bp) return;
      const compDelta = Math.max(0, Number(bp.msrp || 0) - Number(bp.mainProductPriceMin || 0));
      const newMsrp = modelUnit + compDelta;
      const disc = Number(bp.discountPercent || 0) || 0;
      const _gc = _u1PackGiftCents(bp);
      const newFinal = disc > 0 ? ((newMsrp - _gc) * (100 - disc) / 100) : (newMsrp - _gc);
      const msrpEl = card.querySelector('.u1-pdp-card__price-msrp');
      const finalEl = card.querySelector('.u1-pdp-card__price-final');
      if (msrpEl) msrpEl.textContent = formatMoneyCents(newMsrp);
      if (finalEl) finalEl.textContent = formatMoneyCents(newFinal);
      const saveEl2 = card.querySelector('.u1-pdp-bundle-card__save');
      if (saveEl2 && disc > 0) saveEl2.textContent = U1S.save.replace('__A__', formatMoneyCents(Math.max(0, Math.round(newMsrp) - Math.round(newFinal))));
      if (!finalEl && !msrpEl) {
        const pe = card.querySelector('.u1-pdp-card__price');
        if (pe) pe.textContent = formatMoneyCents(newMsrp);
      }
    });
  } catch (_e) { /* noop */ }
};
const emitPdpSelection = () => {
try {
const v = variants.find(v => v && Number(v.id) === Number(state && state.variantId ? state.variantId : 0)) || null;
const vImg = (() => {
try {
if (!v) return { src: '', alt: '' };
const fi = v.featured_image || v.featuredImage || null;
const src =
fi && typeof fi === 'object' && fi.src ? String(fi.src || '') :
fi && typeof fi === 'string' ? String(fi || '') :
'';
const alt =
fi && typeof fi === 'object' && fi.alt ? String(fi.alt || '') :
'';
return { src, alt };
} catch (_e) { return { src: '', alt: '' }; }
})();
const variantTitle = (() => {
try {
if (!v) return '';
const raw = (v.public_title || v.title || '').toString().trim();
const lower = raw.toLowerCase();
if (raw && lower !== 'default title') return raw;
const o1 = (v.option1 || v.option_1 || '').toString().trim();
const o2 = (v.option2 || v.option_2 || '').toString().trim();
const o3 = (v.option3 || v.option_3 || '').toString().trim();
const parts = [o1, o2, o3].filter(Boolean);
return parts.length ? parts.join(' · ') : raw;
} catch (_e2) { return ''; }
})();
const vidItb = Number(state && state.variantId ? state.variantId : 0) || 0;
const itbVar = vidItb ? getInsideBoxImageForVariant(vidItb) : null;
const baseColorForMedia = (state && state.color) ? state.color : (initialMediaColorValue || '');
const itbColor = baseColorForMedia ? getInsideBoxImageForColor(baseColorForMedia) : { src: '', alt: '' };
let box = (itbVar && itbVar.src) ? itbVar : itbColor;
/* helmet_models switch (e.g. FARO normal vs FARO MIPS): the ITB per-variant/color
   image map only covers the base product, so when a different model product is
   active fall back to the selected variant's featured image — otherwise Inside the
   Box keeps showing the base (MIPS) product image. */
if ((!box || !box.src) && String(mainProductHandle || '') !== U1_BASE_PRODUCT_HANDLE && vImg && vImg.src) {
box = vImg;
}
const payload = {
sectionId: String(sectionId || ''),
productHandle: String(mainProductHandle || ''),
productTitle: String(mainProductTitle || ''),
model: state && state.model ? String(state.model) : '',
color: state && state.color ? String(state.color) : '',
size: state && state.size ? String(state.size) : '',
helmetSize: state && state.helmetSize ? String(state.helmetSize) : '',
variantId: Number(state && state.variantId ? state.variantId : 0) || 0,
variantTitle: String(variantTitle || ''),
boxSrc: box && box.src ? String(box.src) : '',
boxAlt: box && box.alt ? String(box.alt) : '',
};
window.__u1PdpSelection = payload;
window.dispatchEvent(new CustomEvent('u1:pdp:selection', { detail: payload }));
/* Bundle variant gate: la chapter de bundle solo se muestra cuando la model card
   seleccionada es una de las variantes permitidas (ej: Pro Dual en Smart Light).
   Vacío = sin restricción (comportamiento normal en las demás PDPs).
   Sin modelo elegido todavía → oculta (primero se elige modelo). */
try {
const _bvRaw = (root.getAttribute('data-u1-pdp-bundle-only-variants') || '').trim();
const _bvStep = root.querySelector('[data-u1-pdp-step="bundle"]');
if (_bvStep) {
if (!_bvRaw) {
/* Sin lista propia manda el gate por modelo (required_model_handle) */
const _gateOff = root.dataset.u1PackGateHidden === '1';
_bvStep.hidden = _gateOff;
_bvStep.setAttribute('aria-hidden', _gateOff ? 'true' : 'false');
} else {
const _bvAllowed = _bvRaw.split(',').map(s => s.trim()).filter(Boolean);
const _bvSel = root.querySelector('[data-u1-pdp-model].is-selected') || root.querySelector('[data-u1-pdp-model][aria-pressed="true"]');
const _bvId = _bvSel ? String(_bvSel.getAttribute('data-u1-pdp-model-variant-id') || '') : '';
const _bvShow = _bvId !== '' && _bvAllowed.indexOf(_bvId) !== -1;
_bvStep.hidden = !_bvShow;
_bvStep.setAttribute('aria-hidden', _bvShow ? 'false' : 'true');
}
}
} catch (_ebv) { /* noop */ }
/* Sincronizar el precio de las cards del bundle picker con el modelo elegido. */
try { syncBundleCardPricesToModel(); } catch (_ebp) { /* noop */ }
} catch (_e) { /* noop */ }
};
const refreshSlides = () => {
slides = Array.from(root.querySelectorAll('[data-u1-pdp-slide]'));
};
const galleryViewport = root.querySelector('.u1-pdp-customizer__gallery-viewport');
const galleryLoaderEl = root.querySelector('[data-u1-pdp-gallery-loader]');
const galleryPagerEl = root.querySelector('[data-u1-pdp-gallery-pager]');
let galleryLoadingCount = 0;
const updateGalleryLoaderUi = () => {
if (!galleryViewport) return;
const on = (Number(galleryLoadingCount || 0) || 0) > 0;
galleryViewport.classList.toggle('is-loading', on);
try { galleryViewport.setAttribute('aria-busy', on ? 'true' : 'false'); } catch (_e) { /* noop */ }
try { if (galleryLoaderEl) galleryLoaderEl.setAttribute('aria-hidden', on ? 'false' : 'true'); } catch (_e2) { /* noop */ }
};
const forceEndGalleryLoadingSoon = (timeoutMs = 2600) => {
if (TEMPLATE !== 'light') return;
const token = String((Number(root._u1ForceLoadToken || '0') || 0) + 1);
root._u1ForceLoadToken = token;
window.setTimeout(() => {
if (String(root._u1ForceLoadToken || '') !== token) return;
galleryLoadingCount = 0;
updateGalleryLoaderUi();
}, Math.max(300, Number(timeoutMs) || 2600));
};
const beginGalleryLoading = () => {
galleryLoadingCount += 1;
updateGalleryLoaderUi();
try { if (TEMPLATE === 'light') forceEndGalleryLoadingSoon(1800); } catch (_e) { /* noop */ }
let done = false;
return () => {
if (done) return;
done = true;
galleryLoadingCount = Math.max(0, (Number(galleryLoadingCount || 0) || 0) - 1);
updateGalleryLoaderUi();
};
};
const watchImgForLoader = (img) => {
if (!img) return;
try {
if (img.dataset && img.dataset.u1LoaderWatch === '1') return;
} catch (_e) { /* noop */ }
if (img.complete && (img.naturalWidth || 0) > 0) return;
try { if (img.dataset) img.dataset.u1LoaderWatch = '1'; } catch (_e2) { /* noop */ }
const end = beginGalleryLoading();
let settled = false;
const finish = () => {
if (settled) return;
settled = true;
end();
};
try { img.addEventListener('load', finish, { once: true }); } catch (_e) { /* noop */ }
try { img.addEventListener('error', finish, { once: true }); } catch (_e2) { /* noop */ }
window.setTimeout(finish, 2500);
};
const galleryBaseLayer = (() => {
if (!galleryViewport) return null;
let el = galleryViewport.querySelector('.u1-pdp-customizer__gallery-base');
if (el && el.tagName && String(el.tagName).toLowerCase() === 'img') {
const next = document.createElement('div');
next.className = 'u1-pdp-customizer__gallery-base';
next.setAttribute('aria-hidden', 'true');
next.style.opacity = '0';
try { el.replaceWith(next); } catch (_e) { galleryViewport.appendChild(next); try { el.remove(); } catch (_e2) {} }
el = next;
}
if (!el) {
el = document.createElement('div');
el.className = 'u1-pdp-customizer__gallery-base';
el.setAttribute('aria-hidden', 'true');
el.style.opacity = '0';
galleryViewport.appendChild(el);
}
const ensureKind = (lifestyle) => {
const wantLife = !!lifestyle;
const prev = String(el.dataset.u1Lifestyle || '');
const prevLife = prev === '1';
if (prev && prevLife === wantLife && el.querySelector('img')) return;
el.dataset.u1Lifestyle = wantLife ? '1' : '0';
el.innerHTML = wantLife
? `
<div class="u1-pdp-customizer__gallery-media u1-pdp-customizer__gallery-media--lifestyle">
<img class="u1-pdp-customizer__gallery-img" alt="" decoding="async" loading="eager" width="2000" height="2000">
</div>
`
: `
<div class="u1-pdp-customizer__gallery-media u1-pdp-customizer__gallery-media--render">
<div class="u1-pdp-customizer__gallery-square">
<img class="u1-pdp-customizer__gallery-img" alt="" decoding="async" loading="eager" width="2000" height="2000">
</div>
</div>
`;
};
ensureKind(false);
const getImg = () => el.querySelector('img');
return { el, ensureKind, getImg };
})();
root._u1GalleryBase = galleryBaseLayer;
const updateDesktopPager = () => {
if (!galleryPagerEl) return;
const uxMode = String(root._u1GalleryUxMode || 'normal');
/* Variante B: los puntitos tambien en mobile/tablet, la galeria vive ahi */
const should = !!(uxMode === 'normal' && slides.length > 1);
if (!should) {
galleryPagerEl.innerHTML = '';
try { delete galleryPagerEl.dataset.u1Count; } catch (_e) { /* noop */ }
galleryPagerEl.classList.remove('is-visible');
galleryPagerEl.setAttribute('aria-hidden', 'true');
return;
}
const count = slides.length;
const active = Math.min(count - 1, Math.max(0, Number(state.galleryIndex || 0) || 0));
const prevCount = Number(galleryPagerEl.dataset.u1Count || 0) || 0;
const existingBtns = Array.from(galleryPagerEl.querySelectorAll('button[data-u1-idx]'));
const needsRebuild = prevCount !== count || existingBtns.length !== count;
if (needsRebuild) {
galleryPagerEl.dataset.u1Count = String(count);
galleryPagerEl.innerHTML = Array.from({ length: count }).map((_, i) => {
const current = i === active ? 'true' : 'false';
return `<button type="button" class="u1-pdp-gallery-dot" data-u1-idx="${i}" aria-current="${current}" aria-label="Slide ${i + 1}"></button>`;
}).join('');
} else {
existingBtns.forEach((b, i) => b.setAttribute('aria-current', (i === active) ? 'true' : 'false'));
}
if (!galleryPagerEl._u1Bound) {
galleryPagerEl._u1Bound = true;
galleryPagerEl.addEventListener('click', (e) => {
const t = e.target;
const btn = t && t.closest ? t.closest('button[data-u1-idx]') : null;
if (!btn) return;
const ux = String(root._u1GalleryUxMode || 'normal');
if (ux !== 'normal') return;
const idx = Number(btn.dataset.u1Idx || 0) || 0;
scrollGalleryToIndex(idx);
});
}
galleryPagerEl.classList.add('is-visible');
galleryPagerEl.setAttribute('aria-hidden', 'false');
};
const U1_ASSET_URL_TEMPLATE = CFG.stylesUrl;
const assetUrlFor = (filename) => {
const f = (filename || '').toString().trim();
if (!f) return '';
const tpl = (U1_ASSET_URL_TEMPLATE || '').toString();
if (!tpl) return '';
return tpl.replace(/\/assets\/[^?]+/, `/assets/${f.replace(/^\//, '')}`);
};
const U1_FILES_URL_BASE = (() => {
try {
const html = document.documentElement ? String(document.documentElement.innerHTML || '') : '';
const m = html.match(/(https?:\/\/[^"'\\s]+\/s\/files\/[^"'\\s]+?)\/files\//i);
if (m && m[1]) return { base: String(m[1]) };
const m2 = html.match(/(https?:\/\/[^"'\\s]+\/cdn\/shop)\/files\//i);
if (m2 && m2[1]) return { base: String(m2[1]) };
} catch (_e) { /* noop */ }
try {
const origin = (window && window.location && window.location.origin) ? String(window.location.origin) : '';
if (origin) return { base: `${origin}/cdn/shop` };
} catch (_e2) { /* noop */ }
return { base: '' };
})();
/* srcset responsivo para imgs de galeria creadas por JS: mismas URLs variando width.
   El navegador elige (mobile retina ~750, desktop retina ~1100) en vez del 1400 fijo. */
const U1_GALLERY_SIZES = '(min-width: 750px) 520px, 100vw';
const u1GallerySrcset = (src) => {
  const s = (src || '').toString();
  if (!/[?&]width=\d+/.test(s)) return '';
  return [480, 750, 1100, 1400].map((w) => s.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w').join(', ');
};
const u1ApplyGallerySrcset = (img, src) => {
  try {
    const ss = u1GallerySrcset(src);
    if (ss) { img.setAttribute('srcset', ss); img.setAttribute('sizes', U1_GALLERY_SIZES); }
    else { img.removeAttribute('srcset'); img.removeAttribute('sizes'); }
  } catch (_e) { /* noop */ }
};
const filesUrlFor = (filename) => {
const f = (filename || '').toString().trim().replace(/^\//, '');
if (!f) return '';
const base = (U1_FILES_URL_BASE && U1_FILES_URL_BASE.base) ? String(U1_FILES_URL_BASE.base) : '';
if (!base) return '';
return `${base}/files/${encodeURIComponent(f)}?width=1600`;
};
const u1ImgPreload = (() => {
const cache = new Map(); // src -> Promise
const preload = (src) => {
const s = (src || '').toString();
if (!s) return Promise.resolve();
if (cache.has(s)) return cache.get(s);
const p = new Promise((resolve) => {
const img = new Image();
img.decoding = 'async';
const done = () => resolve();
img.addEventListener('load', done, { once: true });
img.addEventListener('error', done, { once: true });
u1ApplyGallerySrcset(img, s); /* srcset ANTES de src: asignar src primero dispara la descarga del 1400 antes de que el srcset exista */
img.src = s;
try {
if (typeof img.decode === 'function') img.decode().then(done).catch(done);
} catch (_e) { /* noop */ }
window.setTimeout(done, 1600);
});
cache.set(s, p);
return p;
};
return { preload };
})();
const u1PreloadGalleryImageList = (list) => {
const urls = [];
try {
(Array.isArray(list) ? list : []).forEach((item) => {
if (!item || String(item.type || '') === 'video' || !item.src) return;
const u = String(item.src || '').trim();
if (u && !urls.includes(u)) urls.push(u);
});
} catch (_e) { /* noop */ }
if (!urls.length) return Promise.resolve();
return Promise.all(urls.map((u) => u1ImgPreload.preload(u)));
};
const u1WaitGalleryImgPaintReady = (imgEl, timeoutMs) => {
const t = Math.max(200, Number(timeoutMs) || 1200);
return new Promise((resolve) => {
let done = false;
const finish = () => { if (done) return; done = true; resolve(); };
window.setTimeout(finish, t);
if (!imgEl) { finish(); return; }
try {
if (imgEl.complete && (imgEl.naturalWidth || 0) > 0) {
if (typeof imgEl.decode === 'function') {
imgEl.decode().then(finish).catch(finish);
} else {
finish();
}
return;
}
} catch (_e0) { /* noop */ }
imgEl.addEventListener('load', finish, { once: true });
imgEl.addEventListener('error', finish, { once: true });
});
};
const u1ImgExists = (() => {
const cache = new Map(); // src -> Promise<boolean>
const check = (src) => {
const s = (src || '').toString();
if (!s) return Promise.resolve(false);
if (cache.has(s)) return cache.get(s);
const p = new Promise((resolve) => {
const img = new Image();
img.decoding = 'async';
img.addEventListener('load', () => resolve(true), { once: true });
img.addEventListener('error', () => resolve(false), { once: true });
u1ApplyGallerySrcset(img, s); /* srcset ANTES de src (ver u1ImgPreload) */
img.src = s;
try {
if (typeof img.decode === 'function') img.decode().then(() => resolve(true)).catch(() => resolve(false));
} catch (_e) { /* noop */ }
window.setTimeout(() => resolve(false), 2500);
});
cache.set(s, p);
return p;
};
return { check };
})();
const galleryModeLayers = (() => {
if (!galleryViewport) return { wrap: null, active: null, preview: null };
let wrap = galleryViewport.querySelector('.u1-pdp-customizer__gallery-mode');
if (!wrap) {
wrap = document.createElement('div');
wrap.className = 'u1-pdp-customizer__gallery-mode';
wrap.setAttribute('aria-hidden', 'true');
galleryViewport.appendChild(wrap);
}
const createLayer = (kind) => {
const layer = document.createElement('div');
layer.className = `u1-pdp-customizer__gallery-mode-layer u1-pdp-customizer__gallery-mode-layer--${kind}`;
layer.setAttribute('aria-hidden', 'true');
layer.innerHTML = `
<div class="u1-pdp-customizer__gallery-media u1-pdp-customizer__gallery-media--render">
<div class="u1-pdp-customizer__gallery-square">
<img class="u1-pdp-customizer__gallery-img" alt="" decoding="async" loading="eager" width="2000" height="2000">
</div>
</div>
`;
wrap.appendChild(layer);
const img = layer.querySelector('img');
if (img) {
img.addEventListener('error', () => { try { img.style.visibility = 'hidden'; } catch (_e) {} }, { passive: true });
img.addEventListener('load', () => { try { img.style.visibility = ''; } catch (_e) {} }, { passive: true });
}
return { layer, img, token: 0 };
};
const active = wrap.querySelector('.u1-pdp-customizer__gallery-mode-layer--active') || createLayer('active').layer;
const preview = wrap.querySelector('.u1-pdp-customizer__gallery-mode-layer--preview') || createLayer('preview').layer;
const activeImg = active.querySelector('img');
const previewImg = preview.querySelector('img');
return {
wrap,
active: { el: active, img: activeImg, token: 0 },
preview: { el: preview, img: previewImg, token: 0 },
};
})();
root._u1GalleryModeLayers = galleryModeLayers;

const galleryMipsOverlay = (() => {
if (!galleryViewport) return { img: null };
let img = galleryViewport.querySelector('img.u1-pdp-customizer__gallery-mips-overlay');
if (!img) {
img = document.createElement('img');
img.className = 'u1-pdp-customizer__gallery-mips-overlay';
img.setAttribute('alt', '');
img.setAttribute('aria-hidden', 'true');
img.decoding = 'async';
try { img.loading = 'eager'; } catch (_e) { /* noop */ }
img.hidden = true;
img.addEventListener('error', () => {
try { img.hidden = true; } catch (_e0) { /* noop */ }
try { img.setAttribute('aria-hidden', 'true'); } catch (_e1) { /* noop */ }
try { img.style.display = 'none'; } catch (_e2) { /* noop */ }
try { img.removeAttribute('src'); } catch (_e3) { /* noop */ }
}, { passive: true });
galleryViewport.appendChild(img);
}
return { img, resolved: new Map(), resolving: new Set() };
})();
root._u1GalleryMipsOverlay = galleryMipsOverlay;

// Overlay para accessories de tipo "insert" (ej: Rain Plugs) — z-index sobre el remote
const galleryInsertOverlay = (() => {
if (!galleryViewport) return { img: null };
let img = galleryViewport.querySelector('img.u1-pdp-customizer__gallery-insert-overlay');
if (!img) {
img = document.createElement('img');
img.className = 'u1-pdp-customizer__gallery-insert-overlay';
img.setAttribute('alt', '');
img.setAttribute('aria-hidden', 'true');
img.decoding = 'async';
try { img.loading = 'eager'; } catch (_e) { /* noop */ }
img.hidden = true;
img.addEventListener('error', () => {
try { img.hidden = true; } catch (_e0) { /* noop */ }
try { img.setAttribute('aria-hidden', 'true'); } catch (_e1) { /* noop */ }
try { img.removeAttribute('src'); } catch (_e2) { /* noop */ }
}, { passive: true });
galleryViewport.appendChild(img);
}
return { img };
})();
root._u1GalleryInsertOverlay = galleryInsertOverlay;

const galleryRemoteMipsBadge = (() => {
if (!galleryViewport) return { img: null };
let img = galleryViewport.querySelector('img.u1-pdp-customizer__gallery-remote-mips-badge');
if (!img) {
img = document.createElement('img');
img.className = 'u1-pdp-customizer__gallery-remote-mips-badge';
img.setAttribute('alt', '');
img.setAttribute('aria-hidden', 'true');
img.decoding = 'async';
try { img.loading = 'eager'; } catch (_e) { /* noop */ }
img.hidden = true;
img.addEventListener('error', () => {
try { img.hidden = true; } catch (_e0) { /* noop */ }
try { img.setAttribute('aria-hidden', 'true'); } catch (_e1) { /* noop */ }
try { img.style.display = 'none'; } catch (_e2) { /* noop */ }
try { img.removeAttribute('src'); } catch (_e3) { /* noop */ }
}, { passive: true });
galleryViewport.appendChild(img);
}
return { img, resolved: new Map(), resolving: new Set() };
})();
root._u1GalleryRemoteMipsBadge = galleryRemoteMipsBadge;

const setModeLayerVisible = (layer, visible) => {
if (!layer || !layer.el) return;
layer.el.classList.toggle('is-visible', !!visible);
};
const setModeLayerSrc = (layer, src, { eager } = { eager: true }) => {
if (!layer || !layer.img) return Promise.resolve(false);
const s = (src || '').toString();
if (!s) {
try { layer.img.removeAttribute('src'); } catch (_e) { /* noop */ }
u1ApplyGallerySrcset(layer.img, ''); /* limpiar srcset/sizes: si quedan, el navegador sigue mostrando la imagen vieja del srcset */
return Promise.resolve(false);
}
try { layer.img.loading = eager ? 'eager' : 'lazy'; } catch (_e) { /* noop */ }
if (layer.img.getAttribute('src') === s) return Promise.resolve(true);
u1ApplyGallerySrcset(layer.img, s); /* srcset ANTES de src (ver u1ImgPreload) */
layer.img.setAttribute('src', s);
return Promise.resolve(true);
};
const fadeModeLayerToSrc = (layer, src, { durationMs = 219 } = { durationMs: 219 }) => {
if (!layer || !layer.el || !layer.img) return;
layer.token += 1;
const token = layer.token;
const s = (src || '').toString();
if (!s) {
setModeLayerVisible(layer, false);
return;
}
const wasVisible = layer.el.classList.contains('is-visible');
if (wasVisible) {
layer.el.style.transitionDuration = `${durationMs}ms`;
setModeLayerVisible(layer, false);
}
const waitForImgReady = (img, timeoutMs = 1600) => {
if (!img) return Promise.resolve();
try {
if (img.complete && (img.naturalWidth || 0) > 0) {
if (typeof img.decode === 'function') return img.decode().catch(() => {});
return Promise.resolve();
}
} catch (_e0) { /* noop */ }
return new Promise((resolve) => {
let done = false;
const finish = () => {
if (done) return;
done = true;
resolve();
};
try { img.addEventListener('load', finish, { once: true }); } catch (_e) { /* noop */ }
try { img.addEventListener('error', finish, { once: true }); } catch (_e2) { /* noop */ }
try {
if (typeof img.decode === 'function') img.decode().then(finish).catch(() => {});
} catch (_e3) { /* noop */ }
window.setTimeout(finish, timeoutMs);
});
};
const doSwap = () => {
if (layer.token !== token) return;
setModeLayerSrc(layer, s, { eager: true });
const endLoading = beginGalleryLoading();
try { u1ImgPreload.preload(s); } catch (_eP) { /* noop */ }
waitForImgReady(layer.img, 1800)
.then(() => {
if (layer.token !== token) return;
if (layer.img && !layer.img.naturalWidth) return;
layer.el.style.transitionDuration = `${durationMs}ms`;
setModeLayerVisible(layer, true);
})
.catch(() => {})
.finally(() => endLoading());
};
if (wasVisible) window.setTimeout(doSwap, durationMs + 10);
else doSwap();
};
const getGalleryImagesForColor = (colorValue) => {
if (!hasCustomGallery) return null;
const h = optionNameHandle(colorValue);
const imgs = (h && colorGalleryMap.has(h)) ? colorGalleryMap.get(h) : null;
if (imgs && imgs.length > 0) return imgs;
if (!colorValue && simpleGallerySlides && simpleGallerySlides.length > 0) {
const out = simpleGallerySlides.map((it) => ({
type: 'image',
src: String((it && it.src) ? it.src : ''),
alt: String((it && it.alt) ? it.alt : ''),
lifestyle: !!(it && it.lifestyle),
})).filter((it) => it.src);
if (out.length > 0) return out;
}
if (!colorValue && defaultGalleryVideoSrc) {
const mode = (defaultGalleryVideoMode === 'lifestyle' || defaultGalleryVideoMode === 'cover') ? 'cover' : 'contain';
return [{
type: 'video',
src: defaultGalleryVideoSrc,
poster: defaultGalleryVideoPoster || '',
fit: mode,
}];
}
if (!colorValue && defaultGallerySrc) return [{ type: 'image', src: defaultGallerySrc, alt: defaultGalleryAlt || '', lifestyle: !!defaultGalleryIsLifestyle }];
return null;
};
const updateMobileHeroImage = (imgs) => {
/* Variante B: ya no hay hero. El gancho que la A usaba para que el hero siguiera al color
   ahora actualiza la miniatura del casco en las cards de pack. */
try { if (root._u1BSyncMainThumbs) root._u1BSyncMainThumbs(imgs); } catch (_e) { /* noop */ }
};
const getGalleryImagesForVariant = (variantId) => {
if (!hasCustomGallery && !(variantGalleryMap && variantGalleryMap.size)) return null;
const idNum = Number(variantId || 0);
if (!idNum) return null;
const imgs = (variantGalleryMap && variantGalleryMap.has(idNum)) ? variantGalleryMap.get(idNum) : null;
return (imgs && imgs.length > 0) ? imgs : null;
};
/* Galeria al cambiar de producto (capitulo Model, modo productos separados). Reemplaza
   las slides con la media del producto elegido. Vive aca y no en el snippet porque
   u1-pdp-customizer-js esta al borde de los 256 KB de Shopify.
   NO toca variantGalleryMap a proposito: agregarle una entrada prende hasCustomGallery
   para toda la PDP y, si los bloques de galeria estan vacios (Helmet Visor lo esta),
   la unica foto del mapa se muestra en todos los modelos. Ya paso el 2026-09-29. */
root._u1ModelGallery = (model, focusValue) => {
  try {
    if (!galleryTrack) return;
    /* Vuelta al producto de la pagina: se restaura la galeria original con sus
       data-media-id intactos, y el theme vuelve a moverse solo al cambiar de variante. */
    if (model && model.handle && model.handle === U1_HOME_MODEL.handle) {
      if (!U1_HOME_GALLERY_HTML) return;
      galleryTrack.innerHTML = U1_HOME_GALLERY_HTML;
      /* Igual que hace setGalleryToImages: la lista de slides vive en una variable y hay
         que refrescarla. Sin esto queda apuntando a los nodos viejos, ya desprendidos del
         documento, y el theme deja de poder moverse entre variantes (2026-09-30: volviendo
         de Adaptive, Clear y Tinted dejaban de cambiar la foto). */
      slides = Array.from(root.querySelectorAll('[data-u1-pdp-slide]'));
      state.galleryIndex = 0;
      try { updateGalleryButtons(); } catch (_e1) { /* noop */ }
      try { renderMobileGalleries(); } catch (_e2) { /* noop */ }
      return;
    }
    const imgs = (model && Array.isArray(model.images)) ? model.images.filter(i => i && i.src) : [];
    if (!imgs.length) return;
    setGalleryToImages(imgs, { preserveIndex: false, eagerFirst: true });
  } catch (_eMG) { /* noop */ }
};
const getFinalImageForColor = (colorValue) => {
if (!hasCustomGallery) return null;
const h = optionNameHandle(colorValue);
const it = (h && colorFinalMap && colorFinalMap.has(h)) ? colorFinalMap.get(h) : null;
if (it && it.src) return it;
const imgs = getGalleryImagesForColor(colorValue);
const first = imgs && imgs.length ? imgs[0] : null;
if (!first) return null;
if (first && first.type === 'video') {
const poster = (first && first.poster) ? String(first.poster) : '';
return poster ? { src: poster, alt: '', lifestyle: false } : null;
}
const src = (first && first.src) ? String(first.src) : '';
if (!src) return null;
return { src, alt: String(first.alt || ''), lifestyle: !!first.lifestyle };
};
const getFinalImageForVariant = (variantId) => {
if (!hasCustomGallery && !(variantFinalMap && variantFinalMap.size)) return null;
const idNum = Number(variantId || 0);
if (!idNum) return null;
const it = (variantFinalMap && variantFinalMap.has(idNum)) ? variantFinalMap.get(idNum) : null;
if (it && it.src) return it;
const imgs = getGalleryImagesForVariant(idNum);
const first = imgs && imgs.length ? imgs[0] : null;
if (!first || !first.src) return null;
return { src: String(first.src), alt: String(first.alt || ''), lifestyle: !!first.lifestyle };
};
const setGalleryToImages = (images, { preserveIndex, eagerFirst } = { preserveIndex: true, eagerFirst: false }) => {
if (!galleryTrack) return;
const list = Array.isArray(images) ? images : [];
if (list.length === 0) return;
const idx = preserveIndex ? clamp(state.galleryIndex, 0, list.length - 1) : 0;
galleryTrack.innerHTML = list.map((img, i) => {
const type = (img && img.type) ? String(img.type) : 'image';
if (type === 'video') {
const src = (img && img.src) ? String(img.src) : '';
const poster = (img && img.poster) ? String(img.poster) : '';
const fit = (img && img.fit) ? String(img.fit) : 'contain';
const isCover = fit === 'cover';
const mediaClass = isCover
? 'u1-pdp-customizer__gallery-media u1-pdp-customizer__gallery-media--lifestyle u1-pdp-customizer__gallery-media--video'
: 'u1-pdp-customizer__gallery-media u1-pdp-customizer__gallery-media--render u1-pdp-customizer__gallery-media--video';
const fitAttr = isCover ? 'cover' : 'contain';
const posterAttr = poster ? ` poster="${poster.replace(/"/g, '&quot;')}"` : '';
const videoTag = `<video class="u1-pdp-customizer__gallery-video" playsinline muted loop autoplay preload="metadata"${posterAttr} data-u1-fit="${fitAttr}"><source src="${src.replace(/"/g, '&quot;')}" type="video/mp4"></video>`;
const inner = `<div class="${mediaClass}" data-u1-fit="${fitAttr}">${videoTag}</div>`;
return `<figure class="u1-pdp-customizer__gallery-slide" data-u1-pdp-slide data-u1-media="video">${inner}</figure>`;
}
const src = (img && img.src) ? String(img.src) : '';
const alt = (img && img.alt) ? String(img.alt) : '';
const lifestyle = !!(img && img.lifestyle);
const lifestyleAttr = lifestyle ? '1' : '0';
const safeAlt = alt.replace(/"/g, '&quot;');
const isEager = !!eagerFirst && i === 0;
const loadingAttr = isEager ? 'eager' : 'lazy';
const fetchPr = isEager ? ' fetchpriority="high"' : '';
const _ss = u1GallerySrcset(src);
const _ssAttr = _ss ? ` srcset="${_ss}" sizes="${U1_GALLERY_SIZES}"` : '';
const imgTag = `<img class="u1-pdp-customizer__gallery-img" loading="${loadingAttr}" decoding="async"${fetchPr} alt="${safeAlt}" src="${src}"${_ssAttr} width="2000" height="2000" onerror="this.style.visibility='hidden';var p=this.closest('.u1-pdp-customizer__gallery-square');if(p)p.style.visibility='hidden'" onload="this.style.visibility='';var p=this.closest('.u1-pdp-customizer__gallery-square');if(p)p.style.visibility=''">`;
const inner = lifestyle
? `<div class="u1-pdp-customizer__gallery-media u1-pdp-customizer__gallery-media--lifestyle">${imgTag}</div>`
: `<div class="u1-pdp-customizer__gallery-media u1-pdp-customizer__gallery-media--render"><div class="u1-pdp-customizer__gallery-square">${imgTag}</div></div>`;
return `
<figure class="u1-pdp-customizer__gallery-slide" data-u1-pdp-slide data-u1-lifestyle="${lifestyleAttr}">
${inner}
</figure>
`;
}).join('');
refreshSlides();
state.galleryIndex = idx;
const target = slides[idx];
/* La medida (offsetLeft) va en rAF, despues de TODAS las escrituras del handler: leerla aca
   forzaba un Recalculate Style completo dentro del task del click (medido 16 ms desktop / ~60 ms mobile). */
window.requestAnimationFrame(() => {
if (slides[idx] !== target) return;
const left = target ? target.offsetLeft : 0;
try { galleryTrack.scrollTo({ left, behavior: 'auto' }); } catch (_e) { galleryTrack.scrollLeft = left; }
});
try { watchImgForLoader(target ? target.querySelector('img') : null); } catch (_e2) { /* noop */ }
updateGalleryButtons();
try { updateDesktopPager(); } catch (_e3) { /* noop */ }
renderMobileGalleries();
};
let galleryMode = 'normal'; // normal | final
const setGalleryInteractivity = (on) => {
if (!galleryTrack) return;
const enabled = !!on;
galleryTrack.style.pointerEvents = enabled ? '' : 'none';
galleryTrack.style.scrollSnapType = enabled ? '' : 'none';
galleryTrack.style.overflowX = enabled ? '' : 'hidden';
if (btnPrev) btnPrev.style.display = enabled ? '' : 'none';
if (btnNext) btnNext.style.display = enabled ? '' : 'none';
};
const setGallerySwipeEnabled = (on) => {
if (!galleryTrack) return;
const enabled = !!on;
galleryTrack.style.pointerEvents = enabled ? '' : 'none';
galleryTrack.style.scrollSnapType = enabled ? '' : 'none';
galleryTrack.style.overflowX = enabled ? '' : 'hidden';
};
const crossfadeGalleryToImages = (images, { durationMs, onOverlayReady } = { durationMs: 133, onOverlayReady: null }) => {
if (!galleryViewport || !galleryTrack) return;
const list = Array.isArray(images) ? images : [];
if (!list.length) return;
const cover = list[0];
if (!cover || !cover.src) return;
root._u1GalleryToken = String((Number(root._u1GalleryToken || '0') || 0) + 1);
const token = root._u1GalleryToken;
if (root._u1GalleryTimer) { window.clearTimeout(root._u1GalleryTimer); root._u1GalleryTimer = null; }
// Ocultar el badge MIPS remoto apenas arranca la transicion (evita el flash del pill);
// los re-syncs (doSwap / setBaseToAccessoriesView) lo re-muestran solo sobre la vista del remote.
try {
const _rbi = galleryRemoteMipsBadge && galleryRemoteMipsBadge.img ? galleryRemoteMipsBadge.img : null;
if (_rbi) { _rbi.hidden = true; _rbi.setAttribute('aria-hidden', 'true'); _rbi.style.display = 'none'; }
} catch (_eRB0) { /* noop */ }
galleryViewport.querySelectorAll('.u1-pdp-customizer__gallery-fade').forEach(n => n.remove());
galleryTrack.style.transition = 'none';
galleryTrack.style.opacity = '0';
galleryTrack.offsetWidth;
galleryTrack.style.transition = '';
const getVisibleGalleryIndex = () => {
try {
const s = Array.isArray(slides) ? slides : [];
if (!s.length) return Number(state.galleryIndex || 0) || 0;
const x = Number(galleryTrack.scrollLeft || 0);
let best = 0;
let bestDist = Infinity;
for (let i = 0; i < s.length; i++) {
const left = Number(s[i].offsetLeft || 0);
const d = Math.abs(left - x);
if (d < bestDist) { bestDist = d; best = i; }
}
return best;
} catch (_e) {
return Number(state.galleryIndex || 0) || 0;
}
};
const visibleIdx = getVisibleGalleryIndex();
const currentSlide = slides[visibleIdx];
const currentMedia = currentSlide ? currentSlide.querySelector('.u1-pdp-customizer__gallery-media') : null;
const oldOverlay = (() => {
if (!currentMedia) return null;
const layer = document.createElement('div');
layer.className = 'u1-pdp-customizer__gallery-fade';
layer.setAttribute('aria-hidden', 'true');
layer.style.transition = `opacity ${durationMs}ms ease`;
layer.style.opacity = '1';
layer.appendChild(currentMedia.cloneNode(true));
return layer;
})();
if (oldOverlay) galleryViewport.appendChild(oldOverlay);
const newOverlay = createFadeLayer({ src: String(cover.src), alt: String(cover.alt || ''), lifestyle: !!cover.lifestyle });
newOverlay.style.transition = `opacity ${durationMs}ms ease`;
newOverlay.style.opacity = '0';
galleryViewport.appendChild(newOverlay);
if (oldOverlay) oldOverlay.offsetWidth;
newOverlay.offsetWidth;
const waitForDecode = (img) => {
if (!img) return Promise.resolve();
try { img.loading = 'eager'; } catch (_e) { /* noop */ }
try { img.fetchPriority = 'high'; } catch (_e) { /* noop */ }
if (img.complete && (img.naturalWidth || 0) > 0) {
try {
if (typeof img.decode === 'function') return img.decode().catch(() => {});
} catch (_e) { /* noop */ }
return Promise.resolve();
}
return new Promise((resolve) => {
let done = false;
const finish = () => { if (done) return; done = true; resolve(); };
img.addEventListener('load', finish, { once: true });
img.addEventListener('error', finish, { once: true });
window.setTimeout(finish, 480);
});
};
const overlayImg = newOverlay.querySelector('img');
const endOverlayLoading = beginGalleryLoading();
let didReady = false;
const markReady = () => {
if (didReady) return;
didReady = true;
try {
if (typeof onOverlayReady === 'function') onOverlayReady({ cover, token, overlay: newOverlay, img: overlayImg });
} catch (_e) { /* noop */ }
};
const doSwap = () => {
if (root._u1GalleryToken !== token) return;
setGalleryToImages(list, { preserveIndex: false, eagerFirst: true });
// La base cambió: re-evaluar el badge MIPS remoto (solo debe verse sobre la vista del remote)
try { syncRemoteMipsBadgeOverlay(); } catch (_eRMB) { /* noop */ }
const nextSlide = slides[state.galleryIndex];
const realImg = nextSlide ? nextSlide.querySelector('img') : null;
const cleanup = () => {
if (root._u1GalleryToken !== token) return;
galleryTrack.style.transition = 'none';
galleryTrack.style.opacity = '1';
galleryTrack.offsetWidth;
galleryTrack.style.transition = '';
const outMs = Number(durationMs) || 400;
let removed = false;
const removeNow = () => {
if (removed) return;
removed = true;
try { newOverlay.remove(); } catch (_e) { /* noop */ }
try { if (oldOverlay) oldOverlay.remove(); } catch (_e) { /* noop */ }
};
const onEnd = (e) => {
if (e && e.target !== newOverlay) return;
removeNow();
};
try { newOverlay.addEventListener('transitionend', onEnd, { once: true }); } catch (_e) { /* noop */ }
window.requestAnimationFrame(() => {
if (root._u1GalleryToken !== token) return;
window.requestAnimationFrame(() => {
if (root._u1GalleryToken !== token) return;
newOverlay.style.opacity = '0';
});
});
window.setTimeout(removeNow, outMs + 80);
};
const waitForDecodeReal = (img) => {
if (!img) return Promise.resolve();
try { img.loading = 'eager'; } catch (_e) { /* noop */ }
try { img.fetchPriority = 'high'; } catch (_e) { /* noop */ }
if (img.complete && (img.naturalWidth || 0) > 0) {
try {
if (typeof img.decode === 'function') return img.decode().catch(() => {});
} catch (_e) { /* noop */ }
return Promise.resolve();
}
return new Promise((resolve) => {
let done = false;
const finish = () => { if (done) return; done = true; resolve(); };
img.addEventListener('load', finish, { once: true });
img.addEventListener('error', finish, { once: true });
window.setTimeout(finish, 480);
});
};
const endRealLoading = beginGalleryLoading();
Promise.race([
waitForDecodeReal(realImg),
new Promise((resolve) => window.setTimeout(resolve, 160)),
])
.then(() => cleanup())
.catch(() => cleanup())
.finally(() => endRealLoading());
};
const startFade = () => {
if (root._u1GalleryToken !== token) return;
markReady();
window.requestAnimationFrame(() => {
if (root._u1GalleryToken !== token) return;
window.requestAnimationFrame(() => {
if (root._u1GalleryToken !== token) return;
newOverlay.style.opacity = '1';
if (oldOverlay) oldOverlay.style.opacity = '0';
if (root._u1GalleryTimer) { window.clearTimeout(root._u1GalleryTimer); root._u1GalleryTimer = null; }
root._u1GalleryTimer = window.setTimeout(doSwap, durationMs);
});
});
};
Promise.race([
waitForDecode(overlayImg),
new Promise((resolve) => window.setTimeout(resolve, 96)),
])
.then(() => startFade())
.catch(() => startFade())
.finally(() => endOverlayLoading());
};
const applyFinalGalleryMode = (shouldShowFinal) => {
if (!galleryTrack) return;
const wantFinal = !!shouldShowFinal;
if (wantFinal && galleryMode === 'final') return;
if (!wantFinal && galleryMode === 'normal') return;
if (wantFinal) {
const fin = getFinalImageForColor(state.color);
if (!fin || !fin.src) return;
galleryMode = 'final';
try { root.setAttribute('data-u1-gallery-mode', galleryMode); } catch (_e) { /* noop */ }
setGalleryInteractivity(false);
crossfadeGalleryToImages([fin], { durationMs: 133 });
} else {
galleryMode = 'normal';
try { root.setAttribute('data-u1-gallery-mode', galleryMode); } catch (_e) { /* noop */ }
const imgs = getGalleryImagesForColor(state.color);
if (imgs && imgs.length) {
const first = imgs[0] || null;
if (first && first.type === 'video') {
setGalleryToImages(imgs, { preserveIndex: false });
} else {
crossfadeGalleryToImages(imgs, { durationMs: 133 });
}
}
window.setTimeout(() => setGalleryInteractivity(true), 420);
}
};
const createFadeLayer = ({ src, alt, lifestyle }) => {
const layer = document.createElement('div');
layer.className = 'u1-pdp-customizer__gallery-fade';
layer.setAttribute('aria-hidden', 'true');
layer.dataset.u1Lifestyle = lifestyle ? '1' : '0';
const mediaWrap = document.createElement('div');
mediaWrap.className = `u1-pdp-customizer__gallery-media ${lifestyle ? 'u1-pdp-customizer__gallery-media--lifestyle' : 'u1-pdp-customizer__gallery-media--render'}`;
const img = document.createElement('img');
img.className = 'u1-pdp-customizer__gallery-img';
img.alt = (alt || '').toString();
u1ApplyGallerySrcset(img, src); /* srcset ANTES de src (ver u1ImgPreload) */
img.src = (src || '').toString();
img.decoding = 'async';
img.loading = 'eager';
img.addEventListener('error', () => { try { img.style.visibility = 'hidden'; var p = img.closest('.u1-pdp-customizer__gallery-square'); if (p) p.style.visibility = 'hidden'; } catch (_e) {} }, { passive: true });
img.addEventListener('load', () => { try { img.style.visibility = ''; var p = img.closest('.u1-pdp-customizer__gallery-square'); if (p) p.style.visibility = ''; } catch (_e) {} }, { passive: true });
if (lifestyle) {
mediaWrap.appendChild(img);
} else {
const sq = document.createElement('div');
sq.className = 'u1-pdp-customizer__gallery-square';
sq.appendChild(img);
mediaWrap.appendChild(sq);
}
layer.appendChild(mediaWrap);
return layer;
};
const transitionGalleryToColor = (colorValue, { durationMs, prevColor } = { durationMs: 133, prevColor: null }) => {
if (!hasCustomGallery) return;
// En visor mode, al cambiar color re-aplicamos la vista visor con las imágenes del nuevo color
// (sin este guard, transitionGalleryToColor cambia el token y cancela el setup del visor)
if (String(root._u1GalleryUxMode || '') === 'visor') {
try { setBaseToVisorView(); } catch (_e) { /* noop */ }
return;
}
const hasVariantGalleryData = (variantGalleryMap && variantGalleryMap.size > 0) || (variantFinalMap && variantFinalMap.size > 0);
if (galleryMode === 'final') {
let fin = getFinalImageForColor(colorValue);
if (hasVariantGalleryData && typeof findVariant === 'function') {
try {
const resolved = findVariant(state.color, state.size);
const vid = resolved && resolved.id ? Number(resolved.id) : 0;
if (vid) {
const finV = getFinalImageForVariant(vid);
if (finV && finV.src) fin = finV;
}
} catch (_eF) { /* noop */ }
}
if (fin && fin.src) crossfadeGalleryToImages([fin], { durationMs: 133 });
return;
}
if (hasVariantGalleryData && typeof findVariant === 'function') {
try {
const resolved = findVariant(state.color, state.size);
const vid = resolved && resolved.id ? Number(resolved.id) : 0;
if (vid) {
const vImgs = getGalleryImagesForVariant(vid);
const vFin = getFinalImageForVariant(vid);
if ((vImgs && vImgs.length) || (vFin && vFin.src)) {
transitionGalleryToVariant(vid, { durationMs });
return;
}
}
} catch (_eVg) { /* noop */ }
}
const imgs = getGalleryImagesForColor(colorValue);
try { updateMobileHeroImage(imgs); } catch (_eH) { /* noop */ }
if (!imgs || imgs.length === 0) return;
const idx = clamp(state.galleryIndex, 0, imgs.length - 1);
const cover = imgs[idx] || imgs[0];
if (cover && cover.type === 'video') {
setGalleryToImages(imgs, { preserveIndex: true });
return;
}
if (!galleryViewport || !cover || !cover.src) {
setGalleryToImages(imgs, { preserveIndex: true });
return;
}
root._u1GalleryToken = String((Number(root._u1GalleryToken || '0') || 0) + 1);
const token = root._u1GalleryToken;
if (root._u1GalleryTimer) { window.clearTimeout(root._u1GalleryTimer); root._u1GalleryTimer = null; }
// Ocultar el badge MIPS remoto apenas arranca la transicion (evita el flash del pill);
// los re-syncs (doSwap / setBaseToAccessoriesView) lo re-muestran solo sobre la vista del remote.
try {
const _rbi = galleryRemoteMipsBadge && galleryRemoteMipsBadge.img ? galleryRemoteMipsBadge.img : null;
if (_rbi) { _rbi.hidden = true; _rbi.setAttribute('aria-hidden', 'true'); _rbi.style.display = 'none'; }
} catch (_eRB0) { /* noop */ }
galleryViewport.querySelectorAll('.u1-pdp-customizer__gallery-fade').forEach(n => n.remove());
const doTrackFade = (prevColor == null) && !!galleryTrack;
if (doTrackFade) {
galleryTrack.style.transition = `opacity ${durationMs}ms ease`;
galleryTrack.style.opacity = '1';
}
const currentSlide = slides[state.galleryIndex];
const currentImg = currentSlide ? currentSlide.querySelector('img') : null;
const domOldSrc = currentImg ? (currentImg.currentSrc || currentImg.src || '') : '';
const domOldAlt = currentImg ? (currentImg.getAttribute('alt') || '') : '';
const domLifestyle = (() => {
try {
const a = currentSlide && currentSlide.getAttribute ? String(currentSlide.getAttribute('data-u1-lifestyle') || '') : '';
if (a === '1') return true;
if (a === '0') return false;
} catch (_e) { /* noop */ }
try {
const fit = currentImg ? String(getComputedStyle(currentImg).objectFit || '') : '';
if (fit === 'contain') return false;
} catch (_e2) { /* noop */ }
return true;
})();
const prevImgs = getGalleryImagesForColor(prevColor);
const prevIdx = prevImgs && prevImgs.length ? clamp(state.galleryIndex, 0, prevImgs.length - 1) : 0;
const prevCover = prevImgs && prevImgs.length ? (prevImgs[prevIdx] || prevImgs[0]) : null;
const prevIsVideo = !!(prevCover && prevCover.type === 'video');
const prevSrc = prevIsVideo
? ((prevCover && prevCover.poster) ? String(prevCover.poster) : '')
: ((prevCover && prevCover.src) ? String(prevCover.src) : '');
const prevAlt = (prevCover && prevCover.alt) ? String(prevCover.alt) : '';
const oldSrc = domOldSrc || prevSrc;
const oldAlt = domOldAlt || prevAlt;
const oldIsLifestyle = domOldSrc
? domLifestyle
: ((prevCover && typeof prevCover.lifestyle === 'boolean') ? prevCover.lifestyle : true);
const baseLayer = root._u1GalleryBase || null;
const baseEl = (baseLayer && baseLayer.el) ? baseLayer.el : null;
const baseImg = (baseLayer && typeof baseLayer.getImg === 'function') ? baseLayer.getImg() : null;
const useBase = (prevColor == null) && !!(baseEl && baseImg && oldSrc);
if (baseEl) {
if (!useBase) baseEl.style.opacity = '0';
}
if (useBase && baseEl && baseLayer) {
try { baseLayer.ensureKind(!!oldIsLifestyle); } catch (_e) { /* noop */ }
const img = (typeof baseLayer.getImg === 'function') ? baseLayer.getImg() : baseImg;
if (img) {
img.alt = oldAlt || '';
u1ApplyGallerySrcset(img, oldSrc); /* srcset ANTES de src (ver u1ImgPreload) */
img.src = oldSrc;
}
baseEl.style.transition = 'none';
baseEl.style.opacity = '1';
/* la transicion se restaura en el primer rAF de startTransition (sin reflow forzado) */
}
const oldOverlay = (!doTrackFade && !useBase && oldSrc) ? (() => {
const el = createFadeLayer({ src: oldSrc, alt: oldAlt, lifestyle: domLifestyle });
el.style.opacity = '1';
return el;
})() : null;
const newOverlay = (() => {
const el = createFadeLayer({ src: (cover.src || '').toString(), alt: (cover.alt || '').toString(), lifestyle: !!cover.lifestyle });
el.style.opacity = '0';
return el;
})();
if (oldOverlay) galleryViewport.appendChild(oldOverlay);
galleryViewport.appendChild(newOverlay);
/* Variante B: si el swap real (setTimeout de abajo) ya corrio antes de que este rAF
   llegue a ejecutarse (pasa cuando el hilo se traba en el primer clic, p. ej. la carga
   diferida de Rebuy), el fade no debe volver a apagar el track: quedaba en opacity 0. */
let _u1BSwapped = false;
const startTransition = () => {
window.requestAnimationFrame(() => {
if (root._u1GalleryToken !== token) return;
if (useBase && baseEl) baseEl.style.transition = '';
window.requestAnimationFrame(() => {
if (root._u1GalleryToken !== token) return;
newOverlay.style.opacity = '1'; // fade-in new
if (oldOverlay) oldOverlay.style.opacity = '0'; // fade-out old
if (useBase && baseEl) baseEl.style.opacity = '0'; // fade-out base (no selected)
if (doTrackFade && galleryTrack && !_u1BSwapped) galleryTrack.style.opacity = '0'; // fade-out track real (primera transición)
});
});
};
const endCoverLoading = beginGalleryLoading();
Promise.race([
u1ImgPreload.preload(String(cover.src || '')),
new Promise((resolve) => window.setTimeout(resolve, 96)),
])
.then(() => startTransition())
.catch(() => startTransition())
.finally(() => endCoverLoading());
root._u1GalleryTimer = window.setTimeout(() => {
if (root._u1GalleryToken !== token) return;
u1PreloadGalleryImageList(imgs)
.then(() => {
if (root._u1GalleryToken !== token) return;
_u1BSwapped = true;
setGalleryToImages(imgs, { preserveIndex: true });
if (doTrackFade && galleryTrack) {
galleryTrack.style.transition = 'none';
galleryTrack.style.opacity = '1';
galleryTrack.offsetWidth;
galleryTrack.style.transition = '';
}
const nextSlide = slides[state.galleryIndex];
const realImg = nextSlide ? nextSlide.querySelector('img') : null;
if (realImg) watchImgForLoader(realImg);
const cleanup = () => {
if (root._u1GalleryToken !== token) return;
newOverlay.style.opacity = '0';
window.setTimeout(() => {
if (oldOverlay) oldOverlay.remove();
newOverlay.remove();
}, 140);
};
u1WaitGalleryImgPaintReady(realImg, 420).then(() => cleanup());
})
.catch(() => {
if (root._u1GalleryToken !== token) return;
_u1BSwapped = true;
setGalleryToImages(imgs, { preserveIndex: true });
if (doTrackFade && galleryTrack) {
galleryTrack.style.transition = 'none';
galleryTrack.style.opacity = '1';
galleryTrack.offsetWidth;
galleryTrack.style.transition = '';
}
const nextSlide = slides[state.galleryIndex];
const realImg = nextSlide ? nextSlide.querySelector('img') : null;
if (realImg) watchImgForLoader(realImg);
const cleanup = () => {
if (root._u1GalleryToken !== token) return;
newOverlay.style.opacity = '0';
window.setTimeout(() => {
if (oldOverlay) oldOverlay.remove();
newOverlay.remove();
}, 140);
};
u1WaitGalleryImgPaintReady(realImg, 420).then(() => cleanup());
});
}, durationMs);
};
const transitionGalleryToVariant = (variantId, { durationMs } = { durationMs: 133 }) => {
const idNum = Number(variantId || 0) || 0;
if (!idNum) return;
const imgs = getGalleryImagesForVariant(idNum);
const fin = getFinalImageForVariant(idNum);
const list = (imgs && imgs.length) ? imgs : ((fin && fin.src) ? [fin] : null);
if (!list || !list.length) return;
try { u1PreloadGalleryImageList(list); } catch (_ePl) { /* noop */ }
try { updateMobileHeroImage(list); } catch (_eH) { /* noop */ }
const cover = list[0] || null;
if (cover && cover.type === 'video') {
setGalleryToImages(list, { preserveIndex: false });
return;
}
const ms = Number(durationMs);
if (!Number.isFinite(ms) || ms <= 0) {
setGalleryToImages(list, { preserveIndex: false, eagerFirst: true });
return;
}
crossfadeGalleryToImages(list, { durationMs: ms });
};
const setColorUnsetUI = () => {
/* ── Model unset ── */
const modelUnset = (() => {
if (TEMPLATE === 'light') return !state.variantId;
if (!HAS_CHAPTER_MODEL) return false;
/* Variant-model mode (NEON): model is preselected from init via variantModel */
const _isVMM = String(root.dataset.u1PdpVariantModelMode || '') === '1';
if (_isVMM) return !state.variantModel;
/* Product-model blocks (separate products, e.g. FARO UK): always preselected */
if (CFG.hasProductModelBlocks) {
return false;
}
/* Simple model blocks (Smart Light): selected when simpleModelOptionValue or variantId set */
return !state.simpleModelOptionValue && !state.variantId;
})();
root.classList.toggle('is-model-unset', modelUnset);

/* ── Color unset ── */
const colorUnset = (() => {
if (TEMPLATE === 'light') return false;
const colorChapterActive = String(root.dataset.u1PdpHasColorChapter || '') === 'true';
if (!colorChapterActive) return false;
if (SILICONE_INSERTS_PDP && HAS_CHAPTER_SIZE && HAS_SIZE_OPTION && !state.size) return true;
return !state.color;
})();
root.classList.toggle('is-color-unset', colorUnset);

/* ── Size unset ── */
const sizeUnset = (() => {
if (TEMPLATE === 'light') return false;
if (!HAS_CHAPTER_SIZE) return false;
if (!HAS_SIZE_OPTION) return false;
return !state.size;
})();
root.classList.toggle('is-size-unset', sizeUnset);

/* ── Helmet size unset (visors: blocks model step until helmet size is picked) ── */
const helmetSizeUnset = (() => {
if (typeof HAS_HELMET_SIZE_CHAPTER === 'undefined' || !HAS_HELMET_SIZE_CHAPTER) return false;
try {
if (!root.querySelector('[data-u1-pdp-helmet-size-picker]')) return false;
} catch (_e) { return false; }
return !state.helmetSize;
})();
root.classList.toggle('is-helmet-size-unset', helmetSizeUnset);
};
const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
const optionNameHandle = (s) => (s || '').toString().trim().toLowerCase().replace(/\s+/g, '-');
const COLOR_HANDLE = CFG.colorHandle;
const SIZE_HANDLE = CFG.sizeHandle;
const MODEL_HANDLE = String(root.dataset.u1AccessoryModelHandle || 'model');
const IS_VARIANT_MODEL_MODE = String(root.dataset.u1PdpVariantModelMode || '') === '1';
const VARIANT_MODEL_OPTION_HANDLE = IS_VARIANT_MODEL_MODE ? String(root.dataset.u1PdpVariantModelOption || '').trim() : '';
const VM_OPT_IDX = (() => {
if (!IS_VARIANT_MODEL_MODE) return -1;
const n = Number(String(root.dataset.u1PdpVariantModelOptionIndex ?? '').trim());
return (Number.isFinite(n) && n >= 0 && n <= 2) ? n : -1;
})();
const getVariantModelOptionValue = (v) => {
if (!v || VM_OPT_IDX < 0) return null;
if (VM_OPT_IDX === 0) return v.option1 || null;
if (VM_OPT_IDX === 1) return v.option2 || null;
if (VM_OPT_IDX === 2) return v.option3 || null;
return null;
};

const HAS_COLOR_OPTION = (() => {
const opts = CFG.options;
return Array.isArray(opts) && opts.some(n => optionNameHandle(n) === COLOR_HANDLE);
})();
const HAS_SIZE_OPTION = (() => {
const opts = CFG.options;
return Array.isArray(opts) && opts.some(n => optionNameHandle(n) === SIZE_HANDLE);
})();
const HAS_COLOR_CHAPTER = String(root.dataset.u1PdpHasColorChapter || '') === 'true';
const SIMPLE_MODEL_OPT_HANDLE = String(root.dataset.u1PdpSimpleModelOption || '').trim();
const SINGLE_COLOR = (root.dataset.u1PdpSingleColor || '').toString().trim();
if (SINGLE_COLOR && HAS_COLOR_OPTION) {
state.color = SINGLE_COLOR;
}
const getSelectedOptionsMap = () => {
const m = new Map();
if (IS_VARIANT_MODEL_MODE && VARIANT_MODEL_OPTION_HANDLE && state.variantModel) {
m.set(VARIANT_MODEL_OPTION_HANDLE, state.variantModel);
}
if (SIMPLE_MODEL_OPT_HANDLE && state.simpleModelOptionValue) {
m.set(SIMPLE_MODEL_OPT_HANDLE, state.simpleModelOptionValue);
}
if (state.color) m.set(COLOR_HANDLE, state.color);
if (HAS_SIZE_OPTION && state.size) m.set(SIZE_HANDLE, state.size);
return m;
};
const getVariantOptionByHandle = (variant, handle) => {
const h = (handle || '').toString().trim();
if (IS_VARIANT_MODEL_MODE && VM_OPT_IDX >= 0 && VARIANT_MODEL_OPTION_HANDLE && h === VARIANT_MODEL_OPTION_HANDLE) {
return getVariantModelOptionValue(variant);
}
const optionsOrder = CFG.options;
const idx = Array.isArray(optionsOrder) ? optionsOrder.findIndex(n => optionNameHandle(n) === h) : -1;
if (idx === 0) return variant.option1 || null;
if (idx === 1) return variant.option2 || null;
if (idx === 2) return variant.option3 || null;
return null;
};

/* ═══════════════════════════════════════════════════════════════════════════
   Inline Bundle Picker (v2)
   Stacked card selector — replaces the old carousel pack selector.
   Auto-derives chapter visibility from bundle product option names.
   ═══════════════════════════════════════════════════════════════════════════ */
(function initBundlePicker() {

  /* ──────────────────────────────────────────────────────────────────────
     1. DOM & DATA
     ────────────────────────────────────────────────────────────────────── */

  var picker = root.querySelector('[data-u1-pdp-bundle-picker]');
  if (!picker) return;

  var bpEls = {
    cards:   Array.from(root.querySelectorAll('[data-u1-pdp-bundle-card]')), /* root: incluye las cards movidas al Flash Deal */
    heading: root.querySelector('[data-u1-pdp-product-heading]'),
  };

  if (!bpEls.cards.length) return;

  /* Bundle products JSON -> lookup by handle */
  var bundlePacksByHandle = {};
  try {
    var bpJsonEl = root.querySelector('[data-u1-pdp-bundle-packs]');
    var bpRaw    = bpJsonEl ? JSON.parse(bpJsonEl.textContent || '[]') : [];
    bpRaw.forEach(function(bp) { if (bp && bp.packHandle) bundlePacksByHandle[bp.packHandle] = bp; });
  } catch (_e) { /* noop */ }

  /* ── Pack sold out: si un componente no tiene variante disponible (en este
     mercado), la card queda gris con badge y no se puede seleccionar.
     El visor respeta allowedVisorStyles del pack y el casco de esta PDP
     (caso real: Adaptive/AURA agotado en US, 2026-08-31). ── */
  function _packCompAvailable(bp, c) {
    if (!c) return true;
    var vam = c.variantAvailMap || null;
    if (!vam || !Object.keys(vam).length) return (c.available !== false);
    var filt = String(c.variantFilter || '').trim().toLowerCase();
    var isVisor = String(c.handle || '').toLowerCase() === 'helmet-visor';
    var styles = String(bp.allowedVisorStyles || '').split(',')
      .map(function(x){ return x.trim().toLowerCase(); }).filter(Boolean);
    var mh = String(root.dataset.u1PdpProductHandle || '').toLowerCase();
    var helmet = mh.indexOf('aura') === 0 ? 'aura' : (mh.indexOf('neon') === 0 ? 'neon' : '');
    var keys = Object.keys(vam);
    /* si las variantes distinguen casco, el casco se exige SIEMPRE (aun con filtro):
       "Adaptive" no puede validar con Adaptive/NEON en la PDP de AURA */
    var scoped = helmet && keys.some(function(k) { return k.toLowerCase().indexOf(helmet) !== -1; });
    return keys.some(function(k) {
      if (!vam[k]) return false;
      var kl = k.toLowerCase();
      if (filt && kl.indexOf(filt) === -1) return false;
      if (scoped && kl.indexOf(helmet) === -1) return false;
      if (isVisor && !filt && styles.length && !styles.some(function(st) { return kl.indexOf(st) === 0; })) return false;
      return true;
    });
  }
  function _packIsBuyable(bp) {
    if (!bp || bp.isSolo) return true;
    var comps = bp.componentProducts || [];
    for (var i = 0; i < comps.length; i++) {
      if (!_packCompAvailable(bp, comps[i])) return false;
    }
    return true;
  }
  bpEls.cards.forEach(function(c) {
    var h = c.getAttribute('data-pack-handle');
    var bp = h ? bundlePacksByHandle[h] : null;
    if (!bp || _packIsBuyable(bp)) return;
    c.classList.add('u1-pdp-bundle-card--soldout');
    c.setAttribute('aria-disabled', 'true');
    /* mismo patron que las cards de accesorios: el precio (y el chip de
       descuento) se reemplazan por "Sold out" */
    try {
      var pg = c.querySelector('.u1-pdp-bundle-card__price-group');
      if (pg) pg.innerHTML = '<span class="u1-pdp-card__price u1-text-body-xs u1-pdp-card__price--soldout">' + U1S.sold_out + '</span>';
    } catch (_eB) { /* noop */ }
  });

  /* State (prefixed to avoid shadowing outer `state`) */
  var pkState = {
    selectedPackId:   null,
    activeBundlePack: null,
    defaultHeading:   bpEls.heading ? bpEls.heading.textContent : '',
  };

  /* ──────────────────────────────────────────────────────────────────────
     2. AUTO-DERIVE CHAPTERS from bundle product option names
     ────────────────────────────────────────────────────────────────────── */

  var OPTION_TO_CHAPTER = [
    { keywords: ['color', 'colour'],             chapter: 'color' },
    { keywords: ['size'],                         chapter: 'size'  },
    { keywords: ['visor', 'style', 'lens'],       chapter: 'visor' },
  ];
  /* Chapters that stay visible regardless of bundle selection.
     'model' y 'product_model' entran aca porque son la identidad del producto que se
     esta configurando: si un pack los esconde, el cliente queda encerrado y no puede
     volver al otro modelo (paso en FARO UK: al elegir un pack desaparecia el chapter
     de modelo y no habia forma de volver a FARO comun). */
  var ALWAYS_VISIBLE = ['description', 'bundle', 'model', 'product_model'];

  /** Given a bundle pack object, return an array of chapter keys
      that should be visible. Returns null when all should show.
      Priority: explicit chapters CSV from schema -> auto-derive from options */
  function deriveChapters(bp) {
    if (!bp) return null;
    /* 1) Explicit chapters from pack_chapters setting */
    if (bp.chapters && bp.chapters.trim()) {
      return bp.chapters.split(',').map(function(s) { return s.trim().toLowerCase(); }).filter(Boolean);
    }
    /* No explicit chapters → show all */
    return null;
  }

  /* Original chapter titles (cached once for restore on solo) */
  var _origTitles = {};

  function applyChapterVisibility(packId) {
    var bp      = bundlePacksByHandle[packId] || null;
    var allowed = deriveChapters(bp); /* null = all visible (solo) */
    var isBundleMode = !!bp;

    var allSteps = Array.from(root.querySelectorAll('[data-u1-pdp-step]'));
    allSteps.forEach(function(step) {
      var name = (step.getAttribute('data-u1-pdp-step') || '').toLowerCase();
      /* Always-visible chapters stay untouched */
      if (ALWAYS_VISIBLE.indexOf(name) !== -1) return;
      /* pack-only (ej. sparky_color/sparky_inserts del Family Pack): jamas en modo solo,
         y en bundle solo si el pack los declara. Ocultos por CSS default (display:none),
         la clase is-pack-active los enciende. */
      var packOnly = step.classList.contains('u1-pdp-step--pack-only');
      if (!allowed) {
        /* Solo / no bundle -> show all chapters (menos los pack-only) */
        step.hidden = packOnly;
        step.setAttribute('aria-hidden', packOnly ? 'true' : 'false');
        if (packOnly) step.classList.remove('is-pack-active');
      } else {
        var show = allowed.indexOf(name) !== -1;
        step.hidden = !show;
        step.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (packOnly) step.classList.toggle('is-pack-active', show);
      }
    });

    /* ── Accessories title + gallery: "Complete your setup" in bundle mode ── */
    var accStep = root.querySelector('[data-u1-pdp-step="accessories"]');
    if (accStep) {
      var accTitle = accStep.querySelector('.u1-pdp-step__title');
      var accMobileTitle = accStep.querySelector('.u1-pdp-step__mobile-title');
      var accMobileGallery = accStep.querySelector('.u1-pdp-mobile-gallery');
      if (accTitle) {
        if (!_origTitles.accessories) _origTitles.accessories = accTitle.textContent;
        accTitle.textContent = isBundleMode ? U1S.complete_setup : _origTitles.accessories;
      }
      if (accMobileTitle) {
        if (!_origTitles.accessoriesMobile) _origTitles.accessoriesMobile = accMobileTitle.textContent;
        accMobileTitle.textContent = isBundleMode ? U1S.complete_setup : _origTitles.accessoriesMobile;
      }
      /* Hide mobile gallery in bundle mode — accessories don't need a hero image */
      if (accMobileGallery) {
        accMobileGallery.hidden = isBundleMode;
      }
    }

    /* ── Filter accessories already included in the bundle ── */
    filterBundleAccessories(bp);

    /* ── Generic bundle-hide: hide/show any element with data-u1-pdp-bundle-hide ── */
    root.querySelectorAll('[data-u1-pdp-bundle-hide]').forEach(function(el) {
      el.hidden = isBundleMode;
      el.setAttribute('aria-hidden', isBundleMode ? 'true' : 'false');
    });

    /* ── Family Pack: re-sincroniza prefijos de titulo (AURA Color / AURA Size) ── */
    try { if (root._u1FamRetitle) root._u1FamRetitle(); } catch (_eF) { /* noop */ }
  }

  /** Hide accessory cards whose product is already a component of the active bundle */
  function filterBundleAccessories(bp) {
    var accBtns = Array.from(root.querySelectorAll('[data-u1-pdp-step="accessories"] [data-u1-pdp-accessory]'));
    if (!accBtns.length) return;

    /* Collect bundle component handles from all sources */
    var bundleHandles = {};
    if (bp && bp.componentProducts) {
      bp.componentProducts.forEach(function(c) { if (c && c.handle) bundleHandles[c.handle.toLowerCase()] = true; });
    }

    accBtns.forEach(function(btn) {
      var handle = (btn.getAttribute('data-u1-pdp-accessory-handle') || '').toLowerCase();
      var hit = btn.closest('.u1-pdp-card-hit') || btn;
      if (!bp) {
        /* Solo mode -> show all accessories */
        hit.hidden = false;
        return;
      }
      /* Hide if this accessory is included in the bundle */
      hit.hidden = !!bundleHandles[handle];
      /* Also deselect if hidden */
      if (hit.hidden && btn.getAttribute('aria-pressed') === 'true') {
        btn.setAttribute('aria-pressed', 'false');
        btn.classList.remove('is-selected');
        var key = btn.dataset.u1PdpAccessoryKey || btn.dataset.u1PdpAccessoryHandle;
        if (key && state.accessories.has(key)) state.accessories.delete(key);
      }
    });
    /* Si el pack ya incluye TODOS los accesorios, el chapter queda sin cards:
       esconderlo entero para que no flote el titulo solo (caso Complete Pack
       de Smart Light: Remote + Mount Pack incluidos). */
    try {
      var _accStep = root.querySelector('[data-u1-pdp-step="accessories"]');
      if (_accStep) {
        var _accVisibles = 0;
        accBtns.forEach(function(b) {
          var h2 = b.closest('.u1-pdp-card-hit') || b;
          if (!h2.hidden) _accVisibles += 1;
        });
        _accStep.hidden = _accVisibles === 0;
        _accStep.setAttribute('aria-hidden', _accVisibles === 0 ? 'true' : 'false');
      }
    } catch (_eAS) {}
  }


  /* ──────────────────────────────────────────────────────────────────────
     3. HEADING, URL, PRICING HELPERS
     ────────────────────────────────────────────────────────────────────── */

  function getCardById(packId) {
    for (var i = 0; i < bpEls.cards.length; i++) {
      if (bpEls.cards[i].getAttribute('data-pack-id') === packId) return bpEls.cards[i];
    }
    return null;
  }

  /* Heading stays fixed — never change the customizer title on bundle switch */
  function updateHeading() {}

  function syncUrl(packId) {
    var url = new URL(window.location);
    if (packId && packId !== 'solo') { url.searchParams.set('bundle', packId); }
    else { url.searchParams.delete('bundle'); }
    window.history.replaceState({}, '', url);
  }

  function notifyPricing() {
    try { if (typeof updateAtcTotal === 'function') updateAtcTotal(); } catch (_e) {}
    try { if (typeof updateSummary === 'function') updateSummary(); } catch (_e) {}
  }


  /* ──────────────────────────────────────────────────────────────────────
     4. SELECT PACK
     ────────────────────────────────────────────────────────────────────── */

  function _escHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  /** Extract unique product names from bundle option names.
      e.g. "AURA Mips (Color)" -> "AURA Mips" */
  function _extractNamesFromOptions(opts) {
    var seen = {};
    var names = [];
    (opts || []).forEach(function(o) {
      var raw = (o.name || '').split('(')[0].trim();
      if (raw && !seen[raw]) { seen[raw] = true; names.push(raw); }
    });
    return names;
  }

  /** Parse bundle options to get component qualifiers.
      Options follow "Product Name (Option Type)" format.
      Skips Color/Size (not meaningful for naming), keeps Style/Model/Lens etc.
      Returns map: productName → qualifier string, e.g. { "Helmet Visor": "Adaptive" }
      or { "Helmet Visor": "Clear or Tinted" } when multiple values. */
  function _getComponentQualifiers(bp) {
    if (!bp || !bp.options || !bp.options.length) return null;
    var SKIP = ['color', 'colour', 'size'];
    var map = {};
    bp.options.forEach(function(opt) {
      var name = (opt.name || '');
      var idx = name.indexOf('(');
      if (idx === -1) return;
      var prod = name.substring(0, idx).trim();
      var type = name.substring(idx + 1).replace(/\)\s*$/, '').trim().toLowerCase();
      if (!prod || SKIP.indexOf(type) !== -1) return;
      var vals = (opt.values || []).filter(Boolean);
      if (!vals.length) return;
      var label = vals.length === 1 ? vals[0] : vals.join(' or ');
      map[prod] = map[prod] ? (map[prod] + ', ' + label) : label;
    });
    return Object.keys(map).length ? map : null;
  }

  /** Populate a card's component list from bundle JSON data.
      Always prepends the main product name, then adds bundle extras.
      Enriches names with variant qualifiers from bundle options,
      e.g. "Helmet Visor" → "Helmet Visor (Adaptive)". */
  var _mainProductTitle = root.getAttribute('data-u1-pdp-product-title') || '';
  /* Variante B: miniatura del casco = primera foto de la galeria del color elegido (o la
     default), pedida a 96px. Los productos del pack traen "image" en el JSON. */
  function _u1BThumbUrl(src) { return String(src || '').replace(/([?&])width=\d+/, '$1width=96'); }
  /* Miniatura del casco: featured_image de la variante del color elegido (foto de producto
     con aire alrededor, misma escala que la del remote), no el recorte lateral de la galeria
     que llenaba el cuadro entero (Fermin 2026-09-30: "quedan todas de distintos tamanos").
     Sin color o sin foto de variante cae al comportamiento anterior. */
  var _u1BThumbMap = null;
  function _u1BThumbFromMap() {
    try {
      if (_u1BThumbMap === null) { _u1BThumbMap = JSON.parse(root.getAttribute('data-u1-b-thumbs') || '{}') || {}; }
      var c = String(state.color || '').trim().toLowerCase();
      return (c && _u1BThumbMap[c]) ? String(_u1BThumbMap[c]) : '';
    } catch (_eM) { _u1BThumbMap = {}; return ''; }
  }
  function _u1BVariantThumb() {
    try {
      var fm = _u1BThumbFromMap();
      if (fm) return fm;
      var c = String(state.color || '').trim().toLowerCase();
      if (!c || !variants || !variants.length) return '';
      for (var i = 0; i < variants.length; i++) {
        var x = variants[i]; if (!x || !x.featured_image) continue;
        var opts = [x.option1, x.option2, x.option3].concat(x.options || []);
        var hit = false;
        for (var k = 0; k < opts.length; k++) { if (String(opts[k] || '').trim().toLowerCase() === c) { hit = true; break; } }
        if (!hit) continue;
        var src = typeof x.featured_image === 'string' ? x.featured_image : (x.featured_image.src || '');
        src = String(src || ''); if (!src) continue;
        if (/[?&]width=\d+/.test(src)) return _u1BThumbUrl(src);
        return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=96';
      }
      return '';
    } catch (_eV) { return ''; }
  }
  function _u1BMainThumbSrc() {
    var vs = _u1BVariantThumb();
    if (vs) return vs;
    var list = null;
    try { list = getGalleryImagesForColor(state.color); } catch (_e) { list = null; }
    var src = (list && list[0] && list[0].src) ? list[0].src : (defaultGallerySrc || '');
    /* Sin color elegido y sin default: la foto que esta mostrando la galeria ahora */
    if (!src) {
      try { var g = root.querySelector('[data-u1-pdp-gallery] [data-u1-pdp-slide] img'); src = g ? (g.currentSrc || g.getAttribute('src') || '') : ''; } catch (_e2) { src = ''; }
    }
    return _u1BThumbUrl(src);
  }
  /* Precarga de miniaturas (Fermin 2026-09-30, "mucho ruido visual al abrir un pack"): las
     fotos de los productos y las del casco por color se piden una vez al arrancar, asi al
     abrir una card aparecen todas juntas en vez de ir cayendo de a una. Son ~10 KB cada una. */
  (function _u1BPrefetchThumbs() {
    try {
      var urls = [];
      try { var m = JSON.parse(root.getAttribute('data-u1-b-thumbs') || '{}') || {}; Object.keys(m).forEach(function (k) { if (m[k]) urls.push(String(m[k])); }); } catch (_e1) {}
      try {
        var _el = root.querySelector('[data-u1-pdp-bundle-packs]');
        var _packs = _el ? (JSON.parse(_el.textContent || '[]') || []) : [];
        _packs.forEach(function (bp) { ((bp && bp.componentProducts) || []).forEach(function (c) { if (c && c.image) urls.push(String(c.image)); }); });
      } catch (_e2) {}
      var seen = {};
      var go = function () { urls.forEach(function (u) { if (seen[u]) return; seen[u] = true; var im = new Image(); im.decoding = 'async'; im.src = u; }); };
      if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 2000 }); else window.setTimeout(go, 800);
    } catch (_e) { /* noop */ }
  })();
  /* Miniatura del SEGUNDO casco en packs de 2 cascos (2x AURA, AURA + NEON): sigue el color elegido en el chapter
     del segundo casco. Mismo producto que la PDP -> la misma foto de producto que el principal (mapa de
     miniaturas por color); otro producto -> la foto de su variante (data-u1-pdp-adult-color-imgs) */
  function _u1BAdultThumb(packHandle) {
    try {
      var g = packHandle ? document.querySelector('[data-u1-pdp-adult-color-picker] [data-u1-adult-group="' + packHandle + '"]') : null;
      if (!g) return '';
      var sw = g.querySelector('[data-u1-pdp-adult-color].is-selected') || g.querySelector('[data-u1-pdp-adult-color]');
      if (!sw) return '';
      var name = String(sw.getAttribute('data-u1-pdp-adult-color-name') || '').trim().toLowerCase();
      var ah = String(g.getAttribute('data-u1-adult-handle') || '').toLowerCase();
      var mh = String(root.dataset.u1PdpProductHandle || '').toLowerCase();
      if (ah && ah === mh) {
        if (_u1BThumbMap === null) { try { _u1BThumbMap = JSON.parse(root.getAttribute('data-u1-b-thumbs') || '{}') || {}; } catch (_eTm) { _u1BThumbMap = {}; } }
        if (name && _u1BThumbMap[name]) return String(_u1BThumbMap[name]);
      }
      var imgs = JSON.parse(sw.getAttribute('data-u1-pdp-adult-color-imgs') || '[]') || [];
      var src = String(imgs[0] || '');
      if (!src) return '';
      return /[?&]width=\d+/.test(src) ? _u1BThumbUrl(src) : src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=96';
    } catch (_eAT) { return ''; }
  }
  root._u1BSyncAdultThumbs = function () {
    root.querySelectorAll('[data-u1-b-adult-thumb]').forEach(function (img) {
      var card = img.closest('[data-pack-handle]');
      var src = _u1BAdultThumb(card ? card.getAttribute('data-pack-handle') : '');
      if (!src) return;
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.hidden = false;
    });
  };
  root._u1BSyncMainThumbs = function (imgs) {
    var src = _u1BVariantThumb() || ((imgs && imgs[0] && imgs[0].src) ? _u1BThumbUrl(imgs[0].src) : _u1BMainThumbSrc());
    if (!src) return;
    root.querySelectorAll('[data-u1-b-main-thumb]').forEach(function (img) {
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.hidden = false;
    });
  };

  /* Version B: el item del regalo en la lista del pack lleva 'Free' adelante */
  function _u1IsGiftName(bp, name) {
    var gc = _u1PackGiftComp(bp);
    return !!(gc && gc.title && String(name || '').indexOf(String(gc.title)) === 0);
  }
  /* Regalo del Flash Gift en la lista del pack (Figma de Fermin 23/10): al final, en rojo y con el icono de regalo
     del set U1 (se toma de la card del Flash Gift, que ya lo trae renderizado) */
  function _u1GiftLabelHtml(name) {
    var ic = '';
    try { var el = root.querySelector('.u1-pdp-fgift__icon'); ic = el ? el.innerHTML : ''; } catch (_eGi) {}
    return '<span class="u1-pdp-bundle-card__gift-name">' + (ic ? '<span class="u1-pdp-bundle-card__gift-icon" aria-hidden="true">' + ic + '</span>' : '')
      + '<span><b class="u1-pdp-bundle-card__free">' + _escHtml(_u1FgText('data-u1-fg-free')) + '</b> ' + _escHtml(name) + '</span></span>';
  }
  function populateComponents(card, bp) {
    var container = card.querySelector('[data-u1-pdp-bundle-components]');
    if (!container) return;
    var list = container.querySelector('.u1-pdp-bundle-card__component-list');
    if (!list) return;
    /* Only populate once */
    if (list.children.length > 0) return;

    var items = [];
    var _u1BMainSrc = _u1BMainThumbSrc();
    /* Descripcion por producto = texto del tooltip (metafield custom.bundle_tooltip),
       ya viene en data-u1-tooltips como { "titulo en minusculas": "texto" } */
    var _tt = {};
    try { _tt = JSON.parse(container.getAttribute('data-u1-tooltips') || '{}') || {}; } catch (_eT) { _tt = {}; }
    var _descFor = function (title) { return String(_tt[String(title || '').toLowerCase()] || '').trim(); };
    /* 1) Manual override: componentLabels from block settings (sin miniaturas) */
    var _labels = (bp.componentLabels || '').trim();
    if (_labels) {
      /* Los labels manuales se cruzan por titulo con el producto principal y con los del
         pack para recuperar la foto (ej. "Helmet Visor (Clear or Tinted)" -> Helmet Visor) */
      var _comps = bp.componentProducts || [];
      _labels.split(',').forEach(function(s) {
        var name = s.trim();
        if (!name) return;
        var nl = name.toLowerCase();
        var img = '';
        var desc = '';
        /* Gana la coincidencia MAS LARGA: "Smart Light Mount Pack" empieza como "Smart Light" (producto principal)
           y antes se llevaba su foto y su descripcion (Carlos 21/10) */
        /* Puntaje: igual = gana siempre; el label empieza con el titulo = largo del titulo; el titulo empieza con el label = largo del label */
        var _score = function (t) { return !t ? 0 : (nl === t ? 1e6 : (nl.indexOf(t) === 0 ? t.length : (t.indexOf(nl) === 0 ? nl.length : 0))); };
        var hit = null, hitLen = 0;
        _comps.forEach(function(c) {
          var sc = _score(String((c && c.title) || '').toLowerCase());
          if (sc > hitLen) { hit = c; hitLen = sc; }
        });
        var mainLc = _mainProductTitle ? _mainProductTitle.toLowerCase() : '';
        var mainSc = mainLc && nl.indexOf(mainLc) === 0 ? (nl === mainLc ? 1e6 : mainLc.length) : 0;
        if (mainSc > 0 && mainSc >= hitLen) {
          img = '__main__';
          desc = _descFor(_mainProductTitle);
        } else if (hit) {
          if (hit.image) img = hit.image;
          desc = _descFor(hit.title);
        }
        items.push({ name: name, img: img, desc: desc, comp: img === '__main__' ? null : hit });
      });
    } else {
      /* 2) Auto-detect with qualifier enrichment */
      var coveredBase = {};
      function _add(displayName, baseName, img) {
        var key = baseName || displayName;
        if (!displayName || coveredBase[key]) return;
        coveredBase[key] = true;
        items.push({ name: displayName, img: img || '', desc: _descFor(key) });
      }
      /* Always start with main product */
      if (_mainProductTitle) _add(_mainProductTitle, null, '__main__');
      var quals = _getComponentQualifiers(bp);
      var baseNames = [];
      var baseImgs = {};
      var seenBase = {};
      function _pushBase(n) { if (n && !seenBase[n]) { seenBase[n] = true; baseNames.push(n); } }
      if (bp.componentProducts && bp.componentProducts.length) {
        bp.componentProducts.forEach(function(c) {
          if (!c || !c.title) return;
          _pushBase(c.title);
          if (c.image) baseImgs[c.title] = c.image;
        });
      }
      baseNames.forEach(function(name) {
        if (quals && quals[name]) {
          _add(name + ' (' + quals[name] + ')', name, baseImgs[name]);
        } else {
          _add(name, name, baseImgs[name]);
        }
      });
    }
    if (!items.length) {
      container.style.display = 'none';
      return;
    }
    /* Pack de 2 cascos: el segundo casco de la lista (otro "__main__" o el componente casco) sigue el color del
       chapter del segundo casco */
    if (String(bp.chapters || '').indexOf('adult_color') !== -1) {
      var _adComp = null;
      (bp.componentProducts || []).forEach(function (c) { if (!_adComp && c && /aura|neon/.test(String(c.handle || ''))) _adComp = c; });
      var _helm = items.filter(function (it) { return it.img === '__main__' || (_adComp && it.comp === _adComp); });
      if (_helm.length >= 2) _helm[1].adult = true;
    }
    var html = '';
    items = items.filter(function(it) { return !_u1IsGiftName(bp, it.name); }).concat(items.filter(function(it) { return _u1IsGiftName(bp, it.name); }));
    items.forEach(function(it) {
      var isAdult = !!it.adult;
      var isMain = it.img === '__main__' && !isAdult;
      var src = isAdult ? (_u1BAdultThumb(bp.packHandle) || (it.img === '__main__' ? _u1BMainSrc : it.img)) : (isMain ? _u1BMainSrc : it.img);
      /* El casco lleva SIEMPRE su <img> (oculto si aun no hay color) para que el sync lo encuentre */
      var imgTag = (src || isMain)
        ? '<img class="u1-pdp-bundle-card__thumb-img"' + (src ? ' src="' + _escHtml(src) + '"' : ' hidden') + ' alt="" loading="eager" decoding="async" width="48" height="48"' + (isMain ? ' data-u1-b-main-thumb' : '') + (isAdult ? ' data-u1-b-adult-thumb' : '') + '>'
        : '';
      var thumb = '<span class="u1-pdp-bundle-card__thumb" aria-hidden="true">' + imgTag + '</span>';
      var textHtml = '<span class="u1-pdp-bundle-card__component-text">'
        + '<span class="u1-pdp-bundle-card__component-name">' + (_u1IsGiftName(bp, it.name) ? _u1GiftLabelHtml(it.name) : _escHtml(it.name)) + '</span>'
        + (it.desc ? '<span class="u1-pdp-bundle-card__component-desc">' + _escHtml(it.desc) + '</span>' : '')
        + '</span>';
      html += '<li class="u1-pdp-bundle-card__component-item">' + thumb + textHtml + '</li>';
    });
    list.innerHTML = html;
  }

  /* Colores excluidos de packs (solo compra individual): esconder bolitas en modo bundle */
  var _bundleExcludedColors = String(root.dataset.u1PdpBundleExcludedColors || '')
    .split(',')
    .map(function(s){ return s.trim().toLowerCase().replace(/\s+/g, '-'); })
    .filter(Boolean);
  function applyBundleColorExclusions() {
    if (!_bundleExcludedColors.length) return;
    var active = !!(pkState.activeBundlePack && pkState.activeBundlePack.isSolo !== true);
    var swatches = Array.prototype.slice.call(root.querySelectorAll('[data-u1-pdp-color]'));
    var hidSelected = false;
    swatches.forEach(function(btn) {
      var h = String(btn.dataset.u1PdpValueHandle || '').toLowerCase();
      if (_bundleExcludedColors.indexOf(h) === -1) return;
      btn.classList.toggle('u1-pdp-color__swatch--bundle-hidden', active);
      if (active && btn.classList.contains('is-selected')) hidSelected = true;
    });
    /* Si el color elegido quedo excluido, saltar al primer color visible */
    if (active && hidSelected) {
      var next = swatches.find(function(b) {
        return !b.classList.contains('u1-pdp-color__swatch--bundle-hidden') &&
               !b.classList.contains('is-disabled') && !b.hidden;
      });
      if (next) { try { next.click(); } catch (_e) {  } }
    }
  }

  function selectPack(packId) {
    /* Pack agotado: no seleccionable */
    for (var _si = 0; _si < bpEls.cards.length; _si++) {
      if (bpEls.cards[_si].getAttribute('data-pack-id') === packId &&
          bpEls.cards[_si].classList.contains('u1-pdp-bundle-card--soldout')) return;
    }
    pkState.selectedPackId   = packId;
    pkState.activeBundlePack = (packId && bundlePacksByHandle[packId]) || null;

    /* Visual state on cards + populate components */
    bpEls.cards.forEach(function(c) {
      var sel = c.getAttribute('data-pack-id') === packId;
      c.classList.toggle('is-selected', sel);
      c.setAttribute('aria-pressed', sel ? 'true' : 'false');
      if (sel) {
        var handle = c.getAttribute('data-pack-handle');
        var bp = bundlePacksByHandle[handle] || null;
        if (bp) populateComponents(c, bp);
      }
    });
    root.setAttribute('data-u1-pdp-bundle-active', pkState.activeBundlePack ? 'true' : 'false');
    try { applyBundleColorExclusions(); } catch (_eBx) {  }

    /* ── Reset non-persistent selections (visor, accessories, crash) ── */
    /* Deselect all visors */
    root.querySelectorAll('[data-u1-pdp-visor="true"][aria-pressed="true"]').forEach(function(btn) {
      btn.setAttribute('aria-pressed', 'false');
      btn.classList.remove('is-selected');
      var key = btn.dataset.u1PdpAccessoryKey || btn.dataset.u1PdpAccessoryHandle;
      if (key && state.accessories.has(key)) state.accessories.delete(key);
    });
    /* Deselect all non-visor accessories */
    root.querySelectorAll('[data-u1-pdp-accessory][aria-pressed="true"]:not([data-u1-pdp-visor="true"])').forEach(function(btn) {
      btn.setAttribute('aria-pressed', 'false');
      btn.classList.remove('is-selected');
      var key = btn.dataset.u1PdpAccessoryKey || btn.dataset.u1PdpAccessoryHandle;
      if (key && state.accessories.has(key)) state.accessories.delete(key);
    });
    /* Reset crash replacement to default (standard) */
    var crashCards = root.querySelectorAll('[data-u1-pdp-crash-option]');
    crashCards.forEach(function(c) {
      var isStd = c.getAttribute('data-u1-pdp-crash-option') === 'standard';
      c.classList.toggle('is-selected', isStd);
      c.classList.toggle('is-standard', isStd);
      c.setAttribute('aria-pressed', isStd ? 'true' : 'false');
    });
    if (typeof state.crashVariantId !== 'undefined') state.crashVariantId = 0;

    /* Heading, URL, chapter visibility, visor filter, pricing */
    updateHeading(packId);
    syncUrl(packId);
    applyChapterVisibility(packId);
    filterVisorOptions(pkState.activeBundlePack);
    applyBundleIncludedLabels(pkState.activeBundlePack);
    notifyPricing();
    /* Re-evaluate ATC state — visor requirement may have changed */
    try { if (root._u1UpdateAtcAvailability) root._u1UpdateAtcAvailability(); } catch (_e) {}
    /* Update "Features unlocked" — los componentes del bundle (ej. remote) desbloquean
       features aunque el accesorio no esté seleccionado manualmente. */
    try { if (root._u1SyncFeaturesUnlocked) root._u1SyncFeaturesUnlocked(); } catch (_e) {}
    /* Update mobile galleries for bundle step */
    try { if (root._u1RenderMobileGalleries) root._u1RenderMobileGalleries(); } catch (_e) {}
    /* Update desktop gallery for bundle image (delay to win over transitionGalleryToColor) */
    window.setTimeout(function() {
      try { if (root._u1UpdateBundleGallery) root._u1UpdateBundleGallery(); } catch (_e) {}
    }, 50);
    /* Notify other sections (Inside the Box tabs) */
    try { document.dispatchEvent(new CustomEvent('u1:pdp:pack-change', { detail: { packHandle: packId || '', bundlePack: pkState.activeBundlePack } })); } catch (_e) {}
  }

  /** Hide visor cards whose style is not in the pack's allowedVisorStyles */
  function filterVisorOptions(bp) {
    var visorCards = Array.from(root.querySelectorAll('[data-u1-pdp-visor="true"]'));
    if (!visorCards.length) return;

    /* No bundle or solo -> show all visors */
    if (!bp || bp.isSolo) {
      visorCards.forEach(function(c) {
        var hit = c.closest('.u1-pdp-card-hit');
        if (hit) hit.hidden = false;
      });
      return;
    }

    /* Read allowed visor styles from pack setting (e.g. "Clear,Tinted") */
    var allowedRaw = (bp.allowedVisorStyles || '').trim();
    if (!allowedRaw) {
      /* No filter set -> show all */
      visorCards.forEach(function(c) {
        var hit = c.closest('.u1-pdp-card-hit');
        if (hit) hit.hidden = false;
      });
      return;
    }
    var allowed = allowedRaw.split(',').map(function(s) { return s.trim().toLowerCase(); }).filter(Boolean);
    if (!allowed.length) return;

    visorCards.forEach(function(c) {
      var style = (c.getAttribute('data-u1-pdp-accessory-filter-style') || '').toLowerCase();
      var hit = c.closest('.u1-pdp-card-hit');
      if (!hit) return;
      if (!style) { hit.hidden = false; return; }
      hit.hidden = allowed.indexOf(style) === -1;
    });
  }


  /** Show "Included" instead of price on accessory/visor cards that are part of the bundle */
  function applyBundleIncludedLabels(bp) {
    var allCards = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'));
    var bundleHandles = new Set();
    var hasVisorChapter = false;
    if (bp && !bp.isSolo) {
      (bp.componentProducts || []).forEach(function(cp) { if (cp && cp.handle) bundleHandles.add(cp.handle); });
      hasVisorChapter = (bp.chapters || '').toLowerCase().indexOf('visor') !== -1;
    }
    allCards.forEach(function(c) {
      var priceRow = c.querySelector('[data-u1-pdp-card-price-row]');
      if (!priceRow) return;
      if (!priceRow._u1OrigHTML) priceRow._u1OrigHTML = priceRow.innerHTML;
      var handle = (c.getAttribute('data-u1-pdp-accessory-handle') || '');
      var isVisor = c.getAttribute('data-u1-pdp-visor') === 'true';
      var isIncluded = bp && !bp.isSolo && (bundleHandles.has(handle) || (isVisor && hasVisorChapter));
      /* Visor que no es el componente del pack (Adaptive en Ride/Premium): es un upgrade,
         se muestra el delta contra el visor incluido, ya con el % del pack aplicado */
      var upgradeTxt = '';
      var upgradeHtml = '';
      if (isIncluded && isVisor && !bundleHandles.has(handle)) {
        try {
          var _toCents = parseMoneyCents;
          var _baseCard = null;
          (bp.componentProducts || []).forEach(function(cp) {
            if (_baseCard || !cp || !cp.handle) return;
            _baseCard = root.querySelector('[data-u1-pdp-accessory-handle="' + cp.handle + '"][data-u1-pdp-visor="true"]');
          });
          var _upStr = c.getAttribute('data-u1-pdp-info-price') || '';
          var _upC = _toCents(_upStr);
          var _baseC = _baseCard ? _toCents(_baseCard.getAttribute('data-u1-pdp-info-price')) : 0;
          var _pct = Number(bp.discountPercent || 0) || 0;
          var _full = _upC - _baseC;
          var _delta = Math.round((_upC - _baseC) * (1 - _pct / 100));
          if (_baseCard && _delta > 0) {
            var _sym = (_upStr.match(/^[^0-9]*/) || [''])[0];
            upgradeTxt = '+ ' + formatMoneyCents(_delta);
            /* Carlos 2026-10-02: delta sin descuento tachado, delta con el % del pack y chip del % (mismo chip que la card del pack) */
            if (_pct > 0 && _full > _delta) {
              var _pkBadge = root.querySelector('[data-pack-handle="' + (bp.packHandle || '') + '"] .u1-pdp-bundle-card__badge');
              var _chipStyle = (_pkBadge && _pkBadge.getAttribute('style')) ? ' style="' + _pkBadge.getAttribute('style').replace(/["<>]/g, '') + '"' : '';
              upgradeHtml = '<span class="u1-pdp-card__price u1-text-body-xs u1-pdp-card__price--discount" data-u1-pdp-card-price>'
                + '<span class="u1-pdp-card__price-msrp">+ ' + formatMoneyCents(_full) + '</span>'
                + '<span class="u1-pdp-card__price-final">' + upgradeTxt + '</span>'
                + '<span class="u1-pdp-bundle-card__badge u1-text-body-xs--bold"' + _chipStyle + '>- ' + _pct + '%</span>'
                + '</span>';
            }
          }
        } catch (_eUp) { upgradeTxt = ''; }
      }
      /* pestaña "Why not upgrade?" sobre la card (markup en el picker de visor) */
      try {
        var _hit = c.closest('.u1-pdp-card-hit');
        var _tab = _hit ? _hit.querySelector('[data-u1-pdp-upgrade-tab]') : null;
        if (_tab) _tab.hidden = !upgradeTxt;
        if (_hit) _hit.classList.toggle('u1-pdp-card-hit--upgrade', !!upgradeTxt);
      } catch (_eTab) {}
      if (upgradeTxt) {
        priceRow.innerHTML = upgradeHtml || ('<span class="u1-pdp-card__price u1-text-body-xs" data-u1-pdp-card-price>' + upgradeTxt + '</span>');
        priceRow.style.display = '';
      } else if (isIncluded) {
        /* incluido en el pack: precio original tachado + "Included" (Carlos 2026-10-02) */
        var _incStr = (c.getAttribute('data-u1-pdp-info-price') || '').replace(/["<>&]/g, '');
        priceRow.innerHTML = _incStr
          ? '<span class="u1-pdp-card__price u1-text-body-xs u1-pdp-card__price--discount" data-u1-pdp-card-price><span class="u1-pdp-card__price-msrp">' + _incStr + '</span><span class="u1-pdp-card__price-final">' + U1S.included + '</span></span>'
          : '<span class="u1-pdp-card__price u1-text-body-xs" data-u1-pdp-card-price>' + U1S.included + '</span>';
        priceRow.style.display = '';
      } else {
        priceRow.innerHTML = priceRow._u1OrigHTML;
        priceRow.style.display = '';
      }
    });
  }

  /* ──────────────────────────────────────────────────────────────────────
     5. EVENT LISTENERS & INIT
     ────────────────────────────────────────────────────────────────────── */

  bpEls.cards.forEach(function(card) {
    /* Pre-populate component lists for all cards (hover reveal) */
    var handle = card.getAttribute('data-pack-handle');
    var bp = bundlePacksByHandle[handle] || null;
    if (bp) populateComponents(card, bp);

    card.addEventListener('click', function() {
      selectPack(card.getAttribute('data-pack-id'));
    });
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        selectPack(card.getAttribute('data-pack-id'));
      }
    });
    /* Variante B (Fermin 2026-09-30): sin preview de galeria en hover. La A cambiaba la foto
       de la galeria al pasar el mouse por la card (mouseenter/mouseleave con
       _u1PreviewBundleGallery / _u1RestoreBundleGallery); aca la galeria solo cambia al
       seleccionar el pack. */
  });

  /* URL param auto-select (e.g. ?bundle=aura-ride-pack) */
  var bundleParam = new URLSearchParams(window.location.search).get('bundle');
  if (bundleParam && getCardById(bundleParam)) {
    selectPack(bundleParam);
  } else {
    /* Default: auto-select solo card */
    /* El id de la card solo NO siempre es 'solo': sale de pack_handle del block
       (en SPARKY es 'sparky-solo'), asi que se cae a la card marcada como solo.
       Sin esto la PDP arrancaba sin nada seleccionado. */
    var soloCard = getCardById('solo') || picker.querySelector('.u1-pdp-bundle-card--solo, .u1-pdp-pack-card--solo');
    if (soloCard) selectPack(soloCard.getAttribute('data-pack-id') || 'solo');
  }
  /* ──────────────────────────────────────────────────────────────────────
     GATE POR MODELO (pedido de Fermin 2026-07-31, caso FARO en UK)
     En las PDPs con chapter de modelo (ej. FARO vs FARO Mips) hay packs que
     solo valen para uno de los dos. La card declara su modelo en
     `required_model_handle` y aca se aplica:
       · card con modelo distinto al elegido -> se esconde
       · si el pack activo se esconde -> se vuelve al card solo, en silencio
       · si no queda ningun pack visible -> se esconde el chapter completo
     ────────────────────────────────────────────────────────────────────── */
  function filterPacksByModel(modelHandle) {
    /* Normaliza a handle: en modo "productos separados" (FARO) ya llega como
       faro-mips, pero en modo variante (NEON) llega el valor crudo de la opcion,
       "NEON Mips" con espacio y mayusculas. Sin esto nunca matchea y las cards
       quedan escondidas siempre. */
    var norm = function (v) {
      return (v || '').toString().trim().toLowerCase()
        .replace(/['’]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    };
    var mh = norm(modelHandle);
    var visibles = 0;
    var activeOculto = false;
    bpEls.cards.forEach(function(card) {
      var req = norm(card.getAttribute('data-pack-model'));
      /* Sin modelo elegido, una card con gate NO se muestra (antes pasaba todo
         con seleccion vacia; caso Smart Light sin default_model_value) */
      var ok = !req || req === mh;
      card.hidden = !ok;
      card.setAttribute('aria-hidden', ok ? 'false' : 'true');
      var esSolo = card.classList.contains('u1-pdp-bundle-card--solo');
      if (ok && !esSolo) visibles += 1;
      if (!ok && card.getAttribute('data-pack-id') === pkState.selectedPackId) activeOculto = true;
    });
    if (activeOculto) {
      var sc = getCardById('solo') || picker.querySelector('.u1-pdp-bundle-card--solo, .u1-pdp-pack-card--solo');
      if (sc) selectPack(sc.getAttribute('data-pack-id') || 'solo');
    }
    /* Sin packs para este modelo no tiene sentido mostrar el chapter.
       La decision se publica en el dataset porque el gate por variantes
       (bundle_only_variant_ids) fuerza a mostrar el chapter en cada update de
       seleccion y, si no, volvia a abrirlo dejando solo el titulo colgado. */
    var ocultar = visibles === 0;
    root.dataset.u1PackGateHidden = ocultar ? '1' : '0';
    var step = root.querySelector('[data-u1-pdp-step="bundle"]');
    if (step) {
      step.hidden = ocultar;
      step.setAttribute('aria-hidden', ocultar ? 'true' : 'false');
    }
  }
  root._u1FilterPacksByModel = filterPacksByModel;

  /* Estado inicial: si la PDP tiene chapter de modelo, se aplica el gate al cargar
     leyendo el modelo ya seleccionado (o el default del setting). Sin esto, una card
     con modelo declarado se veria hasta que el cliente toque el chapter. */
  (function () {
    try {
      /* Solo si hay alguna card con gate declarado */
      var hasGate = bpEls.cards.some(function (c) { return (c.getAttribute('data-pack-model') || '') !== ''; });
      if (!hasGate) return;
      var mStep = root.querySelector('[data-u1-pdp-step="product_model"]');
      if (mStep) {
        var run = function () {
          var sel = mStep.querySelector('[data-u1-pdp-product-model].is-selected');
          var h = sel ? sel.getAttribute('data-u1-pdp-product-model-handle')
                      : (root.dataset.u1PdpDefaultProductModel || '');
          filterPacksByModel(h || '');
        };
        run();
        [200, 800, 1800].forEach(function (ms) { window.setTimeout(run, ms); });
        return;
      }
      /* Template light (ej. Smart Light): el chapter es "model" (cards con qty).
         El gate lee el TITULO de la card seleccionada (coincide con el valor de
         la opcion Model) al cargar y en cada click. */
      var lStep = root.querySelector('[data-u1-pdp-step="model"]');
      if (!lStep) return;
      var runLight = function () {
        var sel = lStep.querySelector('[data-u1-pdp-model].is-selected');
        var t = sel ? sel.querySelector('[data-u1-pdp-card-title]') : null;
        filterPacksByModel(t ? (t.textContent || '').trim() : '');
      };
      runLight();
      [200, 800, 1800].forEach(function (ms) { window.setTimeout(runLight, ms); });
      root.addEventListener('click', function (e) {
        var card = e.target && e.target.closest ? e.target.closest('[data-u1-pdp-step="model"] [data-u1-pdp-model]') : null;
        if (!card) return;
        window.setTimeout(runLight, 0);
      });
      /* Smart Light: Pro Dual preseleccionado al cargar (equivalente al
         default_model_value de NEON, que en template light no aplica) */
      if (((root.dataset.u1PdpProductHandle || '').indexOf('smart-light') !== -1)) {
        window.setTimeout(function () {
          try {
            if (lStep.querySelector('[data-u1-pdp-model].is-selected')) return;
            var mcards = lStep.querySelectorAll('[data-u1-pdp-model]');
            for (var mi = 0; mi < mcards.length; mi++) {
              var mt = mcards[mi].querySelector('[data-u1-pdp-card-title]');
              if (mt && /pro dual/i.test(mt.textContent || '')) { mcards[mi].click(); break; }
            }
          } catch (_eDM) {}
        }, 250);
      }
    } catch (_e) {}
  })();

  /* Re-apply included labels after DOM is fully ready */
  setTimeout(function() { try { applyBundleIncludedLabels(pkState.activeBundlePack); } catch(_e) {} }, 300);
  /* Sync "features unlocked" una vez que el pack selector ya está listo — el select
     inicial (default / deep-link ?bundle=) corre antes de asignar root._packSelector. */
  setTimeout(function() { try { if (root._u1SyncFeaturesUnlocked) root._u1SyncFeaturesUnlocked(); } catch(_e) {} }, 0);


  /* ──────────────────────────────────────────────────────────────────────
     6. PUBLIC API  (keeps compat with _getBundleVariantNow + breakdown)
     ────────────────────────────────────────────────────────────────────── */

  root._packSelector = {
    selectPack:          selectPack,
    goBack:              function() {
      var sc = getCardById('solo') || picker.querySelector('.u1-pdp-bundle-card--solo, .u1-pdp-pack-card--solo');
      selectPack(sc ? (sc.getAttribute('data-pack-id') || 'solo') : 'solo');
    },
    getSelectedPackId:   function() { return pkState.selectedPackId; },
    getActiveBundlePack: function() { return pkState.activeBundlePack; },

    /* Find the bundle variant matching the user's current selections.
       @param selections  object with color, size, visorStyle
       @returns variant object or null */
    findBundleVariant: function(selections) {
      var bp = pkState.activeBundlePack;
      if (!bp || !bp.variants) return null;

      var sel  = selections || {};
      var opts = bp.options || [];

      var sizeIdx = -1, colorIdx = -1, visorIdx = -1;
      opts.forEach(function(o, i) {
        var n = (o.name || '').toLowerCase();
        if (n.indexOf('size') !== -1)                                                      sizeIdx  = i;
        else if (n.indexOf('color') !== -1 || n.indexOf('colour') !== -1)                  colorIdx = i;
        else if (n.indexOf('visor') !== -1 || n.indexOf('style') !== -1 || n.indexOf('lens') !== -1) visorIdx = i;
      });

      var getOpt = function(v, idx) {
        return idx === 0 ? v.option1 : idx === 1 ? v.option2 : idx === 2 ? v.option3 : null;
      };

      var match = bp.variants.filter(function(v) {
        if (sel.color      && colorIdx >= 0 && getOpt(v, colorIdx) !== sel.color)      return false;
        if (sel.size       && sizeIdx  >= 0 && getOpt(v, sizeIdx)  !== sel.size)       return false;
        if (sel.visorStyle && visorIdx >= 0 && getOpt(v, visorIdx) !== sel.visorStyle) return false;
        return true;
      });

      var avail = match.filter(function(v) { return v.available; });
      return avail[0] || match[0] || null;
    }
  };
})();

/* ---- antes snippets/u1-pdp-customizer-js-b.liquid ---- */
const findVariantByOptions = (optsMap, { preferAvailable } = { preferAvailable: true }) => {
if (!variants || variants.length === 0) return null;
const matches = (v) => {
if (!v) return false;
for (const [h, val] of optsMap.entries()) {
const got = getVariantOptionByHandle(v, h);
if (!got || got !== val) return false;
}
return true;
};
if (preferAvailable) return variants.find(v => v && v.available && matches(v)) || variants.find(v => v && matches(v)) || null;
return variants.find(v => v && matches(v)) || null;
};
const getColorBadgeType = (colorValue) => {
const h = optionNameHandle(colorValue);
const entry = Array.isArray(colorBadges) ? colorBadges.find(b => b && b.colorHandle === h) : null;
if (entry && typeof entry.badge !== 'undefined' && entry.badge !== null) return String(entry.badge);
return 'none';
};
const setColorBadgeUI = (type) => {
if (!colorBadgeEl) return;
const t = (type || 'none').toString();
const next = (() => {
if (t === 'limited') return { type: 'limited', text: U1S.badge_limited, cls: 'u1-pdp-color__badge--limited' };
if (t === 'sport') return { type: 'sport', text: U1S.badge_sport, cls: 'u1-pdp-color__badge--sport' };
if (t === 'best_seller') return { type: 'best_seller', text: U1S.badge_best, cls: 'u1-pdp-color__badge--best' };
if (t === 'staff_pick') return { type: 'staff_pick', text: U1S.badge_staff, cls: 'u1-pdp-color__badge--staff' };
return { type: 'none', text: '', cls: '' };
})();
const getBadgeMeasureEl = () => {
if (root._u1BadgeMeasureEl) return root._u1BadgeMeasureEl;
const el = document.createElement('div');
el.className = 'u1-pdp-color__badge is-visible';
el.style.position = 'absolute';
el.style.left = '-9999px';
el.style.top = '0';
el.style.visibility = 'hidden';
el.style.pointerEvents = 'none';
el.style.width = 'auto';
el.style.opacity = '0';
el.innerHTML = '<p class="u1-pdp-color__badge-text"></p>';
root.appendChild(el);
root._u1BadgeMeasureEl = el;
window.addEventListener('resize', () => { root._u1BadgeW = null; colorBadgeEl._u1W = undefined; }, { passive: true });
return el;
};
const measureWidth = (cls, text) => {
const key = (cls || '') + '|' + (text || '');
const cache = root._u1BadgeW || (root._u1BadgeW = new Map());
if (cache.has(key)) return cache.get(key);
const m = getBadgeMeasureEl();
m.classList.remove('u1-pdp-color__badge--limited', 'u1-pdp-color__badge--sport', 'u1-pdp-color__badge--best', 'u1-pdp-color__badge--staff', 'u1-pdp-color__badge--soldout');
if (cls) m.classList.add(cls);
const p = m.querySelector('p');
if (p) p.textContent = text || '';
const w = Math.ceil(m.getBoundingClientRect().width || 0);
cache.set(key, w);
return w;
};
const token = String((Number(colorBadgeEl.dataset.u1AnimToken || '0') || 0) + 1);
colorBadgeEl.dataset.u1AnimToken = token;
if (colorBadgeEl._u1AnimTimer) {
window.clearTimeout(colorBadgeEl._u1AnimTimer);
colorBadgeEl._u1AnimTimer = null;
}
const cleanupToAuto = () => {
if (colorBadgeEl.dataset.u1AnimToken !== token) return;
colorBadgeEl.style.width = '';
};
const animateWidth = (fromW, toW, done) => {
if (colorBadgeEl.dataset.u1AnimToken !== token) return;
const f = Math.max(0, Math.ceil(fromW || 0));
const tW = Math.max(0, Math.ceil(toW || 0));
colorBadgeEl.style.width = `${f}px`;
colorBadgeEl._u1W = tW;
window.requestAnimationFrame(() => { window.requestAnimationFrame(() => {
if (colorBadgeEl.dataset.u1AnimToken !== token) return;
colorBadgeEl.style.width = `${tW}px`;
}); });
const onEnd = (e) => {
if (colorBadgeEl.dataset.u1AnimToken !== token) return;
if (!e || e.propertyName !== 'width') return;
colorBadgeEl.removeEventListener('transitionend', onEnd);
done && done();
};
colorBadgeEl.addEventListener('transitionend', onEnd);
colorBadgeEl._u1AnimTimer = window.setTimeout(() => {
if (colorBadgeEl.dataset.u1AnimToken !== token) return;
colorBadgeEl.removeEventListener('transitionend', onEnd);
done && done();
}, 260);
};
const prevVisible = colorBadgeEl.classList.contains('is-visible');
const prevW = (typeof colorBadgeEl._u1W === 'number') ? colorBadgeEl._u1W : Math.ceil(colorBadgeEl.getBoundingClientRect().width || 0);
const prevType = (colorBadgeEl.dataset.u1BadgeType || 'none').toString();
if (next.type === 'none') {
colorBadgeEl.dataset.u1BadgeType = 'none';
colorBadgeEl.setAttribute('aria-hidden', 'true');
const fromW = prevVisible ? prevW : 0;
colorBadgeEl.style.width = `${fromW}px`;
if (colorBadgeTextEl) colorBadgeTextEl.textContent = '';
else colorBadgeEl.textContent = '';
colorBadgeEl.classList.remove('u1-pdp-color__badge--limited', 'u1-pdp-color__badge--sport', 'u1-pdp-color__badge--best', 'u1-pdp-color__badge--staff', 'u1-pdp-color__badge--soldout');
colorBadgeEl.classList.remove('is-visible');
colorBadgeEl._u1W = 0;
window.requestAnimationFrame(() => { window.requestAnimationFrame(() => {
if (colorBadgeEl.dataset.u1AnimToken !== token) return;
colorBadgeEl.style.width = `0px`;
}); });
const onEnd = (e) => {
if (colorBadgeEl.dataset.u1AnimToken !== token) return;
if (!e || e.propertyName !== 'width') return;
colorBadgeEl.removeEventListener('transitionend', onEnd);
cleanupToAuto();
};
colorBadgeEl.addEventListener('transitionend', onEnd);
colorBadgeEl._u1AnimTimer = window.setTimeout(() => {
if (colorBadgeEl.dataset.u1AnimToken !== token) return;
colorBadgeEl.removeEventListener('transitionend', onEnd);
cleanupToAuto();
}, 260);
return;
}
colorBadgeEl.classList.remove('u1-pdp-color__badge--limited', 'u1-pdp-color__badge--sport', 'u1-pdp-color__badge--best', 'u1-pdp-color__badge--staff', 'u1-pdp-color__badge--soldout');
if (next.cls) colorBadgeEl.classList.add(next.cls);
if (colorBadgeTextEl) colorBadgeTextEl.textContent = next.text;
else colorBadgeEl.textContent = next.text;
colorBadgeEl.dataset.u1BadgeType = next.type;
colorBadgeEl.setAttribute('aria-hidden', 'false');
colorBadgeEl.classList.add('is-visible');
const toW = measureWidth(next.cls, next.text);
if (!prevVisible || prevType === 'none') {
animateWidth(0, toW, () => {
cleanupToAuto(); // vuelve a fit-content
});
return;
}
animateWidth(prevW, toW, () => {
cleanupToAuto(); // vuelve a fit-content
});
};
const getColorStatus = (colorValue) => {
if (!colorValue) return { exists: false, available: false };
if (state.size) {
const m = new Map();
if (IS_VARIANT_MODEL_MODE && VARIANT_MODEL_OPTION_HANDLE && state.variantModel) {
m.set(VARIANT_MODEL_OPTION_HANDLE, state.variantModel);
}
if (SIMPLE_MODEL_OPT_HANDLE && state.simpleModelOptionValue) {
m.set(SIMPLE_MODEL_OPT_HANDLE, state.simpleModelOptionValue);
}
m.set(COLOR_HANDLE, colorValue);
m.set(SIZE_HANDLE, state.size);
const v = findVariantByOptions(m, { preferAvailable: false });
return { exists: !!v, available: !!(v && v.available), variant: v || null };
}
const variantMatchesModel = (v) => {
if (IS_VARIANT_MODEL_MODE && VARIANT_MODEL_OPTION_HANDLE && state.variantModel) {
return getVariantOptionByHandle(v, VARIANT_MODEL_OPTION_HANDLE) === state.variantModel;
}
if (SIMPLE_MODEL_OPT_HANDLE && state.simpleModelOptionValue) {
return getVariantOptionByHandle(v, SIMPLE_MODEL_OPT_HANDLE) === state.simpleModelOptionValue;
}
return true;
};
const any = variants.find(v => v && getVariantOptionByHandle(v, COLOR_HANDLE) === colorValue && variantMatchesModel(v));
const anyAvail = variants.find(v => v && v.available && getVariantOptionByHandle(v, COLOR_HANDLE) === colorValue && variantMatchesModel(v));
return { exists: !!any, available: !!anyAvail, variant: (anyAvail || any) || null };
};
const setColorDisplay = (colorValue, hoverOnly) => {
const v = (colorValue || '').toString();
if (!v) {
if (colorNameEl) {
colorNameEl.textContent = PLACEHOLDER_COLOR_TEXT;
colorNameEl.classList.add('is-placeholder');
}
if (colorLabelEl && !hoverOnly) { colorLabelEl.textContent = PLACEHOLDER_COLOR_TEXT; }
if (!hoverOnly) { updateStepMobileTitle('color', ''); }
setColorBadgeUI('none');
setColorUnsetUI();
return;
}
if (colorNameEl) {
colorNameEl.textContent = v;
colorNameEl.classList.remove('is-placeholder');
}
if (colorLabelEl && !hoverOnly) { colorLabelEl.textContent = v; }
if (!hoverOnly) { updateStepMobileTitle('color', v); }
setColorBadgeUI(getColorBadgeType(v));
setColorUnsetUI();
};
const updateColorAvailability = () => {
if (!colorButtons || colorButtons.length === 0) return;
colorButtons.forEach(btn => {
const v = btn.dataset.u1PdpValue || '';
const status = getColorStatus(v);
const disabled = !status.exists;
btn.classList.toggle('is-disabled', disabled);
btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
btn.hidden = disabled;
const oos = status.exists && !status.available;
btn.classList.toggle('is-oos', oos);
const colorVariants = variants.filter(vr => vr && getVariantOptionByHandle(vr, COLOR_HANDLE) === v);
const total = colorVariants.length;
const availCount = colorVariants.filter(vr => vr && vr.available).length;
const someSoldOut = total > 0 && availCount > 0 && availCount < total;
const allSoldOut = total > 0 && availCount === 0;
btn.classList.toggle('is-partial-soldout', someSoldOut);
btn.classList.toggle('is-soldout', allSoldOut);
});
if (state.color) {
const selectedBtn = colorButtons.find(b => (b.dataset.u1PdpValue || '') === state.color);
if (selectedBtn && selectedBtn.getAttribute('aria-disabled') === 'true') {
const memorized = (IS_VARIANT_MODEL_MODE && state.variantModel)
? (colorMemory.get(state.variantModel) || null) : null;
const memorizedBtn = memorized
? colorButtons.find(b => b.getAttribute('aria-disabled') !== 'true' && (b.dataset.u1PdpValue || '') === memorized)
: null;
const next = memorizedBtn || colorButtons.find(b => b.getAttribute('aria-disabled') !== 'true');
if (next) {
state.color = next.dataset.u1PdpValue || null;
setColorDisplay(state.color);
}
}
}
setSelectedButton(colorButtons, state.color || null);
};
const updateSizeAvailability = () => {
if (!sizeButtons || sizeButtons.length === 0) return;
const mBase = new Map();
if (IS_VARIANT_MODEL_MODE && VARIANT_MODEL_OPTION_HANDLE && state.variantModel) {
mBase.set(VARIANT_MODEL_OPTION_HANDLE, state.variantModel);
}
if (SIMPLE_MODEL_OPT_HANDLE && state.simpleModelOptionValue) {
mBase.set(SIMPLE_MODEL_OPT_HANDLE, state.simpleModelOptionValue);
}
if (HAS_COLOR_OPTION && state.color) {
mBase.set(COLOR_HANDLE, state.color);
}
if (HAS_COLOR_CHAPTER && HAS_COLOR_OPTION && !state.color && !state.simpleModelOptionValue && !(IS_VARIANT_MODEL_MODE && state.variantModel)) {
sizeButtons.forEach((btn) => {
btn.classList.remove('is-oos');
btn.setAttribute('aria-disabled', 'false');
});
return;
}
sizeButtons.forEach((btn) => {
const sVal = btn.dataset.u1PdpValue || '';
const m = new Map(mBase);
m.set(SIZE_HANDLE, sVal);
const v = findVariantByOptions(m, { preferAvailable: false });
const exists = !!v;
const available = !!(v && v.available && !isVariantOosNonPreorder(v));
const oos = exists && !available;
btn.classList.toggle('is-oos', oos);
btn.setAttribute('aria-disabled', exists ? 'false' : 'true');
});
};
const findVariant = (color, size) => {
if (!variants || variants.length === 0) return null;
const wanted = getSelectedOptionsMap();
const isHiddenColorVariant = (v) => {
if (!v) return false;
if (!HAS_COLOR_OPTION || !COLOR_HANDLE) return false;
if (!HIDDEN_COLOR_HANDLES || HIDDEN_COLOR_HANDLES.size === 0) return false;
const c = getVariantOptionByHandle(v, COLOR_HANDLE);
const ch = optionNameHandle(c || '');
return !!(ch && HIDDEN_COLOR_HANDLES.has(ch));
};
const matchesWanted = (v) => {
if (!v) return false;
for (const [h, val] of wanted.entries()) {
const got = getVariantOptionByHandle(v, h);
if (!got || got !== val) return false;
}
return true;
};
const exactAvail = variants.find(v => v && v.available && !isHiddenColorVariant(v) && matchesWanted(v));
if (exactAvail) return exactAvail;
const exact = variants.find(v => v && !isHiddenColorVariant(v) && matchesWanted(v));
if (exact) return exact;
if (state.size) {
const vSize = variants.find(v => v && v.available && !isHiddenColorVariant(v) && getVariantOptionByHandle(v, SIZE_HANDLE) === state.size);
if (vSize) return vSize;
}
const v =
variants.find(v => v && v.available && !isHiddenColorVariant(v)) ||
variants.find(v => v && !isHiddenColorVariant(v)) ||
variants.find(v => v && v.available) ||
variants[0];
return v || null;
};
const setSelectedButton = (buttons, value) => {
buttons.forEach(btn => {
const isOn = btn.dataset.u1PdpValue === value;
btn.classList.toggle('is-selected', isOn);
btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
});
};

const syncConditionalFreeAccessories = () => {
try {
const curVid = Number(state && state.variantId ? state.variantId : 0) || 0;
const btns = Array.from(root.querySelectorAll('[data-u1-pdp-accessory][data-u1-pdp-free-variant-ids]'));
if (!btns.length) return;
let changed = false;
btns.forEach((btn) => {
const idsRaw = (btn.dataset.u1PdpFreeVariantIds || '').toString();
const ids = idsRaw.split(',').map(s => Number(String(s).trim())).filter(n => n > 0);
const isFreeNow = curVid > 0 && ids.indexOf(curVid) !== -1;
const wasFree = btn.getAttribute('data-u1-pdp-free') === 'true';
if (isFreeNow === wasFree) return;
changed = true;
const handle = btn.dataset.u1PdpAccessoryHandle || '';
const key = btn.dataset.u1PdpAccessoryKey || handle;
const priceRow = btn.querySelector('[data-u1-pdp-card-price-row]');
if (isFreeNow) {
  if (priceRow && btn._u1NormalPriceHTML == null) btn._u1NormalPriceHTML = priceRow.innerHTML;
  const label = btn.dataset.u1PdpFreeLabel || U1S.free;
  const normalPrice = btn.dataset.u1PdpInfoPriceNormal || '';
  if (priceRow) {
    priceRow.innerHTML = '<span class="u1-pdp-card__price u1-text-body-xs u1-pdp-card__price--discount">' +
      (normalPrice ? '<span class="u1-pdp-card__price-msrp">' + normalPrice + '</span>' : '') +
      '<span class="u1-pdp-card__price-final">' + label + '</span></span>';
  }
  btn.classList.add('u1-pdp-card--free', 'is-selected');
  btn.setAttribute('data-u1-pdp-free', 'true');
  btn.setAttribute('aria-pressed', 'true');
  btn.dataset.u1PdpInfoPrice = label;
  const syncSize = btn.dataset.u1PdpAccessorySyncSize === 'true';
  const fixedVariantId = parseVariantId(btn.dataset.u1PdpAccessoryVariantId || '');
  const filterOptions = readAccessoryFilterOptions(btn);
  const variantId = fixedVariantId || resolveAccessoryVariantId({ handle, size: state.size, preferSize: syncSize, fixedVariantId: 0, filterOptions });
  if (variantId) {
    const discountCode = (btn.dataset.u1PdpDiscountCode || '').toString().trim();
    const discountPercent = Number(btn.dataset.u1PdpDiscountPercent || 0) || 0;
    state.accessories.set(key, { handle, variantId, qty: 1, syncSize, fixedVariantId: fixedVariantId || 0, discountCode, discountPercent, filterOptions: filterOptions || null, free: true });
  }
} else {
  if (priceRow && btn._u1NormalPriceHTML != null) priceRow.innerHTML = btn._u1NormalPriceHTML;
  btn.classList.remove('u1-pdp-card--free', 'is-selected');
  btn.removeAttribute('data-u1-pdp-free');
  btn.setAttribute('aria-pressed', 'false');
  btn.dataset.u1PdpInfoPrice = btn.dataset.u1PdpInfoPriceNormal || '';
  state.accessories.delete(key);
}
});
if (changed) {
  try { updateSummary(); } catch (_e) {}
  try { syncFeaturesUnlocked(); } catch (_e) {}
  try { updateAtcAvailability(); } catch (_e) {}
}
} catch (_e) {}
};
const syncMainStateFromVariant = (v) => {
if (!v) return;
state.variantId = v.id;
const nextColor = getVariantOptionByHandle(v, COLOR_HANDLE) || null;
const nextSize = getVariantOptionByHandle(v, SIZE_HANDLE) || null;
if (nextColor && nextColor !== state.color) {
state.color = nextColor;
setSelectedButton(colorButtons, nextColor);
}
if (nextSize && nextSize !== state.size) {
state.size = nextSize;
setSelectedButton(sizeButtons, nextSize);
applySizeActiveIndex();
updateSizePill();
}
setColorDisplay(state.color);
updateColorAvailability();
updateSizeAvailability();
updateRenderScale();
if (!hasCustomGallery) {
const featuredId = v.featured_media && v.featured_media.id ? v.featured_media.id : null;
if (featuredId) {
const idx = slides.findIndex(s => (s.dataset.mediaId || '') === String(featuredId));
if (idx >= 0) {
state.galleryIndex = idx;
scrollGalleryToIndex(idx);
}
}
}
updateSummary();
updateAtcAvailability();
updateSizeAvailability();
try { syncConditionalFreeAccessories(); } catch (_e) {}
emitPdpSelection();
};
const updateVariant = () => {
const needsModel = false;
const needsColor = (() => {
if (TEMPLATE === 'light') return false;
if (!HAS_COLOR_CHAPTER) return false;
if (!HAS_COLOR_OPTION) return false;
return !state.color;
})();
const needsSize = (() => {
if (TEMPLATE === 'light') return false;
if (!HAS_CHAPTER_SIZE) return false;
if (!HAS_SIZE_OPTION) return false;
return !state.size;
})();
if (needsModel || needsColor || needsSize) {
state.variantId = 0;
updateRenderScale();
updateSummary();
updateAtcAvailability();
emitPdpSelection();
return;
}
const v = findVariant(state.color, state.size);
if (!v) {
state.variantId = 0;
updateRenderScale();
updateSummary();
updateAtcAvailability();
emitPdpSelection();
return;
}
syncMainStateFromVariant(v);
};
const getBundleOutOfStockSelections = () => {
const out = []; // [{id,label}]
try {
state.accessories.forEach((entry) => {
if (!entry) return;
const vid = Number(entry.variantId || 0) || 0;
if (!vid) return;
const meta = accessoryVariantMeta.get(Number(vid)) || null;
if (meta && meta.available === false) {
out.push({ id: vid, label: meta.label || entry.handle || String(vid) });
}
});
} catch (_e) {}

try {
const _bpNow = root._packSelector && root._packSelector.getActiveBundlePack ? root._packSelector.getActiveBundlePack() : null;
if (_bpNow && Array.isArray(_bpNow.componentProducts)) {
  const _addedH = new Set();
  state.accessories.forEach(e => { if (e && e.handle) _addedH.add(e.handle.toLowerCase()); });
  const _mainH = (mainProductHandle || '').toLowerCase();
  _bpNow.componentProducts.forEach((cp) => {
    if (!cp || !cp.handle) return;
    const h = cp.handle.toLowerCase();
    if (h === _mainH || _addedH.has(h)) return;

    const catItem = (Array.isArray(accessoriesCatalog) ? accessoriesCatalog : []).find(p => p && (p.handle || '').toLowerCase() === h);
    if (catItem && Array.isArray(catItem.variants)) {
      const _vf = (cp.variantFilter || '').trim().toLowerCase();
      const matches = catItem.variants.filter(vv => !_vf || (vv.option1||'').toLowerCase()===_vf || (vv.option2||'').toLowerCase()===_vf || (vv.option3||'').toLowerCase()===_vf || (vv.title||'').toLowerCase()===_vf);
      const anyAvail = matches.some(vv => vv && vv.available !== false);
      if (matches.length && !anyAvail) {
        out.push({ id: 0, label: cp.title || h });
      }
    }
  });
}
} catch (_eBpc) {}
try {
const crashVid = Number(state.crashVariantId || 0) || 0;
if (crashVid) {
const meta = crashVariantMeta.get(Number(crashVid)) || null;
if (meta && meta.available === false) {
out.push({ id: crashVid, label: meta.label || `Crash Replacement (${crashVid})` });
}
}
} catch (_e2) {}
return out;
};
const updateAtcAvailability = () => {
if (!atcBtn) return;
const v = variants.find(v => v && Number(v.id) === Number(state.variantId)) || null;
const needsModel = (() => {
if (TEMPLATE === 'light') return !state.variantId;
return false;
})();
const needsColor = (() => {
if (TEMPLATE === 'light') return false;
if (!HAS_COLOR_CHAPTER) return false;
if (!HAS_COLOR_OPTION) return false;
return !state.color;
})();
const needsSize = (() => {
if (TEMPLATE === 'light') return false;
if (!HAS_CHAPTER_SIZE) return false;
if (!HAS_SIZE_OPTION) return false;
return !state.size;
})();
const needsHelmetSize = (() => {
if (typeof HAS_HELMET_SIZE_CHAPTER === 'undefined' || !HAS_HELMET_SIZE_CHAPTER) return false;
try {
if (!root.querySelector('[data-u1-pdp-helmet-size-picker]')) return false;
} catch (_e) { return false; }
return !state.helmetSize;
})();
const needsVisor = (() => {
try {

var _ps = root._packSelector;
var _isBundleNow = (_ps && typeof _ps.getActiveBundlePack === 'function' && !!_ps.getActiveBundlePack())
  || root.getAttribute('data-u1-pdp-bundle-active') === 'true';
if (!_isBundleNow) return false;
var visorStep = root.querySelector('[data-u1-pdp-step="visor"]');
if (!visorStep || visorStep.hidden) return false;
var visorCards = visorStep.querySelectorAll('[data-u1-pdp-visor="true"]');
if (!visorCards.length) return false;
var hasSelected = visorStep.querySelector('[data-u1-pdp-visor="true"][aria-pressed="true"]');
return !hasSelected;
} catch (_e) { return false; }
})();
const preorder = !!(v && isVariantPreorder(v));
const oosNonPreorder = !!(v && isVariantOosNonPreorder(v));
const soldOutMain = !!(v && (v.available === false || oosNonPreorder) && !preorder);
const bundleOos = getBundleOutOfStockSelections();
const soldOutBundle = !!(bundleOos && bundleOos.length);
const soldOut = soldOutMain || soldOutBundle;
const softDisabled = (TEMPLATE === 'light')
? (needsModel || needsHelmetSize)
: (needsModel || needsColor || needsSize || needsHelmetSize || needsVisor || _u1GiftNeedsPick());
const hardDisabled = soldOutBundle;
const disabled = (softDisabled || hardDisabled) && !preorder;

atcBtn.disabled = false;
atcBtn.classList.toggle('is-disabled', disabled);
atcBtn.classList.toggle('is-soft-disabled', softDisabled && !hardDisabled && !preorder);
atcBtn.classList.toggle('is-soldout', soldOut && !preorder);
atcBtn.classList.toggle('is-preorder', preorder);
atcBtn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
if (preorder) atcBtn.dataset.u1PdpDisabledReason = '';
else if (softDisabled && !hardDisabled) atcBtn.dataset.u1PdpDisabledReason = 'customize';
else if (soldOutBundle) atcBtn.dataset.u1PdpDisabledReason = 'bundle_oos';
else if (soldOutMain) atcBtn.dataset.u1PdpDisabledReason = 'soldout';
else atcBtn.dataset.u1PdpDisabledReason = '';

const _L = atcBtn.dataset;
const pickEl = atcBtn.querySelector('.u1-pdp-atc__label--pick');
if (pickEl) {
  let pickText = _L.u1LPick || 'Pick your style';
  if (!needsColor && !needsSize && needsVisor) pickText = _L.u1LVisor || 'Select visor';
  else if (!needsColor && !needsSize && !needsVisor && !needsModel && !needsHelmetSize && _u1GiftNeedsPick()) pickText = _u1FgText('data-u1-fg-select') || pickText;
  else if (!needsColor && !needsSize && !needsVisor && needsModel) pickText = _L.u1LModel || 'Select model';
  else if (!needsColor && !needsSize && !needsVisor && needsHelmetSize) pickText = _L.u1LHsize || 'Select helmet size';
  pickEl.textContent = pickText;
}

root.dataset.u1PdpSelectionsComplete = softDisabled ? 'false' : 'true';
const labelEl = atcBtn.querySelector('[data-u1-pdp-atc-label]');
const nextLabel = preorder ? (_L.u1LPre || 'Pre-order') : (soldOut ? (_L.u1LOos || 'Out of stock') : (_L.u1LAdd || 'Add to cart'));
if (labelEl) labelEl.textContent = nextLabel;
else atcBtn.textContent = nextLabel;
updateAtcTotal();
const needsRealSizeForNotify = HAS_CHAPTER_SIZE && HAS_SIZE_OPTION;
const colorReadyForNotify = !(HAS_COLOR_CHAPTER && HAS_COLOR_OPTION) || !!state.color;
const _showHideBanner = (el, show) => {
el.setAttribute('aria-hidden', show ? 'false' : 'true');
if (show) {
if (el.hidden) el.hidden = false;
window.requestAnimationFrame(() => el.classList.add('is-visible'));
} else {
el.classList.remove('is-visible');
if (el._u1HideTimer) window.clearTimeout(el._u1HideTimer);
el._u1HideTimer = window.setTimeout(() => {
if (!el.classList.contains('is-visible')) el.hidden = true;
}, 340);
}
};
const _bannerShouldShow = (ctx) => {
if (ctx === 'helmet') {
let s = !!(state.helmetSize && colorReadyForNotify);
if (needsRealSizeForNotify) s = false;
return s;
}
return needsRealSizeForNotify ? !!(state.color && state.size) : false;
};
// Notify banners (OOS, non-preorder)
Array.from(root.querySelectorAll('[data-u1-pdp-size-notify-wrap]:not([data-u1-pdp-size-preorder-wrap])')).forEach((el) => {
const ctx = String(el.getAttribute('data-u1-pdp-size-notify-context') || 'size');
const show = !!(v && (v.available === false || oosNonPreorder) && !preorder && _bannerShouldShow(ctx));
_showHideBanner(el, show);
});
// Preorder banners
Array.from(root.querySelectorAll('[data-u1-pdp-size-preorder-wrap]')).forEach((el) => {
const ctx = String(el.getAttribute('data-u1-pdp-size-notify-context') || 'size');
const show = !!(preorder && _bannerShouldShow(ctx));
_showHideBanner(el, show);
});
root.querySelectorAll('[data-u1-pdp-size-notify]').forEach((notifyBtn) => {
if (notifyBtn._u1Bound) return;
notifyBtn._u1Bound = true;
notifyBtn.addEventListener('click', openNotifyModal);
});
const _shipTxt = _getPreorderShippingText();
if (_shipTxt) {
root.querySelectorAll('[data-u1-pdp-preorder-ship]').forEach((el) => {
el.textContent = preorder ? (U1S.est_shipping + _shipTxt) : '';
});
}
const preorderShipEl = root.querySelector('[data-u1-pdp-atc-preorder-ship]');
if (preorderShipEl) {
if (preorder && _shipTxt) {
preorderShipEl.textContent = U1S.est_shipping_short + _shipTxt;
preorderShipEl.hidden = false;
preorderShipEl.setAttribute('aria-hidden', 'false');
} else {
preorderShipEl.textContent = '';
preorderShipEl.hidden = true;
preorderShipEl.setAttribute('aria-hidden', 'true');
}
}
try {
const spInput = root.querySelector('[data-u1-pdp-shoppay-id]');
const nv = (v && v.id) ? String(v.id) : '';
if (spInput && nv && spInput.value !== nv) {
spInput.value = nv;
try { spInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (_eSPd) {}
}
const _spW = root.querySelector('.u1-pdp-shoppay-terms');
if (_spW) {
if (!root._u1SpOrig) root._u1SpOrig = _spW.innerHTML;
const _spFix = () => {
try {
const w = root.querySelector('.u1-pdp-shoppay-terms');
if (!w) return;
const f = w.querySelector('form');
const roto = !w.querySelector('shopify-payment-terms') || (f && /stoq|restock|rr-/i.test(String(f.className)));
if (roto && root._u1SpOrig) {
w.innerHTML = root._u1SpOrig;
const inp = w.querySelector('[data-u1-pdp-shoppay-id]');
if (inp) { inp.value = String((state && state.variantId) || nv || ''); try { inp.dispatchEvent(new Event('change', { bubbles: true })); } catch (_e1) {} }
}
const f2 = w.querySelector('form');
if (f2) {
f2.setAttribute('action', '#'); f2.classList.remove('shopify-product-form'); f2.removeAttribute('data-type');
Array.prototype.slice.call(f2.childNodes).forEach((t) => { if (t.nodeType === 3 && t.textContent.trim()) f2.removeChild(t); });
}
} catch (_e0) {}
};
if (!root._u1SpObs) {
_spFix(); window.setTimeout(_spFix, 400);
try { root._u1SpObs = new MutationObserver(() => { clearTimeout(root._u1SpT); root._u1SpT = setTimeout(_spFix, 50); }); root._u1SpObs.observe(_spW, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); } catch (_eO) {}
}
}
} catch (_eSP) {}
try {
const progWrap = root.querySelector('[data-u1-pdp-preorder-progress]');
if (progWrap) {
const progEnabled = String(root.dataset.u1PdpPreorderProgressEnabled || '') === '1';
const prog = (progEnabled && preorder && typeof _getPreorderProgress === 'function') ? _getPreorderProgress(v) : null;
if (prog && prog.max > 0) {
const tpl = String(root.dataset.u1PdpPreorderProgressText || '{count} of {max} claimed');
const pct = Math.round((prog.count / prog.max) * 100);
const labelEl = progWrap.querySelector('[data-u1-pdp-preorder-progress-label]');
const pctEl = progWrap.querySelector('[data-u1-pdp-preorder-progress-pct]');
const fillEl = progWrap.querySelector('[data-u1-pdp-preorder-progress-fill]');
const trackEl = progWrap.querySelector('[data-u1-pdp-preorder-progress-track]');
if (labelEl) labelEl.textContent = tpl.replace('{count}', String(prog.count)).replace('{max}', String(prog.max));
const infoBtn = progWrap.querySelector('[data-u1-pdp-preorder-progress-info]');
if (infoBtn) {
const tipTxt = String(root.dataset.u1PdpPreorderProgressTooltip || '').trim();
const tipEl = infoBtn.querySelector('[data-u1-pdp-preorder-progress-tooltip-el]');
if (tipEl) tipEl.textContent = tipTxt;
infoBtn.hidden = !tipTxt;
}
if (pctEl) pctEl.textContent = pct + '%';
if (fillEl) fillEl.style.width = pct + '%';
if (trackEl) trackEl.setAttribute('aria-valuenow', String(pct));
progWrap.hidden = false;
progWrap.setAttribute('aria-hidden', 'false');
} else {
progWrap.hidden = true;
progWrap.setAttribute('aria-hidden', 'true');
}
}
} catch (_ePP) {}
};

const _defaultColorEl = root.querySelector('[data-u1-pdp-step="color"] [data-u1-pdp-value]');
const _defaultColor = _defaultColorEl ? (_defaultColorEl.getAttribute('data-u1-pdp-value') || '') : '';

const buildBundleImageUrl = ({ packHandle, color, visor, productHandle, filesBase, chapters }) => {
  const base = (filesBase || '').toString();
  const prod = (productHandle || '').toLowerCase().replace(/\s+/g, '-').split('-')[0];
  const packRaw = (packHandle || '').toLowerCase().replace(/\s+/g, '-');

  const prodPrefix = prod.split('-')[0] + '-';
  const pack = packRaw.indexOf(prodPrefix) === 0 ? packRaw.substring(prodPrefix.length) : packRaw;
  const col = (color || '').toLowerCase().replace(/\s+/g, '-');
  const vis = (visor || '').toLowerCase().replace(/\s+/g, '-');
  const ext = '.jpg';
  const prefix = 'pdp-' + prod + '-' + pack;
  const hasVisorChapter = chapters && chapters.indexOf('visor') !== -1;
  const candidates = [];
  /* data-u1-pdp-img-rev (setting 'Version de las fotos de packs'): cambia la URL para que Shopify y el
     navegador no sigan sirviendo la foto vieja guardada en cache al reemplazarla con el mismo nombre */
  const _rev = root.getAttribute('data-u1-pdp-img-rev') || '';
  const sz = '?width=1600' + (_rev ? '&v=' + encodeURIComponent(_rev) : '');
  if (root._u1FamImgCands) try { root._u1FamImgCands(base + prefix, col, sz, candidates, chapters); } catch (_eF) {}
  if (col && vis && hasVisorChapter) candidates.push(base + prefix + '-' + col + '-' + vis + ext + sz);
  if (col) candidates.push(base + prefix + '-' + col + ext + sz);
  candidates.push(base + prefix + ext + sz);
  return candidates;
};

const getSelectedVisorName = () => {
  var sel = root.querySelector('[data-u1-pdp-visor="true"][aria-pressed="true"]')
           || root.querySelector('[data-u1-pdp-visor="true"].is-selected');
  if (!sel) return '';
  return (sel.getAttribute('data-u1-pdp-info-title') || '').trim();
};

const getBundleGalleryData = (bp) => {
  if (!bp) {
    var ps = root._packSelector;
    bp = ps && typeof ps.getActiveBundlePack === 'function' ? ps.getActiveBundlePack() : null;
  }
  if (!bp) return null;
  var filesBase = root.getAttribute('data-u1-pdp-files-base') || '';
  var chapters = (bp.chapters || '').toString();
  var visor = getSelectedVisorName();
  var hasVisorChapter = chapters.indexOf('visor') !== -1;
  if (!visor && hasVisorChapter) visor = 'clear';
  return {
    candidates: buildBundleImageUrl({
      packHandle: bp.packHandle || bp.productHandle || '',
      color: state.color || _defaultColor,
      visor: visor,
      productHandle: mainProductHandle || '',
      filesBase: filesBase,
      chapters: chapters
    }),
    alt: (bp.packHandle || 'bundle')
  };
};

/* Probe paralelo con cache: assets/u1_pdp_bundle_probe.js (256KB de snippets). */
const preloadBundleImage = (candidates, callback, onFail) => {
  if (window.u1BundleProbe) { window.u1BundleProbe(candidates, callback, onFail); return; }
  if (onFail) onFail();
};

/* Overlay del bundle: el DOM vive en assets/u1_pdp_bundle_probe.js */
/* LAZY: el asset carga con defer, aca todavia no existe u1BundleOverlay */
var _bgInst = null;
var _bgGet = function() {
  if (!_bgInst && window.u1BundleOverlay) _bgInst = window.u1BundleOverlay(root);
  return _bgInst;
};
var _bundleToken = 0;
var _bundleOverlayEl = function() { var g = _bgGet(); return g ? g.el() : null; };
var _bundleOverlayPack = function() { var g = _bgGet(); return g ? g.pack() : ''; };
var _showBundleOverlay = function(src, alt, duration, token, pack) {
  if (token !== undefined && token !== _bundleToken) return;
  var g = _bgGet();
  if (g) g.show(src, alt, duration, pack);
};
var _hideBundleOverlay = function() { var g = _bgGet(); if (g) g.hide(); };

root._u1UpdateBundleGallery = function() {
  var isBundleActive = root.getAttribute('data-u1-pdp-bundle-active') === 'true';
  if (!isBundleActive) {
    if (root._u1BundleGalleryActive) {
      root._u1BundleGalleryActive = false;
      _hideBundleOverlay();
      try {
        var _c = state.color || '';
        if (_c && typeof transitionGalleryToColor === 'function') {
          transitionGalleryToColor(_c, { durationMs: 133 });
        } else if (typeof setBaseToNormalGallery === 'function') {
          setBaseToNormalGallery();
        }
        if (typeof setGallerySwipeEnabled === 'function') setGallerySwipeEnabled(true);
        if (typeof refreshSlides === 'function') refreshSlides();
        if (typeof scheduleGalleryUxModeCheck === 'function') scheduleGalleryUxModeCheck();
      } catch(_e) {}
    }
    return;
  }
  var bpNow = (root._packSelector && root._packSelector.getActiveBundlePack)
    ? root._packSelector.getActiveBundlePack() : null;
  var packNow = (bpNow && bpNow.packHandle) ? String(bpNow.packHandle) : '';
  if (root._u1BundleRetryPack !== packNow) { root._u1BundleRetryPack = packNow; root._u1BundleRetry = 0; }
  var data = getBundleGalleryData();
  if (!data) return;
  var token = ++_bundleToken;
  preloadBundleImage(data.candidates, function(src) {
    if (root.getAttribute('data-u1-pdp-bundle-active') !== 'true') return;
    root._u1BundleGalleryActive = true;
    root._u1BundleRetry = 0;
    _showBundleOverlay(src, data.alt, 200, token, packNow);
  }, function() {
    /* Sin foto: reintenta; si no hay, baja el overlay (jamas dejar otro pack) */
    if (token !== _bundleToken) return;
    var tries = (root._u1BundleRetry || 0) + 1;
    root._u1BundleRetry = tries;
    if (tries <= 2) {
      window.setTimeout(function() {
        if (token !== _bundleToken) return;
        root._u1UpdateBundleGallery();
      }, tries === 1 ? 400 : 1200);
      return;
    }
    root._u1BundleRetry = 0;
    if (_bundleOverlayPack() && _bundleOverlayPack() !== packNow) _hideBundleOverlay();
  });
};

root._u1PreviewBundleGallery = function(bp) {
  if (!bp) return;
  var data = getBundleGalleryData(bp);
  if (!data) return;
  var token = ++_bundleToken;
  var pack = bp.packHandle ? String(bp.packHandle) : '';
  preloadBundleImage(data.candidates, function(src) {
    _showBundleOverlay(src, data.alt, 160, token, pack);
  }, function() {
    if (token === _bundleToken) _hideBundleOverlay();
  });
};

root._u1HideBundleOverlay = function() { _hideBundleOverlay(); };

var _restoreTimer = null;
root._u1RestoreBundleGallery = function() {
  if (_restoreTimer) clearTimeout(_restoreTimer);
  _restoreTimer = setTimeout(function() {
    var isBundleActive = root.getAttribute('data-u1-pdp-bundle-active') === 'true';
    if (isBundleActive && root._u1BundleGalleryActive) {
      root._u1UpdateBundleGallery();
    } else {
      _hideBundleOverlay();
    }
  }, 150);
};

var _origPreview = root._u1PreviewBundleGallery;
root._u1PreviewBundleGallery = function(bp) {
  if (_restoreTimer) { clearTimeout(_restoreTimer); _restoreTimer = null; }
  _origPreview(bp);
};
var _origHide = root._u1HideBundleOverlay;
root._u1HideBundleOverlay = function() {
  if (_restoreTimer) { clearTimeout(_restoreTimer); _restoreTimer = null; }
  _origHide();
};

/* Warm-up de la foto de cada pack: 2 pasadas */
root._u1WarmBundleGallery = function() {
  try { if (window.u1BundleWarm) window.u1BundleWarm(root, getBundleGalleryData); } catch (_e) {}
};
[700, 1800].forEach(function(ms) { window.setTimeout(root._u1WarmBundleGallery, ms); });
/* Deep link (?bundle=x): el pack se elige antes de que el estado este sembrado */
[600, 1500, 3000].forEach(function(ms) {
  window.setTimeout(function() {
    try {
      if (root.getAttribute('data-u1-pdp-bundle-active') === 'true') root._u1UpdateBundleGallery();
    } catch (_e) {}
  }, ms);
});

const renderMobileGalleries = () => {
if (!mobileGalleries || mobileGalleries.length === 0) return;
const waitForImgReady = (img, timeoutMs = 260) => {
if (!img) return Promise.resolve();
try {
if (img.complete && (img.naturalWidth || 0) > 0) {
if (typeof img.decode === 'function') return img.decode().catch(() => {});
return Promise.resolve();
}
} catch (_e0) {}
return new Promise((resolve) => {
let done = false;
const finish = () => { if (done) return; done = true; resolve(); };
try { img.addEventListener('load', finish, { once: true }); } catch (_e) {}
try { img.addEventListener('error', finish, { once: true }); } catch (_e2) {}
try {
if (typeof img.decode === 'function') img.decode().then(finish).catch(() => {});
} catch (_e3) {}
window.setTimeout(finish, timeoutMs);
});
};
const currentSlide = slides[state.galleryIndex];
const imgEl = currentSlide ? currentSlide.querySelector('img') : null;
const src = imgEl ? (imgEl.currentSrc || imgEl.src) : '';
const alt = imgEl ? (imgEl.getAttribute('alt') || '') : '';
const vidEl = currentSlide ? currentSlide.querySelector('video') : null;
const vidSrc = (() => {
try {
if (!vidEl) return '';
const s = vidEl.querySelector('source');
return s ? String(s.getAttribute('src') || '') : '';
} catch (_e) { return ''; }
})();
const vidPoster = vidEl ? String(vidEl.getAttribute('poster') || '') : '';
const vidFit = vidEl && vidEl.dataset ? String(vidEl.dataset.u1Fit || '') : '';
const isVideo = !!(vidEl && vidSrc);
const isLifestyle = (() => {
if (isVideo) return String(vidFit || '') === 'cover';
try {
const a = currentSlide ? String(currentSlide.getAttribute('data-u1-lifestyle') || '') : '';
if (!a) return true;
return a === '1';
} catch (_e) { return true; }
})();
mobileGalleries.forEach((host) => {
if (!host) return;
const stepEl = (host && host.closest) ? host.closest('[data-u1-pdp-step]') : null;
const step = stepEl ? String(stepEl.getAttribute('data-u1-pdp-step') || '') : '';
if (['sparky_color','sparky_inserts','adult_color','adult_size','torch_color'].indexOf(step) !== -1) return;
const isVisorStep = step === 'visor';
const isAccessoriesStep = step === 'accessories';
let baseSrc = src;
let baseAlt = alt;
let baseIsVideo = isVideo;
let baseVidSrc = vidSrc;
let baseVidPoster = vidPoster;
let baseVidFit = vidFit;
let baseIsLifestyle = isLifestyle;
let overlaySrc = '';
let isFixed = false;
if (isVisorStep) {
isFixed = true;
baseIsVideo = false;
try {
const imgs = hasCustomGallery ? getGalleryImagesForColor(getMediaColorValue()) : null;
const base = (imgs && imgs.length >= 2) ? imgs[1] : ((imgs && imgs.length) ? imgs[0] : null);
if (base && base.src) {
baseSrc = String(base.src);
baseAlt = String(base.alt || '');
baseIsLifestyle = !!base.lifestyle;
} else {
const s2 = slides[1] || slides[0] || null;
const im2 = s2 ? s2.querySelector('img') : null;
baseSrc = im2 ? String(im2.currentSrc || im2.src || '') : '';
baseAlt = im2 ? String(im2.getAttribute('alt') || '') : '';
baseIsLifestyle = false;
}
} catch (_e) {}
try {
const selected = getVisorSelectionList();
if (selected && selected.length) {
visorCycleIdx = clamp(visorCycleIdx, 0, selected.length - 1);
const activeSel = selected[visorCycleIdx];
overlaySrc = visorOverlaySrcFor(activeSel);
}
} catch (_e2) {}
} else if (isAccessoriesStep) {
isFixed = true;
baseIsVideo = false;
baseIsLifestyle = false;
try {
  let useRemoteBase = true;
  try {
    if (TEMPLATE_RAW === 'torch' && getTorchInsertSelectedNow && getTorchInsertSelectedNow()) useRemoteBase = false;
  } catch (_e0) {}
  if (!useRemoteBase) {
    baseSrc = src;
  } else {
    let offSrc = '';
    try {
      if (isTorchInserts()) {
        const pH = optionNameHandle(mainProductHandle || '');
        const cH = getMediaColorHandle();
        if (pH && cH) offSrc = filesUrlFor(`pdp-insert-none-${pH}-${cH}.jpg`) || '';
      }
    } catch (_eT) {}
    if (!offSrc) { try { offSrc = remoteBaseOffSrcFor() || ''; } catch (_e1) { offSrc = ''; } }
    baseSrc = offSrc;
  }
} catch (_e) { baseSrc = ''; }
// Sin resolver (p.ej. smart-light, sin cascos): este chapter no lleva gallery
if (!baseSrc) { host.hidden = true; return; }
host.hidden = false;
baseAlt = '';
try { overlaySrc = isRemoteSelected() ? (remoteOnSrcFor() || '') : ''; } catch (_e2) { overlaySrc = ''; }
// Overlays de inserts solo si NO hay modo remote (guard del sticky mobile flag).
if (!overlaySrc && root._u1InsertStickyMobile && !isRemoteSelected() && typeof insertSrcFor === 'function') {
try { overlaySrc = insertSrcFor() || ''; } catch (_eIns) { overlaySrc = ''; }
}
}

const isBundleStep = step === 'bundle';
if (isBundleStep) {
// Solo packs no-solo usan la imagen compuesta; isSolo cae al render normal (overlay MIPS).
var _bpMob = (root._packSelector && typeof root._packSelector.getActiveBundlePack === 'function') ? root._packSelector.getActiveBundlePack() : null;
var _isSoloMob = !_bpMob || _bpMob.isSolo === true;
if (!_isSoloMob) {
isFixed = true;
baseIsVideo = false;
try {
  var _bundleData = getBundleGalleryData();
  if (_bundleData && _bundleData.candidates.length) {
    baseIsLifestyle = true;
    var _bc = window.u1BundleVersions ? window.u1BundleVersions(_bundleData.candidates) : _bundleData.candidates;
    baseSrc = _bc[0];
    baseAlt = _bundleData.alt;
    host._u1BundleFallbacks = _bc.slice(1).concat(src ? [src] : []);
  }

} catch (_eBundle) {}
}
}
host.dataset.u1Kind = baseIsLifestyle ? 'lifestyle' : 'render';
host.dataset.u1Fixed = isFixed ? '1' : '0';
if (!host.dataset.u1Init) {
host.innerHTML = `
<div class="u1-pdp-mobile-gallery__media">
<img class="u1-pdp-mobile-gallery__img" alt="" width="2000" height="2000">
<img class="u1-pdp-mobile-gallery__mips" alt="" width="2000" height="2000" hidden aria-hidden="true">
<img class="u1-pdp-mobile-gallery__overlay" alt="" width="2000" height="2000" hidden aria-hidden="true">
<img class="u1-pdp-mobile-gallery__remote-mips-badge" alt="" width="2000" height="2000" hidden aria-hidden="true">
<video class="u1-pdp-mobile-gallery__video" playsinline muted loop autoplay preload="metadata" hidden aria-hidden="true">
<source src="" type="video/mp4">
</video>
<button type="button" class="u1-pdp-mobile-gallery__hit u1-pdp-mobile-gallery__hit--prev" aria-label="${U1S.prev}"></button>
<button type="button" class="u1-pdp-mobile-gallery__hit u1-pdp-mobile-gallery__hit--next" aria-label="${U1S.next}"></button>
</div>
<div class="u1-pdp-mobile-gallery__dots" data-u1-dots aria-hidden="true"></div>
`;
host.dataset.u1Init = '1';
}
/* 2026-09-28: listeners fuera del if de u1Init (galeria puede venir ya dibujada de Liquid) */
if (!host._u1Bound) {
host._u1Bound = 1;
const bPrev = host.querySelector('.u1-pdp-mobile-gallery__hit--prev');
const bNext = host.querySelector('.u1-pdp-mobile-gallery__hit--next');
if (bPrev) bPrev.addEventListener('click', () => {
if (bPrev.getAttribute('aria-disabled') === 'true') return;
scrollBy(-1);
});
if (bNext) bNext.addEventListener('click', () => {
if (bNext.getAttribute('aria-disabled') === 'true') return;
scrollBy(1);
});
host.addEventListener('click', (evt) => {
const t = evt && evt.target;
const btn = t && t.closest ? t.closest('button[data-u1-idx]') : null;
if (!btn) return;
const idx = Number(btn.dataset.u1Idx || 0) || 0;
scrollGalleryToIndex(idx);
});
}
const img = host.querySelector('.u1-pdp-mobile-gallery__img');
const mips = host.querySelector('.u1-pdp-mobile-gallery__mips');
const overlay = host.querySelector('.u1-pdp-mobile-gallery__overlay');
const remoteMipsBadge = host.querySelector('.u1-pdp-mobile-gallery__remote-mips-badge');
const v = host.querySelector('.u1-pdp-mobile-gallery__video');
const vSource = v ? v.querySelector('source') : null;
if (baseIsVideo && v && vSource && !isFixed) {
if (img) { img.hidden = true; img.setAttribute('aria-hidden', 'true'); }
if (mips) { mips.hidden = true; mips.setAttribute('aria-hidden', 'true'); try { mips.removeAttribute('src'); } catch (_e) {} }
if (remoteMipsBadge) { remoteMipsBadge.hidden = true; remoteMipsBadge.setAttribute('aria-hidden', 'true'); try { remoteMipsBadge.removeAttribute('src'); } catch (_e) {} }
if (overlay) { overlay.hidden = true; overlay.setAttribute('aria-hidden', 'true'); overlay.classList.remove('is-visible'); }
v.hidden = false;
v.setAttribute('aria-hidden', 'false');
if (baseVidFit) v.dataset.u1Fit = baseVidFit;
if (baseVidPoster && v.getAttribute('poster') !== baseVidPoster) v.setAttribute('poster', baseVidPoster);
const current = String(vSource.getAttribute('src') || '');
if (baseVidSrc && current !== baseVidSrc) {
vSource.setAttribute('src', baseVidSrc);
try { v.load(); } catch (_e) {}
}
} else {
if (v) { v.hidden = true; v.setAttribute('aria-hidden', 'true'); }
if (img) {
const okSrc = !!baseSrc;
img.hidden = !okSrc;
img.setAttribute('aria-hidden', okSrc ? 'false' : 'true');
if (okSrc) {
const prev = String(img.getAttribute('src') || '');
const nextSrc = String(baseSrc);
if (prev !== nextSrc) {
try {
const tok = String((Number(host.dataset.u1MobileBaseTok || 0) || 0) + 1);
host.dataset.u1MobileBaseTok = tok;
const pre = new Image();
pre.onload = () => {
try {
if (String(host.dataset.u1MobileBaseTok || '') !== tok) return;
const loadedSrc = pre.src;
if (String(img.getAttribute('src') || '') !== loadedSrc) {
u1ApplyGallerySrcset(img, loadedSrc); /* srcset ANTES de src (gotcha 1400 fijo) */
img.src = loadedSrc;
}
} catch (_ep) {}
};
pre.onerror = () => {
try {
if (String(host.dataset.u1MobileBaseTok || '') !== tok) return;

if (host._u1BundleFallbacks && host._u1BundleFallbacks.length) {
  const fb = host._u1BundleFallbacks.shift();
  u1ApplyGallerySrcset(pre, fb);
  pre.src = fb;
  return;
}
img.hidden = true;
img.setAttribute('aria-hidden', 'true');
img.removeAttribute('src');
u1ApplyGallerySrcset(img, ''); /* limpiar srcset o queda la imagen vieja */
} catch (_ep2) {}
};
u1ApplyGallerySrcset(pre, nextSrc); /* preloader tambien por srcset */
pre.src = nextSrc;
} catch (_ePre) {
try { u1ApplyGallerySrcset(img, nextSrc); img.src = nextSrc; } catch (_eImg) {}
}
}
img.alt = baseAlt;
}
}
if (mips) {
const mipsEnabled = String(root.dataset.u1PdpMipsOverlayEnabled || '') === '1' && String(root.dataset.u1PdpIsMips || '') === '1';
let mipsSrc = '';
if (!isFixed && mipsEnabled && !baseIsLifestyle) {
const ordinal = getMipsOverlayOrdinalForIndex(Number(state.galleryIndex || 0) || 0);
if (ordinal) {
const prefix = getMipsOverlayPrefix();
const key = `${prefix}-${ordinal}`;
const cached = galleryMipsOverlay && galleryMipsOverlay.resolved ? galleryMipsOverlay.resolved.get(key) : '';
if (cached) mipsSrc = String(cached);
else resolveMipsOverlaySrcForOrdinal(ordinal);
}
}
if (!mipsSrc) {
mips.hidden = true;
mips.setAttribute('aria-hidden', 'true');
try { mips.removeAttribute('src'); } catch (_eM) {}
} else {
mips.hidden = false;
mips.setAttribute('aria-hidden', 'false');
if (String(mips.getAttribute('src') || '') !== String(mipsSrc)) mips.setAttribute('src', String(mipsSrc));
}
}
if (remoteMipsBadge) {
let src = '';
if (isFixed && isAccessoriesStep) {
src = remoteMipsBadgeSrcFor() || '';
}
if (!src) {
remoteMipsBadge.hidden = true;
remoteMipsBadge.setAttribute('aria-hidden', 'true');
try { remoteMipsBadge.removeAttribute('src'); } catch (_eB0) {}
} else {
remoteMipsBadge.hidden = false;
remoteMipsBadge.setAttribute('aria-hidden', 'false');
if (String(remoteMipsBadge.getAttribute('src') || '') !== String(src)) remoteMipsBadge.setAttribute('src', String(src));
}
}
if (overlay) {
const want = isFixed && !!overlaySrc;
if (!want) {
overlay.classList.remove('is-visible');
overlay.hidden = true;
overlay.setAttribute('aria-hidden', 'true');
try { overlay.removeAttribute('src'); } catch (_e) {}
} else {
overlay.hidden = false;
overlay.setAttribute('aria-hidden', 'false');
overlay.classList.remove('is-visible');
const tok = String((Number(host.dataset.u1OverlayTok || 0) || 0) + 1);
host.dataset.u1OverlayTok = tok;
if (String(overlay.getAttribute('src') || '') !== String(overlaySrc)) overlay.setAttribute('src', String(overlaySrc));
Promise.race([waitForImgReady(img, 320), new Promise((r) => window.setTimeout(r, 320))]).then(() => {
if (String(host.dataset.u1OverlayTok || '') !== tok) return;
overlay.classList.add('is-visible');
});
}
}
}
const bPrev = host.querySelector('.u1-pdp-mobile-gallery__hit--prev');
const bNext = host.querySelector('.u1-pdp-mobile-gallery__hit--next');
const has = !isFixed && slides.length > 1;
const prevDisabled = !has || state.galleryIndex <= 0;
const nextDisabled = !has || state.galleryIndex >= slides.length - 1;
if (bPrev) bPrev.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
if (bNext) bNext.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
const dots = host.querySelector('[data-u1-dots]');
if (dots) {
if (!has) {
dots.innerHTML = '';
dots.setAttribute('aria-hidden', 'true');
} else {
const count = slides.length;
const active = Math.min(count - 1, Math.max(0, Number(state.galleryIndex || 0) || 0));
const prevCount = Number(dots.dataset.u1Count || 0) || 0;
if (prevCount !== count) {
dots.dataset.u1Count = String(count);
dots.innerHTML = Array.from({ length: count }).map((_, i) => {
const current = i === active ? 'true' : 'false';
return `<button type="button" class="u1-pdp-gallery-dot" data-u1-idx="${i}" aria-current="${current}" aria-label="Slide ${i + 1}"></button>`;
}).join('');
} else {
const btns = Array.from(dots.querySelectorAll('button[data-u1-idx]'));
btns.forEach((b, i) => b.setAttribute('aria-current', (i === active) ? 'true' : 'false'));
}
dots.setAttribute('aria-hidden', 'false');
}
}
});
};

const getMipsOverlayOrdinalForIndex = (idx) => {
try {
const i = clamp(Number(idx || 0) || 0, 0, Math.max(0, slides.length - 1));
const slide = slides[i];
if (!slide) return 0;
if (String(slide.getAttribute('data-u1-media') || '') === 'video') return 0;
if (String(slide.getAttribute('data-u1-lifestyle') || '') === '1') return 0;
let n = 0;
for (let j = 0; j <= i; j++) {
const s = slides[j];
if (!s) continue;
if (String(s.getAttribute('data-u1-media') || '') === 'video') continue;
if (String(s.getAttribute('data-u1-lifestyle') || '') === '1') continue;
n += 1;
}
return n; // 1..N, contando solo no-lifestyle
} catch (_e) {}
return 0;
};

const getMipsOverlayPrefix = () => {
try {
const raw = String(root.dataset.u1PdpMipsOverlayPrefix || '').trim();
if (raw && raw.toLowerCase() !== 'auto') return raw;
const helmets = getHelmetHandleCandidates();
const baseHelmet = helmets.find(h => h && !/mips/i.test(String(h))) || helmets[0] || '';
if (baseHelmet) return `pdp-${baseHelmet}-mips-overlay`;
} catch (_e) {}
return 'pdp-mips-overlay';
};

const resolveMipsOverlaySrcForOrdinal = (ordinal) => {
const n = Number(ordinal || 0) || 0;
if (!n) return '';
const prefix = getMipsOverlayPrefix();
const key = `${prefix}-${n}`;
if (!galleryMipsOverlay || !galleryMipsOverlay.resolved) return '';
const cached = galleryMipsOverlay.resolved.get(key);
if (typeof cached === 'string') return cached;
if (galleryMipsOverlay.resolving && galleryMipsOverlay.resolving.has(key)) return '';
if (galleryMipsOverlay.resolving) galleryMipsOverlay.resolving.add(key);

// Optimistic guess first (fast UI). We'll verify + fallback async.
let guess = '';
try { guess = filesUrlFor(`${key}.png`); } catch (_e0) {}
if (!guess) { try { guess = assetUrlFor(`${key}.png`); } catch (_e1) {} }
try { galleryMipsOverlay.resolved.set(key, guess || ''); } catch (_e2) {}
try { if (guess) u1ImgPreload.preload(guess); } catch (_e3) {}
try { syncMipsOverlayUi(); } catch (_e4) {}
try { renderMobileGalleries(); } catch (_e5) {}

(async () => {
let found = '';
try {
const exts = ['png', 'PNG', 'webp', 'WEBP', 'jpg', 'JPG', 'jpeg', 'JPEG'];
const candidates = [];
for (const ext of exts) {
// Also try Shopify's auto-renamed duplicates: foo.png -> foo_1.png, foo_2.png, ...
for (let suf = 0; suf <= 4; suf++) {
const name = suf ? `${key}_${suf}.${ext}` : `${key}.${ext}`;
try { candidates.push(filesUrlFor(name)); } catch (_e0b) {}
try { candidates.push(assetUrlFor(name)); } catch (_e1b) {}
}
}
const uniqueCands = Array.from(new Set(candidates.filter(Boolean)));
for (const src of uniqueCands) {
// eslint-disable-next-line no-await-in-loop
const ok = await u1ImgExists.check(src);
if (ok) { found = src; break; }
}
} catch (_e2b) {}
try { galleryMipsOverlay.resolved.set(key, found || ''); } catch (_e3b) {}
try { galleryMipsOverlay.resolving.delete(key); } catch (_e4b) {}
try { syncMipsOverlayUi(); } catch (_e5b) {}
try { renderMobileGalleries(); } catch (_e6b) {}
})();

return guess || '';
};

const syncMipsOverlayUi = () => {
const img = galleryMipsOverlay && galleryMipsOverlay.img ? galleryMipsOverlay.img : null;
if (!img) return;
const enabled = String(root.dataset.u1PdpMipsOverlayEnabled || '') === '1';
const isMips = String(root.dataset.u1PdpIsMips || '') === '1';
const uxMode = String(root._u1GalleryUxMode || 'normal');
const hideMips = () => {
img.hidden = true;
img.setAttribute('aria-hidden', 'true');
img.classList.remove('is-visible');
try { img.style.display = 'none'; } catch (_eS) {}
try { img.removeAttribute('src'); } catch (_eR) {}
};
if (!enabled || !isMips || uxMode !== 'normal') { hideMips(); return; }
const ordinal = getMipsOverlayOrdinalForIndex(Number(state.galleryIndex || 0) || 0);
if (!ordinal) { hideMips(); return; }
const prefix = getMipsOverlayPrefix();
const key = `${prefix}-${ordinal}`;
const cached = galleryMipsOverlay && galleryMipsOverlay.resolved ? galleryMipsOverlay.resolved.get(key) : '';
if (cached) {
// Overlay in-slide: hereda caja/escala de la imagen y no se desalinea.
try {
const _activeSlide = slides[Number(state.galleryIndex || 0) || 0];
const _sq = _activeSlide ? _activeSlide.querySelector('.u1-pdp-customizer__gallery-square') : null;
if (_sq) {
if (img.parentElement !== _sq) _sq.appendChild(img);
img.setAttribute('data-u1-in-slide', '1');
} else {
img.setAttribute('data-u1-in-slide', '0');
}
} catch (_eMount) {}
img.hidden = false;
img.setAttribute('aria-hidden', 'false');
try { img.style.display = ''; } catch (_eS2) {}
if (String(img.getAttribute('src') || '') !== String(cached)) img.setAttribute('src', String(cached));
window.requestAnimationFrame(() => { try { img.classList.add('is-visible'); } catch (_e) {} });
return;
}
resolveMipsOverlaySrcForOrdinal(ordinal);
hideMips();
};

const clearMipsOverlays = () => {
// Desktop overlay (per slide)
try {
const img = galleryMipsOverlay && galleryMipsOverlay.img ? galleryMipsOverlay.img : null;
if (img) {
img.hidden = true;
img.setAttribute('aria-hidden', 'true');
img.classList.remove('is-visible');
img.style.display = 'none';
img.removeAttribute('src');
}
} catch (_e0) {}
// Desktop remote MIPS badge overlay (accessories mode)
try {
const img = galleryRemoteMipsBadge && galleryRemoteMipsBadge.img ? galleryRemoteMipsBadge.img : null;
if (img) {
img.hidden = true;
img.setAttribute('aria-hidden', 'true');
img.style.display = 'none';
img.removeAttribute('src');
}
} catch (_e0b) {}
// Mobile overlays (all chapters)
try {
const imgs = Array.from(root.querySelectorAll('.u1-pdp-mobile-gallery__mips'));
imgs.forEach((el) => {
try {
el.hidden = true;
el.setAttribute('aria-hidden', 'true');
el.removeAttribute('src');
} catch (_e1) {}
});
} catch (_e2) {}
// Mobile remote MIPS badge overlays
try {
const imgs = Array.from(root.querySelectorAll('.u1-pdp-mobile-gallery__remote-mips-badge'));
imgs.forEach((el) => {
try {
el.hidden = true;
el.setAttribute('aria-hidden', 'true');
el.removeAttribute('src');
} catch (_e3) {}
});
} catch (_e4) {}
};

const scrollGalleryToIndex = (idx, { behavior } = { behavior: 'smooth' }) => {
if (!galleryTrack || slides.length === 0) return;
const i = clamp(idx, 0, slides.length - 1);
state.galleryIndex = i;
const target = slides[i];
if (!target) return;
const left = target.offsetLeft;
galleryTrack.scrollTo({ left, behavior: behavior || 'smooth' });
updateGalleryButtons();
renderMobileGalleries();
};
const isGallerySettled = () => {
if (!galleryTrack || slides.length === 0) return true;
const slide = slides[state.galleryIndex];
if (!slide) return true;
if (root._u1SetV && root._u1SetI === state.galleryIndex) return root._u1Set;
root._u1SetV = true; root._u1SetI = state.galleryIndex;
window.requestAnimationFrame(() => { root._u1SetV = false; });
return (root._u1Set = Math.abs(slide.offsetLeft - galleryTrack.scrollLeft) < 3);
};
const syncMipsIfSettled = () => {
const img = galleryMipsOverlay && galleryMipsOverlay.img ? galleryMipsOverlay.img : null;
if (!img) return;
if (isGallerySettled()) {
try { syncMipsOverlayUi(); } catch (_e) {}
} else {
img.classList.remove('is-visible');
}
};
const updateGalleryButtons = () => {
const uxMode = String(root._u1GalleryUxMode || 'normal');
try { syncMipsIfSettled(); } catch (_e0) {}
if (uxMode === 'final' || uxMode === 'accessories') {
if (galleryEl) galleryEl.classList.remove('is-carousel');
if (!btnPrev || !btnNext) return;
btnPrev.style.display = 'none';
btnNext.style.display = 'none';
btnPrev.classList.remove('is-disabled');
btnNext.classList.remove('is-disabled');
btnPrev.setAttribute('aria-disabled', 'false');
btnNext.setAttribute('aria-disabled', 'false');
try { updateDesktopPager(); } catch (_e) {}
return;
}
if (uxMode === 'visor') {
const count = Number(root._u1VisorCycleCount || 0) || 0;
const has = count > 1;
if (galleryEl) galleryEl.classList.toggle('is-carousel', has);
if (!btnPrev || !btnNext) return;
if (!has) {
btnPrev.style.display = 'none';
btnNext.style.display = 'none';
btnPrev.classList.remove('is-disabled');
btnNext.classList.remove('is-disabled');
btnPrev.setAttribute('aria-disabled', 'false');
btnNext.setAttribute('aria-disabled', 'false');
return;
}
btnPrev.style.display = 'flex';
btnNext.style.display = 'flex';
btnPrev.classList.remove('is-disabled');
btnNext.classList.remove('is-disabled');
btnPrev.setAttribute('aria-disabled', 'false');
btnNext.setAttribute('aria-disabled', 'false');
try { updateDesktopPager(); } catch (_e) {}
return;
}
const has = slides.length > 1;
if (galleryEl) galleryEl.classList.toggle('is-carousel', has);
if (!btnPrev || !btnNext) return;
if (!has) {
btnPrev.style.display = 'none';
btnNext.style.display = 'none';
btnPrev.classList.remove('is-disabled');
btnNext.classList.remove('is-disabled');
btnPrev.setAttribute('aria-disabled', 'false');
btnNext.setAttribute('aria-disabled', 'false');
return;
}
btnPrev.style.display = 'flex';
btnNext.style.display = 'flex';
const prevDisabled = state.galleryIndex <= 0;
const nextDisabled = state.galleryIndex >= slides.length - 1;
btnPrev.classList.toggle('is-disabled', prevDisabled);
btnNext.classList.toggle('is-disabled', nextDisabled);
btnPrev.setAttribute('aria-disabled', prevDisabled ? 'true' : 'false');
btnNext.setAttribute('aria-disabled', nextDisabled ? 'true' : 'false');
try { updateDesktopPager(); } catch (_e) {}
};
const getActiveGalleryIndex = () => {
if (!galleryTrack || slides.length === 0) return 0;
const x = galleryTrack.scrollLeft;
let best = 0;
let bestDist = Infinity;
for (let i = 0; i < slides.length; i++) {
const d = Math.abs(slides[i].offsetLeft - x);
if (d < bestDist) { bestDist = d; best = i; }
}
return best;
};
const scrollBy = (dir) => {
if (slides.length === 0) return;
scrollGalleryToIndex(state.galleryIndex + dir, { behavior: 'smooth' });
};
const initGalleryDrag = () => {
if (!galleryViewport || !galleryTrack) return;
if (galleryViewport._u1DragBound) return;
galleryViewport._u1DragBound = true;
const drag = { active: false, startX: 0, startY: 0, startScroll: 0, moved: false, pid: null, locked: null };
const canDrag = () => slides.length > 1 && String(root._u1GalleryUxMode || 'normal') === 'normal';
const onDown = (e) => {
if (!canDrag()) return;
if (typeof e.button === 'number' && e.button !== 0) return;
drag.active = true;
drag.moved = false;
drag.pid = e.pointerId;
drag.startX = e.clientX;
drag.startY = e.clientY;
drag.startScroll = galleryTrack.scrollLeft;
drag.locked = null; // null | 'x' | 'y'
root._u1GalleryDragging = false;
try { galleryViewport.setPointerCapture(drag.pid); } catch (_e) {}
};
const onMove = (e) => {
if (!drag.active) return;
const dx = e.clientX - drag.startX;
const dy = e.clientY - drag.startY;
if (drag.locked == null) {
const ax = Math.abs(dx);
const ay = Math.abs(dy);
if (ax < 4 && ay < 4) return;
drag.locked = (ax >= ay) ? 'x' : 'y';
}
if (drag.locked === 'y') {
drag.active = false;
try { if (drag.pid != null) galleryViewport.releasePointerCapture(drag.pid); } catch (_e) {}
drag.pid = null;
return;
}
try { e.preventDefault(); } catch (_e) {}
if (!drag.moved && Math.abs(dx) > 6) {
drag.moved = true;
root._u1GalleryDragging = true;
}
galleryTrack.scrollLeft = drag.startScroll - dx;
};
const onEnd = () => {
if (!drag.active) return;
drag.active = false;
try { if (drag.pid != null) galleryViewport.releasePointerCapture(drag.pid); } catch (_e) {}
drag.pid = null;
if (!canDrag()) return;
if (drag.moved) {
const idx = getActiveGalleryIndex();
state.galleryIndex = idx;
scrollGalleryToIndex(idx);
window.setTimeout(() => { root._u1GalleryDragging = false; }, 0);
}
};
galleryViewport.addEventListener('pointerdown', onDown, { passive: true, capture: true });
galleryViewport.addEventListener('pointermove', onMove, { passive: false });
galleryViewport.addEventListener('pointerup', onEnd, { passive: true });
galleryViewport.addEventListener('pointercancel', onEnd, { passive: true });
galleryViewport.addEventListener('click', (evt) => {
if (!root._u1GalleryDragging) return;
evt.preventDefault();
evt.stopPropagation();
}, true);
};
const scrollToNextStep = (from) => {
const steps = Array.from(root.querySelectorAll('[data-u1-pdp-step]'));
const idx = steps.findIndex(s => s.dataset.u1PdpStep === from);
if (idx < 0) return;
const next = steps[idx + 1];
if (!next) return;
next.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
const updateSummary = () => {
if (summaryEl) {
const parts = [];
if (state.color) parts.push(`Color - ${state.color}`);
if (state.size) parts.push(`Size - ${state.size}`);
parts.push(`Variant ID: ${state.variantId || '-'}`);
if (state.accessories.size > 0) parts.push(`Accessories: ${Array.from(state.accessories.keys()).length}`);
if (state.crashPlan && state.crashPlan !== 'standard') {
const label = String(state.crashPlan);
parts.push(`Crash Replacement: ${label.charAt(0).toUpperCase()}${label.slice(1)}`);
}
summaryEl.textContent = parts.join(' · ');
}
updateAtcTotal();
updateStickyChevron();
try { syncBundleDiscountUi(); } catch (_e) {}
try { updateBreakdownRows(); } catch (_e2) {}
};

const extractPctLabelFromDiscountCode = (code) => {
const c = (code || '').toString().trim();
if (!c) return '';
const ms = c.match(/\d{1,3}/g);
if (!ms || !ms.length) return '';
const n = Number(ms[ms.length - 1] || 0) || 0;
if (n <= 0 || n > 100) return '';
return U1S.pct_off.replace('__N__', n);
};
const getRuleLabel = (rule) => {
try {
const l = (rule && rule.discountLabel) ? String(rule.discountLabel || '').trim() : '';
if (l) return l;
return extractPctLabelFromDiscountCode(rule && rule.discountCode ? rule.discountCode : '');
} catch (_e) { return ''; }
};
const extractPctFromLabel = (label) => {
try {
const s = (label || '').toString();
const m = s.match(/(\d{1,3})\s*%/);
const n = m ? (Number(m[1]) || 0) : 0;
if (n <= 0 || n > 100) return 0;
return n;
} catch (_e) { return 0; }
};
const applyAtcTotalDiscountUi = (pct, label) => {

const _apBundleAttr = root.getAttribute('data-u1-pdp-bundle-active') === 'true';
const _apPack = root._packSelector && root._packSelector.getActiveBundlePack ? root._packSelector.getActiveBundlePack() : null;
if (_apBundleAttr && _apPack && (Number(_apPack.discountPercent || 0) > 0 || (_apPack.componentProducts && _apPack.componentProducts.length > 0))) return;
const p = Math.max(0, Math.min(100, Number(pct || 0) || 0));
const base = Number(root._u1AtcTotalCents || 0) || 0;
const priorMsrp = Number(root._u1AtcMsrpTotalCents || 0) || 0;
const priorSaved = Number(root._u1AtcFixedSavedCents || 0) || 0;
const priorLabel = (root._u1AtcFixedDiscountLabel || '').toString().trim();
if (!atcTotalEl) return;
if (!atcTotalMsrpEl || !base || p <= 0) {
if (!priorMsrp) {
if (atcTotalMsrpEl) atcTotalMsrpEl.setAttribute('aria-hidden', 'true');
if (atcTotalWrapEl) atcTotalWrapEl.classList.remove('is-discount-on');
if (atcSaveEl) { atcSaveEl.hidden = true; atcSaveEl.setAttribute('aria-hidden', 'true'); atcSaveEl.textContent = ''; }
atcTotalEl.textContent = formatMoneyCents(base);
}
return;
}
const finalCents = Math.round((base * (100 - p)) / 100);
const msrpDisplay = priorMsrp > 0 ? priorMsrp : base;
const totalSaved = msrpDisplay - finalCents;
atcTotalMsrpEl.textContent = formatMoneyCents(msrpDisplay);
atcTotalMsrpEl.setAttribute('aria-hidden', 'false');
if (atcTotalWrapEl) atcTotalWrapEl.classList.add('is-discount-on');
atcTotalEl.textContent = formatMoneyCents(finalCents);
if (atcSaveEl && totalSaved > 0) {
const bundleLabel = (label || '').toString().trim();
const labels = [priorLabel, bundleLabel].filter(Boolean);
const combinedLabel = labels.join(' + ');
atcSaveEl.textContent = U1S.save.replace('__A__', formatMoneyCents(totalSaved));
atcSaveEl.hidden = false;
atcSaveEl.setAttribute('aria-hidden', 'false');
} else if (atcSaveEl) {
atcSaveEl.hidden = true;
atcSaveEl.setAttribute('aria-hidden', 'true');
atcSaveEl.textContent = '';
}
};
const ruleMatchesMainProductSelection = (rule) => {
try {
if (!rule || typeof rule !== 'object') return false;
const rulePid = Math.max(0, Math.round(Number(rule.appliesToMainProductId || 0) || 0));
const curPid = Number(mainProductId || 0) || 0;
if (rulePid && curPid && rulePid !== curPid) return false;
const allowed = rule.allowedMainVariantIds;
if (Array.isArray(allowed) && allowed.length > 0) {
const vid = Number(state && state.variantId ? state.variantId : 0) || 0;
if (!vid) return false;
if (!allowed.some((id) => Number(id) === vid)) return false;
}
return true;
} catch (_e) { return false; }
};
const getApplicableBundleRules = () => {
try {
if (!bundleDiscountRules || !bundleDiscountRules.length) return [];
return bundleDiscountRules.filter((r) => !!r && ruleMatchesMainProductSelection(r));
} catch (_e) { return []; }
};
const getSelectedAccessoryHandleSet = () => {
const s = new Set();
try {
// Fuente de verdad para UI: el DOM (evita desync con state)
// Usamos aria-pressed (más confiable que classes si cambian estilos).
const btns = Array.from(root.querySelectorAll('[data-u1-pdp-accessory][aria-pressed="true"],[data-u1-pdp-accessory].is-selected'));
btns.forEach((b) => {
if (!b || !b.dataset) return;
const h = optionNameHandle(b.dataset.u1PdpAccessoryHandle || '');
if (h) s.add(h);
});
} catch (_e) {}
try {
// Complemento: state (por si el DOM cambia la clase/aria en otra capa)
for (const entry of state.accessories.values()) {
if (!entry) continue;
const h = optionNameHandle(entry.handle || '');
if (h) s.add(h);
}
} catch (_e2) {}
return s;
};
const getAccessoryTitleMapFromDom = () => {
const m = new Map();
try {
const btns = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'));
btns.forEach((b) => {
if (!b || !b.dataset) return;
const h = optionNameHandle(b.dataset.u1PdpAccessoryHandle || '');
if (!h) return;
const t =
((b.dataset.u1PdpInfoTitle || '').toString().trim()) ||
(() => {
try {
const el = b.querySelector('[data-u1-pdp-card-title]');
return el ? (el.textContent || '').toString().trim() : '';
} catch (_e2) { return ''; }
})();
if (t) m.set(h, t);
});
} catch (_e) {}
return m;
};

const getAccessoryIndexFromDom = () => {
const byHandle = new Map(); // handleH -> { title }
try {
const btns = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'));
btns.forEach((b) => {
if (!b || !b.dataset) return;
const h = optionNameHandle(b.dataset.u1PdpAccessoryHandle || '');
if (!h) return;
const title =
((b.dataset.u1PdpInfoTitle || '').toString().trim()) ||
(() => {
try {
const el = b.querySelector('[data-u1-pdp-card-title]');
return el ? (el.textContent || '').toString().trim() : '';
} catch (_e2) { return ''; }
})();
byHandle.set(h, { title: title || '' });
});
} catch (_e) {}
return { byHandle };
};

const resolveAccessoryTokenToHandle = (tokenH, index) => {
const tok = optionNameHandle(tokenH || '');
if (!tok) return '';
const byHandle = index && index.byHandle ? index.byHandle : null;
if (!byHandle || typeof byHandle.has !== 'function') return tok;
if (byHandle.has(tok)) return tok;
// substring match on existing handles (covers unit-1-remote vs unit-1-remote-xxx)
for (const h of byHandle.keys()) {
if (h && h.includes(tok)) return h;
}
const tail = tok.split('-').filter(Boolean).pop() || '';
if (tail) {
for (const [h, meta] of byHandle.entries()) {
if (h && h.includes(tail)) return h;
const t = meta && meta.title ? optionNameHandle(meta.title) : '';
if (t && (t === tail || t.includes(tail))) return h;
}
}
return tok;
};

const getAccessoryTitleForHandle = (handleH, index, titleMap) => {
try {
const h0 = optionNameHandle(handleH || '');
if (!h0) return '';
// Resolver a un handle real presente en el DOM (tolerante a tokens)
const idx = index && index.byHandle ? index : getAccessoryIndexFromDom();
const h = resolveAccessoryTokenToHandle(h0, idx) || h0;
if (!h) return '';
const fromMap = titleMap && typeof titleMap.get === 'function' ? (titleMap.get(h) || '') : '';
if (fromMap) return String(fromMap).trim();
const byHandle = index && index.byHandle ? index.byHandle : null;
if (byHandle && typeof byHandle.get === 'function' && byHandle.has(h)) {
const meta = byHandle.get(h) || null;
const t = meta && meta.title ? String(meta.title || '').trim() : '';
if (t) return t;
}
// fallback: buscar por substring en el índice DOM
try {
if (idx && idx.byHandle) {
for (const [hh, meta] of idx.byHandle.entries()) {
if (!hh) continue;
if (hh.includes(h0) || h0.includes(hh)) {
const t = meta && meta.title ? String(meta.title || '').trim() : '';
if (t) return t;
}
}
}
} catch (_e2) {}
return getAccessoryTitleFromCard(h) || getAccessoryTitleFromCatalog(h) || h;
} catch (_e) { return ''; }
};

const getAccessoryTitleFromCard = (handleH) => {
try {
const h = optionNameHandle(handleH || '');
if (!h) return '';
// No usar CSS.escape (no siempre está disponible). Match por dataset.
const btns = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'));
const btn = btns.find(b => b && b.dataset && optionNameHandle(b.dataset.u1PdpAccessoryHandle || '') === h) || null;
if (!btn) return '';
const el = btn.querySelector('[data-u1-pdp-card-title]');
return el ? (el.textContent || '').toString().trim() : '';
} catch (_e) { return ''; }
};

const getAccessoryTitleFromCatalog = (handleH) => {
try {
const want = (handleH || '').toString().trim();
if (!want) return '';
// accessoriesCatalog trae {handle,title}
const hit = (Array.isArray(accessoriesCatalog) ? accessoriesCatalog : []).find(p => p && optionNameHandle(p.handle || '') === want) || null;
return hit && hit.title ? String(hit.title || '').trim() : '';
} catch (_e) { return ''; }
};
const getRuleMissingHandles = (rule, selectedSet) => {
const missing = [];
try {
const req = Array.isArray(rule && rule.requiredAccessoryHandles ? rule.requiredAccessoryHandles : null) ? rule.requiredAccessoryHandles : [];
req.forEach((h) => { if (h && !selectedSet.has(String(h))) missing.push(String(h)); });
} catch (_e) {}
return missing;
};
const setPromoCopyOnBtn = (btn, { note, off, show, bundleMsg }) => {
if (!btn || !btn.querySelector) return;
const promo = btn.querySelector('[data-u1-pdp-card-promo]');
if (!promo) return;
const offEl = promo.querySelector('[data-u1-pdp-card-promo-off]');
const noteEl = promo.querySelector('[data-u1-pdp-card-promo-note]');
if (offEl) offEl.textContent = (off || '').toString();
if (noteEl) noteEl.textContent = (note || '').toString();
if (bundleMsg) btn.classList.add('is-bundle-msg'); else btn.classList.remove('is-bundle-msg');
if (show) {
promo.hidden = false;
promo.setAttribute('aria-hidden', 'false');
} else {
promo.hidden = true;
promo.setAttribute('aria-hidden', 'true');
}
};
const visorBannerEl = root.querySelector('[data-u1-pdp-bundle-save-visor]');
const visorBannerSubEl = visorBannerEl ? visorBannerEl.querySelector('[data-u1-pdp-bundle-save-visor-subtitle]') : null;
const visorBannerTitleEl = visorBannerEl ? visorBannerEl.querySelector('[data-u1-pdp-bundle-save-visor-title]') : null;
const accBannerTitleEl = bundleSaveEl ? bundleSaveEl.querySelector('.u1-pdp-bundle-save__title') : null;
const setBundleSaveBanner = ({ show, subtitle, isVisor, bannerTitle }) => {

const accEl = bundleSaveEl;
const visEl = visorBannerEl;
const _bt = (bannerTitle || U1S.bundle_save).toString();
if (isVisor && visEl) {
  visEl.hidden = !show;
  visEl.setAttribute('aria-hidden', show ? 'false' : 'true');
  if (show) {
    if (visorBannerTitleEl) visorBannerTitleEl.textContent = _bt;
    if (visorBannerSubEl) visorBannerSubEl.textContent = (subtitle || '').toString();
  }
  if (accEl) { accEl.hidden = true; accEl.setAttribute('aria-hidden', 'true'); }
} else {
  if (accEl) {
    accEl.hidden = !show;
    accEl.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) {
      if (accBannerTitleEl) accBannerTitleEl.textContent = _bt;
      if (bundleSaveSubtitleEl) bundleSaveSubtitleEl.textContent = (subtitle || '').toString();
    }
  }
  if (visEl) { visEl.hidden = true; visEl.setAttribute('aria-hidden', 'true'); }
}
};
const syncBundleDiscountUi = () => {
const rules = getApplicableBundleRules();
if (!rules.length) { setBundleSaveBanner({ show: false }); return; }
const idx = getAccessoryIndexFromDom();
const titleByHandle = (() => {
const m = new Map();
try {
for (const [h, meta] of idx.byHandle.entries()) {
if (!h) continue;
const t = meta && meta.title ? String(meta.title || '').trim() : '';
if (t) m.set(h, t);
}
} catch (_e) {}
return m;
})();
const selected = getSelectedAccessoryHandleSet();

// TIERS: ordenados por level ascendente (1..N)
const tiers = [...rules].sort((a, b) => (Number(a.level || 0) || 0) - (Number(b.level || 0) || 0));
const maxTier = tiers.length ? tiers[tiers.length - 1] : null;
try {
if (maxTier) {
const maxLabel = getRuleLabel(maxTier) || '';
const req = Array.isArray(maxTier.requiredAccessoryHandles)
? maxTier.requiredAccessoryHandles.map(x => resolveAccessoryTokenToHandle(x, idx)).filter(Boolean)
: [];
const titles = req.map(h => getAccessoryTitleForHandle(h, idx.byHandle ? idx : null, titleByHandle)).filter(Boolean);
const subtitle = (titles.length && maxLabel) ? `${titles.join(' + ')}: ${maxLabel}` : (maxLabel || '');

const isVisorDiscount = req.length > 0 && req.every(function(h) {
  return !!root.querySelector('[data-u1-pdp-accessory-handle="' + h + '"][data-u1-pdp-visor="true"]');
});
const visorSubtitle = isVisorDiscount ? (maxLabel || '') : subtitle;
const bTitle = (maxTier && maxTier.bannerTitle) ? String(maxTier.bannerTitle) : U1S.bundle_save;
setBundleSaveBanner({ show: true, subtitle: isVisorDiscount ? visorSubtitle : subtitle, isVisor: isVisorDiscount, bannerTitle: bTitle });
} else {
setBundleSaveBanner({ show: false });
}
} catch (_eBanner) { setBundleSaveBanner({ show: false }); }

let unlockedIdx = -1;
tiers.forEach((t, i) => {
const reqResolved = (Array.isArray(t.requiredAccessoryHandles) ? t.requiredAccessoryHandles : []).map(x => resolveAccessoryTokenToHandle(x, idx)).filter(Boolean);
const miss = reqResolved.filter(h => !selected.has(String(h)));
if (!miss.length) unlockedIdx = Math.max(unlockedIdx, i);
});

const currentTier = unlockedIdx >= 0 ? tiers[unlockedIdx] : null;
const nextTier = (unlockedIdx + 1 < tiers.length) ? tiers[unlockedIdx + 1] : null;
const currentLabel = currentTier ? getRuleLabel(currentTier) : '';

if (currentTier) {
applyAtcTotalDiscountUi(extractPctFromLabel(currentLabel), currentLabel);
} else if (nextTier) {
applyAtcTotalDiscountUi(0, '');
} else {
applyAtcTotalDiscountUi(0, '');
}

// Per-card promo copy (only for cards participating in rules)
const tiersByHandle = (() => {
const m = new Map(); // handle -> [tier1..tierN] that include it
tiers.forEach((t) => {
const req = Array.isArray(t.requiredAccessoryHandles) ? t.requiredAccessoryHandles.map(x => resolveAccessoryTokenToHandle(x, idx)).filter(Boolean) : [];
req.forEach((h) => {
if (!h) return;
if (!m.has(h)) m.set(h, []);
m.get(h).push(t);
});
});
return m;
})();

// Special-case copy for 2-tier: Remote (tier 1) + Winter Liner (tier 2)
const inferTwoTierHandles = () => {
try {
const t1 = tiers && tiers.length ? tiers[0] : null;
const t2 = tiers && tiers.length ? tiers[tiers.length - 1] : null;
const req1 = t1 && Array.isArray(t1.requiredAccessoryHandles) ? t1.requiredAccessoryHandles.map(x => resolveAccessoryTokenToHandle(x, idx)).filter(Boolean) : [];
const req2 = t2 && Array.isArray(t2.requiredAccessoryHandles) ? t2.requiredAccessoryHandles.map(x => resolveAccessoryTokenToHandle(x, idx)).filter(Boolean) : [];
const remoteH = req1.length === 1 ? optionNameHandle(req1[0]) : '';
let winterH = '';
if (remoteH && req2.length) {
const other = req2.map(x => optionNameHandle(x)).filter(Boolean).find(x => x !== remoteH) || '';
winterH = other;
}
return { remoteH, winterH, tier1: t1, tier2: t2 };
} catch (_e) { return { remoteH: '', winterH: '', tier1: null, tier2: null }; }
};
const { remoteH, winterH, tier1: tier1Rule, tier2: tier2Rule } = inferTwoTierHandles();

const _visorDiscountLabel = (() => {
  try {
    for (var ri = 0; ri < rules.length; ri++) {
      var r = rules[ri];
      var rHandles = Array.isArray(r.requiredAccessoryHandles) ? r.requiredAccessoryHandles : [];
      for (var rhi = 0; rhi < rHandles.length; rhi++) {
        var rh = optionNameHandle(rHandles[rhi] || '');
        if (rh && root.querySelector('[data-u1-pdp-accessory-handle="' + rh + '"][data-u1-pdp-visor="true"]')) {
          return getRuleLabel(r) || '';
        }
      }
    }
    return '';
  } catch(_e) { return ''; }
})();

const btns = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'));
btns.forEach((btn) => {
if (!btn || !btn.dataset) return;
const h = optionNameHandle(btn.dataset.u1PdpAccessoryHandle || '');
if (!h) return;

if (btn.dataset.u1PdpVisor === 'true' && _visorDiscountLabel) {
  setPromoCopyOnBtn(btn, { note: U1S.limited_offer, off: _visorDiscountLabel, show: true, bundleMsg: false });
  return;
}
const list = tiersByHandle.get(h) || null;
if (!list || !list.length) return;

const isSelected = btn.classList && btn.classList.contains('is-selected');
const remoteSelected = remoteH ? selected.has(remoteH) : false;
const winterSelected = winterH ? selected.has(winterH) : false;

if (remoteH && h === remoteH) {
if (winterH && remoteSelected && winterSelected) {
setPromoCopyOnBtn(btn, { note: U1S.unlocked, off: (tier2Rule ? getRuleLabel(tier2Rule) : ''), show: true, bundleMsg: true });
} else {
// Si Winter ya está seleccionado, agregar Remote completa el tier 2 → mostrar 15% OFF
if (winterH && winterSelected && !remoteSelected) {
setPromoCopyOnBtn(btn, { note: U1S.limited_offer, off: (tier2Rule ? getRuleLabel(tier2Rule) : (tier1Rule ? getRuleLabel(tier1Rule) : '')), show: true, bundleMsg: true });
} else {
setPromoCopyOnBtn(btn, { note: U1S.limited_offer, off: (tier1Rule ? getRuleLabel(tier1Rule) : ''), show: true, bundleMsg: true });
}
}
return;
}
if (winterH && h === winterH) {
if (remoteSelected && winterSelected) {
setPromoCopyOnBtn(btn, { note: U1S.unlocked, off: (tier2Rule ? getRuleLabel(tier2Rule) : ''), show: true, bundleMsg: true });
} else if (remoteSelected) {
const pct2 = extractPctFromLabel(tier2Rule ? getRuleLabel(tier2Rule) : '');
const pct1 = extractPctFromLabel(tier1Rule ? getRuleLabel(tier1Rule) : '');
const delta = (pct2 && pct1 && pct2 > pct1) ? (pct2 - pct1) : 5;
setPromoCopyOnBtn(btn, { note: U1S.limited_offer, off: U1S.pct_off_plus.replace('__N__', delta), show: true, bundleMsg: true });
} else {
const remoteTitle = getAccessoryTitleForHandle(remoteH, idx.byHandle ? idx : null, titleByHandle) || 'Remote';
setPromoCopyOnBtn(btn, { note: U1S.add_unlock.replace('__N__', remoteTitle), off: '', show: true, bundleMsg: true });
}
return;
}
// mejor tier que este item ayuda a desbloquear
const candidates = [...list].sort((a, b) => (Number(a.level || 0) || 0) - (Number(b.level || 0) || 0));
let target = null;
if (nextTier && candidates.some(t => String(t.id) === String(nextTier.id))) target = nextTier;
else if (currentTier && candidates.some(t => String(t.id) === String(currentTier.id))) target = currentTier;
else target = null;
const label = target ? getRuleLabel(target) : '';
if (!label) {
setPromoCopyOnBtn(btn, { note: '', off: '', show: false, bundleMsg: false });
return;
}

const req = Array.isArray(target.requiredAccessoryHandles) ? target.requiredAccessoryHandles.map(x => resolveAccessoryTokenToHandle(x, idx)).filter(Boolean) : [];
const missingNow = req.filter(x => x && !selected.has(String(x)));

let note = '';
let off = label;
if (missingNow.length === 0) {
note = U1S.unlocked;
} else if (!isSelected) {
const missingAfter = req.filter(x => x && !(selected.has(String(x)) || optionNameHandle(String(x)) === h));
if (missingAfter.length === 0) {
note = U1S.limited_offer;
} else {
const want = String(missingAfter[0] || '');
const wantTitle = getAccessoryTitleForHandle(want, idx.byHandle ? idx : null, titleByHandle) || want;
note = U1S.add_name.replace('__N__', wantTitle);
}
} else {
const want = String(missingNow[0] || '');
const wantTitle = getAccessoryTitleForHandle(want, idx.byHandle ? idx : null, titleByHandle) || want;
note = U1S.add_name.replace('__N__', wantTitle);
}

setPromoCopyOnBtn(btn, { note, off, show: true, bundleMsg: true });
});
};

// initial paint
try { syncBundleDiscountUi(); } catch (_e) {}

// Safety: re-sync after any accessory click (covers async DOM/state updates)
document.addEventListener('click', (e) => {
try {
const t = e && e.target && e.target.closest ? e.target.closest('[data-u1-pdp-accessory]') : null;
if (!t || !root.contains(t)) return;
window.requestAnimationFrame(() => {
try { syncBundleDiscountUi(); } catch (_e2) {}
});
} catch (_e) {}
}, true);
const toastEl = root.querySelector('[data-u1-toast]');
const showToast = (msg) => {
if (!toastEl) return;
toastEl.textContent = (msg || '').toString();
toastEl.classList.add('is-visible');
if (toastEl._u1Timer) window.clearTimeout(toastEl._u1Timer);
toastEl._u1Timer = window.setTimeout(() => {
toastEl.classList.remove('is-visible');
}, 1600);
};
const notifyModalEl = root.querySelector('[data-u1-notify-modal]');
const notifyCloseEls = Array.from(root.querySelectorAll('[data-u1-notify-close]'));
const notifyImgEl = root.querySelector('[data-u1-notify-img]');
const notifyNameEl = root.querySelector('[data-u1-notify-name]');
const notifyVariantEl = root.querySelector('[data-u1-notify-variant]');
const notifyUiForm = root.querySelector('[data-u1-notify-ui-form]');
const notifyUiEmail = root.querySelector('[data-u1-notify-ui-email]');
const notifyUiWrap = root.querySelector('[data-u1-notify-ui]');
const notifyUiCaption = root.querySelector('[data-u1-notify-ui-caption]');
const notifyUiSuccess = root.querySelector('[data-u1-notify-ui-success]');
const notifyMarketingCheck = root.querySelector('[data-u1-notify-marketing]');
const notifyUiSubmit = root.querySelector('.u1-notify-modal__submit');

const shopifyMarketId = CFG.marketId;
const notifyKlaviyoMount = root.querySelector('[data-u1-notify-klaviyo]');
const notifyKlaviyoTpl = root.querySelector('[data-u1-notify-klaviyo-template]');
const waitFor = (predicate, { timeoutMs = 8000, intervalMs = 50 } = {}) => new Promise((resolve, reject) => {
const started = Date.now();
const tick = () => {
try {
const v = predicate();
if (v) return resolve(v);
} catch (_e) {}
if (Date.now() - started >= timeoutMs) return reject(new Error('timeout'));
window.setTimeout(tick, intervalMs);
};
tick();
});
const ensureNotifyKlaviyoMounted = () => {
if (!notifyKlaviyoMount || !notifyKlaviyoTpl) return false;
if (notifyKlaviyoMount.dataset.u1Mounted === 'true') return true;
const html = (notifyKlaviyoTpl.innerHTML || '').trim();
if (!html) return false;
notifyKlaviyoMount.innerHTML = html;
notifyKlaviyoMount.hidden = false;
notifyKlaviyoMount.setAttribute('aria-hidden', 'true');
notifyKlaviyoMount.dataset.u1Mounted = 'true';
return true;
};
const showNotifyKlaviyoForm = () => {
if (notifyModalEl) notifyModalEl.classList.add('is-klaviyo-handoff');
if (notifyKlaviyoMount) {
notifyKlaviyoMount.hidden = false;
notifyKlaviyoMount.setAttribute('aria-hidden', 'false');
}
if (notifyUiWrap) {
notifyUiWrap.style.display = 'none';
}
};
const submitNotifyToStoq = async (email) => {
const variantId = Number(state && state.variantId ? state.variantId : 0);
if (!variantId) throw new Error('stoq_missing_variant');
const productId = Number(mainProductId || 0);
if (!productId) throw new Error('stoq_missing_product');
const shopDomain = (window.Shopify && window.Shopify.shop) ? String(window.Shopify.shop) : '';
if (!shopDomain) throw new Error('stoq_missing_shop_domain');
const payload = {
intent: {
shopify_variant_id: variantId,
shopify_product_id: productId,
...(shopifyMarketId ? { shopify_market_id: Number(shopifyMarketId) } : {}),
channel: 'email',
quantity: 1,
source: 'api',
},
customer: {
email: String(email || '').trim(),
accepts_marketing: !!(notifyMarketingCheck && notifyMarketingCheck.checked),
...(shopifyMarketId ? { shopify_market_id: Number(shopifyMarketId) } : {}),
},
};
const url = 'https://app.stoqapp.com/api/v1/intents.json';
try {
if (window.__U1_NOTIFY_DEBUG__ === true) {
const dbg = {
at: Date.now(),
page: String(location && location.href ? location.href : ''),
shopDomain,
variantId,
productId,
shopifyMarketId: shopifyMarketId || 0,
};
window.__u1NotifyDebug = dbg;
console.warn('[U1 Notify][Stoq] debug', dbg);
}
} catch (_e) {}
let res = null;
try {
res = await fetch(url, {
method: 'POST',
headers: {
'Content-Type': 'application/json',
'X-Shopify-Shop-Domain': shopDomain,
},
body: JSON.stringify(payload),
});
} catch (e) {
try { console.warn('[U1 Notify][Stoq] fetch failed', e); } catch (_e2) {}
throw e;
}
if (res && res.ok) return { ok: true, detail: 'stoq_back_in_stock' };
let txt = '';
try { txt = await res.text(); } catch (_e) {}
throw new Error(`stoq_back_in_stock_failed:${res ? res.status : '0'}:${txt || ''}`);
};
const setNotifyUiError = (msg) => {
if (notifyUiWrap) notifyUiWrap.classList.remove('is-success');
if (notifyUiWrap) notifyUiWrap.classList.add('is-error');
if (notifyUiCaption) notifyUiCaption.textContent = (msg || U1S.email_invalid).toString();
};
const clearNotifyUiError = () => {
if (notifyUiWrap) notifyUiWrap.classList.remove('is-error');
if (notifyUiCaption) notifyUiCaption.textContent = '';
};
const setNotifyUiSuccess = () => {
if (notifyUiWrap) notifyUiWrap.classList.remove('is-error');
if (notifyUiWrap) notifyUiWrap.classList.add('is-success');
if (notifyUiSuccess) notifyUiSuccess.setAttribute('aria-hidden', 'false');
};
const resetNotifyUi = () => {
if (notifyModalEl) notifyModalEl.classList.remove('is-klaviyo-handoff');
if (notifyUiWrap) {
notifyUiWrap.classList.remove('is-success');
notifyUiWrap.classList.remove('is-error');
notifyUiWrap.style.display = '';
}
if (notifyUiCaption) notifyUiCaption.textContent = '';
if (notifyUiSuccess) notifyUiSuccess.setAttribute('aria-hidden', 'true');
if (notifyUiForm) notifyUiForm._u1Submitting = false;
if (notifyUiEmail) {
notifyUiEmail.disabled = false;
notifyUiEmail.value = '';
}
if (notifyUiSubmit) {
notifyUiSubmit.disabled = false;
notifyUiSubmit.classList.remove('is-loading');
}
if (notifyKlaviyoMount) {
notifyKlaviyoMount.hidden = true;
notifyKlaviyoMount.setAttribute('aria-hidden', 'true');
}
};
const syncNotifyModalContent = () => {
if (!notifyModalEl) return;
const v = variants.find(v => v && Number(v.id) === Number(state.variantId)) || null;
const name = (mainProductTitle || mainProductHandle || 'UNIT1').toString();
const variantLabel = (() => {
if (v && v.title) return String(v.title);
const parts = [];
if (state.color) parts.push(state.color);
if (state.size) parts.push(state.size);
return parts.join(' ') || '';
})();
if (notifyNameEl) notifyNameEl.textContent = name.toUpperCase();
if (notifyVariantEl) notifyVariantEl.textContent = variantLabel;
try {
const idx = getActiveGalleryIndex();
const slide = slides[idx] || slides[state.galleryIndex] || null;
const img = slide ? slide.querySelector('img') : null;
const src = img ? (img.currentSrc || img.src || '') : '';
if (notifyImgEl && src) {
notifyImgEl.src = src;
notifyImgEl.alt = name;
}
} catch (_e) {}
};
const openNotifyModal = () => {
if (!notifyModalEl) return;
syncNotifyModalContent();
resetNotifyUi();
notifyModalEl.hidden = false;
window.requestAnimationFrame(() => notifyModalEl.classList.add('is-open'));
};
const closeNotifyModal = () => {
if (!notifyModalEl) return;
notifyModalEl.classList.remove('is-open');
window.setTimeout(() => { notifyModalEl.hidden = true; }, 220);
};
notifyCloseEls.forEach((el) => el.addEventListener('click', closeNotifyModal));
window.addEventListener('keydown', (e) => {
if (!notifyModalEl || notifyModalEl.hidden) return;
if (e.key === 'Escape') closeNotifyModal();
});
if (notifyUiForm && !notifyUiForm._u1Bound) {
notifyUiForm._u1Bound = true;
if (notifyUiEmail) {
notifyUiEmail.addEventListener('input', () => clearNotifyUiError());
notifyUiEmail.addEventListener('blur', () => {
const v = (notifyUiEmail.value || '').toString().trim();
if (!v) return;
const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
if (!ok) setNotifyUiError(U1S.email_invalid);
});
}
notifyUiForm.addEventListener('submit', async (e) => {
e.preventDefault();
const email = (notifyUiEmail && notifyUiEmail.value ? String(notifyUiEmail.value).trim() : '');
const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
if (!email || !isValid) {
setNotifyUiError(U1S.email_invalid);
notifyUiEmail?.focus?.();
return;
}
clearNotifyUiError();
if (notifyUiForm._u1Submitting) return;
notifyUiForm._u1Submitting = true;
if (notifyUiEmail) notifyUiEmail.disabled = true;
if (notifyUiSubmit) {
notifyUiSubmit.disabled = true;
notifyUiSubmit.classList.add('is-loading');
}
try {
const res = await submitNotifyToStoq(email);
if (res && res.ok) {
setNotifyUiSuccess();
} else {
setNotifyUiError(U1S.email_failed);
}
} catch (_err) {
try { if (window.__U1_NOTIFY_DEBUG__ === true) console.warn('[U1 Notify] submit failed', _err, window.__u1NotifyDebug || null); } catch (_e) {}
try {
setNotifyUiError(U1S.email_failed);
} catch (_e2) {
setNotifyUiError(U1S.email_failed);
}
} finally {
if (notifyUiEmail) notifyUiEmail.disabled = false;
if (notifyUiSubmit) {
notifyUiSubmit.disabled = false;
notifyUiSubmit.classList.remove('is-loading');
}
notifyUiForm._u1Submitting = false;
}
});
}
const sizeChartModalEl = root.querySelector('[data-u1-size-chart-modal]');
const sizeChartCloseEls = Array.from(root.querySelectorAll('[data-u1-size-chart-close]'));
const sizeChartScrollEl = sizeChartModalEl ? sizeChartModalEl.querySelector('[data-u1-size-chart-scroll]') : null;
const sizeChartUnitBtns = Array.from(sizeChartModalEl ? sizeChartModalEl.querySelectorAll('[data-u1-size-chart-unit-btn]') : []);
const sizeChartValEls = Array.from(sizeChartModalEl ? sizeChartModalEl.querySelectorAll('[data-u1-size-chart-val]') : []);
const sizeChartToggleEl = sizeChartModalEl ? sizeChartModalEl.querySelector('[data-u1-size-chart-toggle]') : null;
const sizeChartThumbEl = sizeChartModalEl ? sizeChartModalEl.querySelector('[data-u1-size-chart-thumb]') : null;
const convertInToCmRange = (raw) => {
const s = (raw || '').toString().trim();
if (!s) return '';
const nums = Array.from(s.matchAll(/(\d+(?:\.\d+)?)/g)).map(m => Number(m[1]));
if (!nums.length) return '';
const delim = s.includes('–') ? '–' : '-';
const fmt = (n) => (n * 2.54).toFixed(1);
if (nums.length >= 2 && s.includes(delim)) return `${fmt(nums[0])}${delim}${fmt(nums[1])}`;
if (nums.length === 1) return `${fmt(nums[0])}`;
return nums.map(fmt).join(delim);
};
const applySizeChartUnit = (unit) => {
if (!sizeChartModalEl) return;
const u = (unit === 'cm') ? 'cm' : 'in';
sizeChartModalEl.dataset.u1SizeChartUnit = u;
if (sizeChartToggleEl) sizeChartToggleEl.classList.toggle('is-cm', u === 'cm');
sizeChartUnitBtns.forEach((btn) => {
const isActive = (btn.dataset.unit || '') === u;
btn.classList.toggle('is-active', isActive);
btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
});
sizeChartValEls.forEach((cell) => {
const inVal = (cell.dataset.in || '').toString().trim();
const cmVal = (cell.dataset.cm || '').toString().trim();
const numEl = cell.querySelector('[data-u1-size-chart-num]');
const unitEl = cell.querySelector('[data-u1-size-chart-unit]');
const nextVal = (u === 'cm') ? (cmVal || convertInToCmRange(inVal)) : inVal;
if (numEl) numEl.textContent = nextVal || '';
if (unitEl) unitEl.textContent = u;
});
};
const updateSizeChartGradients = () => {
if (!sizeChartModalEl || !sizeChartScrollEl) return;
const top = sizeChartScrollEl.scrollTop <= 2;
const bottom = (sizeChartScrollEl.scrollTop + sizeChartScrollEl.clientHeight) >= (sizeChartScrollEl.scrollHeight - 2);
sizeChartModalEl.classList.toggle('is-at-top', top);
sizeChartModalEl.classList.toggle('is-at-bottom', bottom);
};
const updateSizeChartScrollbar = () => {
if (!sizeChartThumbEl || !sizeChartScrollEl) return;
const h = sizeChartScrollEl.clientHeight;
const sh = sizeChartScrollEl.scrollHeight;
const hasOverflow = sh > (h + 2);
if (sizeChartModalEl) sizeChartModalEl.classList.toggle('is-no-scroll', !hasOverflow);
if (!hasOverflow) {
sizeChartThumbEl.style.height = `0px`;
sizeChartThumbEl.style.transform = `translateY(0px)`;
return;
}
const maxScroll = Math.max(1, sh - h);
const ratio = h / sh;
const barEl = sizeChartThumbEl.parentElement;
const barH = barEl ? barEl.clientHeight : 320;
const thumbH = Math.max(56, Math.min(barH, Math.round(barH * ratio)));
const maxY = Math.max(0, barH - thumbH);
const y = Math.round((sizeChartScrollEl.scrollTop / maxScroll) * maxY);
sizeChartThumbEl.style.height = `${thumbH}px`;
sizeChartThumbEl.style.transform = `translateY(${y}px)`;
};
const openSizeChartModal = () => {
if (!sizeChartModalEl) return;
sizeChartModalEl.hidden = false;
applySizeChartUnit('in');
window.requestAnimationFrame(() => {
updateSizeChartGradients();
updateSizeChartScrollbar();
sizeChartModalEl.classList.add('is-open');
});
};
const closeSizeChartModal = () => {
if (!sizeChartModalEl) return;
sizeChartModalEl.classList.remove('is-open');
window.setTimeout(() => { sizeChartModalEl.hidden = true; }, 220);
};
sizeChartCloseEls.forEach((el) => el.addEventListener('click', closeSizeChartModal));
if (sizeChartScrollEl) sizeChartScrollEl.addEventListener('scroll', () => {
updateSizeChartGradients();
updateSizeChartScrollbar();
if (sizeChartModalEl) {
sizeChartModalEl.classList.add('is-scrolling');
if (sizeChartModalEl._u1ScrollTimer) window.clearTimeout(sizeChartModalEl._u1ScrollTimer);
sizeChartModalEl._u1ScrollTimer = window.setTimeout(() => {
sizeChartModalEl.classList.remove('is-scrolling');
}, 260);
}
}, { passive: true });
sizeChartUnitBtns.forEach((btn) => btn.addEventListener('click', () => applySizeChartUnit(btn.dataset.unit || 'in')));
const sparkySizeChartModalEl = root.querySelector('[data-u1-sparky-size-chart-modal]');
const sparkySizeChartCloseEls = sparkySizeChartModalEl
? Array.from(sparkySizeChartModalEl.querySelectorAll('[data-u1-sparky-size-chart-close]'))
: [];
const sparkySizeChartScrollEl = sparkySizeChartModalEl
? sparkySizeChartModalEl.querySelector('[data-u1-sparky-size-chart-scroll]')
: null;
const sparkySizeChartThumbEl = sparkySizeChartModalEl
? sparkySizeChartModalEl.querySelector('[data-u1-sparky-size-chart-thumb]')
: null;
const updateSparkySizeChartGradients = () => {
if (!sparkySizeChartModalEl || !sparkySizeChartScrollEl) return;
const top = sparkySizeChartScrollEl.scrollTop <= 2;
const bottom = (sparkySizeChartScrollEl.scrollTop + sparkySizeChartScrollEl.clientHeight) >= (sparkySizeChartScrollEl.scrollHeight - 2);
sparkySizeChartModalEl.classList.toggle('is-at-top', top);
sparkySizeChartModalEl.classList.toggle('is-at-bottom', bottom);
};
const updateSparkySizeChartScrollbar = () => {
if (!sparkySizeChartThumbEl || !sparkySizeChartScrollEl || !sparkySizeChartModalEl) return;
const h = sparkySizeChartScrollEl.clientHeight;
const sh = sparkySizeChartScrollEl.scrollHeight;
const hasOverflow = sh > (h + 2);
sparkySizeChartModalEl.classList.toggle('is-no-scroll', !hasOverflow);
if (!hasOverflow) {
sparkySizeChartThumbEl.style.height = '0px';
sparkySizeChartThumbEl.style.transform = 'translateY(0px)';
return;
}
const maxScroll = Math.max(1, sh - h);
const ratio = h / sh;
const barEl = sparkySizeChartThumbEl.parentElement;
const barH = barEl ? barEl.clientHeight : 320;
const thumbH = Math.max(56, Math.min(barH, Math.round(barH * ratio)));
const maxY = Math.max(0, barH - thumbH);
const y = Math.round((sparkySizeChartScrollEl.scrollTop / maxScroll) * maxY);
sparkySizeChartThumbEl.style.height = `${thumbH}px`;
sparkySizeChartThumbEl.style.transform = `translateY(${y}px)`;
};
const openSparkySizeChartModal = () => {
if (!sparkySizeChartModalEl) return;
sparkySizeChartModalEl.hidden = false;
window.requestAnimationFrame(() => {
updateSparkySizeChartGradients();
updateSparkySizeChartScrollbar();
sparkySizeChartModalEl.classList.add('is-open');
});
};
const closeSparkySizeChartModal = () => {
if (!sparkySizeChartModalEl) return;
sparkySizeChartModalEl.classList.remove('is-open');
window.setTimeout(() => { sparkySizeChartModalEl.hidden = true; }, 220);
};
sparkySizeChartCloseEls.forEach((el) => el.addEventListener('click', closeSparkySizeChartModal));
if (sparkySizeChartScrollEl) {
sparkySizeChartScrollEl.addEventListener('scroll', () => {
updateSparkySizeChartGradients();
updateSparkySizeChartScrollbar();
if (sparkySizeChartModalEl) {
sparkySizeChartModalEl.classList.add('is-scrolling');
if (sparkySizeChartModalEl._u1ScrollTimer) window.clearTimeout(sparkySizeChartModalEl._u1ScrollTimer);
sparkySizeChartModalEl._u1ScrollTimer = window.setTimeout(() => {
sparkySizeChartModalEl.classList.remove('is-scrolling');
}, 260);
}
}, { passive: true });
}
Array.from(root.querySelectorAll('[data-u1-pdp-sparky-size-chart]')).forEach((btn) => {
btn.addEventListener('click', (ev) => {
ev.preventDefault();
openSparkySizeChartModal();
});
});
window.addEventListener('keydown', (e) => {
if (e.key !== 'Escape') return;
if (sparkySizeChartModalEl && !sparkySizeChartModalEl.hidden) {
closeSparkySizeChartModal();
return;
}
if (!sizeChartModalEl || sizeChartModalEl.hidden) return;
closeSizeChartModal();
});
const measureModalEl = root.querySelector('[data-u1-measure-modal]');
const measureCloseEls = Array.from(root.querySelectorAll('[data-u1-measure-close]'));
const measureVideoEl = measureModalEl ? measureModalEl.querySelector('[data-u1-measure-video]') : null;
const measurePlayerMount = measureModalEl ? measureModalEl.querySelector('[data-u1-measure-player]') : null;
const parseYouTubeId = (raw) => {
const s = (raw || '').toString().trim();
if (!s) return '';
if (/^[a-zA-Z0-9_-]{11}$/.test(s)) return s;
try {
const u = new URL(s);
const host = (u.hostname || '').toLowerCase();
if (host.includes('youtu.be')) {
const id = u.pathname.split('/').filter(Boolean)[0] || '';
return (id || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 11);
}
const v = u.searchParams.get('v');
if (v) return v.replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 11);
const parts = u.pathname.split('/').filter(Boolean);
const idx = parts.indexOf('embed');
if (idx >= 0 && parts[idx + 1]) return parts[idx + 1];
const sIdx = parts.indexOf('shorts');
if (sIdx >= 0 && parts[sIdx + 1]) return (parts[sIdx + 1] || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 11);
const lIdx = parts.indexOf('live');
if (lIdx >= 0 && parts[lIdx + 1]) return (parts[lIdx + 1] || '').replace(/[^a-zA-Z0-9_-]/g, '').slice(0, 11);
return '';
} catch (_e) {
const m = s.match(/(?:v=|\/shorts\/|\/embed\/|youtu\.be\/|\/live\/)([a-zA-Z0-9_-]{11})/);
return m && m[1] ? m[1] : '';
}
};
const buildMeasureEmbedUrl = (vid) => {
const id = (vid || '').toString().trim();
if (!id) return '';
const params = new URLSearchParams({
autoplay: '0',
controls: '1',
rel: '0',
playsinline: '1',
modestbranding: '1',
iv_load_policy: '3',
});
return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?${params.toString()}`;
};
const openMeasureModal = () => {
if (!measureModalEl) return;
ensureMeasureIframe();
measureModalEl.hidden = false;
window.requestAnimationFrame(() => measureModalEl.classList.add('is-open'));
};
const closeMeasureModal = () => {
if (!measureModalEl) return;
measureModalEl.classList.remove('is-open');
try { if (measurePlayerMount) measurePlayerMount.innerHTML = ''; } catch (_e) {}
window.setTimeout(() => { measureModalEl.hidden = true; }, 220);
};
measureCloseEls.forEach((el) => el.addEventListener('click', closeMeasureModal));
window.addEventListener('keydown', (e) => {
if (!measureModalEl || measureModalEl.hidden) return;
if (e.key === 'Escape') closeMeasureModal();
});
const ensureMeasureIframe = () => {
if (!measureModalEl || !measurePlayerMount) return null;
if (measurePlayerMount.querySelector('iframe')) return measurePlayerMount.querySelector('iframe');
const vid = parseYouTubeId(measureModalEl.dataset.u1MeasureYoutube || '');
if (!vid) return null;
const src = buildMeasureEmbedUrl(vid);
if (!src) return null;
measurePlayerMount.innerHTML = `
<iframe
src="${src}"
title="${U1S.yt_player}"
allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
allowfullscreen
referrerpolicy="strict-origin-when-cross-origin"
></iframe>
`;
return measurePlayerMount.querySelector('iframe');
};
const infoModalEl = root.querySelector('[data-u1-info-modal]');
const infoCloseEls = Array.from(root.querySelectorAll('[data-u1-info-close]'));
const infoTitleEl = root.querySelector('[data-u1-info-title]');
const infoDescEl = root.querySelector('[data-u1-info-desc]');
const infoPriceEl = root.querySelector('[data-u1-info-price]');
const infoMediaWrap = root.querySelector('[data-u1-info-media]');
const infoImgEl = root.querySelector('[data-u1-info-img]');
const isCardInfoEnabled = (root.dataset.u1PdpAccessoriesInfo || 'true') !== 'false';
const openInfoModalFromCard = (cardEl) => {
if (!infoModalEl || !cardEl) return;
const t = cardEl.dataset.u1PdpInfoTitle || U1S.info;
const d = cardEl.dataset.u1PdpInfoDesc || '';
const p = cardEl.dataset.u1PdpInfoPrice || '';
const img = cardEl.dataset.u1PdpInfoImg || '';
if (infoTitleEl) infoTitleEl.textContent = t;
if (infoDescEl) { infoDescEl.textContent = d; infoDescEl.hidden = !d; }
if (infoPriceEl) infoPriceEl.textContent = p || '';
if (infoMediaWrap && infoImgEl && img) {
infoMediaWrap.hidden = false;
infoImgEl.src = img;
infoImgEl.alt = t;
} else if (infoMediaWrap) {
infoMediaWrap.hidden = true;
}
infoModalEl.hidden = false;
};
const closeInfoModal = () => {
if (!infoModalEl) return;
infoModalEl.hidden = true;
};
const openInfoModalSimple = ({ title, desc }) => {
if (!infoModalEl) return;
const t = (title || U1S.info).toString();
const d = (desc || '').toString();
if (infoTitleEl) infoTitleEl.textContent = t;
if (infoDescEl) { infoDescEl.textContent = d; infoDescEl.hidden = !d; }
if (infoPriceEl) infoPriceEl.textContent = '';
if (infoMediaWrap) infoMediaWrap.hidden = true;
infoModalEl.hidden = false;
};
infoCloseEls.forEach((el) => el.addEventListener('click', closeInfoModal));
window.addEventListener('keydown', (e) => {
if (!infoModalEl || infoModalEl.hidden) return;
if (e.key === 'Escape') closeInfoModal();
});
// Model switch (cross-product): navegar al producto seleccionado (scopeado al step)
(() => {
const _u1Fpm = (h) => { try { root._u1FilterPacksByModel?.(h); } catch (_e) {} };
const step = root.querySelector('[data-u1-pdp-step="product_model"]');
if (!step) return;
const _u1ApplyModel = (model, handle) => {
mainProductTitle = model.title || mainProductTitle;
mainProductHandle = model.handle || mainProductHandle;
mainProductId = model.id || mainProductId;
variants = model.variants;
_u1RecalcPreorder(variants);
// Disponibilidad de colores/talles del modelo nuevo
try { updateColorAvailability(); } catch (_eCU2) {}
try { updateSizeAvailability(); } catch (_eSU2) {}
try {
const isMips = (String(root.dataset.u1PdpMipsForce || '') === '1') || /mips/i.test(String(model.handle || '')) || /mips/i.test(String(model.title || ''));
root.dataset.u1PdpIsMips = isMips ? '1' : '0';
if (!isMips) {
try { clearMipsOverlays(); } catch (_eC) {}
}
} catch (_eM) {}

try {
const titleEl = root.querySelector('.u1-pdp-product__title');
if (titleEl) titleEl.textContent = U1S.buy_title.replace('__T__', mainProductTitle).trim();
} catch (_eT) {}
try {
const descEl = root.querySelector('[data-u1-pdp-desc]');
if (descEl && typeof model.descriptionHtml === 'string') descEl.innerHTML = model.descriptionHtml;
} catch (_eD) {}

try {
const btns = Array.from(step.querySelectorAll('[data-u1-pdp-product-model]'));
btns.forEach((b) => {
const on = String(b.dataset.u1PdpProductModelHandle || '') === handle;
b.classList.toggle('is-selected', on);
b.setAttribute('aria-pressed', on ? 'true' : 'false');
});
} catch (_eS) {}

try { updateVariant(); } catch (_eV) {}
try { root._u1RequestAccessoriesBaseRefresh?.(); } catch (_eA) {}
try { root._u1RequestSyncModeOverlays?.(); } catch (_eO) {}
try { syncMipsOverlayUi(); } catch (_eMO) {}
try { renderMobileGalleries(); } catch (_eMG) {}
root._u1ModelGallery?.(model, handle);
try { updateStepMobileTitle('product_model', model.title || handle); } catch (_eMT) {}
_u1Fpm(model.handle || handle);
};
step.addEventListener('click', (e) => {
const t = e.target;
if (!t || !t.closest) return;
const btn = t.closest('[data-u1-pdp-product-model][data-u1-pdp-product-model-handle]');
if (!btn || !step.contains(btn)) return;
const handle = (btn.dataset.u1PdpProductModelHandle || '').toString();
if (!handle) return;
if (btn.getAttribute('aria-disabled') === 'true') return;
if (btn.classList.contains('is-selected')) return;

// ── Variant model mode (single product, model = variant option value) ──
/* Una card que apunta a OTRO producto trae su id: esas van siempre por la rama de
   cambio de producto, aunque el capitulo sea de variantes. */
if (IS_VARIANT_MODEL_MODE && !btn.dataset.u1PdpProductModelId) {
if (mainProductHandle !== U1_HOME_MODEL.handle) { try { _u1ApplyModel(U1_HOME_MODEL, handle); } catch (_eH) {} }
state.variantModel = handle;
const isMips = (String(root.dataset.u1PdpMipsForce || '') === '1') || /mips/i.test(handle);
root.dataset.u1PdpIsMips = isMips ? '1' : '0';
if (!isMips) { try { clearMipsOverlays(); } catch (_eC) {} }
// Restaurar color memorizado para este modelo antes de recalcular disponibilidad
if (colorMemory.has(handle)) state.color = colorMemory.get(handle);
try {
const btns = Array.from(step.querySelectorAll('[data-u1-pdp-product-model]'));
btns.forEach((b) => {
const on = String(b.dataset.u1PdpProductModelHandle || '') === handle;
b.classList.toggle('is-selected', on);
b.setAttribute('aria-pressed', on ? 'true' : 'false');
});
} catch (_eS) {}
try { updateColorAvailability(); } catch (_eCU) {}
try { updateSizeAvailability(); } catch (_eSU) {}
try { updateVariant(); } catch (_eV) {}
try { root._u1RequestAccessoriesBaseRefresh?.(); } catch (_eA) {}
try { root._u1RequestSyncModeOverlays?.(); } catch (_eO) {}
try { syncMipsOverlayUi(); } catch (_eMO) {}
try { renderMobileGalleries(); } catch (_eMG) {}
try { updateStepMobileTitle('product_model', handle); } catch (_eT) {}
_u1Fpm(handle);
return;
}

// ── helmet_models mode (separate products) ──
const model = productModels.get(handle) || null;
if (!model || !Array.isArray(model.variants) || !model.variants.length) return;

_u1ApplyModel(model, handle);
}, true);
/* Default product model: auto-click de la card que matchea (no en variant-model mode) */
(() => {
try {
if (String(root.dataset.u1PdpVariantModelMode || '') === '1') return;
const defHandle = (root.dataset.u1PdpDefaultProductModel || '').trim();
if (!defHandle) return;
const btn = step.querySelector('[data-u1-pdp-product-model-handle="' + CSS.escape(defHandle) + '"]');
if (!btn || btn.classList.contains('is-selected')) return;
requestAnimationFrame(() => { requestAnimationFrame(() => {
try { if (!btn.classList.contains('is-selected')) btn.click(); } catch (_eDPM) {}
}); });
} catch (_eDPMi) {}
})();
})();
root.addEventListener('click', (e) => {
const t = e.target;
if (!t || !t.closest) return;
const opener = t.closest('[data-u1-pdp-open-info]');
if (!opener) return;
if (!isCardInfoEnabled) return;
const card = opener.closest('.u1-pdp-card');
if (!card) return;
e.preventDefault();
e.stopPropagation();
openInfoModalFromCard(card);
}, true);
const crashTermsModalEl = root.querySelector('[data-u1-crash-terms-modal]');
const crashTermsCloseEls = Array.from(root.querySelectorAll('[data-u1-crash-terms-close]'));
const crashTermsScrollEl = crashTermsModalEl ? crashTermsModalEl.querySelector('[data-u1-crash-terms-scroll]') : null;
const crashTermsThumbEl = crashTermsModalEl ? crashTermsModalEl.querySelector('[data-u1-crash-terms-thumb]') : null;
const lockPageScroll = (on) => {
try { document.documentElement.style.overflow = on ? 'hidden' : ''; } catch (_e) {}
};
const updateCrashTermsGradients = () => {
if (!crashTermsModalEl || !crashTermsScrollEl) return;
const top = crashTermsScrollEl.scrollTop <= 2;
const bottom = (crashTermsScrollEl.scrollTop + crashTermsScrollEl.clientHeight) >= (crashTermsScrollEl.scrollHeight - 2);
crashTermsModalEl.classList.toggle('is-at-top', top);
crashTermsModalEl.classList.toggle('is-at-bottom', bottom);
};
const updateCrashTermsScrollbar = () => {
if (!crashTermsThumbEl || !crashTermsScrollEl || !crashTermsModalEl) return;
const h = crashTermsScrollEl.clientHeight;
const sh = crashTermsScrollEl.scrollHeight;
const hasOverflow = sh > (h + 2);
crashTermsModalEl.classList.toggle('is-no-scroll', !hasOverflow);
if (!hasOverflow) {
crashTermsThumbEl.style.height = `0px`;
crashTermsThumbEl.style.transform = `translateY(0px)`;
return;
}
const maxScroll = Math.max(1, sh - h);
const ratio = h / sh;
const barEl = crashTermsThumbEl.parentElement;
const barH = barEl ? barEl.clientHeight : 320;
const thumbH = Math.max(56, Math.min(barH, Math.round(barH * ratio)));
const maxY = Math.max(0, barH - thumbH);
const y = Math.round((crashTermsScrollEl.scrollTop / maxScroll) * maxY);
crashTermsThumbEl.style.height = `${thumbH}px`;
crashTermsThumbEl.style.transform = `translateY(${y}px)`;
};
const openCrashTermsModal = () => {
if (!crashTermsModalEl) return;
crashTermsModalEl.hidden = false;
lockPageScroll(true);
window.requestAnimationFrame(() => {
updateCrashTermsGradients();
updateCrashTermsScrollbar();
crashTermsModalEl.classList.add('is-open');
});
};
const closeCrashTermsModal = () => {
if (!crashTermsModalEl) return;
crashTermsModalEl.classList.remove('is-open');
lockPageScroll(false);
window.setTimeout(() => { crashTermsModalEl.hidden = true; }, 220);
};
crashTermsCloseEls.forEach((el) => el.addEventListener('click', closeCrashTermsModal));
if (crashTermsScrollEl) crashTermsScrollEl.addEventListener('scroll', () => {
updateCrashTermsGradients();
updateCrashTermsScrollbar();
if (crashTermsModalEl) {
crashTermsModalEl.classList.add('is-scrolling');
if (crashTermsModalEl._u1ScrollTimer) window.clearTimeout(crashTermsModalEl._u1ScrollTimer);
crashTermsModalEl._u1ScrollTimer = window.setTimeout(() => {
crashTermsModalEl.classList.remove('is-scrolling');
}, 260);
}
}, { passive: true });
window.addEventListener('keydown', (e) => {
if (!crashTermsModalEl || crashTermsModalEl.hidden) return;
if (e.key === 'Escape') closeCrashTermsModal();
});
const visorBestModalEl = root.querySelector('[data-u1-visor-best-modal]');
const visorBestCloseEls = Array.from(root.querySelectorAll('[data-u1-visor-best-close]'));
const openVisorBestModal = () => {
if (!visorBestModalEl) return;

try {
  var availableVisors = new Set();
  root.querySelectorAll('[data-u1-pdp-visor="true"]').forEach(function(v) {
    if (v.hidden || v.closest('[hidden]')) return;
    var title = (v.getAttribute('data-u1-pdp-info-title') || '').trim().toLowerCase();
    if (title) availableVisors.add(title);
  });
  if (availableVisors.size > 0) {
    visorBestModalEl.querySelectorAll('[data-u1-visor-type]').forEach(function(col) {
      var type = (col.getAttribute('data-u1-visor-type') || '').toLowerCase();

      var visible = availableVisors.has(type) || (type === 'photochromic' && availableVisors.has('adaptive'));
      col.hidden = !visible;
    });
  }
} catch(_e) {}
visorBestModalEl.hidden = false;
lockPageScroll(true);
window.requestAnimationFrame(() => visorBestModalEl.classList.add('is-open'));
};
const closeVisorBestModal = () => {
if (!visorBestModalEl) return;
visorBestModalEl.classList.remove('is-open');
lockPageScroll(false);
window.setTimeout(() => { visorBestModalEl.hidden = true; }, 220);
};
visorBestCloseEls.forEach((el) => el.addEventListener('click', closeVisorBestModal));
window.addEventListener('keydown', (e) => {
if (!visorBestModalEl || visorBestModalEl.hidden) return;
if (e.key === 'Escape') closeVisorBestModal();
});
const helpEls = Array.from(root.querySelectorAll('[data-u1-pdp-size-help], [data-u1-pdp-visor-help], [data-u1-pdp-crash-terms]'));
helpEls.forEach((el) => {
el.addEventListener('click', (e) => {
e.preventDefault();
const sizeHelp = el.dataset.u1PdpSizeHelp || '';
const visorHelp = el.dataset.u1PdpVisorHelp || '';
const isTerms = el.hasAttribute('data-u1-pdp-crash-terms');
if (isTerms || sizeHelp === 'terms') {
openCrashTermsModal();
return;
}
if (visorHelp) {
if (visorHelp === 'best') {
openVisorBestModal();
return;
}
openInfoModalSimple({ title: U1S.visor_help, desc: '' });
return;
}
if (sizeHelp === 'what') {
openSizeChartModal();
return;
}
if (sizeHelp === 'measure') {
openMeasureModal();
return;
}
openInfoModalSimple({ title: U1S.info, desc: '' });
});
});
if (isCardInfoEnabled) {
const openInfoHoverEls = Array.from(root.querySelectorAll('.u1-pdp-card [data-u1-pdp-open-info]'));
openInfoHoverEls.forEach((el) => {
const card = el.closest('.u1-pdp-card');
if (!card) return;
const clearOff = () => {
if (card._u1InfoHoverOff) {
window.clearTimeout(card._u1InfoHoverOff);
card._u1InfoHoverOff = null;
}
};
el.addEventListener('mouseenter', () => {
clearOff();
card.classList.add('is-open-info-hover');
});
el.addEventListener('mouseleave', () => {
clearOff();
card._u1InfoHoverOff = window.setTimeout(() => {
card.classList.remove('is-open-info-hover');
}, 12);
});
});
}
root.addEventListener('click', (e) => {
const isLight = TEMPLATE === 'light';
const isAccessory = false;
const needsModel = isAccessory ? !state.model : false;
const needsColor = !isLight && HAS_COLOR_CHAPTER && !state.color;
const needsSize = (() => {
if (isLight) return false;
if (!HAS_CHAPTER_SIZE) return false;
if (!HAS_SIZE_OPTION) return false;
return !state.size;
})();
const needsHelmetSize = (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER) && !!root.querySelector('[data-u1-pdp-helmet-size-picker]') && !state.helmetSize;
const requiredStep = (() => {
if (isLight) {
if (!state.variantId) return 'model';
if (needsHelmetSize) return 'helmet_size';
return null;
}
if (typeof SILICONE_INSERTS_PDP !== 'undefined' && SILICONE_INSERTS_PDP) {
if (HAS_CHAPTER_SIZE && HAS_SIZE_OPTION && !state.size) return 'size';
if (HAS_COLOR_CHAPTER && !state.color) return 'color';
if (needsHelmetSize) return 'helmet_size';
return null;
}
return needsModel ? 'model' : (needsColor ? 'color' : (needsSize ? 'size' : (needsHelmetSize ? 'helmet_size' : null)));
})();
const isBlocked = isLight ? (!state.variantId || needsHelmetSize) : (needsModel || needsColor || needsSize || needsHelmetSize);
if (!isBlocked) return;
const t = e.target;
if (!t || !t.closest) return;
if (t.closest('[data-u1-pdp-open-info]')) return;
const step = t.closest('[data-u1-pdp-step]');
if (!step) return;
const stepName = step.dataset.u1PdpStep || '';
// Permitir cambiar de producto/modelo antes de elegir color (helmet model switch)
if (stepName === 'product_model') return;
// Template light (ej. visors): se puede cambiar de card Model salvo que falte helmet size
if (stepName === 'model' && !needsHelmetSize) return;
if (stepName === 'size') return;
if (stepName === 'sparky_color' || stepName === 'sparky_inserts') return;
if (stepName === 'color' && !(typeof SILICONE_INSERTS_PDP !== 'undefined' && SILICONE_INSERTS_PDP && HAS_CHAPTER_SIZE && HAS_SIZE_OPTION && !state.size)) return;
if (stepName === 'helmet_size') return;
if (stepName === 'helmet_model') return;
if (stepName === 'bundle') return;
// Torch: permitir clicks en step accessories (cards Smart Light / Pro Dual) sin bloquear
if (typeof TEMPLATE_RAW !== 'undefined' && TEMPLATE_RAW === 'torch' && stepName === 'accessories') return;
if (stepName && requiredStep && stepName !== requiredStep && stepName !== 'description') {
e.preventDefault();
e.stopPropagation();
const toastHelmet = requiredStep === 'helmet_size' ? U1S.sel_helmet_first : null;
const toastModelFirst = (requiredStep === 'model' || (typeof SILICONE_INSERTS_PDP !== 'undefined' && SILICONE_INSERTS_PDP && requiredStep === 'size'));
showToast(toastModelFirst ? U1S.sel_model_first : (requiredStep === 'color' ? U1S.sel_color_first : (toastHelmet || U1S.sel_size)));
}
}, true);
const colorPickerEl = root.querySelector('.u1-pdp-color__picker');
let hoverColorValue = null;
const getNearestColorValue = (clientX, clientY) => {
if (!colorButtons || colorButtons.length === 0) return null;
let bestBtn = null;
let bestD = Infinity;
for (const b of colorButtons) {
const r = b.getBoundingClientRect();
const cx = r.left + r.width / 2;
const cy = r.top + r.height / 2;
const dx = clientX - cx;
const dy = clientY - cy;
const d = dx * dx + dy * dy;
if (d < bestD) { bestD = d; bestBtn = b; }
}
return bestBtn ? (bestBtn.dataset.u1PdpValue || '') : null;
};
const setHoverColor = (v) => {
const next = (v || '').toString();
if (!next) return;
if (hoverColorValue === next) return;
hoverColorValue = next;
setColorDisplay(next, true);
};
const clearHoverColor = () => {
hoverColorValue = null;
setColorDisplay(state.color || null, true);
};
if (colorPickerEl) {
const moveEvt = ('PointerEvent' in window) ? 'pointermove' : 'mousemove';
colorPickerEl.addEventListener(moveEvt, (e) => {
const evt = e;
const targetBtn = evt.target && evt.target.closest ? evt.target.closest('[data-u1-pdp-color]') : null;
if (targetBtn) {
setHoverColor(targetBtn.dataset.u1PdpValue || '');
return;
}
if (typeof evt.clientX === 'number' && typeof evt.clientY === 'number') {
setHoverColor(getNearestColorValue(evt.clientX, evt.clientY));
}
}, { passive: true });
colorPickerEl.addEventListener('pointerleave', clearHoverColor);
colorPickerEl.addEventListener('mouseleave', clearHoverColor);
}
colorButtons.forEach(btn => {
btn.addEventListener('click', () => {
const v = btn.dataset.u1PdpValue || null;
if (btn.getAttribute('aria-disabled') === 'true') return;
if (state.color && v && state.color === v) {
window.setTimeout(() => {
try { window.scrollBy({ top: stickyAtcNudgePx, left: 0, behavior: 'smooth' }); } catch (_e) { window.scrollBy(0, stickyAtcNudgePx); }
}, 0);
return;
}
const prevColor = state.color;
state.color = v;
if (v) hasSelectedColor = true;
// Recordar último color elegido para este modelo
if (IS_VARIANT_MODEL_MODE && state.variantModel && v) colorMemory.set(state.variantModel, v);
setSelectedButton(colorButtons, v);
setColorDisplay(v || '');
transitionGalleryToColor(v, { durationMs: 133, prevColor });
window.setTimeout(function() { try { if (root._u1UpdateBundleGallery) root._u1UpdateBundleGallery(); } catch(_e) {} }, 50);
updateSizeAvailability();
updateVariant();
if (stickyBottomEl) {
showStickyBottom();
if (!hasUserScrolled && !didAutoNudge) {
didAutoNudge = true;
window.setTimeout(() => {
try { window.scrollBy({ top: stickyAtcNudgePx, left: 0, behavior: 'smooth' }); } catch (_e) { window.scrollBy(0, stickyAtcNudgePx); }
}, 0);
}
}
updateStickyChevron();
updateGalleryC1Variant();
scheduleGalleryUxModeCheck();
syncModeOverlays();
});
});
if (colorNameEl) {
colorNameEl.dataset.initialValue = PLACEHOLDER_COLOR_TEXT;
}
const sizePickerEl = root.querySelector('[data-u1-pdp-size-picker]');
const sizePillEl = sizePickerEl ? sizePickerEl.querySelector('[data-u1-pdp-size-pill]') : null;
const sizeDividers = sizePickerEl ? Array.from(sizePickerEl.querySelectorAll('.u1-pdp-size__divider')) : [];
let hoverSizeIndex = null;
const getSizeIndex = (btn) => {
if (!btn) return null;
const all = sizeButtons;
const idx = all.indexOf(btn);
return idx >= 0 ? idx : null;
};
const applySizeActiveIndex = () => {
if (!sizePickerEl) return;
const selectedIdx = getSizeIndex(sizeButtons.find(b => b.classList.contains('is-selected')));
if (selectedIdx === null || selectedIdx === undefined || selectedIdx < 0) {
sizePickerEl.removeAttribute('data-u1-selected-index');
return;
}
sizePickerEl.setAttribute('data-u1-selected-index', String(selectedIdx));
};
const updateSizePill = () => {
if (!sizePickerEl || !sizePillEl) return;
const selectedBtn = sizeButtons.find(b => b.classList.contains('is-selected'));
if (!selectedBtn) {
sizePillEl.classList.remove('is-visible');
sizePillEl.style.width = '0px';
sizePillEl.style.transform = 'translate3d(0,0,0)';
return;
}
const left = selectedBtn.offsetLeft;
const w = selectedBtn.offsetWidth;
sizePillEl.style.width = `${w}px`;
sizePillEl.style.transform = `translate3d(${left}px,0,0)`;
sizePillEl.classList.add('is-visible');
};
if (sizePickerEl && 'ResizeObserver' in window) {
const ro = new ResizeObserver(() => updateSizePill());
ro.observe(sizePickerEl);
}
window.addEventListener('resize', () => updateSizePill(), { passive: true });
sizeButtons.forEach(btn => {
btn.addEventListener('click', () => {
if (TEMPLATE === 'light') return;
const requiresColorBeforeSize =
HAS_COLOR_CHAPTER && HAS_COLOR_OPTION &&
!(typeof SILICONE_INSERTS_PDP !== 'undefined' && SILICONE_INSERTS_PDP);
if (requiresColorBeforeSize && !state.color) { showToast(U1S.sel_color_first); return; }
if (btn.getAttribute('aria-disabled') === 'true') return;
const v = btn.dataset.u1PdpValue || null;
if (state.size && v && state.size === v) {
window.setTimeout(() => {
try { window.scrollBy({ top: stickyAtcNudgePx, left: 0, behavior: 'smooth' }); } catch (_e) { window.scrollBy(0, stickyAtcNudgePx); }
}, 0);
return;
}
state.size = v;
setSelectedButton(sizeButtons, v);
updateStepMobileTitle('size', v || '');
applySizeActiveIndex();
updateSizePill();
updateVariant();
updateColorAvailability();
updateSizeAvailability();
try {
const idNum = Number(state.variantId || 0) || 0;
const hasVG = (variantGalleryMap && variantGalleryMap.size > 0) || (variantFinalMap && variantFinalMap.size > 0);
if (idNum && hasVG) {
const vImgs = getGalleryImagesForVariant(idNum);
const vFin = getFinalImageForVariant(idNum);
if ((vImgs && vImgs.length) || (vFin && vFin.src)) {
transitionGalleryToVariant(idNum, { durationMs: 88 });
try { forceEndGalleryLoadingSoon(2600); } catch (_eL) {}
}
}
} catch (_eG) {}
setColorDisplay(state.color);
syncAccessoriesToCurrentSize();
syncRestposGiftState({ openModalIfNeeded: true });
updateSummary();
});
});
const helmetSizePickerEl = root.querySelector('[data-u1-pdp-helmet-size-picker]');
const helmetSizePillEl = helmetSizePickerEl ? helmetSizePickerEl.querySelector('[data-u1-pdp-helmet-size-pill]') : null;
const getHelmetSizeIndex = (btn) => {
if (!btn) return null;
const all = helmetSizeButtons;
const idx = all.indexOf(btn);
return idx >= 0 ? idx : null;
};
const applyHelmetSizeActiveIndex = () => {
if (!helmetSizePickerEl) return;
const selectedIdx = getHelmetSizeIndex(helmetSizeButtons.find(b => b.classList.contains('is-selected')));
if (selectedIdx === null || selectedIdx === undefined || selectedIdx < 0) {
helmetSizePickerEl.removeAttribute('data-u1-selected-index');
return;
}
helmetSizePickerEl.setAttribute('data-u1-selected-index', String(selectedIdx));
};
const updateHelmetSizePill = () => {
if (!helmetSizePickerEl || !helmetSizePillEl) return;
const selectedBtn = helmetSizeButtons.find(b => b.classList.contains('is-selected'));
if (!selectedBtn) {
helmetSizePillEl.classList.remove('is-visible');
helmetSizePillEl.style.width = '0px';
helmetSizePillEl.style.transform = 'translate3d(0,0,0)';
return;
}
const left = selectedBtn.offsetLeft;
const w = selectedBtn.offsetWidth;
helmetSizePillEl.style.width = `${w}px`;
helmetSizePillEl.style.transform = `translate3d(${left}px,0,0)`;
helmetSizePillEl.classList.add('is-visible');
};
helmetSizeButtons.forEach((btn) => {
btn.addEventListener('click', () => {
const v = btn.dataset.u1PdpValue || null;
if (btn.getAttribute('aria-disabled') === 'true') return;
state.helmetSize = v;
state.size = v;
setSelectedButton(helmetSizeButtons, v);
applyHelmetSizeActiveIndex();
updateHelmetSizePill();
try { setColorUnsetUI(); } catch (_eU) {}
const selectedModelBtn = modelButtons.find(b => b.classList.contains('is-selected'));
if (selectedModelBtn && selectedModelBtn.dataset.u1PdpModelStyleFilter) {
  applyModelSelection(selectedModelBtn);
}
syncAccessoriesToCurrentSize();
syncRestposGiftState({ openModalIfNeeded: true });
updateSummary();
updateAtcAvailability();
emitPdpSelection();
});
});
const helmetModelPillEl = root.querySelector('[data-u1-pdp-helmet-model-pill]');
const applyHelmetModelPill = () => {
if (!helmetModelPillEl) return;
const sel = helmetModelButtons.find(b => b.classList.contains('is-selected'));
if (!sel) { helmetModelPillEl.classList.remove('is-visible'); return; }
const parent = sel.parentElement;
if (!parent) return;
const left = sel.offsetLeft;
const w = sel.offsetWidth;
helmetModelPillEl.style.width = `${w}px`;
helmetModelPillEl.style.transform = `translate3d(${left}px,0,0)`;
helmetModelPillEl.classList.add('is-visible');
};
helmetModelButtons.forEach((btn) => {
btn.addEventListener('click', () => {
const v = btn.dataset.u1PdpHelmetModelValue || btn.dataset.u1PdpValue || null;
if (!v) return;
if (btn.getAttribute('aria-disabled') === 'true') return;
state.helmetModel = v;
helmetModelButtons.forEach(b => {
b.classList.remove('is-selected');
b.setAttribute('aria-pressed', 'false');
});
btn.classList.add('is-selected');
btn.setAttribute('aria-pressed', 'true');
applyHelmetModelPill();
const selectedModelBtn = modelButtons.find(b => b.classList.contains('is-selected'));
if (selectedModelBtn && selectedModelBtn.dataset.u1PdpModelStyleFilter) {
applyModelSelection(selectedModelBtn);
}
syncAccessoriesToCurrentSize();
updateSummary();
updateAtcAvailability();
emitPdpSelection();
});
});
applyHelmetModelPill();
const defaultHelmetModelBtn = helmetModelButtons.find(b => b.classList.contains('is-selected'));
if (defaultHelmetModelBtn) {
state.helmetModel = defaultHelmetModelBtn.dataset.u1PdpHelmetModelValue || defaultHelmetModelBtn.dataset.u1PdpValue || null;
}
const accessoryBtns = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'));
const restposModalEl = root.querySelector('[data-u1-restpos-modal]');
const restposCloseEls = Array.from(root.querySelectorAll('[data-u1-restpos-close]'));
const restposColorsWrap = restposModalEl ? restposModalEl.querySelector('[data-u1-restpos-colors]') : null;
const restposColorNameEl = restposModalEl ? restposModalEl.querySelector('[data-u1-restpos-color-name]') : null;
const restposEnabled = !!(restposBottle && restposBottle.variants && Array.isArray(restposBottle.variants) && restposBottle.variants.length);
const restposDiscountCode = (restposConfig && restposConfig.discountCode) ? String(restposConfig.discountCode || '').trim() : '';
const restposDefaultColor = (restposConfig && restposConfig.defaultColor) ? String(restposConfig.defaultColor || '').trim() : '';
const restposSwatches = (restposBottle && restposBottle.colorSwatches) ? (restposBottle.colorSwatches || {}) : {};
const closeRestposModal = () => {
if (!restposModalEl) return;
state.restposModalClosed = true;
try { restposModalEl.classList.remove('is-open'); } catch (_e0) {}
window.setTimeout(() => { try { restposModalEl.hidden = true; } catch (_e1) {} }, 220);
};
const openRestposModal = () => {
if (!restposModalEl) return;
try { ensureRestposBottle(''); } catch (_e0) {}
restposModalEl.hidden = false;
state.restposModalShown = true;
window.requestAnimationFrame(() => { try { restposModalEl.classList.add('is-open'); } catch (_e1) {} });
try { renderRestposColors(); } catch (_e) {}
};
restposCloseEls.forEach((b) => { try { b.addEventListener('click', closeRestposModal); } catch (_e) {} });
try { document.addEventListener('keydown', (e) => { if (e && e.key === 'Escape' && restposModalEl && !restposModalEl.hidden) closeRestposModal(); }); } catch (_e) {}

const isLargeValue = (val) => {
const h = optionNameHandle(val);
return h === 'large' || h === 'l';
};
const hasSelectedVisor = () => {
try {
if (accessoryBtns.some((b) => b && b.dataset && b.dataset.u1PdpVisor === 'true' && b.classList && b.classList.contains('is-selected'))) return true;
// Template Light: visores via chapter Model
if (typeof TEMPLATE !== 'undefined' && TEMPLATE === 'light' && Array.isArray(modelButtons) && modelButtons.length) {
return modelButtons.some((b) => b && b.classList && b.classList.contains('is-selected'));
}
return false;
} catch (_e) { return false; }
};
const isVisorPdp = (() => {
return false;
})();

const bottleColorIndex = (() => {
if (!restposEnabled) return -1;
try {
const opts = Array.isArray(restposBottle.options) ? restposBottle.options : [];
const idx = opts.findIndex((n) => optionNameHandle(n) === 'color');
if (idx >= 0) return idx;
// Fallback: si la bottle tiene 1 sola opción (muchas veces se llama "Title"),
// tratamos option1 como "color" para que el picker no quede vacío.
if (opts.length === 1) return 0;
return -1;
} catch (_e) { return -1; }
})();
const bottleVariantColorValue = (v) => {
if (!v) return '';
if (bottleColorIndex === 0 && typeof v.option1 !== 'undefined') return String(v.option1 || '');
if (bottleColorIndex === 1 && typeof v.option2 !== 'undefined') return String(v.option2 || '');
if (bottleColorIndex === 2 && typeof v.option3 !== 'undefined') return String(v.option3 || '');
// Fallback: algunas serializaciones exponen `options: []` en vez de option1/2/3
try {
if (bottleColorIndex >= 0 && Array.isArray(v.options) && typeof v.options[bottleColorIndex] !== 'undefined') return String(v.options[bottleColorIndex] || '');
} catch (_e) {}
// Fallback: 1 opcion ("Title") -> title/public_title
if (bottleColorIndex === 0) {
const t = String(v.public_title || v.title || '').trim();
if (!t || t.toLowerCase() === 'default title') return '';
return t.includes(' / ') ? t.split(' / ')[0].trim() : t;
}
return '';
};
let syncRestposOfferUi = () => {};
const getBottleVariantIdForColor = (colorValue) => {
if (!restposEnabled) return 0;
const wanted = String(colorValue || '').trim();
const list = Array.isArray(restposBottle.variants) ? restposBottle.variants : [];
if (!wanted) return Number((list.find(v => v && v.available) || list[0] || {}).id || 0) || 0;
const exactAvail = list.find(v => v && v.available && bottleVariantColorValue(v) === wanted);
if (exactAvail && exactAvail.id) return Number(exactAvail.id) || 0;
const exact = list.find(v => v && bottleVariantColorValue(v) === wanted);
if (exact && exact.id) return Number(exact.id) || 0;
return Number((list.find(v => v && v.available) || list[0] || {}).id || 0) || 0;
};
const getBottleVariantById = (idNum) => {
if (!restposEnabled) return null;
const id = Number(idNum || 0) || 0;
if (!id) return null;
const list = Array.isArray(restposBottle.variants) ? restposBottle.variants : [];
return list.find(v => v && Number(v.id) === id) || null;
};
const getBottleSwatchStyle = (colorValue) => {
const h = optionNameHandle(colorValue);
if (!h) return '';
const s = restposSwatches && typeof restposSwatches[h] === 'string' ? restposSwatches[h] : '';
return s ? String(s) : '';
};
const getBottleInitialVariant = () => {
if (!restposEnabled) return null;
const list = Array.isArray(restposBottle.variants) ? restposBottle.variants : [];
return (list.find(v => v && v.available) || list[0] || null);
};
const getBottleInitialColorValue = () => {
const v = getBottleInitialVariant();
const c = bottleVariantColorValue(v);
return String(c || '').trim();
};
const applyBottleSwatchToEl = (el, colorValue) => {
if (!el) return;
const style = getBottleSwatchStyle(colorValue);
if (!style) return;
try { el.style.cssText = `${style}`; } catch (_e) {}
};
const ensureRestposBottle = (colorValue) => {
if (!restposEnabled) return;
const raw = String(colorValue || '').trim();
const current = String(state.restposBottleColor || '').trim();
const first = getBottleInitialColorValue();
const color = raw || current || first || restposDefaultColor;
const vid = getBottleVariantIdForColor(color);
state.restposBottleVariantId = Number(vid || 0) || 0;
state.restposBottleColor = color || null;
try { syncRestposOfferUi(); } catch (_e) {}
};
const renderRestposColors = () => {
if (!restposEnabled || !restposColorsWrap) return;
try { restposColorsWrap.innerHTML = ''; } catch (_e) {}
const list = Array.isArray(restposBottle.variants) ? restposBottle.variants : [];
const seen = new Set();
const colors = [];
list.forEach((v) => {
const c = bottleVariantColorValue(v);
if (!c) return;
const h = optionNameHandle(c);
if (!h || seen.has(h)) return;
seen.add(h);
colors.push(c);
});
colors.forEach((c) => {
const btn = document.createElement('button');
btn.type = 'button';
btn.className = 'u1-pdp-color__swatch';
btn.dataset.u1RestposColor = c;
btn.dataset.u1PdpValue = c;
btn.setAttribute('aria-pressed', 'false');
btn.setAttribute('aria-label', String(c || ''));
btn.innerHTML = `<span class="u1-pdp-color__swatch-dot" aria-hidden="true"></span><span class="visually-hidden">${String(c || '').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</span>`;
btn.addEventListener('click', () => {
ensureRestposBottle(c);
setSelectedButton(Array.from(restposColorsWrap.querySelectorAll('[data-u1-restpos-color]')), c);
try {
if (restposColorNameEl) {
restposColorNameEl.textContent = String(state.restposBottleColor || '');
restposColorNameEl.classList.toggle('is-placeholder', !String(state.restposBottleColor || '').trim());
}
} catch (_e3) {}
});
restposColorsWrap.appendChild(btn);
try {
const dot = btn.querySelector('.u1-pdp-color__swatch-dot');
applyBottleSwatchToEl(dot, c);
} catch (_e4) {}
});
const initial = state.restposBottleColor || getBottleInitialColorValue() || colors[0] || restposDefaultColor || '';
if (initial) {
ensureRestposBottle(initial);
setSelectedButton(Array.from(restposColorsWrap.querySelectorAll('[data-u1-restpos-color]')), initial);
try {
if (restposColorNameEl) {
const txt = String(state.restposBottleColor || initial || '');
restposColorNameEl.textContent = txt || PLACEHOLDER_COLOR_TEXT;
restposColorNameEl.classList.toggle('is-placeholder', !String(txt || '').trim());
}
} catch (_e5) {}
}
};
renderRestposColors();

const shouldApplyRestposGift = () => {
if (!restposEnabled) return false;
if (!restposDiscountCode) return false;
const largeFromProductSize = isLargeValue(state.size);
const largeFromHelmetFake = (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER && isLargeValue(state.helmetSize));
let largeFromLightVariant = false;
if (typeof TEMPLATE !== 'undefined' && TEMPLATE === 'light' && state.variantId && typeof getVariantOptionByHandle === 'function' && typeof SIZE_HANDLE !== 'undefined' && SIZE_HANDLE && typeof HAS_SIZE_OPTION !== 'undefined' && HAS_SIZE_OPTION) {
try {
const vid = Number(state.variantId || 0) || 0;
const v = variants.find(vv => vv && Number(vv.id) === vid) || null;
if (v) {
const sz = getVariantOptionByHandle(v, SIZE_HANDLE);
largeFromLightVariant = isLargeValue(sz);
}
} catch (_e) {}
}
return (largeFromProductSize || largeFromHelmetFake || largeFromLightVariant) && hasSelectedVisor();
};
const syncRestposGiftState = ({ openModalIfNeeded } = { openModalIfNeeded: true }) => {
if (!restposEnabled) return;
if (!shouldApplyRestposGift()) {
state.restposBottleVariantId = 0;
state.restposBottleColor = null;
try { syncRestposOfferUi(); } catch (_e) {}
return;
}
ensureRestposBottle(state.restposBottleColor);
if (openModalIfNeeded && restposModalEl && !state.restposModalShown) openRestposModal();
try { syncRestposOfferUi(); } catch (_e) {}
};

// --- Sticky offer UI (bottle) inside CTA
const offerEl = root.querySelector('[data-u1-pdp-offer]');
const offerImgEl = offerEl ? offerEl.querySelector('[data-u1-pdp-offer-img]') : null;
const offerTitleEl = offerEl ? offerEl.querySelector('[data-u1-pdp-offer-title]') : null;
const offerMsrpEl = offerEl ? offerEl.querySelector('[data-u1-pdp-offer-msrp]') : null;
const offerPickerEl = offerEl ? offerEl.querySelector('[data-u1-pdp-offer-picker]') : null;
const offerInfoBtn = offerEl ? offerEl.querySelector('[data-u1-pdp-offer-info]') : null;

const setOfferVisible = (on) => {
if (!offerEl) return;
if (on) {
offerEl.hidden = false;
offerEl.setAttribute('aria-hidden', 'false');
try { offerEl.classList.remove('is-visible'); } catch (_e0) {}
window.requestAnimationFrame(() => { try { offerEl.classList.add('is-visible'); } catch (_e1) {} });
} else {
try { offerEl.classList.remove('is-visible'); } catch (_e2) {}
if (offerEl._u1HideTimer) window.clearTimeout(offerEl._u1HideTimer);
offerEl._u1HideTimer = window.setTimeout(() => {
offerEl.hidden = true;
offerEl.setAttribute('aria-hidden', 'true');
}, 240);
}
if (stickyBottomEl && stickyBottomEl.classList) stickyBottomEl.classList.toggle('has-offer', !!on);
if (!on && offerPickerEl) { try { offerPickerEl.classList.remove('is-open'); } catch (_e) {} offerPickerEl.dataset.state = 'closed'; }
};
const isOfferPickerOpen = () => !!(offerPickerEl && offerPickerEl.classList && offerPickerEl.classList.contains('is-open'));
const openOfferPicker = () => {
if (!offerPickerEl) return;
try { offerPickerEl.classList.add('is-open'); } catch (_e) {}
offerPickerEl.dataset.state = 'open';
try { renderOfferPicker(); } catch (_e2) {}
};
const closeOfferPicker = () => {
if (!offerPickerEl) return;
try { offerPickerEl.classList.remove('is-open'); } catch (_e) {}
offerPickerEl.dataset.state = 'closed';
try { renderOfferPicker(); } catch (_e2) {}
};

const getBottleColorEntries = () => {
if (!restposEnabled) return [];
const list = Array.isArray(restposBottle.variants) ? restposBottle.variants : [];
const byHandle = new Map(); // h -> {value, available, variantId}
list.forEach((v) => {
if (!v || !v.id) return;
const value = bottleVariantColorValue(v);
if (!value) return;
const h = optionNameHandle(value);
if (!h) return;
const available = (v.available === true);
const current = byHandle.get(h) || null;
if (!current) {
byHandle.set(h, { value, available, variantId: Number(v.id) || 0 });
return;
}
// Preferir available si existe
if (!current.available && available) byHandle.set(h, { value, available, variantId: Number(v.id) || 0 });
});
return Array.from(byHandle.values());
};

const renderOfferPicker = () => {
if (!offerPickerEl) return;
try { offerPickerEl.innerHTML = ''; } catch (_e) {}
const entries0 = getBottleColorEntries();
const selH0 = optionNameHandle(state.restposBottleColor || restposDefaultColor || '');
const selected0 = entries0.find(x => optionNameHandle(x.value) === selH0) || null;
const selected = selected0 || (entries0.find(x => x && x.available) || entries0[0] || null);
const selH = optionNameHandle((selected && selected.value) || '');
const open = isOfferPickerOpen();
// Closed: solo la opción seleccionada (para que nunca quede “vacío”)
// Open: primero la seleccionada, luego el resto
const entries = open && selected ? [selected].concat(entries0.filter(x => optionNameHandle(x.value) !== selH)) : (selected ? [selected] : entries0.slice(0, 1));

entries.forEach((it) => {
const btn = document.createElement('button');
btn.type = 'button';
btn.className = 'u1-pdp-minipicker2__opt';
btn.dataset.u1PdpOfferColor = String(it.value || '');
btn.innerHTML = `
  <span class="u1-pdp-minipicker2__row">
    <span class="u1-pdp-minipicker2__dot" aria-hidden="true"><span class="u1-pdp-minipicker2__dot-inner" aria-hidden="true"></span></span>
    <span class="u1-pdp-minipicker2__label">${String(it.value || '').replace(/</g,'&lt;').replace(/>/g,'&gt;')}</span>
    <span class="u1-pdp-minipicker2__icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
      <path d="M10 7.5L14.5 12L10 16.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
  </span>
`;
btn.setAttribute('aria-disabled', it.available ? 'false' : 'true');
btn.classList.toggle('is-selected', optionNameHandle(it.value) === selH);
btn.addEventListener('click', () => {
if (!offerEl || offerEl.hidden) return;
if (!isOfferPickerOpen()) { openOfferPicker(); return; }
if (!it.available) return;
const clickedIsSelected = optionNameHandle(String(state.restposBottleColor || restposDefaultColor || '')) === optionNameHandle(it.value);
if (!clickedIsSelected) ensureRestposBottle(it.value);
try { syncRestposOfferUi(); } catch (_e2) {}
closeOfferPicker();
});
offerPickerEl.appendChild(btn);
try {
const dotInner = btn.querySelector('.u1-pdp-minipicker2__dot-inner');
applyBottleSwatchToEl(dotInner, it.value);
} catch (_e3) {}
});
};

const syncOfferUi = () => {
if (!offerEl || !restposEnabled) return;
// Simplicidad > gating: el offer debe estar visible cuando aplica el gift,
// independientemente de si el modal está abierto/cerrado.
const on = shouldApplyRestposGift() && !!state.restposBottleVariantId;
if (!on) { setOfferVisible(false); return; }
setOfferVisible(true);
try {
if (offerTitleEl) offerTitleEl.textContent = String(restposBottle.title || offerTitleEl.dataset.u1LBottle || 'UNIT 1 Bottle');
if (offerImgEl && restposBottle.imageSrc) { offerImgEl.src = String(restposBottle.imageSrc); offerImgEl.alt = String(restposBottle.imageAlt || restposBottle.title || ''); }
const list = Array.isArray(restposBottle.variants) ? restposBottle.variants : [];
const any = list && list.length ? (list.find(v => v && typeof v.price !== 'undefined') || list[0]) : null;
const msrpCents = any && typeof any.price !== 'undefined' ? Number(any.price) || 0 : 0;
if (offerMsrpEl) offerMsrpEl.textContent = msrpCents ? formatMoneyCents(msrpCents) : '';
try {
const currentV = getBottleVariantById(state.restposBottleVariantId || 0);
const img =
currentV && currentV.featured_image && currentV.featured_image.src ? String(currentV.featured_image.src) :
currentV && currentV.featured_image ? String(currentV.featured_image) :
'';
if (offerImgEl && img) offerImgEl.src = img;
} catch (_e2) {}
} catch (_e) {}
renderOfferPicker();
};
syncRestposOfferUi = syncOfferUi;
try { syncOfferUi(); } catch (_e0) {}

if (offerInfoBtn && !offerInfoBtn._u1Bound) {
offerInfoBtn._u1Bound = true;
offerInfoBtn.addEventListener('click', () => {
try { openRestposModal(); } catch (_e) {}
});
}
// Click en foto/título/free reabre el modal
if (offerEl && !offerEl._u1OpenModalBound) {
offerEl._u1OpenModalBound = true;
offerEl.addEventListener('click', (e) => {
if (!offerEl || offerEl.hidden) return;
const t = e && e.target && e.target.closest ? e.target : null;
if (!t) return;
if (t.closest('[data-u1-pdp-offer-open-modal]')) { try { openRestposModal(); } catch (_e2) {} }
});
}
// Close on outside click
if (offerEl && !offerEl._u1OutsideBound) {
offerEl._u1OutsideBound = true;
document.addEventListener('click', (e) => {
if (!offerEl || offerEl.hidden) return;
if (!offerPickerEl || !isOfferPickerOpen()) return;
const t = e && e.target && e.target.closest ? e.target : null;
if (t && (t.closest('[data-u1-pdp-offer-minipicker]') || t.closest('[data-u1-pdp-offer-picker]'))) return;
closeOfferPicker();
}, true);
}
const featuresPanelEl = root.querySelector('[data-u1-pdp-features]');
const featureCountEl = featuresPanelEl ? featuresPanelEl.querySelector('[data-u1-pdp-features-count]') : null;
const featureItemEls = featuresPanelEl ? Array.from(featuresPanelEl.querySelectorAll('[data-u1-feature-key]')) : [];
const syncFeaturesUnlocked = () => {
if (!featuresPanelEl || !featureItemEls.length) return;
const total = featureItemEls.length;
const unlocked = new Set();
try {

const _fbPack = root._packSelector && root._packSelector.getActiveBundlePack ? root._packSelector.getActiveBundlePack() : null;
const _normH = (h) => (h || '').toLowerCase().replace(/-\d+$/, '');
const _fbHandles = new Set();
if (_fbPack && Array.isArray(_fbPack.componentProducts)) {
  _fbPack.componentProducts.forEach(cp => { if (cp && cp.handle) _fbHandles.add(_normH(cp.handle)); });
}
accessoryBtns.forEach((btn) => {
if (!btn || !btn.dataset) return;
if (btn.dataset.u1PdpVisor === 'true') return;
const _h = _normH(btn.dataset.u1PdpAccessoryHandle || '');
const _inBundle = _h && _fbHandles.has(_h);
if (!btn.classList.contains('is-selected') && !_inBundle && !(btn.hasAttribute('data-u1-flash-gift-acc') && !root.classList.contains('is-fgift-off'))) return; // regalo del Flash deal: desbloqueado si la variante califica
const raw = String(btn.dataset.u1Features || '');
if (!raw) return;
raw.split('|').map(s => s.trim()).filter(Boolean).forEach((k) => unlocked.add(k));
});
} catch (_e) {}
let onCount = 0;
featureItemEls.forEach((el) => {
const k = el && el.dataset ? String(el.dataset.u1FeatureKey || '') : '';
const on = !!(k && unlocked.has(k));
if (on) onCount += 1;
try { el.classList.toggle('is-unlocked', on); } catch (_e) {}
});
if (featureCountEl) featureCountEl.textContent = `${onCount}/${total}`;
};
root._u1SyncFeaturesUnlocked = syncFeaturesUnlocked;
root._u1UpdateAtcAvailability = updateAtcAvailability;
root._u1RenderMobileGalleries = renderMobileGalleries;
const parseVariantId = (raw) => {
const s = (raw || '').toString().trim();
if (!s) return 0;
if (/^\d+$/.test(s)) return Number(s);
const m1 = s.match(/(\d+)\s*$/);
if (m1) return Number(m1[1]);
const m2 = s.match(/[?&]variant=(\d+)/);
if (m2) return Number(m2[1]);
try {
const decoded = atob(s);
const m3 = decoded.match(/(\d+)\s*$/) || decoded.match(/ProductVariant\/(\d+)/);
if (m3) return Number(m3[1]);
} catch (_e) {}
return 0;
};
const applyFixedVariantToCard = (btn) => {
if (!btn) return;
const handle = btn.dataset.u1PdpAccessoryHandle || '';
if (!handle) return;
const raw = btn.dataset.u1PdpAccessoryVariantId || '';
const fixedId = parseVariantId(raw);
if (!fixedId) return;
const item = accessoriesCatalog.find(p => p && p.handle === handle) || null;
const vv = item && Array.isArray(item.variants)
? item.variants.find(v => v && Number(v.id) === Number(fixedId))
: null;
if (!vv) {
btn.dataset.u1PdpAccessoryVariantId = '';
return;
}
btn.dataset.u1PdpAccessoryVariantId = String(fixedId);
const titleEl = btn.querySelector('[data-u1-pdp-card-title]');
const priceEl = btn.querySelector('[data-u1-pdp-card-price]');
const imgEl = btn.querySelector('[data-u1-pdp-card-img]');
/* Sin titulo de variante (producto simple), el nombre de la card manda sobre el del
   producto: el Inside the Box compara ese texto contra su label exacto. */
const t = (vv.title && vv.title !== 'Default Title') ? String(vv.title) : String(btn.dataset.u1PdpInfoTitle || item.title || '');
if (titleEl && t) titleEl.textContent = t;
if (priceEl && btn.dataset.u1PdpInfoPrice) {
if (priceEl.classList && priceEl.classList.contains('u1-pdp-card__price--discount')) {
const finalEl = priceEl.querySelector('.u1-pdp-card__price-final');
if (finalEl) finalEl.textContent = btn.dataset.u1PdpInfoPrice;
} else {
priceEl.textContent = btn.dataset.u1PdpInfoPrice;
}
}
const imgSrc = vv.featured_image && (vv.featured_image.src || vv.featured_image.url) ? (vv.featured_image.src || vv.featured_image.url) : '';
if (imgEl && imgSrc) imgEl.src = imgSrc;
btn.dataset.u1PdpInfoTitle = t || btn.dataset.u1PdpInfoTitle || '';
if (imgSrc) btn.dataset.u1PdpInfoImg = imgSrc;
};
accessoryBtns.forEach(applyFixedVariantToCard);
const resolveAccessoryVariantId = ({ handle, size, preferSize, fixedVariantId, filterOptions }) => {
if (fixedVariantId) {
return Number(fixedVariantId);
}
const item = accessoriesCatalog.find(p => p.handle === handle);
if (!item || !Array.isArray(item.variants) || item.variants.length === 0) return null;
let candidates = item.variants;
if (filterOptions && typeof filterOptions === 'object') {
const STYLE_ALIASES = { 'Photochromic': 'Adaptive' };
const filterValues = Object.values(filterOptions).filter(Boolean);
if (filterValues.length) {
candidates = candidates.filter(v => {
if (!v) return false;
return filterValues.every(val => {
const aliases = [val];
if (STYLE_ALIASES[val]) aliases.push(STYLE_ALIASES[val]);
return aliases.some(a => v.option1 === a || v.option2 === a || v.option3 === a);
});
});
if (!candidates.length) return null;
}
}
if (preferSize && size) {
let v = candidates.find(vv =>
vv && (vv.option1 === size || vv.option2 === size || vv.option3 === size)
);
if (!v) {
const norm = (s) => String(s || '').trim().toUpperCase();
const head = (s) => norm(s).charAt(0);
const wantedHead = head(size);
v = candidates.find(vv => {
if (!vv) return false;
const opts = [vv.option1, vv.option2, vv.option3].filter(Boolean).map(norm);
return opts.some(o => head(o) === wantedHead);
});
}
if (v && v.id) return v.id;
}
return candidates[0] && candidates[0].id ? candidates[0].id : null;
};
const readAccessoryFilterOptions = (btn) => {
if (!btn || !btn.dataset) return null;
const out = {};
if (btn.dataset.u1PdpAccessoryFilterStyle) out.style = btn.dataset.u1PdpAccessoryFilterStyle;
if (btn.dataset.u1PdpAccessoryFilterHelmet) out.helmet = btn.dataset.u1PdpAccessoryFilterHelmet;

if (!out.helmet && btn.dataset.u1PdpVisor === 'true') {
  if (state.helmetModel) out.helmet = state.helmetModel;
  else {
    const _ph = (mainProductHandle || '').split('-')[0].toUpperCase();
    if (_ph) out.helmet = _ph;
  }
}
return Object.keys(out).length ? out : null;
};
const syncAccessoriesToCurrentSize = () => {
const currentSize = state.size || state.helmetSize || '';
if (!currentSize || state.accessories.size === 0) return;
for (const [key, entry] of state.accessories.entries()) {
if (!entry || !entry.syncSize) continue;
if (entry.fixedVariantId) continue;
const handle = entry.handle || key;
const nextId = resolveAccessoryVariantId({ handle, size: currentSize, preferSize: true, filterOptions: entry.filterOptions || null });
if (nextId && Number(nextId) !== Number(entry.variantId)) {
state.accessories.set(key, { ...entry, variantId: nextId });
}
}
};
accessoryBtns.forEach(btn => {
btn.addEventListener('click', () => {
if (TEMPLATE === 'light') {
if (!state.variantId) {
if (!goToMissingSelection()) showToast(U1S.sel_model_first);
return;
}
const needsHelmetLight = (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER) && !!root.querySelector('[data-u1-pdp-helmet-size-picker]') && !state.helmetSize;
if (needsHelmetLight) {
if (!goToMissingSelection()) showToast(U1S.sel_helmet_first);
return;
}
} else {
const needsColor = HAS_COLOR_CHAPTER && !state.color;
const needsSize = HAS_CHAPTER_SIZE && HAS_SIZE_OPTION && !state.size;
const needsHelmetSize = (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER) && !!root.querySelector('[data-u1-pdp-helmet-size-picker]') && !state.helmetSize;
if (needsColor || needsSize || needsHelmetSize) {
if (!goToMissingSelection()) {
if (typeof SILICONE_INSERTS_PDP !== 'undefined' && SILICONE_INSERTS_PDP) {
showToast(needsSize ? U1S.sel_model_first : (needsHelmetSize ? U1S.sel_helmet_first : U1S.sel_color_first));
} else {
showToast(needsColor ? U1S.sel_color_first : (needsHelmetSize ? U1S.sel_helmet_first : U1S.sel_size));
}
}
return;
}
}
if (btn.getAttribute('aria-disabled') === 'true') return;
const handle = btn.dataset.u1PdpAccessoryHandle;
if (!handle) return;
const handleH = optionNameHandle(handle);
const isRemoteCard = handleH === remoteHandle && btn.dataset.u1PdpVisor !== 'true';
const torchVariantId = (TEMPLATE_RAW === 'torch' && torchLightHandles.length && torchLightHandles.includes(handleH))
? parseVariantId(btn.dataset.u1PdpAccessoryVariantId || '')
: 0;
const isTorchLightVariant =
  TEMPLATE_RAW === 'torch' &&
  (torchVariantId === 43829988884641 || torchVariantId === 43829988851873);
const key = isTorchLightVariant ? `torch:${torchVariantId}` : (btn.dataset.u1PdpAccessoryKey || handle);
const isOn = state.accessories.has(key);
const _isBundleActive = root.getAttribute('data-u1-pdp-bundle-active') === 'true';
if (isOn) {

if (btn.dataset.u1PdpVisor === 'true' && _isBundleActive) return;
if (btn.dataset.u1PdpFree === 'true') return;
state.accessories.delete(key);
btn.classList.remove('is-selected');
btn.setAttribute('aria-pressed', 'false');
} else {

if (btn.dataset.u1PdpVisor === 'true' && _isBundleActive) {
  var _allVisorBtns = root.querySelectorAll('[data-u1-pdp-visor="true"]');
  _allVisorBtns.forEach(function(vb) {
    if (vb === btn) return;
    var vKey = vb.dataset.u1PdpAccessoryKey || vb.dataset.u1PdpAccessoryHandle;
    if (vKey && state.accessories.has(vKey)) {
      state.accessories.delete(vKey);
    }
    vb.classList.remove('is-selected');
    vb.setAttribute('aria-pressed', 'false');
  });
}

const syncSize = (() => {
  if (btn.dataset.u1PdpAccessorySyncSize === 'true') return true;
  try {
    const catItem = (Array.isArray(accessoriesCatalog) ? accessoriesCatalog : []).find(p => p && p.handle === handle);
    if (!catItem || !Array.isArray(catItem.variants) || catItem.variants.length < 2) return false;
    const v1 = catItem.variants[0]; const v2 = catItem.variants[1];
    if (!v1 || !v2) return false;
    return (v1.option1 !== v2.option1 || v1.option2 !== v2.option2 || v1.option3 !== v2.option3);
  } catch(_e) { return false; }
})();
let fixedVariantId = parseVariantId(btn.dataset.u1PdpAccessoryVariantId || '');
if (fixedVariantId) {
const item = accessoriesCatalog.find(p => p && p.handle === handle) || null;
const ok = !!(item && Array.isArray(item.variants) && item.variants.some(v => v && Number(v.id) === Number(fixedVariantId)));
if (!ok) fixedVariantId = 0;
}
const filterOptions = readAccessoryFilterOptions(btn);
const variantId = fixedVariantId || resolveAccessoryVariantId({ handle, size: state.size, preferSize: syncSize, fixedVariantId: 0, filterOptions });
if (!variantId) return;
const meta = accessoryVariantMeta.get(Number(variantId)) || null;
if (meta && meta.available === false) {
showToast(U1S.out_of_stock);
return;
}
const discountCode = (btn.dataset.u1PdpDiscountCode || '').toString().trim();
const discountPercent = Number(btn.dataset.u1PdpDiscountPercent || 0) || 0;
state.accessories.set(key, { handle, variantId, qty: 1, syncSize, fixedVariantId: fixedVariantId || 0, discountCode, discountPercent, filterOptions: filterOptions || null });
btn.classList.add('is-selected');
btn.setAttribute('aria-pressed', 'true');
}
syncRestposGiftState({ openModalIfNeeded: true });
updateSummary();
updateAtcAvailability();
try { syncFeaturesUnlocked(); } catch (_e0) {}

if (btn.dataset.u1PdpVisor === 'true') {
  window.setTimeout(function() { try { if (root._u1UpdateBundleGallery) root._u1UpdateBundleGallery(); } catch (_e) {} }, 50);
}
if (TEMPLATE !== 'light' && isDesktop && isRemoteCard) {
try { applyUxMode('accessories', { force: true }); } catch (_e) {}
}
if (btn.dataset.u1PdpVisor === 'true' && !root._u1VisorBaseReady && String(root._u1GalleryUxMode || '') === 'visor') {
try { applyUxMode('visor', { force: true }); } catch (_e) {}
}
if (TEMPLATE_RAW === 'torch' && torchLightHandles.length && torchLightHandles.includes(handleH)) {
window.requestAnimationFrame(() => {
try { applyUxMode('accessories', { force: true }); } catch (_e) {}
syncModeOverlays();
});
} else {
scheduleGalleryUxModeCheck();
syncModeOverlays();
}
});
});
// Auto-select free accessories on init
accessoryBtns.forEach(btn => {
if (!btn || btn.dataset.u1PdpFree !== 'true') return;
if (btn.getAttribute('aria-disabled') === 'true') return;
const handle = btn.dataset.u1PdpAccessoryHandle;
if (!handle) return;
const key = btn.dataset.u1PdpAccessoryKey || handle;
if (state.accessories.has(key)) return;

const syncSize = (() => {
  if (btn.dataset.u1PdpAccessorySyncSize === 'true') return true;
  try {
    const catItem = (Array.isArray(accessoriesCatalog) ? accessoriesCatalog : []).find(p => p && p.handle === handle);
    if (!catItem || !Array.isArray(catItem.variants) || catItem.variants.length < 2) return false;
    const v1 = catItem.variants[0]; const v2 = catItem.variants[1];
    if (!v1 || !v2) return false;
    return (v1.option1 !== v2.option1 || v1.option2 !== v2.option2 || v1.option3 !== v2.option3);
  } catch(_e) { return false; }
})();
let fixedVariantId = parseVariantId(btn.dataset.u1PdpAccessoryVariantId || '');
const filterOptions = readAccessoryFilterOptions(btn);
const variantId = fixedVariantId || resolveAccessoryVariantId({ handle, size: state.size, preferSize: syncSize, fixedVariantId: 0, filterOptions });
if (!variantId) return;
const discountCode = (btn.dataset.u1PdpDiscountCode || '').toString().trim();
const discountPercent = Number(btn.dataset.u1PdpDiscountPercent || 0) || 0;
state.accessories.set(key, { handle, variantId, qty: 1, syncSize, fixedVariantId: fixedVariantId || 0, discountCode, discountPercent, filterOptions: filterOptions || null, free: true });
btn.classList.add('is-selected');
btn.setAttribute('aria-pressed', 'true');
});
try { updateSummary(); } catch (_e) {}
try { syncFeaturesUnlocked(); } catch (_e) {}
root._u1GalleryUxMode = root._u1GalleryUxMode || 'normal';
root._u1VisorCycleCount = Number(root._u1VisorCycleCount || 0) || 0;
const visorStepEl = root.querySelector('[data-u1-pdp-step="visor"]');
const accessoriesStepEl2 = root.querySelector('[data-u1-pdp-step="accessories"]');
const crashStepEl2 = root.querySelector('[data-u1-pdp-step="crash"]');
const visorBtns = accessoryBtns.filter(b => b && b.dataset && b.dataset.u1PdpVisor === 'true');
const visorBtnByKey = (() => {
const m = new Map();
try {
visorBtns.forEach((b) => {
const k = b.dataset.u1PdpAccessoryKey || b.dataset.u1PdpAccessoryHandle || '';
if (k) m.set(String(k), b);
});
} catch (_e) {}
return m;
})();
let remoteHandle = optionNameHandle(root.dataset.u1PdpRemoteHandle || 'unit-1-remote');
let remoteBtn = accessoryBtns.find(b => b && b.dataset && optionNameHandle(b.dataset.u1PdpAccessoryHandle || '') === remoteHandle && b.dataset.u1PdpVisor !== 'true') || null;
if (!remoteBtn) {
remoteBtn = accessoryBtns.find((b) => {
if (!b || !b.dataset) return false;
if (b.dataset.u1PdpVisor === 'true') return false;
const t = `${b.dataset.u1PdpInfoTitle || ''} ${b.dataset.u1PdpAccessoryHandle || ''}`.toLowerCase();
return t.includes('remote');
}) || null;
if (remoteBtn && remoteBtn.dataset) {
const inferred = optionNameHandle(remoteBtn.dataset.u1PdpAccessoryHandle || '');
if (inferred) remoteHandle = inferred;
}
}
try {
root.dataset.u1RemoteHandleWanted = remoteHandle;
root.dataset.u1RemoteCardFound = remoteBtn ? '1' : '0';
if (remoteBtn && remoteBtn.dataset) {
root.dataset.u1RemoteCardHandle = String(remoteBtn.dataset.u1PdpAccessoryHandle || '');
root.dataset.u1RemoteCardTitle = String(remoteBtn.dataset.u1PdpInfoTitle || '');
}
} catch (_e) {}
const torchLightHandles = (() => {
const raw = (root.dataset.u1PdpTorchLightHandles || 'smart-light,smart-light-pro-dual').toString().trim();
if (!raw) return [];
return raw.split(',').map(s => optionNameHandle(s.trim())).filter(Boolean);
})();
const hasTorchLightCards = (() => {
try {
if (!torchLightHandles.length || !Array.isArray(accessoryBtns)) return false;
return accessoryBtns.some((b) => {
if (!b || !b.dataset) return false;
// En sparky puede haber cards "smart light" en el DOM pero ocultas/deshabilitadas.
// Si existen pero no son visibles/activas, no queremos cargar imágenes de lights.
try {
if (b.hidden) return false;
const ad = b.getAttribute && b.getAttribute('aria-disabled');
if (String(ad || '') === 'true') return false;
if (b.classList && b.classList.contains('is-disabled')) return false;
if (b.closest && b.closest('.is-disabled')) return false;
} catch (_e0) {}
const h = optionNameHandle(b.dataset.u1PdpAccessoryHandle || '');
return !!(h && torchLightHandles.includes(h));
});
} catch (_e) {
return false;
}
})();

// Sparky: cuando el "insert" está seleccionado, no queremos que el UX trate
// esa misma template (`torch`) como "lights/remote".
const getTorchInsertSelectedNow = () => {
try {
// Usar el botón real del insert (insertBtn) evita depender del dataset
// que puede no coincidir/estar disponible igual en todos los colores.
if (!insertBtn) return false;
if (insertBtn.hidden) return false;
try {
const ad = insertBtn.getAttribute && insertBtn.getAttribute('aria-disabled');
if (String(ad || '') === 'true') return false;
} catch (_e0) {}
if (insertBtn.classList && insertBtn.classList.contains('is-disabled')) return false;
try {
if (insertBtn.closest && insertBtn.closest('.is-disabled')) return false;
} catch (_e1) {}
  // Para Sparky: si el insert existe y está habilitado, NO queremos llamar a lights/remote,
  // aunque el insert no esté seleccionado todavía (sucede en desktop al hacer entry).
  return true;
} catch (_e) {
return false;
}
};
const getMediaColorValue = () => (state && state.color) ? state.color : (initialMediaColorValue || '');
const getMediaColorHandle = () => optionNameHandle(getMediaColorValue());
const getHelmetHandle = () => String(mainProductHandle || '').toString();
const getHelmetHandleCandidates = () => {
const raw = getHelmetHandle();
const out = [];
const add = (v) => {
const s = (v || '').toString().trim();
if (!s) return;
if (!out.includes(s)) out.push(s);
};
add(raw);
add(raw.replace(/-smart-helmet$/i, ''));
add(raw.replace(/-mips-helmet$/i, '-mips'));
add(raw.replace(/-mips$/i, ''));
add(raw.replace(/-helmet$/i, ''));
return out;
};
const getVisorSelectionList = () => {
const out = []; // [{ variantId, handle, filterStyle }]
try {
for (const [key, entry] of state.accessories.entries()) {
const btnEl = visorBtnByKey.get(String(key)) || null;
if (!btnEl) continue;
const handle = (entry && entry.handle) ? String(entry.handle) : String(btnEl.dataset.u1PdpAccessoryHandle || '');
const variantId = Number(entry && entry.variantId ? entry.variantId : 0) || parseVariantId(btnEl.dataset.u1PdpAccessoryVariantId || '');
const filterStyle = (entry && entry.filterOptions && entry.filterOptions.style) ? String(entry.filterOptions.style) : (btnEl.dataset.u1PdpAccessoryFilterStyle || '');
if (variantId) out.push({ variantId, handle, filterStyle });
}
} catch (_e) {}
return out;
};
const isRemoteSelected = () => {
// Sparky con insert elegido: remote/lights off.
try {
if (TEMPLATE_RAW === 'torch' && getTorchInsertSelectedNow()) return false;
} catch (_e0) {}
if (
  torchLightHandles.length &&
  (
    TEMPLATE_RAW === 'torch' ||
    TEMPLATE === 'torch'
  )
) {
try {
for (const [_k, entry] of state.accessories.entries()) {
const h = entry && entry.handle ? optionNameHandle(entry.handle) : '';
if (h && torchLightHandles.includes(h)) return true;
}
} catch (_e) {}
return false;
}
try {
for (const [_k, entry] of state.accessories.entries()) {
const h = entry && entry.handle ? optionNameHandle(entry.handle) : '';
if (h && h === remoteHandle) return true;
}
} catch (_e) {}
try {
const _bp = root._packSelector && root._packSelector.getActiveBundlePack ? root._packSelector.getActiveBundlePack() : null;
if (_bp && !_bp.isSolo && (_bp.componentProducts || []).some(c => c && optionNameHandle(c.handle || '') === remoteHandle)) return true;
} catch (_eB) {}
return false;
};
const VISOR_OVERLAY_COLOR_INDEPENDENT = String(root.dataset.u1PdpVisorColorIndependent || '') === '1';
const VISOR_OVERLAY_ALIAS = { 'adaptive': 'photochromic' };
const visorOverlaySrcFor = ({ variantId, filterStyle } = {}) => {
const helmet = getHelmetHandle();
if (!helmet) return '';
let token = filterStyle ? optionNameHandle(filterStyle) : String(Number(variantId || 0) || 0);
if (VISOR_OVERLAY_ALIAS[token]) token = VISOR_OVERLAY_ALIAS[token];
if (!token || token === '0') return '';
if (VISOR_OVERLAY_COLOR_INDEPENDENT) {
return filesUrlFor(`pdp-visor-${helmet}-${token}.png`);
}
const colorH = getMediaColorHandle();
if (!colorH) return '';
return filesUrlFor(`pdp-visor-${helmet}-${colorH}-${token}.png`);
};
const remoteResolved = new Map(); // key -> src
const remoteResolving = new Set(); // key
const remoteSrcFor = (kind) => {
if (
  torchLightHandles.length &&
  (
    TEMPLATE_RAW === 'torch' ||
    TEMPLATE === 'torch'
  )
) {
const colorH = getMediaColorHandle();
const k = (kind === 'on') ? 'on' : 'off';
if (!colorH) return '';
const cacheKey = `pdp-light-torch-${colorH}-${k}`;
const cached = remoteResolved.get(cacheKey);
if (cached) return cached;
const exts = ['jpg', 'JPG', 'jpeg', 'JPEG', 'webp', 'WEBP', 'png', 'PNG'];
const candidates = [];
exts.forEach((ext) => {
const name = `pdp-light-torch-${colorH}-${k}.${ext}`;
try { candidates.push(filesUrlFor(name)); } catch (_e) {}
try { candidates.push(assetUrlFor(name)); } catch (_e2) {}
});
const uniq = Array.from(new Set(candidates.filter(Boolean)));
if (!uniq.length) return '';
if (!remoteResolving.has(cacheKey)) {
remoteResolving.add(cacheKey);
(async () => {
try {
for (const src of uniq) {
const ok = await u1ImgExists.check(src);
if (ok) {
remoteResolved.set(cacheKey, src);
try { root._u1RequestAccessoriesBaseRefresh?.(); } catch (_e2) {}
try { root._u1RequestSyncModeOverlays?.(); } catch (_e3) {}
try { root._u1RequestRemoteHoverPreview?.(); } catch (_e4) {}
break;
}
}
} catch (_e) {}
remoteResolving.delete(cacheKey);
})();
}
// Igual que la rama "remote": devolvemos un guess inmediato para que la UX
// no se quede sin imagen; la verificación asíncrona terminará con el src correcto en caché.
return uniq[0] || '';
}
const helmets = getHelmetHandleCandidates();
const colorH = getMediaColorHandle();
const k = (kind === 'on') ? 'on' : 'off';
if (!helmets.length || !colorH) return '';
const cacheKey = `pdp-remote-${helmets[0]}-${colorH}-${k}`;
const cached = remoteResolved.get(cacheKey);
if (cached) return cached;
try {
root.dataset.u1RemoteHelmet = helmets[0] || '';
root.dataset.u1RemoteHelmetCandidates = helmets.join(',');
root.dataset.u1RemoteColor = colorH;
} catch (_e0) {}
const candidates = (() => {
const exts = ['jpg', 'JPG', 'jpeg', 'JPEG', 'webp', 'WEBP', 'png', 'PNG'];
const out = [];
exts.forEach((ext) => {
helmets.forEach((helmet) => {
const base = `pdp-remote-${helmet}-${colorH}-${k}`;
const name = `${base}.${ext}`;
try { out.push(filesUrlFor(name)); } catch (_e) {}
try { out.push(assetUrlFor(name)); } catch (_e2) {}
});
});
return Array.from(new Set(out.filter(Boolean)));
})();
if (!candidates.length) return '';
if (!remoteResolving.has(cacheKey)) {
remoteResolving.add(cacheKey);
(async () => {
try {
try {
if (k === 'off') root.dataset.u1RemoteOffGuess = candidates[0] || '';
else root.dataset.u1RemoteOnGuess = candidates[0] || '';
} catch (_eD) {}
for (const src of candidates) {
const ok = await u1ImgExists.check(src);
if (ok) {
remoteResolved.set(cacheKey, src);
try {
if (k === 'off') root.dataset.u1RemoteOffResolved = src;
else root.dataset.u1RemoteOnResolved = src;
} catch (_eD2) {}
try { root._u1RequestAccessoriesBaseRefresh?.(); } catch (_e2) {}
try { root._u1RequestSyncModeOverlays?.(); } catch (_e3) {}
try { root._u1RequestRemoteHoverPreview?.(); } catch (_e4) {}
break;
}
}
} catch (_e) {}
remoteResolving.delete(cacheKey);
})();
}
return candidates[0] || '';
};
const remoteBaseOffSrcFor = () => remoteSrcFor('off');
const remoteOnSrcFor = () => remoteSrcFor('on');
const remoteMipsBadgeSrcFor = () => {
const enabled = String(root.dataset.u1PdpRemoteMipsBadgeEnabled || '') === '1';
const isMips = String(root.dataset.u1PdpIsMips || '') === '1';
if (!enabled || !isMips) return '';
const helmets = getHelmetHandleCandidates();
const baseHelmet = helmets.find(h => h && !/mips/i.test(String(h))) || helmets[0] || '';
if (!baseHelmet) return '';
const key = `pdp-remote-${baseHelmet}-mips-badge`;
const cached = galleryRemoteMipsBadge && galleryRemoteMipsBadge.resolved ? galleryRemoteMipsBadge.resolved.get(key) : null;
if (typeof cached === 'string') return cached;
if (galleryRemoteMipsBadge && galleryRemoteMipsBadge.resolving && galleryRemoteMipsBadge.resolving.has(key)) return '';
try { galleryRemoteMipsBadge.resolving.add(key); } catch (_e0) {}

// Optimistic guess + async verify (handles .PNG / webp / etc)
let guess = '';
try { guess = filesUrlFor(`${key}.png`); } catch (_e1) {}
if (!guess) { try { guess = assetUrlFor(`${key}.png`); } catch (_e2) {} }
try { galleryRemoteMipsBadge.resolved.set(key, guess || ''); } catch (_e3) {}
try { if (guess) u1ImgPreload.preload(guess); } catch (_e4) {}
try { syncRemoteMipsBadgeOverlay(); } catch (_e5) {}
try { renderMobileGalleries(); } catch (_e6) {}

(async () => {
let found = '';
try {
const exts = ['png', 'PNG', 'webp', 'WEBP', 'jpg', 'JPG', 'jpeg', 'JPEG'];
const candidates = [];
for (const ext of exts) {
const name = `${key}.${ext}`;
try { candidates.push(filesUrlFor(name)); } catch (_e1b) {}
try { candidates.push(assetUrlFor(name)); } catch (_e2b) {}
}
for (const src of Array.from(new Set(candidates.filter(Boolean)))) {
// eslint-disable-next-line no-await-in-loop
const ok = await u1ImgExists.check(src);
if (ok) { found = src; break; }
}
} catch (_e3b) {}
try { galleryRemoteMipsBadge.resolved.set(key, found || ''); } catch (_e4b) {}
try { galleryRemoteMipsBadge.resolving.delete(key); } catch (_e5b) {}
try { syncRemoteMipsBadgeOverlay(); } catch (_e6b) {}
try { renderMobileGalleries(); } catch (_e7b) {}
})();

return guess || '';
};
/* Badge remoto: solo sobre la vista trasera (archivo con "remote") */
const isRemoteViewShowing = () => {
try {
const imgs = Array.from(root.querySelectorAll('[data-u1-pdp-gallery-viewport] .u1-pdp-customizer__gallery-slide img.u1-pdp-customizer__gallery-img'));
if (!imgs.length) return false;
const cur = imgs[Number(state.galleryIndex || 0)] || imgs[0];
const src = cur ? String(cur.currentSrc || cur.src || '') : '';
return /remote/i.test(src);
} catch (_e) { return false; }
};
const syncRemoteMipsBadgeOverlay = () => {
const img = galleryRemoteMipsBadge && galleryRemoteMipsBadge.img ? galleryRemoteMipsBadge.img : null;
if (!img) return;
if (root._u1GalleryUxMode !== 'accessories' || !isRemoteViewShowing()) {
img.hidden = true;
img.setAttribute('aria-hidden', 'true');
try { img.style.display = 'none'; } catch (_eD0) {}
try { img.removeAttribute('src'); } catch (_e0) {}
return;
}
const src = remoteMipsBadgeSrcFor();
if (!src) {
img.hidden = true;
img.setAttribute('aria-hidden', 'true');
try { img.style.display = 'none'; } catch (_eD1) {}
try { img.removeAttribute('src'); } catch (_e1) {}
return;
}
img.hidden = false;
img.setAttribute('aria-hidden', 'false');
try { img.style.display = ''; } catch (_eD2) {}
if (String(img.getAttribute('src') || '') !== String(src)) img.setAttribute('src', String(src));
};
const initMipsBadgeOverlay = () => {
const enabled = String(root.dataset.u1PdpMipsBadgeEnabled || '') === '1';
const isMips = String(root.dataset.u1PdpIsMips || '') === '1';
if (!enabled || !isMips) return;
const rawName = String(root.dataset.u1PdpMipsBadgeFile || '').trim();
const names = rawName ? [rawName] : ['pdp-mips-badge.png', 'mips-badge.png', 'mips.png'];
const cands = [];
names.forEach((name) => {
try { cands.push(filesUrlFor(name)); } catch (_e) {}
try { cands.push(assetUrlFor(name)); } catch (_e2) {}
});
const uniq = Array.from(new Set(cands.filter(Boolean)));
if (!uniq.length) return;
(async () => {
try {
for (const src of uniq) {
const ok = await u1ImgExists.check(src);
if (ok) {
try { root.style.setProperty('--u1-pdp-mips-badge-url', `url("${src}")`); } catch (_eS) {}
try { root.dataset.u1PdpMipsBadgeReady = '1'; } catch (_eD) {}
break;
}
}
} catch (_e) {}
})();
};
initMipsBadgeOverlay();
const preloadVisorOverlaysForCurrentColor = () => {
try {
const srcs = visorBtns
.map((b) => {
const vid = b && b.dataset ? parseVariantId(b.dataset.u1PdpAccessoryVariantId || '') : 0;
const fs = b && b.dataset ? (b.dataset.u1PdpAccessoryFilterStyle || '') : '';
return visorOverlaySrcFor({ variantId: vid, filterStyle: fs });
})
.filter(Boolean);
srcs.forEach(s => u1ImgPreload.preload(s));
} catch (_e) {}
};
// Preloadea slide-2 (visor base) de todos los colores con baja prioridad,
// así cuando el usuario llega a la sección visor la imagen ya está en caché.
const preloadAllVisorBaseImages = () => {
try {
if (!hasCustomGallery || !colorGalleryMap || !colorGalleryMap.size) return;
colorGalleryMap.forEach((imgs) => {
const base = (imgs && imgs.length >= 2) ? imgs[1] : (imgs && imgs.length ? imgs[0] : null);
if (base && base.src) u1ImgPreload.preload(String(base.src));
});
} catch (_e) {}
};
const preloadRemoteForCurrentColor = () => {
try {
if (TEMPLATE_RAW === 'torch' && getTorchInsertSelectedNow()) return;
const offSrc = remoteBaseOffSrcFor();
const onSrc = remoteOnSrcFor();
if (offSrc) u1ImgPreload.preload(offSrc);
if (onSrc) u1ImgPreload.preload(onSrc);
} catch (_e) {}
};
let visorInView = false;
let accessoriesInView = false;
let ioModes = null;
const setupModeObservers = () => {
visorInView = false;
accessoriesInView = false;
if (ioModes) { try { ioModes.disconnect(); } catch (_e) {} }
ioModes = null;
if (!isDesktop) return;
if (!('IntersectionObserver' in window)) return;
const targets = [];
if (visorStepEl) targets.push(visorStepEl);
if (accessoriesStepEl2) targets.push(accessoriesStepEl2);
if (!targets.length) return;
ioModes = new IntersectionObserver((entries) => {
entries.forEach((e) => {
if (!e || !e.target) return;
if (visorStepEl && e.target === visorStepEl) visorInView = !!e.isIntersecting;
if (accessoriesStepEl2 && e.target === accessoriesStepEl2) accessoriesInView = !!e.isIntersecting;
});
scheduleGalleryUxModeCheck();
}, { threshold: 0.25 });
targets.forEach(t => ioModes.observe(t));
// Observer anticipado: precarga la imagen base del visor cuando la sección
// está a 600px de entrar en pantalla (mucho antes del threshold de activación).
if (visorStepEl && 'IntersectionObserver' in window) {
let visorBasePreloaded = false;
const ioEarly = new IntersectionObserver((entries) => {
entries.forEach((e) => {
if (!e.isIntersecting || visorBasePreloaded) return;
visorBasePreloaded = true;
try { preloadVisorOverlaysForCurrentColor(); } catch (_e) {}
try { preloadAllVisorBaseImages(); } catch (_e) {}
ioEarly.disconnect();
});
}, { rootMargin: '0px 0px 600px 0px', threshold: 0 });
ioEarly.observe(visorStepEl);
}
};
setupModeObservers();
if (desktopMq) {
try {
desktopMq.addEventListener('change', () => setupModeObservers());
} catch (_e) {
try { desktopMq.addListener(() => setupModeObservers()); } catch (_e2) {}
}
}
let visorCycleIdx = 0;
const clearModeOverlays = () => {
if (galleryModeLayers && galleryModeLayers.preview) setModeLayerVisible(galleryModeLayers.preview, false);
if (galleryModeLayers && galleryModeLayers.active) setModeLayerVisible(galleryModeLayers.active, false);
};
const setBaseToNormalGallery = () => {
if (galleryMode === 'final') return;
if (!hasCustomGallery) return;
const imgs = getGalleryImagesForColor(getMediaColorValue());
if (!imgs || !imgs.length) return;
const first = imgs[0] || null;
if (first && first.type === 'video') setGalleryToImages(imgs, { preserveIndex: false });
else crossfadeGalleryToImages(imgs, { durationMs: 133 });
setGallerySwipeEnabled(true);
};
const setBaseToVisorView = () => {
clearModeOverlays();
root._u1VisorBaseReady = false;
if (hasCustomGallery) {
const imgs = getGalleryImagesForColor(getMediaColorValue());
const base = (imgs && imgs.length >= 2) ? imgs[1] : ((imgs && imgs.length) ? imgs[0] : null);
if (base && base.src) {
const baseImg = { src: String(base.src), alt: String(base.alt || ''), lifestyle: !!base.lifestyle };
// Bloquea la galería al frame del visor INMEDIATAMENTE (síncrono) — sin esto,
// la galería puede seguir teniendo N slides si crossfadeGalleryToImages es cancelado
// antes de que doSwap corra (race condition con transitionGalleryToColor).
setGalleryToImages([baseImg], { preserveIndex: false, eagerFirst: true });
crossfadeGalleryToImages(
[baseImg],
{
durationMs: 133,
onOverlayReady: ({ token: readyToken } = {}) => {
if (String(root._u1GalleryUxMode || '') !== 'visor') return;
// Verifica que el token no haya cambiado entre startFade y onOverlayReady
if (readyToken && String(root._u1GalleryToken) !== String(readyToken)) {
return;
}
root._u1VisorBaseReady = true;
try { syncVisorOverlay(); } catch (_e) {}
}
}
);
} else {
window.requestAnimationFrame(() => { root._u1VisorBaseReady = true; });
}
} else if (slides && slides.length >= 2) {
state.galleryIndex = 1;
scrollGalleryToIndex(1);
window.requestAnimationFrame(() => {
if (String(root._u1GalleryUxMode || '') !== 'visor') return;
root._u1VisorBaseReady = true;
try { syncVisorOverlay(); } catch (_e) {}
});
}
setGallerySwipeEnabled(false);
};
const setBaseToAccessoriesView = () => {
clearModeOverlays();
try {
if (TEMPLATE_RAW === 'torch' && getTorchInsertSelectedNow()) return;
} catch (_e0) {}
const offSrc = remoteBaseOffSrcFor();
if (!offSrc) { var _ovA = _bundleOverlayEl(); if (_ovA) _ovA.style.opacity = '1'; return; }
try {
if (root._u1RemoteBaseLoadingEnd) { root._u1RemoteBaseLoadingEnd(); root._u1RemoteBaseLoadingEnd = null; }
} catch (_e3) {}
try { if (galleryTrack) galleryTrack.style.opacity = ''; } catch (_e4) {}
crossfadeGalleryToImages([{ src: offSrc, alt: (TEMPLATE_RAW === 'torch' ? U1S.alt_torch : U1S.alt_remote), lifestyle: false }], { durationMs: 133 });
setGallerySwipeEnabled(false);
// Re-sync del badge MIPS remoto cuando la base ya es la vista del remote
window.setTimeout(() => { try { syncRemoteMipsBadgeOverlay(); } catch (_eRB) {} }, 200);
};
root._u1RequestAccessoriesBaseRefresh = () => {
try {
if (root._u1GalleryUxMode === 'accessories') setBaseToAccessoriesView();
} catch (_e) {}
};
const getChaptersGapPx = () => {
try {
const raw = String(getComputedStyle(root).getPropertyValue('--u1-pdp-chapters-gap') || '').trim();
const n = Number.parseFloat(raw || '0');
return Number.isFinite(n) ? n : 0;
} catch (_e) { return 0; }
};
const getUxBandHalfHeightPx = () => {
const gap = getChaptersGapPx();
const derived = gap ? (gap / 2 + 40) : 160;
return Math.max(120, Math.min(280, derived));
};
const isStepActiveBand = (el, { centerRatio = 0.55, halfHeightPx = 160 } = { centerRatio: 0.55, halfHeightPx: 160 }) => {
if (!el || !el.getBoundingClientRect) return false;
const r = el.getBoundingClientRect();
const ratio = Math.max(0.05, Math.min(0.95, Number(centerRatio || 0.55) || 0.55));
const y = window.innerHeight * ratio;
const hh = Math.max(40, Number(halfHeightPx || 160) || 160);
const top = y - hh;
const bottom = y + hh;
return (r.bottom >= top) && (r.top <= bottom);
};
const stepDistanceToY = (el, y) => {
if (!el || !el.getBoundingClientRect) return Infinity;
const r = el.getBoundingClientRect();
const mid = (r.top + r.bottom) / 2;
return Math.abs(mid - y);
};
const isStepActiveLine = (el, y) => {
if (!el || !el.getBoundingClientRect) return false;
const r = el.getBoundingClientRect();
return (r.top <= y) && (r.bottom >= y);
};
const _initSlidesReady = !!(slides && slides.length >= 2);
const computeUxMode = () => {
if (!isDesktop) return 'normal';
if (TEMPLATE === 'light') return 'normal';

if (root._u1BundleGalleryActive) return 'normal';
if (root._u1FinalLatched) return 'final';

const _reqsDone = _initSlidesReady || !(
  (HAS_COLOR_CHAPTER && HAS_COLOR_OPTION && !state.color) ||
  (HAS_CHAPTER_SIZE && HAS_SIZE_OPTION && !state.size)
);
const y = window.innerHeight * 0.5;
const crashIsCentered = isStepActiveLine(crashStepEl2, y);
if (crashIsCentered) return (galleryMode === 'final') ? 'final' : 'normal';

const candidates = [
{ el: colorStepEl,        mode: 'normal' },
{ el: sizeStepEl,         mode: 'normal' },
{ el: visorStepEl,        mode: _reqsDone ? 'visor' : 'normal' },
{ el: accessoriesStepEl2, mode: _reqsDone ? 'accessories' : 'normal' },
].filter(function(c) { return c.el; })
 .map(function(c) { return { mode: c.mode, d: stepDistanceToY(c.el, y) }; })
 .sort(function(a, b) { return a.d - b.d; });
if (candidates.length && candidates[0].d !== Infinity) return candidates[0].mode;
if (galleryMode === 'final') return 'final';
return 'normal';
};
const applyUxMode = (nextMode, { force } = { force: false }) => {
const prev = String(root._u1GalleryUxMode || 'normal');
let next = String(nextMode || 'normal');
if (TEMPLATE === 'light' && next !== 'normal') next = 'normal';
if (!force && prev === next) return;
if (prev === 'accessories' && next !== 'accessories') {
try {
if (root._u1RemoteBaseLoadingEnd) { root._u1RemoteBaseLoadingEnd(); root._u1RemoteBaseLoadingEnd = null; }
} catch (_e) {}
try { if (galleryTrack) galleryTrack.style.opacity = ''; } catch (_e2) {}
} else if (next !== 'accessories') {
try {
if (root._u1RemoteBaseLoadingEnd) { root._u1RemoteBaseLoadingEnd(); root._u1RemoteBaseLoadingEnd = null; }
} catch (_e3) {}
try { if (galleryTrack) galleryTrack.style.opacity = ''; } catch (_e4) {}
}
root._u1GalleryUxMode = next;
root.setAttribute('data-u1-gallery-ux-mode', next);

if (root._u1BundleGalleryActive) {
  if (next === 'visor' || next === 'accessories') {
    var _ovB = _bundleOverlayEl(); if (_ovB) _ovB.style.opacity = '0';
  } else if (next === 'normal') {
    var _ovC = _bundleOverlayEl(); if (_ovC) _ovC.style.opacity = '1';
  }
}
if (galleryMode === 'final' && next !== 'final') {
try { applyFinalGalleryMode(false); } catch (_e) {}
}
if (next === 'final') {
clearModeOverlays();
root._u1RemoteHovering = false;
try { applyFinalGalleryMode(true); } catch (_e0) {}
setGallerySwipeEnabled(false);
root._u1VisorCycleCount = 0;
updateGalleryButtons();
return;
}
if (next === 'visor') {
setBaseToVisorView();
preloadVisorOverlaysForCurrentColor();
} else if (next === 'accessories') {
setBaseToAccessoriesView();
preloadRemoteForCurrentColor();
} else {
setBaseToNormalGallery();
clearModeOverlays();
root._u1RemoteHovering = false;
}
syncModeOverlays();
updateGalleryButtons();
};
let galleryModeRaf = null;
const scheduleGalleryUxModeCheck = () => {
if (galleryModeRaf) return;
galleryModeRaf = window.requestAnimationFrame(() => {
galleryModeRaf = null;
applyUxMode(computeUxMode());
try {
const hit = root._u1RemoteHitEl || null;
const torchHits = root._u1TorchLightHitEls || [];
const hoveringNow = !!(hit && hit.matches && hit.matches(':hover')) || (torchHits.length > 0 && torchHits.some(el => el && el.matches && el.matches(':hover')));
if (!hoveringNow && root._u1RemoteHovering) {
root._u1RemoteHovering = false;
if (galleryModeLayers && galleryModeLayers.preview) setModeLayerVisible(galleryModeLayers.preview, false);
}
} catch (_e) {}
});
};
window.addEventListener('scroll', scheduleGalleryUxModeCheck, { passive: true });
window.addEventListener('resize', scheduleGalleryUxModeCheck, { passive: true });
const syncVisorOverlay = () => {
const selected = getVisorSelectionList();
root._u1VisorCycleCount = selected.length;
if (root._u1GalleryUxMode !== 'visor') {
if (galleryModeLayers && galleryModeLayers.preview) setModeLayerVisible(galleryModeLayers.preview, false);
if (galleryModeLayers && galleryModeLayers.active) setModeLayerVisible(galleryModeLayers.active, false);
updateGalleryButtons();
return;
}
if (!root._u1VisorBaseReady) {
if (galleryModeLayers && galleryModeLayers.preview) setModeLayerVisible(galleryModeLayers.preview, false);
if (galleryModeLayers && galleryModeLayers.active) setModeLayerVisible(galleryModeLayers.active, false);
updateGalleryButtons();
return;
}
if (!selected.length) {
if (galleryModeLayers && galleryModeLayers.active) setModeLayerVisible(galleryModeLayers.active, false);
updateGalleryButtons();
return;
}
visorCycleIdx = clamp(visorCycleIdx, 0, selected.length - 1);
const activeSel = selected[visorCycleIdx];
const src = visorOverlaySrcFor(activeSel);
if (src && galleryModeLayers && galleryModeLayers.active) fadeModeLayerToSrc(galleryModeLayers.active, src, { durationMs: 219 });
updateGalleryButtons();
};
const syncRemoteOverlay = () => {
if (root._u1GalleryUxMode !== 'accessories') return;
try {
if (TEMPLATE_RAW === 'torch' && getTorchInsertSelectedNow()) return;
} catch (_e0) {}
const onSrc = remoteOnSrcFor();
const offSrc = remoteBaseOffSrcFor();
if (!onSrc) return;
if (!galleryModeLayers || !galleryModeLayers.active || !galleryModeLayers.preview) return;
if (isRemoteSelected()) {
fadeModeLayerToSrc(galleryModeLayers.active, onSrc, { durationMs: 219 });
} else {
setModeLayerVisible(galleryModeLayers.active, false);
}
};
// ── Insert overlay (Rain Plugs / accessories with color picker + overlay image) ──
// overlayPrefixMap: JSON de Liquid (overlay_image_prefix) + mapa hardcodeado (el editor a veces borra el campo)
const _HARDCODED_OVERLAY_PREFIXES = {
  'rain-plugs': 'pdp-rain-plug-neon',
  'rain-plugs-for-neon': 'pdp-rain-plug-neon'
};

const overlayPrefixMap = (() => {
  try {
    const el = root.querySelector && root.querySelector('#u1-pdp-acc-overlay-map');
    if (el) {
      const d = JSON.parse(el.textContent || '{}');
      return Object.assign({}, _HARDCODED_OVERLAY_PREFIXES, d.overlayPrefixes || {});
    }
  } catch (_e) {}
  return Object.assign({}, _HARDCODED_OVERLAY_PREFIXES);
})();

const insertBtn = (() => {
  const allAcc = Array.from(root.querySelectorAll('[data-u1-pdp-accessory]'));
  // Prioridad 1: section setting (backward compat)
  const sectionHandle = optionNameHandle(root.dataset.u1PdpInsertHandle || '');
  if (sectionHandle) {
    const byHandle = allAcc.find(
      b => b && b.dataset && optionNameHandle(b.dataset.u1PdpAccessoryHandle || '') === sectionHandle
    );
    if (byHandle) return byHandle;
  }
  // Prioridad 2: JSON map
  const byMap = allAcc.find(
    b => b && b.dataset && !!overlayPrefixMap[b.dataset.u1PdpAccessoryHandle || '']
  );
  if (byMap) return byMap;
  // Prioridad 3: data-attribute como fallback
  return allAcc.find(
    b => b && b.dataset && String(b.dataset.u1PdpAccessoryOverlayPrefix || '').length > 0
  ) || null;
})();

const insertBtnHandle = insertBtn ? optionNameHandle(insertBtn.dataset.u1PdpAccessoryHandle || '') : '';

const isInsertSelected = () => {
  if (!insertBtn) return false;
  return insertBtn.getAttribute('aria-pressed') === 'true' || insertBtn.classList.contains('is-selected');
};

// ── Silicone inserts como accesorio: Torch PDP o flag enable_insert_torch_assets (ej. Sparky) ──
const isTorchInserts = () =>
  !!insertBtn &&
  !!insertBtnHandle &&
  (TEMPLATE_RAW === 'torch' || INSERT_TORCH_ASSETS);

const normInsertColorHandle = (h) => {
  const x = optionNameHandle(h || '');
  if (x === 'tangerine-orange') return 'tangerine-orange';
  if (x === 'ice-white') return 'ice-white';
  return '';
};

const normInsertModelHandle = (h) => {
  const x = optionNameHandle(h || '');
  if (x === 'dino') return 'dino';
  if (x === 'lightning') return 'lightning';
  if (x === 'spikes') return 'spikes';
  return '';
};

const INSERT_VARIANT_ID_BY_COLOR_MODEL = {
  'tangerine-orange': {
    dino: 44941442482337,
    lightning: 44941442515105,
    spikes: 44941442547873
  },
  'ice-white': {
    dino: 44941442580641,
    lightning: 44941442613409,
    spikes: 44941442646177
  }
};

const pickInsertVariantId = ({ colorHandle, modelHandle } = { colorHandle: '', modelHandle: '' }) => {
  const c = normInsertColorHandle(colorHandle);
  const m = normInsertModelHandle(modelHandle);
  if (!c || !m) return 0;
  const row = INSERT_VARIANT_ID_BY_COLOR_MODEL[c];
  const vid = row ? Number(row[m] || 0) : 0;
  return Number.isFinite(vid) ? vid : 0;
};

const insertSrcFor = (colorHandleOverride) => {
  const btn = insertBtn;
  if (!btn) return '';

  if (isTorchInserts()) {
    const modelH = normInsertModelHandle(btn.dataset.u1PdpAccessorySelectedModel || 'dino') || 'dino';
    const insertColorH = normInsertColorHandle(
      colorHandleOverride || String(btn.dataset.u1PdpAccessorySelectedColor || '')
    ) || 'tangerine-orange';
    const prodH = optionNameHandle(mainProductHandle || '');
    const colorH = getMediaColorHandle();
    if (!prodH || !colorH) return '';
    const base = `pdp-insert-${modelH}-${insertColorH}-${prodH}-${colorH}`;
    try { return filesUrlFor(`${base}.jpg`); } catch (_e0) {}
    try { return assetUrlFor(`${base}.jpg`); } catch (_e1) {}
    return '';
  }

  const handle = btn.dataset.u1PdpAccessoryHandle || '';
  const prefix = (overlayPrefixMap[handle] || String(btn.dataset.u1PdpAccessoryOverlayPrefix || '')).trim();
  const color = colorHandleOverride || String(btn.dataset.u1PdpAccessorySelectedColor || '');
  if (!prefix || !color) return '';
  try { return filesUrlFor(`${prefix}-${color}.png`); } catch (_e) {}
  return '';
};

const syncInsertOverlay = () => {
  const img = galleryInsertOverlay && galleryInsertOverlay.img ? galleryInsertOverlay.img : null;
  if (!img) return;

  const uxMode = root._u1GalleryUxMode;
  if (uxMode !== 'accessories') {
    img.hidden = true;
    img.setAttribute('aria-hidden', 'true');
    try { img.removeAttribute('src'); } catch (_e0) {}
    return;
  }

  const selected = isInsertSelected();
  let src = '';
  const torchInserts = isTorchInserts();

  if (torchInserts) {
    const prodH = optionNameHandle(mainProductHandle || '');
    const colorH = getMediaColorHandle();

    if (!prodH || !colorH) {
      src = '';
    } else if (selected || root._u1InsertHovering) {
      // Card seleccionada O estoy en hover sobre la card → combinación actual
      src = insertSrcFor();
    } else {
      // Sin card seleccionada y sin hover → base "none"
      const base = `pdp-insert-none-${prodH}-${colorH}`;
      try { src = filesUrlFor(`${base}.jpg`); } catch (_e1) {}
      if (!src) {
        try { src = assetUrlFor(`${base}.jpg`); } catch (_e2) {}
      }
    }
  } else {
    // Otros templates/cards → comportamiento original
    src = selected ? insertSrcFor() : '';
  }

  if (!src) {
    img.hidden = true;
    img.setAttribute('aria-hidden', 'true');
    try { img.removeAttribute('src'); } catch (_e3) {}
    return;
  }

  img.hidden = false;
  img.setAttribute('aria-hidden', 'false');
  const currentSrc = String(img.getAttribute('src') || '');
  if (currentSrc !== String(src)) {
    const pre = new Image();
    pre.onload = () => {
      try { img.setAttribute('src', String(src)); } catch (_ep) {}
    };
    pre.onerror = () => {
      try { img.hidden = true; img.setAttribute('aria-hidden', 'true'); img.removeAttribute('src'); } catch (_ep) {}
    };
    pre.src = String(src);
  }
};

// Hover para insert card (Torch Inserts)
if (insertBtn) {
  const insertHit = (insertBtn.closest && insertBtn.closest('.u1-pdp-card-hit')) || insertBtn;

  insertHit.addEventListener('mouseenter', () => {
    if (!isTorchInserts()) return;
    if (root._u1GalleryUxMode !== 'accessories') return;
    root._u1InsertHovering = true;
    try { syncInsertOverlay(); } catch (_e) {}
  }, { passive: true });

  insertHit.addEventListener('mouseleave', () => {
    if (!isTorchInserts()) return;
    if (root._u1GalleryUxMode !== 'accessories') return;
    root._u1InsertHovering = false;
    try { syncInsertOverlay(); } catch (_e2) {}
  }, { passive: true });
}

// Color swatch click handler — actualiza color seleccionado, color name text, overlay y variant
const insertColorSwatches = Array.from(root.querySelectorAll('[data-u1-pdp-card-color-swatch]'));
insertColorSwatches.forEach((swatch) => {
  swatch.addEventListener('click', (e) => {
    try { e.stopPropagation(); } catch (_e) {}

    const variantId = swatch.dataset.u1PdpCardColorSwatchVariantId || '';
    const colorHandle = swatch.dataset.u1PdpCardColorHandle || '';
    const colorLabel = String(swatch.getAttribute('aria-label') || '').trim();
    const strip = (swatch.closest && swatch.closest('.u1-pdp-card-color-strip')) || null;
    const cardHit = (swatch.closest && swatch.closest('.u1-pdp-card-hit')) || null;
    const cardBtn = cardHit ? cardHit.querySelector('[data-u1-pdp-accessory]') : null;

    // Actualizar color seleccionado en el botón
    if (cardBtn) {
      cardBtn.dataset.u1PdpAccessorySelectedColor = colorHandle;
      if (optionNameHandle(cardBtn.dataset.u1PdpAccessoryHandle || '') === 'set-of-silicone-inserts') {
        // combo color+modelo en cualquier PDP; sin esto, cambiar color pisaba el modelo elegido
        const mH = normInsertModelHandle(cardBtn.dataset.u1PdpAccessorySelectedModel || 'dino') || 'dino';
        const nextVid = pickInsertVariantId({ colorHandle, modelHandle: mH }) || parseVariantId(variantId || '');
        cardBtn.dataset.u1PdpAccessoryVariantId = String(nextVid || '');
      } else {
        cardBtn.dataset.u1PdpAccessoryVariantId = variantId;
      }
    }

    // Actualizar aria-pressed de swatches + nombre del color
    if (strip) {
      Array.from(strip.querySelectorAll('[data-u1-pdp-card-color-swatch]')).forEach((s) => {
        const on = s === swatch;
        s.classList.toggle('is-selected', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      const nameEl = strip.querySelector('[data-u1-pdp-card-color-name]');
      if (nameEl) nameEl.textContent = colorLabel;
    }

    // Si la card ya está seleccionada, actualizar state + overlay
    const isCardSelected =
      cardBtn &&
      (cardBtn.getAttribute('aria-pressed') === 'true' || cardBtn.classList.contains('is-selected'));

    if (isCardSelected && cardBtn) {
      const handle = optionNameHandle(cardBtn.dataset.u1PdpAccessoryHandle || '');
      if (handle) {
        const existing = state.accessories.get(handle);
        if (existing) existing.variantId =
          Number(cardBtn.dataset.u1PdpAccessoryVariantId || variantId) || 0;
      }
      try { syncInsertOverlay(); } catch (_eS) {}
      try { updateSummary(); } catch (_eSu) {}
      try { updateAtcAvailability(); } catch (_eAtc) {}
    }

        // Si estoy sobre la card y NO está seleccionada, usar combinación actual (hover=true)
    if (!isInsertSelected() && root._u1InsertHovering && isTorchInserts() && cardBtn === insertBtn) {
      try { syncInsertOverlay(); } catch (_eH) {}
    }

    // Mobile/Tablet: cuando toco un swatch de inserts, queda "sticky" aunque no esté agregado
    if (isTorchInserts() && cardBtn === insertBtn) {
      try { root._u1InsertStickyMobile = true; } catch (_eF) {}
      try { u1ImgPreload.preload(insertSrcFor(colorHandle)); } catch (_eP) {}
      try { renderMobileGalleries(); } catch (_eM) {}
    }
  });
});

// Silicone Inserts model pills (Dino/Lightning/Spikes); genericas, la card las trae si el block las prende
const insertModelPills = Array.from(root.querySelectorAll('[data-u1-pdp-insert-model]'));
insertModelPills.forEach((pill) => {
  pill.addEventListener('click', (e) => {
    try { e.preventDefault(); } catch (_e0) {}
    try { e.stopPropagation(); } catch (_e1) {}

    const model = normInsertModelHandle(pill.dataset.u1PdpInsertModel || '') || '';
    if (!model) return;

    const hit = (pill.closest && pill.closest('.u1-pdp-card-hit')) || null;
    const cardBtn = hit ? hit.querySelector('[data-u1-pdp-accessory]') : null;
    if (!cardBtn) return;
    if (optionNameHandle(cardBtn.dataset.u1PdpAccessoryHandle || '') !== 'set-of-silicone-inserts') return;

    cardBtn.dataset.u1PdpAccessorySelectedModel = model;

    // UI state (pills)
    try {
      insertModelPills.forEach((p) => {
        const on = p === pill;
        p.classList.toggle('is-selected', on);
        p.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    } catch (_e2) {}

    // Resolver variantId por (color, modelo)
    const cH = normInsertColorHandle(cardBtn.dataset.u1PdpAccessorySelectedColor || 'tangerine-orange') || 'tangerine-orange';
    const nextVid = pickInsertVariantId({ colorHandle: cH, modelHandle: model });
    if (nextVid) cardBtn.dataset.u1PdpAccessoryVariantId = String(nextVid);

    // Si la card está seleccionada, actualizar state + overlay
    const isCardSelected =
      cardBtn.getAttribute('aria-pressed') === 'true' || cardBtn.classList.contains('is-selected');
    if (isCardSelected) {
      const entry = state.accessories.get(cardBtn.dataset.u1PdpAccessoryHandle || '');
      if (entry) entry.variantId = Number(nextVid || 0) || entry.variantId;
      try { updateSummary(); } catch (_eSu) {}
      try { updateAtcAvailability(); } catch (_eAtc) {}
    }

    if (isTorchInserts()) {
    try { root._u1InsertStickyMobile = true; } catch (_eF) {}
    try { u1ImgPreload.preload(insertSrcFor(cH)); } catch (_eP) {}
    try { syncInsertOverlay(); } catch (_eS) {}
    try { renderMobileGalleries(); } catch (_eM) {}
    }
  });
});
const syncModeOverlays = () => {
syncVisorOverlay();
syncRemoteOverlay();
try { syncRemoteMipsBadgeOverlay(); } catch (_e0) {}
try { syncInsertOverlay(); } catch (_e1) {}
try { renderMobileGalleries(); } catch (_e) {}
};
root._u1RequestSyncModeOverlays = () => {
try { syncModeOverlays(); } catch (_e) {}
};
visorBtns.forEach((b) => {
const hit = (b && b.closest) ? (b.closest('.u1-pdp-card-hit') || b) : b;
hit.addEventListener('mouseenter', () => {
if (root._u1GalleryUxMode !== 'visor') return;
if (!root._u1VisorBaseReady) return;
const vid = parseVariantId(b.dataset.u1PdpAccessoryVariantId || '');
const fs = b.dataset.u1PdpAccessoryFilterStyle || '';
const src = visorOverlaySrcFor({ variantId: vid, filterStyle: fs });
if (!src || !galleryModeLayers || !galleryModeLayers.preview) return;
fadeModeLayerToSrc(galleryModeLayers.preview, src, { durationMs: 180 });
});
hit.addEventListener('mouseleave', () => {
if (!galleryModeLayers || !galleryModeLayers.preview) return;
setModeLayerVisible(galleryModeLayers.preview, false);
});
});
const applyRemoteHoverPreview = () => {
if (!root._u1RemoteHovering) return;
if (root._u1GalleryUxMode !== 'accessories') return;
try {
if (TEMPLATE_RAW === 'torch' && getTorchInsertSelectedNow()) return;
} catch (_e0) {}
const onSrc = remoteOnSrcFor();
if (!onSrc || !galleryModeLayers || !galleryModeLayers.preview) return;
fadeModeLayerToSrc(galleryModeLayers.preview, onSrc, { durationMs: 180 });
};
root._u1RequestRemoteHoverPreview = applyRemoteHoverPreview;
const addRemoteHoverListeners = (hit) => {
if (!hit) return;
hit.addEventListener('mouseenter', () => {
root._u1RemoteHovering = true;
try {
if (TEMPLATE_RAW === 'torch' && getTorchInsertSelectedNow()) return;
} catch (_e0) {}
if (isDesktop && root._u1GalleryUxMode !== 'accessories') {
try { applyUxMode('accessories', { force: true }); } catch (_e) {}
}
if (root._u1GalleryUxMode !== 'accessories') return;
try { preloadRemoteForCurrentColor(); } catch (_e2) {}
applyRemoteHoverPreview();
});
hit.addEventListener('mouseleave', () => {
root._u1RemoteHovering = false;
if (!galleryModeLayers || !galleryModeLayers.preview) return;
setModeLayerVisible(galleryModeLayers.preview, false);
});
};
if (TEMPLATE_RAW === 'torch' && torchLightHandles.length) {
// Torch: solo hover en Smart Light / Smart Light Pro Dual; sin hover en Remote
const torchLightHitEls = accessoryBtns
.filter(b => b && b.dataset && torchLightHandles.includes(optionNameHandle(b.dataset.u1PdpAccessoryHandle || '')))
.map(b => (b.closest && b.closest('.u1-pdp-card-hit')) || b)
.filter(Boolean);
root._u1TorchLightHitEls = torchLightHitEls;
torchLightHitEls.forEach(addRemoteHoverListeners);
} else if (remoteBtn) {
const hit = (remoteBtn && remoteBtn.closest) ? (remoteBtn.closest('.u1-pdp-card-hit') || remoteBtn) : remoteBtn;
root._u1RemoteHitEl = hit;
addRemoteHoverListeners(hit);
}
root._u1CycleVisor = (dir) => {
const selected = getVisorSelectionList();
if (root._u1GalleryUxMode !== 'visor') return false;
if (!root._u1VisorBaseReady) return false;
if (!selected || selected.length <= 1) return false;
const d = Number(dir || 0) || 0;
visorCycleIdx = (visorCycleIdx + (d < 0 ? -1 : 1) + selected.length) % selected.length;
const activeSel = selected[visorCycleIdx];
const src = visorOverlaySrcFor(activeSel);
if (src && galleryModeLayers && galleryModeLayers.active) fadeModeLayerToSrc(galleryModeLayers.active, src, { durationMs: 219 });
updateGalleryButtons();
return true;
};
scheduleGalleryUxModeCheck();
syncModeOverlays();
const applyCrashSelection = (opt, btnEl) => {
const nextOpt = String(opt || 'standard');
if (nextOpt === 'standard') {
state.crashPlan = 'standard';
state.crashVariantId = 0;
} else {
const vid = btnEl ? parseVariantId(btnEl.dataset.u1PdpCrashVariantId || '') : 0;
if (!vid) {
showToast('Set Crash Replacement product/variants in section settings.');
return;
}
state.crashPlan = nextOpt;
state.crashVariantId = vid;
}
crashOptionBtns.forEach((b) => {
const isOn = b === btnEl || (nextOpt === 'standard' && String(b.dataset.u1PdpCrashOption || '') === 'standard');
b.classList.toggle('is-selected', isOn);
b.setAttribute('aria-pressed', isOn ? 'true' : 'false');
});
if (crashGroupEl) crashGroupEl.classList.toggle('is-unlimited', nextOpt === 'unlimited');
if (crashFootEl) crashFootEl.setAttribute('aria-hidden', nextOpt === 'unlimited' ? 'true' : 'false');
updateSummary();
};
if (crashOptionBtns.length) {
crashOptionBtns.forEach((btn) => {
btn.addEventListener('click', () => {
if (TEMPLATE === 'light') {
if (!state.variantId) {
if (!goToMissingSelection()) showToast(U1S.sel_model_first);
return;
}
const needsHelmetLight = (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER) && !!root.querySelector('[data-u1-pdp-helmet-size-picker]') && !state.helmetSize;
if (needsHelmetLight) {
if (!goToMissingSelection()) showToast(U1S.sel_helmet_first);
return;
}
} else {
const needsColor = HAS_COLOR_CHAPTER && !state.color;
const needsSize = HAS_CHAPTER_SIZE && HAS_SIZE_OPTION && !state.size;
const needsHelmetSize = (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER) && !!root.querySelector('[data-u1-pdp-helmet-size-picker]') && !state.helmetSize;
if (needsColor || needsSize || needsHelmetSize) {
if (!goToMissingSelection()) {
if (typeof SILICONE_INSERTS_PDP !== 'undefined' && SILICONE_INSERTS_PDP) {
showToast(needsSize ? U1S.sel_model_first : (needsHelmetSize ? U1S.sel_helmet_first : U1S.sel_color_first));
} else {
showToast(needsColor ? U1S.sel_color_first : (needsHelmetSize ? U1S.sel_helmet_first : U1S.sel_size));
}
}
return;
}
}
if (btn.getAttribute && btn.getAttribute('aria-disabled') === 'true') return;
const opt = String(btn.dataset.u1PdpCrashOption || 'standard');
if (crashFreeOption !== 'none') {
const crashRank = { standard: 0, premium: 1, unlimited: 2 };
if ((crashRank[opt] || 0) < (crashRank[crashFreeOption] || 0)) return;
}
applyCrashSelection(opt, btn);
});
});
if (crashFreeOption !== 'none') {
const freeBtn = crashOptionBtns.find(b => String(b.dataset.u1PdpCrashOption || '') === crashFreeOption);
if (freeBtn) { applyCrashSelection(crashFreeOption, freeBtn); document.addEventListener('u1:pdp:pack-change', () => applyCrashSelection(crashFreeOption, freeBtn)); }
} else {
const standardBtn = crashOptionBtns.find(b => String(b.dataset.u1PdpCrashOption || '') === 'standard') || crashOptionBtns[0];
if (standardBtn) applyCrashSelection('standard', standardBtn);
}
}
if (btnPrev) btnPrev.addEventListener('click', (e) => {
if (root._u1GalleryDragging) { e.preventDefault(); return; }
if (btnPrev.getAttribute('aria-disabled') === 'true') return;
const uxMode = String(root._u1GalleryUxMode || 'normal');
if (uxMode === 'visor' && typeof root._u1CycleVisor === 'function') {
if (root._u1CycleVisor(-1)) return;
return;
}
if (uxMode !== 'normal') return;
scrollBy(-1);
});
if (btnNext) btnNext.addEventListener('click', (e) => {
if (root._u1GalleryDragging) { e.preventDefault(); return; }
if (btnNext.getAttribute('aria-disabled') === 'true') return;
const uxMode = String(root._u1GalleryUxMode || 'normal');
if (uxMode === 'visor' && typeof root._u1CycleVisor === 'function') {
if (root._u1CycleVisor(1)) return;
return;
}
if (uxMode !== 'normal') return;
scrollBy(1);
});
initGalleryDrag();
const initProductDescriptionToggle = () => {
if (!productWrap || !descEl || !moreBtn) return;

for (const p of descEl.querySelectorAll(':scope > p')) {
  if (p.textContent.replace(/[\s ]+/g, '') === '') { p.hidden = true; } else { break; }
}
const minLinesRaw = parseInt(String(root.dataset.u1PdpDescMinLines || '4'), 10);
const minLinesForToggle = Math.min(20, Math.max(2, Number.isFinite(minLinesRaw) ? minLinesRaw : 4));
const cs = getComputedStyle(descEl);
let lineHeightPx = parseFloat(cs.lineHeight);
if (!Number.isFinite(lineHeightPx) || lineHeightPx <= 0) {
const fs = parseFloat(cs.fontSize);
lineHeightPx = Number.isFinite(fs) && fs > 0 ? fs * 1.45 : 20;
}
const estimatedLines = Math.max(1, Math.ceil(descEl.scrollHeight / lineHeightPx));
const needsToggle = estimatedLines > minLinesForToggle;
productWrap.classList.toggle('u1-pdp-desc--short', !needsToggle);
moreBtn.hidden = !needsToggle;

const collapsedLines = 2;
descEl.style.setProperty('--u1-pdp-desc-collapsed', `${Math.ceil(lineHeightPx * collapsedLines)}px`);
if (!needsToggle) return;
const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let animTimer = null;
const startAnimating = () => {
if (prefersReducedMotion) return;
productWrap.classList.add('is-animating');
if (animTimer) window.clearTimeout(animTimer);
animTimer = window.setTimeout(() => {
productWrap.classList.remove('is-animating');
}, 520);
};
const computeExpandedHeight = () => {
/* 2026-09-28: clone+scrollHeight = layout forzado; solo si cambio ancho o texto */
const w = descEl.offsetWidth;
const k = w + ':' + descEl.textContent.length;
if (descEl._u1EK !== k) {
const clone = descEl.cloneNode(true);
clone.style.cssText = 'max-height:none;position:absolute;visibility:hidden;width:' + w + 'px';
descEl.parentNode.appendChild(clone);
descEl._u1EH = clone.scrollHeight;
clone.remove();
descEl._u1EK = k;
}
descEl.style.setProperty('--u1-pdp-desc-expanded', `${descEl._u1EH + 4}px`);
return descEl._u1EH;
};
const setExpanded = (expanded) => {
const expandedH = computeExpandedHeight();
const collapsedH = parseInt(getComputedStyle(descEl).getPropertyValue('--u1-pdp-desc-collapsed')) || 42;
const diff = Math.abs(expandedH - collapsedH);
const duration = Math.max(150, Math.min(350, diff * 4));
descEl.style.transitionDuration = duration + 'ms';
startAnimating();
productWrap.classList.toggle('is-expanded', expanded);
moreBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
const labelEl = moreBtn.querySelector('.u1-pdp-product__more-text');
if (labelEl) labelEl.textContent = expanded ? U1S.show_less : U1S.show_more;
};
computeExpandedHeight();
let expanded = false;
setExpanded(false);
moreBtn.addEventListener('click', () => {
expanded = !expanded;
setExpanded(expanded);
});
descEl.addEventListener('transitionend', (e) => {
if (prefersReducedMotion) return;
if (!e || e.propertyName !== 'max-height') return;
productWrap.classList.remove('is-animating');
if (animTimer) {
window.clearTimeout(animTimer);
animTimer = null;
}
});
const ro = new ResizeObserver(() => {
computeExpandedHeight();
});
ro.observe(descEl);
};
const attachHitCursor = (btn) => {
if (!btn) return;
const icon = btn.querySelector('.u1-pdp-customizer__gallery-hit-icon');
if (!icon) return;
const setPos = (evt) => {
const r = btn.getBoundingClientRect();
const x = evt.clientX - r.left;
const y = evt.clientY - r.top;
btn.style.setProperty('--u1-hit-x', `${x}px`);
btn.style.setProperty('--u1-hit-y', `${y}px`);
};
btn.addEventListener('mouseenter', (e) => {
btn.classList.add('is-hover');
setPos(e);
});
btn.addEventListener('mousemove', setPos);
btn.addEventListener('mouseleave', () => {
btn.classList.remove('is-hover');
});
btn.addEventListener('pointerdown', () => {
btn.classList.add('is-active');
}, { passive: true });
const clearActive = () => btn.classList.remove('is-active');
btn.addEventListener('pointerup', clearActive, { passive: true });
btn.addEventListener('pointercancel', clearActive, { passive: true });
btn.addEventListener('blur', clearActive, { passive: true });
};
attachHitCursor(btnPrev);
attachHitCursor(btnNext);
if (galleryTrack) {
galleryTrack.addEventListener('scroll', () => {
/* 2026-09-28: si el slide activo no cambio, no tocar el DOM (evita layout forzado) */
const gi = getActiveGalleryIndex();
if (gi === state.galleryIndex && galleryTrack._u1Si) return;
galleryTrack._u1Si = 1;
state.galleryIndex = gi;
updateGalleryButtons();
renderMobileGalleries();
try {
const slide = slides[state.galleryIndex];
const img = slide ? slide.querySelector('img') : null;
watchImgForLoader(img);
} catch (_e) {}
}, { passive: true });
}
const getCartAddJsUrl = () => {
if (typeof routes !== 'undefined' && routes && routes.cart_add_url) {
const u = String(routes.cart_add_url);
return u.endsWith('.js') ? u : `${u}.js`;
}
return '/cart/add.js';
};
const U1_DISCOUNT_STORAGE_KEY = 'u1_pdp_discount_code';
const pickBundleDiscountCodeFromState = () => {
try {
if (!bundleDiscountRules || !bundleDiscountRules.length) return '';
if (!Number(state && state.variantId ? state.variantId : 0)) return '';
const selected = new Set();
for (const entry of state.accessories.values()) {
if (!entry) continue;
const h = optionNameHandle(entry.handle || '');
if (h) selected.add(h);
}
let best = null;
let bestScore = -Infinity;
bundleDiscountRules.forEach((rule, idx) => {
if (!rule || !rule.discountCode) return;
if (!ruleMatchesMainProductSelection(rule)) return;
const req = Array.isArray(rule.requiredAccessoryHandles) ? rule.requiredAccessoryHandles : [];
if (!req.length) return;
for (const h of req) { if (!selected.has(h)) return; }
const level = Number(rule.level || 0) || 0; // auto: depende del orden del block (arriba = mayor)
const score = (level * 1000) + req.length + (idx * 0.0001);
if (score > bestScore) { bestScore = score; best = rule; }
});
return best && best.discountCode ? String(best.discountCode).trim() : '';
} catch (_e) { return ''; }
};
const pickAllDiscountCodes = () => {
const codes = [];
try {
if (TEMPLATE === 'light') {
const meta = getMainQtyDiscountMeta();
const qty = getMainQty();
const minQty = Math.max(2, Number(meta.minQty || 0) || 0);
const c = (meta.code || '').toString().trim();
if (c && qty >= minQty && Number(state.variantId || 0)) codes.push(c);
}
const bundleCode = pickBundleDiscountCodeFromState();
if (bundleCode) codes.push(bundleCode);
/* Modelo de campana elegido con codigo de la app de descuentos (ej. Pro Dual -> PRODUAL35); si no, la card solo
   elegida con codigo. Solo llega aca sin pack activo (con pack, va el codigo del pack) */
const _mcSel = root.querySelector('[data-u1-pdp-model].is-selected[data-u1-model-camp-code]');
const _soloSel = root.querySelector('.u1-pdp-bundle-card--solo.is-selected[data-u1-solo-code]');
const _campCode = _mcSel ? String(_mcSel.getAttribute('data-u1-model-camp-code') || '').trim()
  : (_soloSel && _soloSel.offsetParent !== null ? String(_soloSel.getAttribute('data-u1-solo-code') || '').trim() : '');
if (_campCode && codes.indexOf(_campCode) === -1) codes.push(_campCode);
if (ATC_DISCOUNT_ON && ATC_DISCOUNT_CODE && getMainCompareAtPriceCents() > 0) codes.push(ATC_DISCOUNT_CODE);
for (const entry of state.accessories.values()) {
if (!entry) continue;
const c = (entry.discountCode || '').toString().trim();
if (c) codes.push(c);
}
const cfOpt = (crashFreeOption || 'none').toString().trim();
const crashPlanNow = (state.crashPlan || 'standard').toString().trim();
const cfCode = (crashFreeDiscountCode || '').toString().trim();
if (cfCode && cfOpt !== 'none' && crashPlanNow === cfOpt && (crashPlanNow === 'premium' || crashPlanNow === 'unlimited')) {
codes.push(cfCode);
}
} catch (_e) {}
const seen = new Set();
return codes.filter(c => { const k = c.toUpperCase(); if (seen.has(k)) return false; seen.add(k); return true; });
};
const pickDiscountCodeFromState = () => {
const all = pickAllDiscountCodes();
return all.length ? all[0] : '';
};
const persistDiscountCode = (code) => {
const c = (code || '').toString().trim();
try {
if (!c) {
window.localStorage.removeItem(U1_DISCOUNT_STORAGE_KEY);
return;
}
window.localStorage.setItem(U1_DISCOUNT_STORAGE_KEY, c);
} catch (_e) {}
};
const getPersistedDiscountCode = () => {
try {
return (window.localStorage.getItem(U1_DISCOUNT_STORAGE_KEY) || '').toString().trim();
} catch (_e) {
return '';
}
};
const applyDiscountCodeBestEffort = (code) => {
const c = (code || '').toString().trim();
if (!c) return Promise.resolve(false);
const url = `/discount/${encodeURIComponent(c)}?redirect=/cart`;
try {
return fetch(url, { method: 'GET', credentials: 'same-origin', cache: 'no-store', redirect: 'manual' })
.then(() => true)
.catch(() => false);
} catch (_e) {
return Promise.resolve(false);
}
};
const applyDiscountCodesSequential = async (codes) => {
const list = (codes || []).map((c) => String(c || '').trim()).filter(Boolean);
if (!list.length) return;
for (let i = 0; i < list.length; i++) {
try {
await applyDiscountCodeBestEffort(list[i]);
} catch (_e) {}
if (i < list.length - 1) {
await new Promise((r) => window.setTimeout(r, 150));
}
}
};
const fallbackSubmitMainProduct = () => {
if (!atcForm || !atcIdInput) return false;
if (!state.variantId) return false;
atcIdInput.value = String(state.variantId);
atcForm.hidden = false;
atcForm.submit();
return true;
};
const postAdd = async (items) => {
const formData = new FormData();
items.forEach((item, i) => {
formData.append(`items[${i}][id]`, String(item.id));
formData.append(`items[${i}][quantity]`, String(item.quantity || 1));
if (item.selling_plan) formData.append(`items[${i}][selling_plan]`, String(item.selling_plan));
if (item.properties && typeof item.properties === 'object') {
  Object.keys(item.properties).forEach((pk) => {
    formData.append(`items[${i}][properties][${pk}]`, String(item.properties[pk]));
  });
}
});
const addUrl = getCartAddJsUrl();
const res = await fetch(addUrl, {
method: 'POST',
headers: { 'X-Requested-With': 'XMLHttpRequest' },
body: formData,
credentials: 'same-origin',
});
const raw = await res.text();
let data = null;
try { data = JSON.parse(raw); } catch (_e) {}
if (!res.ok || (data && data.status) || !data) {
const isHtml = raw.trim().startsWith('<');
const msg =
(data && (data.description || data.message)) ? (data.description || data.message) :
(isHtml ? 'Error al agregar al carrito (respuesta HTML). Revisar endpoint /cart/add.js y formato.' : ((window.U1S && window.U1S.atc_error) || 'Error al agregar al carrito.'));
const err = new Error(msg);
err._u1_raw = raw;
err._u1_isHtml = isHtml;
throw err;
}
return data;
};
function scrollToStep(el) {
if (!el) return false;
const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const behavior = prefersReducedMotion ? 'auto' : 'smooth';
const topOffsetPx = 200; // avoid navbar overlap
try {
const r = el.getBoundingClientRect();
const y = (window.pageYOffset || document.documentElement.scrollTop || 0) + r.top - topOffsetPx;
window.scrollTo({ top: Math.max(0, y), left: 0, behavior });
} catch (_e) {
try { el.scrollIntoView(true); } catch (_e2) {}
}
return true;
}

const _seenChapters = new Set();
try {
if ('IntersectionObserver' in window) {
const _seenIO = new IntersectionObserver(function (entries) {
entries.forEach(function (e) {
if (e.isIntersecting && e.target && e.target.dataset && e.target.dataset.u1PdpStep) {
_seenChapters.add(e.target.dataset.u1PdpStep);
}
});
}, { threshold: 0.25 });
root.querySelectorAll('[data-u1-pdp-steps] [data-u1-pdp-step]').forEach(function (el) { _seenIO.observe(el); });
}
} catch (_e) {}

const _isChapterComplete = (step) => {
try {
switch (step) {
case 'color': return !(HAS_COLOR_CHAPTER && HAS_COLOR_OPTION) || !!state.color;
case 'size': return !(HAS_CHAPTER_SIZE && HAS_SIZE_OPTION) || !!state.size;
case 'model': case 'product_model': return !!state.variantId;
case 'helmet_size': case 'helmet-size': {
const has = (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER) && !!root.querySelector('[data-u1-pdp-helmet-size-picker]');
return !has || !!state.helmetSize;
}
case 'visor': {
const _ps = root._packSelector;
const _isBundle = (_ps && typeof _ps.getActiveBundlePack === 'function' && !!_ps.getActiveBundlePack()) || root.getAttribute('data-u1-pdp-bundle-active') === 'true';
if (!_isBundle) return true;
const vStep = root.querySelector('[data-u1-pdp-step="visor"]');
if (!vStep || vStep.hidden || !vStep.querySelectorAll('[data-u1-pdp-visor="true"]').length) return true;
return !!vStep.querySelector('[data-u1-pdp-visor="true"][aria-pressed="true"]');
}
case 'accessories': return !_u1GiftNeedsPick();
default: return true;
}
} catch (_e) { return true; }
};

const _chapterToast = (step, el) => {
try {
switch (step) {
case 'bundle': {
const t = el && el.querySelector('.u1-pdp-step__title');
const txt = t ? (t.textContent || '').trim() : '';
return txt || U1S.step_pick;
}
case 'color': return U1S.step_color;
case 'size': return U1S.step_size;
case 'helmet_size': case 'helmet-size': return U1S.step_hsize;
case 'visor': return U1S.step_visor;
case 'model': case 'product_model': return U1S.step_model;
case 'accessories': return _u1GiftNeedsPick() ? _u1FgText('data-u1-fg-select') : U1S.step_acc;
default: {
const t = el && el.querySelector('.u1-pdp-step__title');
return t ? (t.textContent || '').trim() : '';
}
}
} catch (_e) { return ''; }
};
function goToMissingSelection() {

try {
if (window.matchMedia && window.matchMedia('(max-width: 1024px)').matches) {
const chapters = Array.from(root.querySelectorAll('[data-u1-pdp-steps] [data-u1-pdp-step]')).filter(function (el) { return el && !el.hidden; });
chapters.sort(function (a, b) { return a.getBoundingClientRect().top - b.getBoundingClientRect().top; });
const target = chapters.find(function (el) {
const step = el.dataset.u1PdpStep;
return !_isChapterComplete(step) || !_seenChapters.has(step);
});
if (target) {
const _m = _chapterToast(target.dataset.u1PdpStep, target);
if (_m) showToast(_m);
return scrollToStep(target);
}
return false;
}
} catch (_e) {}

const candidates = [];

if (TEMPLATE === 'light') {
if (!state.variantId && modelStepEl) candidates.push(modelStepEl);
} else {
const needsColor = HAS_COLOR_CHAPTER && HAS_COLOR_OPTION && !state.color;
const needsSize = HAS_CHAPTER_SIZE && HAS_SIZE_OPTION && !state.size;
if (needsColor && colorStepEl) candidates.push(colorStepEl);
if (needsSize && sizeStepEl) candidates.push(sizeStepEl);
}

const needsHelmetSize = (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER)
  && (() => { try { return !!root.querySelector('[data-u1-pdp-helmet-size-picker]'); } catch (_e) { return false; } })()
  && !state.helmetSize;
if (needsHelmetSize && helmetSizeStepEl) candidates.push(helmetSizeStepEl);

const needsVisor = (() => {
try {
var _ps = root._packSelector;
var _isBundleNow = (_ps && typeof _ps.getActiveBundlePack === 'function' && !!_ps.getActiveBundlePack()) || root.getAttribute('data-u1-pdp-bundle-active') === 'true';
if (!_isBundleNow) return false;
var vStep = root.querySelector('[data-u1-pdp-step="visor"]');
if (!vStep || vStep.hidden) return false;
if (!vStep.querySelectorAll('[data-u1-pdp-visor="true"]').length) return false;
return !vStep.querySelector('[data-u1-pdp-visor="true"][aria-pressed="true"]');
} catch (_e) { return false; }
})();
if (needsVisor && visorStepEl) candidates.push(visorStepEl);

let bundleOos = [];
try { bundleOos = getBundleOutOfStockSelections() || []; } catch (_e) {}
if (bundleOos.length && accessoriesStepEl2) candidates.push(accessoriesStepEl2);
if (_u1GiftNeedsPick() && accessoriesStepEl2 && candidates.indexOf(accessoriesStepEl2) === -1) candidates.push(accessoriesStepEl2);

const visible = candidates.filter((el) => {
if (!el || el.hidden) return false;
try { if (el.offsetParent === null && el.getClientRects().length === 0) return false; } catch (_e) {}
return true;
});
if (!visible.length) return false;
visible.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
const _dtarget = visible[0];
const _dm = _chapterToast(_dtarget.dataset.u1PdpStep, _dtarget);
if (_dm) showToast(_dm);
return scrollToStep(_dtarget);
}
const enableMainQty = String(root.dataset.u1PdpEnableMainQty || '') === 'true';
const mainQtyMax = (() => {
const n = Number(root.dataset.u1PdpMainQtyMax || 9);
if (!Number.isFinite(n)) return 9;
return Math.max(1, Math.min(99, Math.round(n)));
})();
const getLightPresetFromUrl = () => {
try {
const out = { modelIndex: 0, qty: 0 };
const parseIntSafe = (v) => {
const n = Number(String(v || '').trim());
return Number.isFinite(n) ? Math.floor(n) : 0;
};
const parsePresetString = (s) => {
const str = String(s || '');
if (!str) return;
const m = str.match(/m(?:odel)?\s*(\d+)/i);
const q = str.match(/q(?:ty)?\s*(\d+)/i);
const mi = m ? parseIntSafe(m[1]) : 0;
const qi = q ? parseIntSafe(q[1]) : 0;
if (mi > 0) out.modelIndex = mi;
if (qi > 0) out.qty = qi;
};
const params = new URLSearchParams(window.location.search || '');
const mi =
parseIntSafe(params.get('u1_model')) ||
parseIntSafe(params.get('u1m')) ||
parseIntSafe(params.get('model')) ||
0;
const qi =
parseIntSafe(params.get('u1_qty')) ||
parseIntSafe(params.get('u1q')) ||
parseIntSafe(params.get('qty')) ||
0;
if (mi > 0) out.modelIndex = mi;
if (qi > 0) out.qty = qi;
const preset = (params.get('u1_preset') || params.get('u1preset') || params.get('preset') || '').toString();
if (preset) parsePresetString(preset);
const h = (window.location.hash || '').toString();
const hm = h.match(/#u1=([^&]+)/i);
if (hm && hm[1]) parsePresetString(decodeURIComponent(hm[1]));
return out;
} catch (_e) {
return { modelIndex: 0, qty: 0 };
}
};
const syncModelQtyPromoUi = () => {
if (TEMPLATE !== 'light') return;
const selected = modelButtons.find(b => b && b.classList && b.classList.contains('is-selected')) || null;
if (!selected) return;
const qty = getMainQty();
const meta = getMainQtyDiscountMeta();
const minQty = Math.max(2, Number(meta.minQty || 0) || 0);
const pct = Number(meta.percent || 0) || 0;
const on = !!(pct > 0 && qty >= minQty);
selected.classList.toggle('is-qty-promo-on', on);
};
const syncModelPriceUi = () => {
if (TEMPLATE !== 'light') return;
const selected = modelButtons.find(b => b && b.classList && b.classList.contains('is-selected')) || null;
if (!selected) return;
const unitPriceEl = selected.querySelector('[data-u1-pdp-model-unit-price]');
const discWrap = selected.querySelector('[data-u1-pdp-model-price-discount]');
const msrpEl = selected.querySelector('[data-u1-pdp-model-msrp]');
const finalEl = selected.querySelector('[data-u1-pdp-model-final]');
if (!unitPriceEl || !discWrap || !msrpEl || !finalEl) return;
const unit = Number(getMainPriceCents() || 0) || 0;
const qty = getMainQty();
const meta = getMainQtyDiscountMeta();
const minQty = Math.max(2, Number(meta.minQty || 0) || 0);
const pct = Number(meta.percent || 0) || 0;
const on = !!(pct > 0 && qty >= minQty && unit > 0 && qty > 1);
try {
const lineTotal = unit > 0 ? (unit * Math.max(1, qty)) : 0;
unitPriceEl.textContent = formatMoneyCents(lineTotal);
} catch (_eT) {}
const msrpTotal = unit * qty;
const finalTotal = getMainTotalCents();
msrpEl.textContent = formatMoneyCents(msrpTotal);
finalEl.textContent = formatMoneyCents(finalTotal);
selected.classList.toggle('is-model-discount-on', on);
};
const setSelectedModelBtn = (btn) => {
if (!Array.isArray(modelButtons) || modelButtons.length === 0) return;
modelButtons.forEach((b) => {
const isOn = !!(btn && b === btn);
b.classList.toggle('is-selected', isOn);
try { b.setAttribute('aria-pressed', isOn ? 'true' : 'false'); } catch (_e) {}
});
};
const syncMainQtyUi = () => {
if (!enableMainQty) return;
if (!Array.isArray(modelButtons) || modelButtons.length === 0) return;
modelButtons.forEach((b) => {
if (!b || !b.dataset) return;
const vid = Number(b.dataset.u1PdpModelVariantId || 0) || 0;
let q = 1;
if (TEMPLATE === 'light' && vid) {
try {
const m = state && state.modelQtyByVariantId ? state.modelQtyByVariantId : null;
if (m && typeof m.get === 'function' && m.has(vid)) q = Number(m.get(vid) || 1) || 1;
} catch (_e) {}
} else {
q = getMainQty();
}
const vEls = Array.from(b.querySelectorAll('[data-u1-pdp-main-qty-value]'));
vEls.forEach((el) => { if (el) el.textContent = String(q); });
});
};
const setMainQty = (nextQty) => {
const q = clamp(Math.round(Number(nextQty || 1) || 1), 1, mainQtyMax);
state.mainQty = q;
if (TEMPLATE === 'light') {
const id = Number(state.variantId || 0) || 0;
if (id) {
try { state.modelQtyByVariantId.set(id, q); } catch (_e) {}
}
}
syncMainQtyUi();
syncModelQtyPromoUi();
syncModelPriceUi();
updateAtcAvailability();
updateSummary();
emitPdpSelection();
};
const resolveStyleFilterVariantId = (styleFilter) => {
if (!styleFilter) return 0;
const helmet = state.helmetModel || '';
const size = state.size || state.helmetSize || '';
const match = (v, val) => v && (v.option1 === val || v.option2 === val || v.option3 === val);
let candidates = variants.filter(v => v && match(v, styleFilter));
if (helmet) candidates = candidates.filter(v => match(v, helmet));
if (size) candidates = candidates.filter(v => match(v, size));
if (candidates.length) return Number(candidates[0].id);
if (helmet) {
  const fallback = variants.filter(v => v && match(v, styleFilter) && match(v, helmet));
  if (fallback.length) return Number(fallback[0].id);
}
const styleOnly = variants.filter(v => v && match(v, styleFilter));
if (styleOnly.length) return Number(styleOnly[0].id);
return 0;
};
const applyModelSelection = (btn) => {
if (!btn || !btn.dataset) return false;
const raw = btn.dataset.u1PdpModelVariantId;
let idNum = Number(raw || 0);
const styleFilter = btn.dataset.u1PdpModelStyleFilter || '';
if (!idNum && styleFilter) {
idNum = resolveStyleFilterVariantId(styleFilter);
}
if (!idNum) return false;
const v = variants.find(vv => vv && Number(vv.id) === idNum) || null;
if (!v) return false;
state.variantId = idNum;
setColorUnsetUI();
setSelectedModelBtn(btn);
if (TEMPLATE !== 'light') {
if (SIMPLE_MODEL_OPT_HANDLE) {
const mv = getVariantOptionByHandle(v, SIMPLE_MODEL_OPT_HANDLE);
state.simpleModelOptionValue = mv || null;
}
if (HAS_COLOR_OPTION) {
const nextColor = getVariantOptionByHandle(v, COLOR_HANDLE) || null;
if (nextColor) {
state.color = nextColor;
setSelectedButton(colorButtons, nextColor);
}
}
if (HAS_CHAPTER_SIZE && HAS_SIZE_OPTION) {
const nextSize = getVariantOptionByHandle(v, SIZE_HANDLE) || null;
if (nextSize) {
state.size = nextSize;
setSelectedButton(sizeButtons, nextSize);
applySizeActiveIndex();
updateSizePill();
}
}
try { setColorDisplay(state.color); } catch (_eC) {}
try { updateColorAvailability(); } catch (_eCa) {}
try { updateSizeAvailability(); } catch (_eSz) {}
try { setColorUnsetUI(); } catch (_eU) {}
try {
const cardTitle = btn.querySelector('[data-u1-pdp-card-title]');
const modelName = cardTitle ? (cardTitle.textContent || '').trim() : '';
updateStepMobileTitle('model', modelName);
} catch (_eMT) {}
}
const code = (btn.dataset.u1PdpQtyDiscountCode || '').toString().trim();
const percent = Number(btn.dataset.u1PdpQtyDiscountPercent || 0) || 0;
const minQty = Number(btn.dataset.u1PdpQtyDiscountMin || 0) || 0;
state.mainQtyDiscount = (code || percent > 0)
? { code, percent, minQty: Math.max(2, minQty || 2) }
: null;
try {
const saved = state.modelQtyByVariantId && state.modelQtyByVariantId.has(idNum)
? Number(state.modelQtyByVariantId.get(idNum) || 1) || 1
: 1;
state.mainQty = Math.max(1, Math.min(mainQtyMax, Math.round(saved)));
if (state.modelQtyByVariantId && typeof state.modelQtyByVariantId.set === 'function') {
state.modelQtyByVariantId.set(idNum, state.mainQty);
}
} catch (_eS) {
state.mainQty = 1;
}
syncMainQtyUi();
syncModelQtyPromoUi();
syncModelPriceUi();
try {
const imgs = getGalleryImagesForVariant(idNum);
const fin = getFinalImageForVariant(idNum);
if ((imgs && imgs.length) || (fin && fin.src)) {
transitionGalleryToVariant(idNum, { durationMs: 88 });
forceEndGalleryLoadingSoon(2600);
} else if (!hasCustomGallery) {
const featuredId = v.featured_media && v.featured_media.id ? v.featured_media.id : null;
if (featuredId) {
const idx = slides.findIndex(s => (s.dataset.mediaId || '') === String(featuredId));
if (idx >= 0) {
state.galleryIndex = idx;
scrollGalleryToIndex(idx);
}
}
}
} catch (_e) {}
try { syncConditionalFreeAccessories(); } catch (_eCF) {}
updateSummary();
updateAtcAvailability();
try { syncRestposGiftState({ openModalIfNeeded: true }); } catch (_eR) {}
emitPdpSelection();
return true;
};
if (Array.isArray(modelButtons) && modelButtons.length) {
modelButtons.forEach((btn) => {
btn.addEventListener('click', (e) => {
const t = e && e.target && e.target.closest ? e.target : null;
if (t && t.closest('[data-u1-pdp-main-qty]')) return;
if (btn.getAttribute && btn.getAttribute('aria-disabled') === 'true') return;
applyModelSelection(btn);
syncMainQtyUi();
});
});
if (TEMPLATE === 'light' && enableMainQty && !root._u1MainQtyBound) {
root._u1MainQtyBound = true;
root.addEventListener('click', (e) => {
const t = e && e.target && e.target.closest ? e.target : null;
if (!t) return;
const minus = t.closest('[data-u1-pdp-main-qty-minus]');
const plus = t.closest('[data-u1-pdp-main-qty-plus]');
if (!minus && !plus) return;
try { e.preventDefault(); } catch (_e0) {}
try { e.stopPropagation(); } catch (_e1) {}
const card = t.closest('[data-u1-pdp-model]') || null;
if (card && card.getAttribute && card.getAttribute('aria-disabled') === 'true') return;
if (card && card.classList && !card.classList.contains('is-selected')) {
applyModelSelection(card);
}
const selected = modelButtons.find(b => b && b.classList && b.classList.contains('is-selected')) || null;
if (!selected) return;
const current = getMainQty();
const next = minus ? (current - 1) : (current + 1);
setMainQty(next);
}, true);
}
}
const applyAccessoryModelSelection = (btn) => {
if (!btn || !btn.dataset) return false;
if (btn.getAttribute && btn.getAttribute('aria-disabled') === 'true') return false;
const v = btn.dataset.u1PdpValue || null;
if (!v) return false;
if (state.model && state.model === v) return true;
state.model = v;
setSelectedButton(accessoryModelButtons, v);
try { updateStepMobileTitle('model', v); } catch (_eMT) {}
setColorUnsetUI();
updateColorAvailability();
updateSizeAvailability();
updateVariant();
syncRestposGiftState({ openModalIfNeeded: true });
updateSummary();
updateAtcAvailability();
emitPdpSelection();
return true;
};
if (false && Array.isArray(accessoryModelButtons) && accessoryModelButtons.length) {
accessoryModelButtons.forEach((btn) => {
btn.addEventListener('click', () => {
applyAccessoryModelSelection(btn);
});
});
}
/* Flash Gift en packs: el producto regalo que viene dentro de un pack va gratis (solo si el regalo tiene codigo:
   hoy FREE REMOTE US/UK; la card lo declara en data-u1-flash-gift-code). Devuelve su precio (centavos)
   si el pack lo trae y hay card de regalo en la pagina; el pack se cobra (MSRP - regalo) con el % del pack.
   Una sola cuenta para la card del pack, el CTA y el Total Breakdown. */
function _u1FlashGiftHandle() {
try { var el = root.querySelector('[data-u1-flash-gift-handle][data-u1-flash-gift-code]'); return el ? String(el.getAttribute('data-u1-flash-gift-handle') || '').trim().toLowerCase() : ''; } catch (_e) { return ''; }
}
function _u1PackGiftComp(bp) {
var h = _u1FlashGiftHandle();
if (!h || !bp || bp.isSolo) return null;
/* Regalo atado a un modelo (Mount Pack -> Pro Dual): solo los packs de ese modelo */
try {
  var _gm = root.querySelector('[data-u1-flash-gift-model]');
  var _gmv = _gm ? String(_gm.getAttribute('data-u1-flash-gift-model') || '') : '';
  if (_gmv) {
    var _pc = root.querySelector('[data-u1-pdp-bundle-card][data-pack-handle="' + String(bp.packHandle || '') + '"]');
    if (!_pc || String(_pc.getAttribute('data-pack-model') || '') !== _gmv) return null;
  }
} catch (_eGm) {}
return (bp.componentProducts || []).find(function(c) { return c && String(c.handle || '').toLowerCase() === h; }) || null;
}
/* Flash Gift con eleccion (Silicone Inserts de SPARKY, Fermin 21/10): la card del regalo queda en Accesorios
   ([data-u1-flash-gift-pick]) y el boton de compra no avanza hasta que se elige el diseno. Solo producto suelto. */
/* Textos del Flash Gift: salen traducidos del HTML de la card (data-u1-fg-*, locales u1.flash_gift.*) */
function _u1FgText(attr) {
try { var el = root.querySelector('[data-u1-flash-gift]'); return el ? String(el.getAttribute(attr) || '') : ''; } catch (_e) { return ''; }
}
function _u1GiftPickBtn() {
try {
var el = root.querySelector('[data-u1-flash-gift][data-u1-flash-gift-code]');
if (!el || el.hidden || el.classList.contains('is-muted')) return null;
var ps = root._packSelector;
var bp = ps && typeof ps.getActiveBundlePack === 'function' ? ps.getActiveBundlePack() : null;
if (bp && !bp.isSolo) return null;
return root.querySelector('[data-u1-pdp-accessory][data-u1-flash-gift-pick]');
} catch (_e) { return null; }
}
function _u1GiftNeedsPick() {
var b = _u1GiftPickBtn();
return !!(b && !b.classList.contains('is-selected') && b.getAttribute('aria-pressed') !== 'true');
}
function _u1PackGiftCents(bp) { var c = _u1PackGiftComp(bp); return c ? (Number(c.price || 0) || 0) : 0; }
/* Flash deal de regalo (card [data-u1-flash-gift] del capitulo de producto): el regalo va solo con el producto
   suelto (sin pack) y, si la card trae lista, solo con esas variantes (ej. Smart Light Pro Dual). El $0 lo pone un
   descuento automatico Buy X Get Y de Shopify; la linea lleva _u1_flash_gift = variante que lo trajo y el carrito
   del navbar la saca si ese producto se va o si la cobran. Con pack la card se oculta; con otra variante se apaga. */
const _flashGiftEl = document.querySelector('[data-u1-flash-gift][data-u1-flash-gift-section="' + sectionId + '"]');
const _flashGiftVid = _flashGiftEl ? (parseInt(_flashGiftEl.getAttribute('data-u1-flash-gift-variant'), 10) || 0) : 0;
const _flashGiftIds = _flashGiftEl ? String(_flashGiftEl.getAttribute('data-u1-flash-gift-qualify') || '').split(',').map((s) => s.trim()).filter(Boolean) : [];
const _flashGiftStatus = () => {
if (!_flashGiftEl || !_flashGiftVid) return 'off';
const _fgPs = root._packSelector;
const _fgBp = _fgPs && typeof _fgPs.getActiveBundlePack === 'function' ? _fgPs.getActiveBundlePack() : null;
if (_fgBp && !_fgBp.isSolo) return 'pack';
if (_flashGiftIds.length && _flashGiftIds.indexOf(String(state.variantId || '')) === -1) return 'variant';
return 'ok';
};
const _syncFlashGiftCard = () => {
if (!_flashGiftEl) return;
const st = _flashGiftStatus();
/* Con pack la card sigue a la vista si el pack trae el regalo (el Remote va gratis igual, Fermin 22/10); se oculta solo si el pack no lo trae */
let _fgPackHas = false;
if (st === 'pack') {
  try { const _fgPs2 = root._packSelector; const _fgBp2 = _fgPs2 && typeof _fgPs2.getActiveBundlePack === 'function' ? _fgPs2.getActiveBundlePack() : null; _fgPackHas = !!_u1PackGiftComp(_fgBp2); } catch (_eFgP) {}
}
_flashGiftEl.hidden = st === 'pack' && !_fgPackHas;
_flashGiftEl.classList.toggle('is-muted', st === 'variant');
/* Variante que no califica (Smart Light comun): el accesorio regalo vuelve a verse y a cobrarse, sin avisos de regalo */
root.classList.toggle('is-fgift-off', st === 'variant');
try { if (typeof root._u1SyncFeaturesUnlocked === 'function') root._u1SyncFeaturesUnlocked(); } catch (_eSf) {}
};
if (_flashGiftEl) {
window.addEventListener('u1:pdp:selection', (e) => {
if (e && e.detail && e.detail.sectionId && String(e.detail.sectionId) !== String(sectionId)) return;
_syncFlashGiftCard();
});
document.addEventListener('u1:pdp:pack-change', _syncFlashGiftCard);
/* Inserts del Flash Gift: la card no se agrega ni se saca a mano (Fermin 22/10): solo se tocan color y modelo y la
   card queda elegida sola. Un click real en la card se ignora; el click que hace el codigo (isTrusted false) pasa. */
root.addEventListener('click', (e) => {
try {
  if (!e.isTrusted) return;
  const c = e.target && e.target.closest ? e.target.closest('[data-u1-pdp-accessory][data-u1-flash-gift-pick]') : null;
  if (!c || !_u1GiftPickBtn()) return;
  e.preventDefault();
  e.stopImmediatePropagation();
} catch (_eFgB) {}
}, true);
/* Inserts del Flash Gift: apenas se tocan color y modelo en la card, la card queda elegida sola (destraba el boton) */
root.addEventListener('click', (e) => {
try {
  const t = e.target && e.target.closest ? e.target : null;
  if (!t) return;
  const sw = t.closest('[data-u1-pdp-card-color-swatch]');
  const pill = t.closest('[data-u1-pdp-insert-model]');
  if (!sw && !pill) return;
  const hit = t.closest('.u1-pdp-card-hit');
  const card = hit ? hit.querySelector('[data-u1-pdp-accessory][data-u1-flash-gift-pick]') : null;
  if (!card) return;
  if (sw) card.dataset.u1FgColorTouched = '1';
  if (pill) card.dataset.u1FgModelTouched = '1';
  if (card.dataset.u1FgColorTouched === '1' && card.dataset.u1FgModelTouched === '1'
    && !card.classList.contains('is-selected') && card.getAttribute('aria-pressed') !== 'true') {
    window.setTimeout(() => { try { card.click(); } catch (_eC) {} }, 0);
  }
} catch (_eFgT) {}
}, true);
_syncFlashGiftCard();
}
const addBundleToCart = async () => {
if (!atcBtn) return;

var _visorStep = root ? root.querySelector('[data-u1-pdp-step="visor"]') : null;
var _isBundleForVisorGate = (root._packSelector && typeof root._packSelector.getActiveBundlePack === 'function' && !!root._packSelector.getActiveBundlePack())
  || root.getAttribute('data-u1-pdp-bundle-active') === 'true';
if (_isBundleForVisorGate && _visorStep && !_visorStep.hidden) {
  var _allVisorBtns = Array.from(_visorStep.querySelectorAll('[data-u1-pdp-visor="true"]'));
  var _visibleVisors = _allVisorBtns.filter(function(btn) {
    var hit = btn.closest('.u1-pdp-card-hit');
    return !hit || !hit.hidden;
  });
  if (_visibleVisors.length > 0 && !_visorStep.querySelector('[data-u1-pdp-visor="true"][aria-pressed="true"]')) {

    if (!goToMissingSelection()) showToast(U1S.sel_visor);
    return;
  }
}
if (_u1GiftNeedsPick()) { if (!goToMissingSelection()) showToast(_u1FgText('data-u1-fg-select')); return; }
const vNow = variants.find(v => v && Number(v.id) === Number(state.variantId)) || null;
// Pre-order variants bypass notify — they're purchasable via selling plan
if (vNow && (vNow.available === false || isVariantOosNonPreorder(vNow)) && !isVariantPreorder(vNow)) {
openNotifyModal();
return;
}
const isAriaDisabled = atcBtn.getAttribute('aria-disabled') === 'true';
if (isAriaDisabled && !atcBtn.disabled && atcBtn.dataset.u1PdpDisabledReason === 'customize') {
if (!goToMissingSelection()) {
const msg = (() => {
if (TEMPLATE === 'light') {
if (!state.variantId) return U1S.sel_model_first;
if (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER && root.querySelector('[data-u1-pdp-helmet-size-picker]') && !state.helmetSize) return U1S.sel_helmet_first;
return U1S.sel_model_first;
}
if (typeof SILICONE_INSERTS_PDP !== 'undefined' && SILICONE_INSERTS_PDP) {
if (HAS_CHAPTER_SIZE && HAS_SIZE_OPTION && !state.size) return U1S.sel_model_first;
if (HAS_COLOR_CHAPTER && !state.color) return U1S.sel_color_first;
if (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER && root.querySelector('[data-u1-pdp-helmet-size-picker]') && !state.helmetSize) return U1S.sel_helmet_first;
return U1S.sel_model_first;
}
if (HAS_COLOR_CHAPTER && !state.color) return U1S.sel_color_first;
if (typeof HAS_HELMET_SIZE_CHAPTER !== 'undefined' && HAS_HELMET_SIZE_CHAPTER && root.querySelector('[data-u1-pdp-helmet-size-picker]') && !state.helmetSize) return U1S.sel_helmet_first;
return U1S.sel_size;
})();
showToast(msg);
}
return;
}
if (atcBtn.dataset.u1PdpDisabledReason === 'soldout') { openNotifyModal(); return; }
if (atcBtn.dataset.u1PdpDisabledReason === 'bundle_oos') {
const oos = getBundleOutOfStockSelections();
const msg = oos && oos.length
? `${U1S.oos_colon} ${oos.map(x => x.label ? String(x.label) : String(x.id)).join(', ')}`
: U1S.oos_some;
showToast(msg);
return;
}
if (!state.variantId) return;
if (errorEl) {
errorEl.hidden = true;
errorEl.textContent = '';
}
const oosNow = getBundleOutOfStockSelections();
if (oosNow && oosNow.length) {
if (errorEl) {
errorEl.hidden = false;
errorEl.textContent = `${U1S.oos_colon} ${oosNow.map(x => x.label ? String(x.label) : String(x.id)).join(', ')}`;
}
updateAtcAvailability();
return;
}
atcBtn.setAttribute('aria-disabled', 'true');
atcBtn.classList.add('is-loading');

const _packNow = root._packSelector && root._packSelector.getActiveBundlePack ? root._packSelector.getActiveBundlePack() : null;
const _packCode = _packNow && _packNow.discountCode ? String(_packNow.discountCode).trim() : '';

const _bundleTag = (_packNow && !_packNow.isSolo) ? (_packNow.packHandle || 'bundle') : '';
const mainItem = { id: state.variantId, quantity: getMainQty() };
if (_bundleTag) mainItem.properties = Object.assign({}, mainItem.properties, { _u1_bundle: _bundleTag });
// Attach selling plan for preorder variants (Stoq partial payment)
const _preorderSpId = vNow ? getPreorderSellingPlanId(vNow) : 0;
if (_preorderSpId) mainItem.selling_plan = _preorderSpId;
const items = [mainItem];
syncRestposGiftState({ openModalIfNeeded: false });
const allDiscountCodes = _packCode ? [_packCode] : pickAllDiscountCodes();
// u1-pack-gift: con pack suma el codigo del crash gratis (si es el plan elegido)
const _cfc = (crashFreeDiscountCode || '').trim().toUpperCase();
if (_packCode && _cfc && pickAllDiscountCodes().some(c => c.toUpperCase() === _cfc)) allDiscountCodes.push(crashFreeDiscountCode.trim());
if (!_packCode) {
  if (state.restposBottleVariantId && restposDiscountCode) {
    if (!allDiscountCodes.some(c => c.toUpperCase() === restposDiscountCode.toUpperCase())) allDiscountCodes.push(restposDiscountCode);
  }
}
// Flash Gift con codigo (FREE REMOTE US / UK): va con el producto suelto y con los packs que ya traen el regalo
{
const _fgCode = _flashGiftEl ? String(_flashGiftEl.getAttribute('data-u1-flash-gift-code') || '').trim() : '';
const _fgH = _flashGiftEl ? String(_flashGiftEl.getAttribute('data-u1-flash-gift-handle') || '').trim().toLowerCase() : '';
if (_fgCode) {
  const _fgSolo = !_bundleTag && _flashGiftStatus() === 'ok';
  const _fgInPack = !!(_bundleTag && _packNow && _fgH && _u1PackGiftComp(_packNow));
  if ((_fgSolo || _fgInPack) && !allDiscountCodes.some((c) => String(c).toUpperCase() === _fgCode.toUpperCase())) {
    allDiscountCodes.push(_fgCode);
    /* El carrito sabe que este codigo es de regalo (y lo saca si el regalo se va) sin tener nombres fijos */
    try { await fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _u1_flash_codes: _fgCode } }) }); } catch (_eAttr) {}
  }
}
}
persistDiscountCode(allDiscountCodes.join(','));

const _normHandle = (h) => (h || '').toLowerCase().replace(/-\d+$/, '');
const _bundleCompHandles = new Set();
if (_bundleTag && _packNow && Array.isArray(_packNow.componentProducts)) {
  _packNow.componentProducts.forEach(cp => { if (cp && cp.handle) _bundleCompHandles.add(_normHandle(cp.handle)); });
}
const _isVisorHandle = (h) => !!root.querySelector('[data-u1-pdp-accessory-handle="' + h + '"][data-u1-pdp-visor="true"]');
const _addedHandles = new Set();
state.accessories.forEach((v) => {
if (!v) return;
const vid = parseVariantId(v.variantId);
if (!vid) return;
if (v.handle) { _addedHandles.add(v.handle.toLowerCase()); if (_isVisorHandle(v.handle)) _addedHandles.add('*visor'); }
const meta = accessoryVariantMeta.get(Number(vid)) || null;
const _item = { id: vid, quantity: v.qty || 1, _u1_label: (meta && meta.label) ? meta.label : (v.handle || String(vid)) };
/* Regalo elegido en Accesorios: va como linea de regalo (1 unidad, _u1_flash_gift) */
try {
  const _gpb = _u1GiftPickBtn();
  if (_gpb && v.handle && String(_gpb.getAttribute('data-u1-pdp-accessory-handle') || '').toLowerCase() === String(v.handle).toLowerCase()) {
    _item.quantity = 1;
    _item.properties = Object.assign({}, _item.properties || {}, { _u1_flash_gift: String(state.variantId) });
    _item._u1_flashGift = true;
  }
} catch (_eGp) {}

if (_bundleTag && v.handle && (_bundleCompHandles.has(_normHandle(v.handle)) || _isVisorHandle(v.handle))) {
  _item.properties = { _u1_bundle: _bundleTag };
}
items.push(_item);
});

try {
const _ps = root._packSelector;
const _bp = _ps && typeof _ps.getActiveBundlePack === 'function' ? _ps.getActiveBundlePack() : null;
if (_bp && Array.isArray(_bp.componentProducts)) {
  const _mainHandle = (mainProductHandle || '').toLowerCase();
  _bp.componentProducts.forEach((cp) => {
    if (!cp || !cp.handle) return;
    const h = cp.handle.toLowerCase();

    /* Pack de 2 cascos iguales (2x AURA / 2x NEON): el segundo casco es el mismo producto de la pagina; va con el
       color y talle de su chapter (una sola vez aunque el pack lo liste dos veces). Cualquier otro pack lo saltea */
    if (h === _mainHandle) {
      const _fciM = root._u1FamCompItem ? root._u1FamCompItem(h, _bundleTag) : null;
      if (_fciM && !_addedHandles.has('#2:' + h)) { items.push(_fciM); _addedHandles.add('#2:' + h); }
      return;
    }
    /* cualquier visor elegido cubre el componente visor del pack (Adaptive en Ride/Premium) */
    if (_addedHandles.has(h) || (_addedHandles.has('*visor') && _isVisorHandle(h))) return;
    const _fci = root._u1FamCompItem ? root._u1FamCompItem(h, _bundleTag) : null;
    if (_fci) { items.push(_fci); _addedHandles.add(h); return; }
    const _vf = (cp.variantFilter || '').trim().toLowerCase();
    const _sz = (state.size || '').trim();
    const _hm = (state.helmetModel || (mainProductHandle || '').split('-')[0].toUpperCase() || '').trim();
    const _matchVariant = (variants) => {
      if (!Array.isArray(variants) || !variants.length) return null;
      const _matchesFilter = (vv) => !_vf || (
        (vv.option1 || '').toLowerCase() === _vf ||
        (vv.option2 || '').toLowerCase() === _vf ||
        (vv.option3 || '').toLowerCase() === _vf ||
        (vv.title || '').toLowerCase() === _vf
      );
      const _matchesHelmet = (vv) => !_hm || (
        vv.option1 === _hm || vv.option2 === _hm || vv.option3 === _hm
      );
      const _szHead = _sz ? _sz.charAt(0).toUpperCase() : '';
      const _matchesSize = (vv) => {
        if (!_sz) return true;
        const opts = [vv.option1, vv.option2, vv.option3];
        return opts.some(o => o === _sz || o === _szHead);
      };

      const best = variants.find(vv => vv && vv.available !== false && _matchesFilter(vv) && _matchesHelmet(vv) && _matchesSize(vv));
      if (best) return best;
      const fh = variants.find(vv => vv && vv.available !== false && _matchesFilter(vv) && _matchesHelmet(vv));
      if (fh) return fh;
      /* REGLA DURA: nunca cruzar de casco ni de estilo (antes vendia Adaptive/NEON con AURA) */
      const _helmetScoped = _hm && variants.some(vv => vv && (vv.option1 === _hm || vv.option2 === _hm || vv.option3 === _hm));
      if (_helmetScoped) return null;
      const fs = variants.find(vv => vv && vv.available !== false && _matchesFilter(vv) && _matchesSize(vv));
      if (fs) return fs;
      const fo = variants.find(vv => vv && vv.available !== false && _matchesFilter(vv));
      if (fo) return fo;
      if (_vf) return null;
      return variants.find(vv => vv && vv.available !== false) || variants[0];
    };
    const catItem = (Array.isArray(accessoriesCatalog) ? accessoriesCatalog : []).find(p => p && (p.handle || '').toLowerCase() === h);
    if (catItem && Array.isArray(catItem.variants) && catItem.variants.length) {
      const av = _matchVariant(catItem.variants);
      if (av && av.id) {
        const _ci = { id: Number(av.id), quantity: 1, _u1_label: cp.title || h };
        if (_bundleTag) _ci.properties = { _u1_bundle: _bundleTag };
        items.push(_ci);
        _addedHandles.add(h);
      }
    } else {
      if (!_bp._pendingFetches) _bp._pendingFetches = [];
      _bp._pendingFetches.push({ handle: cp.handle, title: cp.title || h, variantFilter: _vf });
    }
  });
}

if (_bp && _bp._pendingFetches && _bp._pendingFetches.length) {
  for (const pf of _bp._pendingFetches) {
    try {
      const res = await fetch('/products/' + encodeURIComponent(pf.handle) + '.js');
      if (res.ok) {
        const prod = await res.json();
        if (prod && Array.isArray(prod.variants) && prod.variants.length) {
          const _pfVf = (pf.variantFilter || '').toLowerCase();
          const _pfSz = (state.size || '').trim();
          const _pfHm = (state.helmetModel || (mainProductHandle || '').split('-')[0].toUpperCase() || '').trim();
          const _pfMatchF = (vv) => !_pfVf || ((vv.option1||'').toLowerCase()===_pfVf || (vv.option2||'').toLowerCase()===_pfVf || (vv.option3||'').toLowerCase()===_pfVf || (vv.title||'').toLowerCase()===_pfVf);
          const _pfMatchH = (vv) => !_pfHm || (vv.option1===_pfHm || vv.option2===_pfHm || vv.option3===_pfHm);
          const _pfSzH = _pfSz ? _pfSz.charAt(0).toUpperCase() : '';
          const _pfMatchS = (vv) => !_pfSz || [vv.option1,vv.option2,vv.option3].some(o => o===_pfSz || o===_pfSzH);
          let av = prod.variants.find(vv => vv && vv.available && _pfMatchF(vv) && _pfMatchH(vv) && _pfMatchS(vv));
          if (!av) av = prod.variants.find(vv => vv && vv.available && _pfMatchF(vv) && _pfMatchH(vv));
          /* misma regla dura que _matchVariant */
          const _pfScoped = _pfHm && prod.variants.some(vv => vv && (vv.option1===_pfHm || vv.option2===_pfHm || vv.option3===_pfHm));
          if (!av && !_pfScoped) av = prod.variants.find(vv => vv && vv.available && _pfMatchF(vv) && _pfMatchS(vv));
          if (!av && !_pfScoped) av = prod.variants.find(vv => vv && vv.available && _pfMatchF(vv));
          if (!av && !_pfScoped && !_pfVf) av = prod.variants.find(vv => vv && vv.available) || prod.variants[0];
          if (av && av.id) {
            const _pfi = { id: Number(av.id), quantity: 1, _u1_label: pf.title };
            if (_bundleTag) _pfi.properties = { _u1_bundle: _bundleTag };
            items.push(_pfi);
          }
        }
      }
    } catch (_eFetch) {}
  }
  _bp._pendingFetches = [];
}
} catch (_eBundleComp) {}
{
const bottleVid = parseVariantId(state.restposBottleVariantId || 0);
if (bottleVid) items.push({ id: bottleVid, quantity: 1, _u1_label: 'Free Bottle' });
}
const crashVid = parseVariantId(state.crashVariantId || 0);
if (crashVid) {
const meta = crashVariantMeta.get(Number(crashVid)) || null;
items.push({ id: crashVid, quantity: 1, _u1_label: (meta && meta.label) ? meta.label : `Crash Replacement (${crashVid})` });
}
// Flash deal: el regalo va con el producto suelto, una vez por producto (si ya esta en el carrito no se repite)
if (!_bundleTag && _flashGiftStatus() === 'ok') {
let _fgInCart = false;
try {
const _fgCart = await (await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })).json();
_fgInCart = (_fgCart.items || []).some((it) => it && it.properties && String(it.properties._u1_flash_gift || '') === String(state.variantId));
} catch (_eFg) {}
let _fgPickVid = _flashGiftVid;
try {
  /* Regalo al azar entre variantes (Silicone Inserts): data-u1-flash-gift-random = ids disponibles */
  const _fgRnd = String(_flashGiftEl.getAttribute('data-u1-flash-gift-random') || '').split(',').map((n) => parseInt(n, 10)).filter(Boolean);
  if (_fgRnd.length) _fgPickVid = _fgRnd[Math.floor(Math.random() * _fgRnd.length)];
} catch (_eRnd) {}
if (!_fgInCart && !_u1GiftPickBtn()) items.push({ id: _fgPickVid, quantity: 1, properties: { _u1_flash_gift: String(state.variantId) }, _u1_label: 'Flash deal gift', _u1_flashGift: true });
}
try {

if (_packCode) {
  try { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ discount: '' }) }); } catch(_eClear) {}
}
if (allDiscountCodes.length) {
await applyDiscountCodesSequential(allDiscountCodes);
}
let data = null;
try {
data = await postAdd(items);
} catch (e) {
if (items.length <= 1) throw e;
data = await postAdd([mainItem]);
const failed = [];
for (let i = 1; i < items.length; i++) {
const it = items[i];
if (!it || !it.id) continue;
try {
await postAdd([it]);
} catch (_e2) {
if (it._u1_flashGift) continue; // sin regalo no se frena la compra ni se muestra error
const label = it._u1_label ? String(it._u1_label) : String(it.id);
const reason = (_e2 && _e2.message) ? String(_e2.message) : 'Error';
failed.push(`${label} (${it.id}) — ${reason}`);
}
}
if (failed.length && errorEl) {
errorEl.hidden = false;
const parts = [];
if (failed.length) parts.push(`Fallaron: ${failed.join(' | ')}`);
errorEl.textContent = parts.join(' — ');
}
}
document.dispatchEvent(new CustomEvent('cart:change', { detail: data, bubbles: true }));
document.dispatchEvent(new CustomEvent('variant:add', { detail: { variant: { id: state.variantId }, quantity: getMainQty() }, bubbles: true }));
} catch (e) {
if (errorEl) {
errorEl.hidden = false;
errorEl.textContent = (e && e.message) ? e.message : 'Error';
}
fallbackSubmitMainProduct();
} finally {
atcBtn.classList.remove('is-loading');
atcBtn.removeAttribute('aria-disabled');
}
};
if (atcBtn) atcBtn.addEventListener('click', addBundleToCart);
document.addEventListener('click', (e) => {
const t = e && e.target && e.target.closest ? e.target : null;
if (!t) return;
const a = t.closest('a[href]');
if (!a) return;
const hrefRaw = (a.getAttribute('href') || '').toString();
if (!hrefRaw) return;
const isCheckout =
hrefRaw === '/checkout' ||
hrefRaw.startsWith('/checkout?') ||
hrefRaw.startsWith('/checkout#') ||
hrefRaw.includes('/checkout');
if (!isCheckout) return;
if (hrefRaw.includes('/discount/')) return;
const allCodes = pickAllDiscountCodes();
const persisted = (getPersistedDiscountCode() || '').split(',').map(s => s.trim()).filter(Boolean);
const mergedCodes = [...allCodes];
persisted.forEach(c => { if (!mergedCodes.some(m => m.toUpperCase() === c.toUpperCase())) mergedCodes.push(c); });
if (!mergedCodes.length) return;
const next = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'checkout?discount=' + encodeURIComponent(mergedCodes.join(','));
try {
e.preventDefault();
e.stopPropagation();
window.location.assign(next);
} catch (_e) {}
}, true);
if (TEMPLATE === 'light') {
setSelectedModelBtn(null);
state.variantId = 0;
state.mainQty = 1;
state.mainQtyDiscount = null;
try { state.modelQtyByVariantId = new Map(); } catch (_e) {}
setColorUnsetUI();
updateRenderScale();
try {
const firstModelBtn = modelButtons && modelButtons.length ? modelButtons[0] : null;
const firstId = firstModelBtn ? Number(firstModelBtn.dataset.u1PdpModelVariantId || 0) : 0;
const fin = firstId ? getFinalImageForVariant(firstId) : null;
const preview = firstId ? (getGalleryImagesForVariant(firstId) || (fin && fin.src ? [fin] : null)) : null;
if (preview && preview.length) {
transitionGalleryToVariant(firstId, { durationMs: 0 });
forceEndGalleryLoadingSoon(2600);
} else {
const firstKey = variantGalleryMap && variantGalleryMap.size ? Array.from(variantGalleryMap.keys())[0] : 0;
const firstFinKey = (!firstKey && variantFinalMap && variantFinalMap.size) ? Array.from(variantFinalMap.keys())[0] : 0;
const k = firstKey || firstFinKey;
if (k) {
transitionGalleryToVariant(k, { durationMs: 0 });
forceEndGalleryLoadingSoon(2600);
}
}
} catch (_e) {}
try {
if (!root._u1LightPresetApplied) {
root._u1LightPresetApplied = true;
const preset = getLightPresetFromUrl();
const idx = Number(preset && preset.modelIndex ? preset.modelIndex : 0) || 0;
const qty = Number(preset && preset.qty ? preset.qty : 0) || 0;
if (idx > 0 && Array.isArray(modelButtons) && modelButtons.length) {
const btn = modelButtons[Math.max(0, Math.min(modelButtons.length - 1, idx - 1))];
if (btn && btn.getAttribute && btn.getAttribute('aria-disabled') !== 'true') {
applyModelSelection(btn);
}
}
if (qty > 0) setMainQty(qty);
}
} catch (_e2) {}
updateAtcAvailability();
} else {
setSelectedButton(colorButtons, null);
setSelectedButton(sizeButtons, null);
setColorDisplay(null);
updateRenderScale();
const initialImgs = getGalleryImagesForColor(initialMediaColorValue || null) || getGalleryImagesForColor(null);
if (initialImgs && initialImgs.length > 0) setGalleryToImages(initialImgs, { preserveIndex: false });
updateColorAvailability();
updateSizeAvailability();
const needsUserHelmetSelection = (HAS_COLOR_CHAPTER && HAS_COLOR_OPTION)
|| (HAS_CHAPTER_SIZE && HAS_SIZE_OPTION);
if (!needsUserHelmetSelection) {
try { updateVariant(); } catch (_eInitV) {}
}
// Silicone inserts: variant_gallery solo se aplica cuando ya hay talla+color; el HTML inicial es product.media.
// Sin esto, la PDP arranca con las fotos de Shopify hasta el primer click.
if (typeof SILICONE_INSERTS_PDP !== 'undefined' && SILICONE_INSERTS_PDP) {
const vgOn = (variantGalleryMap && variantGalleryMap.size > 0) || (variantFinalMap && variantFinalMap.size > 0);
if (vgOn && Array.isArray(sizeButtons) && sizeButtons.length && Array.isArray(colorButtons) && colorButtons.length) {
const pickFirstEnabled = (btns) => btns.find((b) => b && b.getAttribute && b.getAttribute('aria-disabled') !== 'true' && !b.hidden) || null;
let szVal = (state.size || '').toString().trim() || null;
if (!szVal) {
const sb = pickFirstEnabled(sizeButtons);
if (sb) szVal = (sb.dataset.u1PdpValue || '').toString().trim() || null;
}
if (szVal) {
state.size = szVal;
setSelectedButton(sizeButtons, szVal);
applySizeActiveIndex();
updateSizePill();
}
updateColorAvailability();
updateSizeAvailability();
let colVal = (state.color || '').toString().trim() || null;
if (!colVal) {
const cb = pickFirstEnabled(colorButtons);
if (cb) colVal = (cb.dataset.u1PdpValue || '').toString().trim() || null;
}
if (colVal) {
state.color = colVal;
setSelectedButton(colorButtons, colVal);
setColorDisplay(colVal);
}
try { updateVariant(); } catch (_eSi) {}
const vid = Number(state.variantId || 0) || 0;
if (vid) {
try {
const vImgs = getGalleryImagesForVariant(vid);
const vFin = getFinalImageForVariant(vid);
if ((vImgs && vImgs.length) || (vFin && vFin.src)) {
transitionGalleryToVariant(vid, { durationMs: 0 });
try { forceEndGalleryLoadingSoon(2600); } catch (_eL) {}
}
} catch (_eG) {}
}
try { setColorUnsetUI(); } catch (_eU) {}
try { updateGalleryC1Variant(); } catch (_eC1) {}
try { scheduleGalleryUxModeCheck(); } catch (_eGx) {}
try { syncModeOverlays(); } catch (_eMo) {}
}
}
updateAtcAvailability();
applySizeActiveIndex();
updateSizePill();
}
updateGalleryButtons();
renderMobileGalleries();
try { syncFeaturesUnlocked(); } catch (_e0) {}
initProductDescriptionToggle();
if (TEMPLATE !== 'light') {
syncAccessoriesToCurrentSize();
}
updateSummary();
emitPdpSelection();
// Preload de slide-2 + visor overlays con delay para no competir con imágenes ATF
window.setTimeout(() => {
  try { preloadAllVisorBaseImages(); } catch (_e) {}
  try { preloadVisorOverlaysForCurrentColor(); } catch (_e2) {}
}, 2000);

const scrollToReviewsBtn = document.querySelector('[data-u1-scroll-to-reviews]');
if (scrollToReviewsBtn) {
  scrollToReviewsBtn.addEventListener('click', () => {
    const looxSection = document.querySelector('[data-u1-loox]');
    if (!looxSection) return;
    looxSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

    let checks = 0;
    const recheck = () => {
      if (++checks > 3) return;
      const r = looxSection.getBoundingClientRect();
      if (Math.abs(r.top) > 80) {
        looxSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    setTimeout(recheck, 600);
    setTimeout(recheck, 1500);
  });
}

{
  let _bdEl = null;
  let _bdList = null;

  const _bdEscapeHtml = (str) => {
    const d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  };


  const _stale = root.querySelector('[data-u1-pdp-summary]');
  if (_stale) _stale.remove();

  const _anchor = document.createElement('div');
  _anchor.setAttribute('data-u1-pdp-summary', '');
  if (stickyBottomEl) stickyBottomEl.parentElement.insertBefore(_anchor, stickyBottomEl);

  _anchor.className = 'u1-pdp-step u1-pdp-summary';
  _anchor.hidden = true;
  _anchor.setAttribute('aria-hidden', 'true');
  _anchor.innerHTML = ''
    + '<h3 class="u1-pdp-step__title text-h5">' + U1S.total_breakdown + '</h3>'
    + '<div class="u1-pdp-summary__body">'
    +   '<ul class="u1-pdp-summary__list" data-u1-pdp-summary-list role="list"></ul>'
    +   '<div class="u1-pdp-summary__divider"></div>'
    + '</div>';

  const _summaryEl = _anchor;
  _bdEl = _anchor;
  _bdList = _anchor.querySelector('[data-u1-pdp-summary-list]');

  if (_summaryEl && stickyBottomEl) {
    const _summaryObs = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        var show;
        if (e.isIntersecting) {
          /* El breakdown está en pantalla → estado breakdown. */
          show = true;
        } else if (e.boundingClientRect && e.boundingClientRect.top < 0) {
          /* Salio por arriba: mantener breakdown, no volver al CTA plano */
          show = true;
        } else {
          /* Está por debajo del viewport (scrolleaste hacia arriba) → CTA plano. */
          show = false;
        }
        stickyBottomEl.classList.toggle('is-summary-visible', show);
      });
    }, { threshold: 0 });
    _summaryObs.observe(_summaryEl);
  }

  /* Purga de widgets Stoq: en assets/u1-pdp-app-guard.js */

  const _bdUpdateExpanded = (hasRows) => {
    if (!_summaryEl) return;
    /* Sin bundle solo con data-u1-pdp-breakdown-always; el resto solo con bundle */
    const isBundleActive = root.getAttribute('data-u1-pdp-bundle-active') === 'true';
    const alwaysOn = root.getAttribute('data-u1-pdp-breakdown-always') === '1';
    const show = hasRows && (isBundleActive || alwaysOn);

    _summaryEl.hidden = !show;
    _summaryEl.setAttribute('aria-hidden', show ? 'false' : 'true');
  };

  var updateBreakdownRows = () => {
    if (!_bdEl || !_bdList) return;

    const ps = root._packSelector;
    const bp = (ps && typeof ps.getActiveBundlePack === 'function') ? ps.getActiveBundlePack() : null;
    /* Sin bundle: filas del estado actual; bp puede ser null */

    const rows = [];

    var _bdLabelOverrides = null;
    var _bdLabelsRaw = ((bp && bp.componentLabels) || '').trim();
    if (_bdLabelsRaw) {
      _bdLabelOverrides = {};
      _bdLabelsRaw.split(',').forEach(function(s) {
        var display = s.trim();
        if (!display) return;

        var base = display.split(' (')[0].trim();
        _bdLabelOverrides[base] = display;
      });
    }

    var _bdQuals = null;
    if (!_bdLabelOverrides && bp && bp.allowedVisorStyles) {
      var _avs = bp.allowedVisorStyles.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
      if (_avs.length) {
        _bdQuals = {};
        _bdQuals['Helmet Visor'] = _avs.join(' or ');
      }
    }

    function _bdEnrich(baseName) {
      if (_bdLabelOverrides) {

        if (_bdLabelOverrides[baseName]) return _bdLabelOverrides[baseName];

        var _bn = baseName.toLowerCase();
        for (var _k in _bdLabelOverrides) {
          if (_k.toLowerCase().indexOf(_bn) === 0) return _bdLabelOverrides[_k];
        }
      }
      if (_bdQuals && _bdQuals[baseName]) return baseName + ' (' + _bdQuals[baseName] + ')';
      return baseName;
    }

    function _resolveComponentPrice(comp, enrichedName) {
      var vpm = comp.variantPriceMap;
      if (!vpm || typeof vpm !== 'object') return Number(comp.price || 0);

      var m = enrichedName.match(/\(([^)]+)\)\s*$/);
      if (m) {
        var q = m[1].trim().toLowerCase();
        for (var k in vpm) { if (k.toLowerCase() === q) return Number(vpm[k]); }
      }

      var el = enrichedName.trim().toLowerCase();
      for (var k in vpm) { if (k.toLowerCase() === el) return Number(vpm[k]); }

      for (var k in vpm) {
        var kl = k.toLowerCase();
        if (kl !== 'default title' && kl.length > 2 && el.indexOf(kl) !== -1) return Number(vpm[k]);
      }
      return Number(comp.price || 0);
    }

    function _bdLookupAccessoryPrice(enrichedName, fallbackPrice) {

      var m = enrichedName.match(/\(([^)]+)\)\s*$/);
      var qualifier = m ? m[1].trim().toLowerCase() : '';
      var baseName = m ? enrichedName.substring(0, m.index).trim().toLowerCase() : enrichedName.trim().toLowerCase();

      var cards = root.querySelectorAll('[data-u1-pdp-accessory]');
      for (var i = 0; i < cards.length; i++) {
        var card = cards[i];
        var cTitle = (card.getAttribute('data-u1-pdp-info-title') || '').trim().toLowerCase();
        var cHandle = (card.getAttribute('data-u1-pdp-accessory-handle') || '').replace(/-/g, ' ').toLowerCase();

        if (qualifier && cTitle === qualifier && cHandle.indexOf(baseName.split(' ')[0]) !== -1) {
          var p = card.getAttribute('data-u1-pdp-info-price') || '';
          var cents = parseMoneyCents(p);
          if (cents > 0) return cents;
        }

        if (!qualifier && cTitle === baseName) {
          var p2 = card.getAttribute('data-u1-pdp-info-price') || '';
          var cents2 = parseMoneyCents(p2);
          if (cents2 > 0) return cents2;
        }
      }
      return Number(fallbackPrice || 0);
    }

    {

      var mainPrice = bp
        ? Number(bp.mainProductPriceMin || 0)
        : (typeof getMainTotalCents === 'function' ? Number(getMainTotalCents() || 0) : 0);
      /* Modelo elegido manda (Pro Dual vs base) */
      try{var _msl=root.querySelector('[data-u1-pdp-model].is-selected')||root.querySelector('[data-u1-pdp-model][aria-pressed="true"]');if(_msl){var _mvp=Number((variants.find(function(v){return v&&Number(v.id)===Number(_msl.getAttribute('data-u1-pdp-model-variant-id')||0);})||{}).price||0);if(_mvp>0)mainPrice=_mvp;}}catch(_eMv){}
      var mainName = _bdEnrich(mainProductTitle || 'Helmet');
      /* Modelo elegido (Smart Light Pro Dual): su nombre reemplaza al del producto si empieza igual */
      try {
        var _mslN = root.querySelector('[data-u1-pdp-model].is-selected') || root.querySelector('[data-u1-pdp-model][aria-pressed="true"]');
        var _mvN = _mslN ? variants.find(function(v){ return v && Number(v.id) === Number(_mslN.getAttribute('data-u1-pdp-model-variant-id') || 0); }) : null;
        var _mo1 = _mvN ? String(_mvN.option1 || '').trim() : '';
        if (_mo1 && mainProductTitle && _mo1.toLowerCase().indexOf(String(mainProductTitle).toLowerCase()) === 0 && _mo1.length > String(mainProductTitle).length) mainName = _mo1;
      } catch (_eMn) {}
      /* Nombre: producto + color, nunca talle */
      try {
        var _mainColor = (state && state.color) ? String(state.color).trim() : '';
        if (_mainColor && mainName.toLowerCase().indexOf(_mainColor.toLowerCase()) === -1) {
          mainName += ' ' + _mainColor;
        }
      } catch (_eMc) {}
      rows.push({ name: mainName, price: mainPrice });
      /* Flash Gift con el producto suelto: fila del regalo en Free (en packs sale de la lista de componentes) */
      try {
        if ((!bp || bp.isSolo) && typeof _flashGiftStatus === 'function' && _flashGiftStatus() === 'ok' && _flashGiftEl && _flashGiftEl.hasAttribute('data-u1-flash-gift-code')) {
          var _fgNm = _flashGiftEl.querySelector('.u1-pdp-fgift__name');
          if (_fgNm && _fgNm.textContent.trim()) rows.push({ name: _fgNm.textContent.trim(), price: 0, isGift: true });
        }
      } catch (_eFgr) {}

      if (bp && Array.isArray(bp.componentProducts)) {
        bp.componentProducts.forEach(function(cp) {
          if (!cp || !cp.title) return;
          var enriched = _bdEnrich(String(cp.title) + ((root._u1FamCompSuffix && root._u1FamCompSuffix(cp.handle)) || ''));
          var price = _resolveComponentPrice(cp, enriched);

          if (price === Number(cp.price || 0)) {
            var accPrice = _bdLookupAccessoryPrice(enriched, 0);
            if (accPrice > 0) price = accPrice;
          }
          var _isGiftRow = !!(_u1PackGiftComp(bp) && String(cp.handle || '').toLowerCase() === _u1FlashGiftHandle());
          rows.push({ name: enriched, price: price, isGift: _isGiftRow });
        });
      }
    }

    try {
      var visorStep = root.querySelector('[data-u1-pdp-step="visor"]');
      if (visorStep && !visorStep.hidden) {
        /* Visores seleccionados: pueden ser varios */
        var selectedVisors = visorStep.querySelectorAll('[data-u1-pdp-visor="true"][aria-pressed="true"]');
        selectedVisors.forEach(function(selectedVisor) {
          var vTitle = selectedVisor.getAttribute('data-u1-pdp-info-title') || 'Visor';
          /* Nombre: estilo + producto */
          if (!/visor/i.test(vTitle)) vTitle = vTitle + ' Visor';
          var vPrice = selectedVisor.getAttribute('data-u1-pdp-info-price') || '';
          var vHandle = selectedVisor.getAttribute('data-u1-pdp-accessory-handle') || '';
          var alreadyListed = rows.some(function(r) {
            return vHandle && r.name.toLowerCase().indexOf(vHandle.replace(/-/g, ' ').toLowerCase()) !== -1;
          });
          if (!alreadyListed && vPrice) {
            var vid = Number(selectedVisor.getAttribute('data-u1-pdp-accessory-variant-id') || 0);
            var meta = vid ? (accessoryVariantMeta.get(vid) || null) : null;
            var cents = meta ? Number(meta.priceCents || 0) : 0;
            if (!cents) {
              /* variant-id sin resolver → meta vacia → daba $0; fallback al precio del boton */
              cents = parseMoneyCents(vPrice);
            }
            /* visor upgrade: reemplaza la fila del componente visor del pack */
            var _vi = bp ? rows.findIndex(function(r) { return !r.isAddon && /visor/i.test(r.name); }) : -1;
            if (_vi >= 0) rows[_vi] = { name: vTitle, price: cents }; else rows.push({ name: vTitle, price: cents });
          }
        });
      }
    } catch (_e) {}

    try {
      var allAccBtns = root.querySelectorAll('[data-u1-pdp-accessory][aria-pressed="true"], [data-u1-pdp-accessory].is-selected');
      allAccBtns.forEach(function(btn) {
        if (!btn) return;

        if (btn.dataset.u1PdpVisor === 'true') return;
        var aTitle = btn.getAttribute('data-u1-pdp-info-title') || btn.getAttribute('data-u1-pdp-accessory-handle') || 'Add-on';
        var aHandle = (btn.getAttribute('data-u1-pdp-accessory-handle') || '').toLowerCase();

        var _bpHandlesLc = ((bp && bp.componentProducts) || []).map(function(cp) { return (cp.handle || '').toLowerCase(); });
        if (_bpHandlesLc.indexOf(aHandle) !== -1) return;
        var aVid = Number(btn.getAttribute('data-u1-pdp-accessory-variant-id') || 0);
        var aMeta = aVid ? (accessoryVariantMeta.get(aVid) || null) : null;
        var aCents = aMeta ? Number(aMeta.priceCents || 0) : 0;
        if (!aCents) {
          var aPriceStr = btn.getAttribute('data-u1-pdp-info-price') || '';
          aCents = parseMoneyCents(aPriceStr);
        }
        var _aEntry = (state && state.accessories) ? state.accessories.get(aHandle) || state.accessories.get(btn.getAttribute('data-u1-pdp-accessory-handle') || '') : null;
        if (aCents > 0) rows.push({ name: aTitle, price: aCents, isAddon: true, isFree: !!(_aEntry && _aEntry.free) });
      });
    } catch (_e) {}

    try {
      var crashCents = typeof getCrashTotalCents === 'function' ? getCrashTotalCents() : 0;
      if (crashCents > 0) {
        /* Fuente real del plan: state.crashPlan */
        var crashPlan = (state && state.crashPlan && state.crashPlan !== 'standard') ? String(state.crashPlan) : '';
        var crashLabel = U1S.crash_title;
        /* Nombre: producto + variante sin parentesis */
        if (crashPlan) {
          var crashPlanTxt = crashPlan === 'unlimited'
            ? U1S.crash_unlimited
            : crashPlan === 'premium' ? U1S.crash_premium : crashPlan.charAt(0).toUpperCase() + crashPlan.slice(1);
          crashLabel += ' ' + crashPlanTxt;
        }
        rows.push({ name: crashLabel, price: crashCents, isAddon: true });
      }
    } catch (_e) {}

    /* Sin pack con precio tachado: el producto va a su precio de lista y el descuento en su fila (las filas suman el total) */
    try {
      var _adc = !bp ? root._u1AtcDisc : null;
      if (_adc && _adc.kind === 'compare' && _adc.compareMain > 0 && rows[0] && !rows[0].isAddon && !rows[0].isGift) rows[0].price = _adc.compareMain;
    } catch (_eAdc) {}

    var html = '';
    var componentSum = 0;
    rows.forEach(function(r) {
      componentSum += Number(r.price || 0);
      html += '<li class="u1-pdp-atc__breakdown-row u1-text-body-xs">'
        + '<span class="u1-pdp-atc__breakdown-name">' + _bdEscapeHtml(r.name) + '</span>'
        + '<span class="u1-pdp-atc__breakdown-price">' + ((r.isGift && !(Number(r.price) > 0)) ? _bdEscapeHtml(_u1FgText('data-u1-fg-free')) : formatMoneyCents(r.price)) + '</span>'
        + '</li>';
    });
    _bdList.innerHTML = html;

    /* Sin bundle: el CTA lo maneja updateAtcTotal; solo filas */
    if (!bp) {
      /* Una fila por descuento, sea cual sea (Fermin 28/10): campaña (Pro Dual -35%), promo %, precio tachado y
         accesorios gratis. Montos de updateAtcTotal, asi coinciden con el CTA. Textos de locales via data-* (Orbe) */
      try {
        var _ndRow = function (label, cents) {
          if (!label || !(cents > 0)) return;
          var li = document.createElement('li');
          li.className = 'u1-pdp-atc__breakdown-row u1-pdp-atc__breakdown-row--discount u1-text-body-xs';
          var n = document.createElement('span');
          n.className = 'u1-pdp-atc__breakdown-name';
          n.textContent = label;
          var pr = document.createElement('span');
          pr.className = 'u1-pdp-atc__breakdown-price';
          pr.textContent = '-'.concat(formatMoneyCents(cents));
          li.append(n, pr);
          _bdList.appendChild(li);
        };
        var _nd = root._u1AtcDisc || null;
        if (_nd && _nd.amt > 0) {
          var _ndName = '';
          if (_nd.kind === 'camp') {
            /* titulo del aviso de campaña (Halloween Deals) */
            var _ndHd = root.querySelector('.u1-pdp-hwn .u1-pdp-fgift__title') || document.querySelector('.u1-pdp-hwn .u1-pdp-fgift__title');
            _ndName = _ndHd ? _ndHd.textContent.trim() : '';
          }
          if (!_ndName) _ndName = (root.getAttribute('data-u1-pdp-atc-discount-label') || '').trim() || root.getAttribute('data-u1-disc-label') || '';
          var _ndTpl = root.getAttribute('data-u1-pack-row') || '%PACK% (-%PCT%%)';
          _ndRow(_nd.pct > 0 ? _ndTpl.replace('%PACK%', _ndName).replace('%PCT%', String(_nd.pct)) : _ndName, _nd.amt);
        }
        var _frTpl = root.getAttribute('data-u1-free-row') || '';
        rows.forEach(function (r) { if (r.isFree && _frTpl) _ndRow(_frTpl.replace('%GIFT%', r.name), Number(r.price || 0)); });
      } catch (_eNd) {}
      _bdUpdateExpanded(rows.length > 0);
      return;
    }

    /* msrp del total = suma de filas no-addon (siguen al modelo elegido) */
    var _bdMsrp = 0;
    rows.forEach(function(r) { if (!r.isAddon) _bdMsrp += Number(r.price || 0); });
    if (!_bdMsrp) _bdMsrp = Number(bp.msrp || 0) || 0;
    var _bdDiscPct = Number(bp.discountPercent || 0) || 0;
    var _bdGift = 0;
    rows.forEach(function(r) { if (r.isGift) _bdGift += Number(r.price || 0); });
    var _bdDiscAmt = Math.round((_bdMsrp - _bdGift) * _bdDiscPct / 100);

    var _bdExtras = 0;
    rows.forEach(function(r) { if (r.isAddon) _bdExtras += Number(r.price || 0); });
    var _bdMsrpDisplay = _bdMsrp + _bdExtras;
    var _bdTotal = _bdMsrp - _bdGift - _bdDiscAmt + _bdExtras;
    /* Filas de descuento (Fermin 23/10): cada producto a su precio y abajo una fila por descuento (regalo y pack),
       asi las filas suman exacto el total. Textos desde locales via data-* (Orbe) */
    try {
      var _bdDiscHtml = '';
      var _bdRow = function (label, cents) {
        return '<li class="u1-pdp-atc__breakdown-row u1-pdp-atc__breakdown-row--discount u1-text-body-xs">'
          + '<span class="u1-pdp-atc__breakdown-name">' + _bdEscapeHtml(label) + '</span>'
          + '<span class="u1-pdp-atc__breakdown-price">-' + formatMoneyCents(cents) + '</span>'
          + '</li>';
      };
      if (_bdGift > 0) {
        var _fgRowEl = root.querySelector('[data-u1-fg-row]');
        var _fgLabel = _fgRowEl ? (_fgRowEl.getAttribute('data-u1-fg-row') || '') : '';
        if (!_fgLabel) { var _gr = rows.find(function (r) { return r.isGift; }); _fgLabel = _u1FgText('data-u1-fg-free') + ' ' + (_gr ? _gr.name : ''); }
        _bdDiscHtml += _bdRow(_fgLabel, _bdGift);
      }
      if (_bdDiscPct > 0 && _bdDiscAmt > 0) {
        var _pkCard = root.querySelector('[data-u1-pdp-bundle-card].is-selected') || root.querySelector('[data-u1-pdp-bundle-card][aria-pressed="true"]');
        var _pkTitle = (_pkCard && _pkCard.getAttribute('data-pack-title')) || bp.title || '';
        /* Pack de campaña (2x AURA, AURA + NEON...): la fila lleva el titulo del aviso (Halloween Deals) */
        if (_pkCard && _pkCard.classList.contains('u1-pdp-bundle-card--campaign')) {
          var _pkHd = root.querySelector('.u1-pdp-hwn .u1-pdp-fgift__title') || document.querySelector('.u1-pdp-hwn .u1-pdp-fgift__title');
          if (_pkHd && _pkHd.textContent.trim()) _pkTitle = _pkHd.textContent.trim();
        }
        var _pkTpl = root.getAttribute('data-u1-pack-row') || '%PACK% (-%PCT%%)';
        _bdDiscHtml += _bdRow(_pkTpl.replace('%PACK%', _pkTitle).replace('%PCT%', String(_bdDiscPct)), _bdDiscAmt);
      }
      if (_bdDiscHtml) _bdList.innerHTML = html + _bdDiscHtml;
    } catch (_eBdD) {}
    if ((_bdDiscPct > 0 && _bdDiscAmt > 0) || _bdGift > 0) {
      if (atcTotalMsrpEl) {
        atcTotalMsrpEl.textContent = formatMoneyCents(_bdMsrpDisplay);
        atcTotalMsrpEl.setAttribute('aria-hidden', 'false');
      }
      if (atcTotalWrapEl) atcTotalWrapEl.classList.add('is-discount-on');
      if (atcTotalEl) atcTotalEl.textContent = formatMoneyCents(_bdTotal);
      if (atcSaveEl) {
        /* Save consistente con lo mostrado: (MSRP mostrado) - (Tota... */
        var _saveWhole = Math.max(0, _bdMsrpDisplay - _bdTotal);
        if (_saveWhole > 0) {
          atcSaveEl.textContent = U1S.save.replace('__A__', formatMoneyCents(_saveWhole));
          atcSaveEl.hidden = false;
          atcSaveEl.setAttribute('aria-hidden', 'false');
        } else {
          atcSaveEl.hidden = true;
          atcSaveEl.setAttribute('aria-hidden', 'true');
        }
      }
    } else {

      if (atcTotalEl) atcTotalEl.textContent = formatMoneyCents(_bdMsrp + _bdExtras);
    }

    _bdUpdateExpanded(rows.length > 0);
  };

  /* Primera carga: updateSummary() del init corre ANTES de qu... */
  try { updateBreakdownRows(); } catch (_eBd0) {}
}
})();
/* ---- antes snippets/u1-pdp-bundle-tooltips-b.liquid ---- */
/*
  Bundle component tooltips — agrega el icono "i" con tooltip a cada item de la lista
  de componentes de las bundle cards. El texto sale del metafield custom.bundle_tooltip
  de cada producto (mapa en data-u1-tooltips, generado por u1-pdp-inline-bundle-picker).

  Vive como snippet separado porque u1-pdp-customizer-js.liquid esta al limite de 256KB.
  Sin MutationObserver (leccion Stoq): decorado idempotente con reintentos por timeout
  y re-decorado al clickear una card (la lista se re-renderiza por JS).
*/
/* OJO: este snippet se renderiza DENTRO del <script> principal de la seccion (como u1-pdp-customizer-js): JS PURO, jamas tags script aca. */
(function () {
  var BOX = '[data-u1-pdp-bundle-components]';

  function escapeHtml(t) {
    var d = document.createElement('div');
    d.textContent = t;
    return d.innerHTML;
  }

  function decorate() {
    try {
      document.querySelectorAll(BOX).forEach(function (box) {
        var map;
        try { map = JSON.parse(box.getAttribute('data-u1-tooltips') || '{}'); } catch (e) { return; }
        box.querySelectorAll('li').forEach(function (li) {
          if (li.querySelector('.u1-pdp-bundle-card__info')) return;
          var name = (li.textContent || '').replace(/^\+\s*/, '').trim().toLowerCase();
          if (!name) return;
          var txt = map[name] || '';
          if (!txt) {
            /* labels curados del pack pueden diferir del titulo ("Helmet Visor (Clear or Tinted)"):
               match por contencion en ambos sentidos */
            for (var k in map) {
              if (map[k] && k && (name.indexOf(k) !== -1 || k.indexOf(name) !== -1)) { txt = map[k]; break; }
            }
          }
          if (!txt) return;
          var s = document.createElement('span');
          s.className = 'u1-pdp-bundle-card__info';
          s.setAttribute('role', 'button');
          s.setAttribute('tabindex', '0');
          s.setAttribute('aria-label', U1S.more_info);
          s.innerHTML = '<svg viewBox="0 0 14 14" fill="none" aria-hidden="true"><circle cx="7" cy="7" r="6.3" stroke="currentColor" stroke-width="1.1"/><path d="M7 6.4v3.3" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><circle cx="7" cy="4.4" r="0.75" fill="currentColor"/></svg>'
            + '<span class="u1-pdp-color__tooltip" aria-hidden="true">' + escapeHtml(txt) + '</span>';
          li.appendChild(s);
        });
      });
    } catch (e) { /* noop */ }
  }

  /* La card y la lista de componentes tienen overflow hidden (bordes redondeados +
     animacion de expandir) y recortaban el tooltip. Posicionarlo FIXED en coordenadas
     de viewport cuando se muestra: flota por encima y sobresale de la card sin recorte.
     (fixed no queda atrapado por overflow de ancestros; ningun ancestro tiene transform) */
  function positionTip(info) {
    try {
      var tip = info.querySelector('.u1-pdp-color__tooltip');
      if (!tip) return;
      var r = info.getBoundingClientRect();
      tip.style.position = 'fixed';
      tip.style.left = (r.left + r.width / 2) + 'px';
      tip.style.top = (r.bottom + 8) + 'px';
      tip.style.bottom = 'auto';
      tip.style.zIndex = '999';
      /* Cada card tiene z-index:0 (contexto propio): una card posterior pinta ENCIMA
         del tooltip de la anterior. Elevar la card mientras su tooltip esta visible. */
      var card = info.closest('[data-u1-pdp-bundle-card]');
      if (card) card.style.zIndex = '30';
    } catch (e) { /* noop */ }
  }
  function resetCardz(except) {
    try {
      document.querySelectorAll('[data-u1-pdp-bundle-card]').forEach(function (c) {
        if (c !== except && !c.querySelector('.u1-pdp-bundle-card__info.is-open')) c.style.zIndex = '';
      });
    } catch (e) { /* noop */ }
  }
  document.addEventListener('mouseover', function (e) {
    var info = e.target && e.target.closest ? e.target.closest('.u1-pdp-bundle-card__info') : null;
    if (info) positionTip(info);
  }, true);
  document.addEventListener('mouseout', function (e) {
    var info = e.target && e.target.closest ? e.target.closest('.u1-pdp-bundle-card__info') : null;
    if (info && !info.classList.contains('is-open')) resetCardz(null);
  }, true);
  /* El tooltip es position:fixed (coordenadas de viewport): al scrollear quedaba
     flotando en el medio de la pantalla, despegado del icono. Cerrarlo al scrollear
     (capture: agarra tambien scrolls de contenedores internos). */
  window.addEventListener('scroll', function () {
    var open = document.querySelectorAll('.u1-pdp-bundle-card__info.is-open');
    if (open.length) {
      open.forEach(function (o) { o.classList.remove('is-open'); });
      resetCardz(null);
    }
  }, { passive: true, capture: true });

  /* El icono vive DENTRO del <button> de la card: capturar el click para que
     abrir el tooltip (tap mobile) no seleccione/deseleccione el pack */
  document.addEventListener('click', function (e) {
    var info = e.target && e.target.closest ? e.target.closest('.u1-pdp-bundle-card__info') : null;
    if (info) {
      e.preventDefault();
      e.stopPropagation();
      positionTip(info);
      document.querySelectorAll('.u1-pdp-bundle-card__info.is-open').forEach(function (o) { if (o !== info) o.classList.remove('is-open'); });
      info.classList.toggle('is-open');
      return;
    }
    document.querySelectorAll('.u1-pdp-bundle-card__info.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    resetCardz(null);
    /* la lista de componentes se re-renderiza al interactuar con las cards */
    if (e.target && e.target.closest && e.target.closest('[data-u1-pdp-bundle-card]')) {
      window.setTimeout(decorate, 250);
      window.setTimeout(decorate, 900);
    }
  }, true);

  decorate();
  window.setTimeout(decorate, 800);
  window.setTimeout(decorate, 2500);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate);
})();

/* ── Preseleccion de pack por URL: /products/x?pack=<pack_handle> ──
   Clickea la bundle card del handle al cargar (con reintentos porque el
   selector se inicializa async). Vive aca y no en customizer-js por el
   limite de 256KB de ese archivo. */
(function () {
  try {
    var pk = new URLSearchParams(window.location.search || '').get('pack');
    if (!pk) return;
    pk = pk.toLowerCase();
    var tries = 0;
    function go() {
      var card = document.querySelector('[data-u1-pdp-bundle-card][data-pack-handle="' + pk + '"]')
              || document.querySelector('[data-u1-pdp-bundle-card][data-pack-id="' + pk + '"]');
      if (card) {
        card.click();
        try { card.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (_e) {}
        return;
      }
      if (++tries < 24) window.setTimeout(go, 250);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { window.setTimeout(go, 300); });
    else window.setTimeout(go, 300);
  } catch (e) { /* noop */ }
})();
/* ---- antes snippets/u1-pdp-family-js-b.liquid ---- */
/*
  FAMILY PACK — JS de los chapters del segundo casco (Etapa 1: seleccion + titulos).
  Etapas siguientes: galeria en tiempo real (2) y carrito/breakdown (3).

  OJO: se renderiza DENTRO del <script> principal de la seccion (como customizer-js
  y bundle-tooltips): JS PURO, jamas tags script aca adentro.

  V3 defensivo: no asume nada del scope ni del DOM al momento de ejecutar.
  - Root se resuelve por document (no depende del `root` del scope compartido).
  - Listener delegado en document (sobrevive re-renders de la seccion).
  - Init con reintentos (los chapters pueden no estar aun).
  - Marcador root.dataset.u1FamJs para verificar en consola que corrio.
  - Todo el cuerpo en try/catch con console.error: si muere, se VE.
*/
(function () {
  try {
    var FAM_SEL_STEP = '[data-u1-pdp-step="sparky_color"], [data-u1-pdp-step="sparky_inserts"]';

    function famRoot() {
      var st = document.querySelector(FAM_SEL_STEP);
      if (st) {
        var sec = st.closest('.u1-pdp-customizer') || st.closest('.shopify-section');
        if (sec) return sec;
      }
      return document.querySelector('section.u1-pdp-customizer, .u1-pdp-customizer');
    }

    /* ── Inserts: mapa "model|color" → {id, available} para resolver el SKU exacto ── */
    function insData() {
      var w = document.querySelector('[data-u1-pdp-sparky-inserts-picker]');
      if (!w) return null;
      if (!w._u1Map) {
        try { w._u1Map = JSON.parse(w.getAttribute('data-u1-fam-ins-map') || '{}'); } catch (eM) { w._u1Map = {}; }
        w._u1HasModel = w.getAttribute('data-u1-fam-ins-has-model-opt') === '1';
      }
      return w;
    }
    function resolveInsertVariant(r) {
      var w = insData();
      if (!w || !r) return;
      var d = r.dataset.u1SparkyInsertDesign || '';
      var c = r.dataset.u1SparkyInsertColor || '';
      var key = w._u1HasModel ? (d + '|' + c) : c;
      var hit = w._u1Map[key];
      r.dataset.u1SparkyInsertVid = hit ? String(hit.id) : '';
    }
    /* Stock por COMBINACION modelo|color en el mercado (Carlos 22/10, EU): apaga los colores sin stock para el modelo
       elegido y los modelos sin ningun color con stock; si lo elegido quedo sin stock, salta a la primera combinacion
       disponible (antes "Tangerine Orange / Lightning" agotado en EU rompia el add-to-cart del Everyday Pack) */
    function syncInsAvail(r) {
      try {
        var w = insData();
        if (!w) return;
        var map = w._u1Map || {};
        var cBtns = Array.prototype.slice.call(w.querySelectorAll('[data-u1-pdp-sparky-insert-color]'));
        var mBtns = Array.prototype.slice.call(w.querySelectorAll('[data-u1-pdp-sparky-insert-design]'));
        var ok = function (m, c) { var h = map[w._u1HasModel ? (m + '|' + c) : c]; return !!(h && h.a); };
        var selOf = function (list, attr) { var b = list.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; })[0] || list[0]; return b ? (b.getAttribute(attr) || '') : ''; };
        var selM = selOf(mBtns, 'data-u1-pdp-sparky-insert-design');
        var selC = selOf(cBtns, 'data-u1-pdp-sparky-insert-color');
        cBtns.forEach(function (b) {
          var on = ok(selM, b.getAttribute('data-u1-pdp-sparky-insert-color') || '');
          b.classList.toggle('is-oos', !on); b.disabled = !on;
        });
        if (w._u1HasModel) mBtns.forEach(function (b) {
          var m = b.getAttribute('data-u1-pdp-sparky-insert-design') || '';
          var any = cBtns.some(function (c) { return ok(m, c.getAttribute('data-u1-pdp-sparky-insert-color') || ''); });
          b.classList.toggle('is-oos', !any); b.disabled = !any;
        });
        if (!ok(selM, selC)) {
          var alt = cBtns.filter(function (c) { return !c.disabled; })[0];
          if (alt) { alt.click(); return; }
          var mAlt = mBtns.filter(function (m) { return !m.disabled; })[0];
          if (mAlt) mAlt.click();
        }
      } catch (eSa) { /* noop */ }
    }
    window.setTimeout(function () { try { var r0 = famRoot(); if (r0) syncInsAvail(r0); } catch (eS0) {} }, 0);

    function pick(groupSel, btn) {
      var group = btn.closest(groupSel);
      if (!group) return;
      group.querySelectorAll('button[aria-pressed="true"]').forEach(function (b) {
        if (b !== btn) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); }
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
    }

    /* Nombre del color al TITULO del chapter (mismo formato que AURA: "Base – Valor").
       Sin depender de updateStepMobileTitle del scope: replica su logica minima,
       preservando el span del fam-prefix. */
    function famTitleValue(r, stepName, value) {
      try {
        var stepEl = r.querySelector('[data-u1-pdp-step="' + stepName + '"]');
        if (!stepEl) return;
        stepEl.querySelectorAll('[data-u1-pdp-step-mobile-title]').forEach(function (el) {
          var base = el.dataset.u1PdpMobileBase || '';
          var pref = el.querySelector('[data-u1-fam-prefix]');
          el.textContent = '';
          if (pref) el.appendChild(pref);
          if (value) {
            el.appendChild(document.createTextNode(base + ' – '));
            var vs = document.createElement('span');
            vs.className = 'u1-pdp-step__mobile-title-value';
            vs.textContent = value;
            el.appendChild(vs);
          } else {
            el.appendChild(document.createTextNode(base));
          }
        });
      } catch (eT) { /* noop */ }
    }

    function famSetLabel(r, sel, value) {
      var el = r.querySelector(sel);
      if (el) el.textContent = value || '';
    }

    /* ── ETAPA 3 (carrito): items exactos de los componentes del pack Family.
       customizer-js consulta estos hooks al armar el add-to-cart y el breakdown.
       Solo responden con los chapters family activos (pack Family seleccionado);
       con otro pack o modo solo devuelven null/'' y el flujo generico sigue igual. ── */
    function famActive(r) {
      return !!(r && r.querySelector('.u1-pdp-step--pack-only.is-pack-active'));
    }
    /* Family Pack invertido: variantes del casco adulto (color + talle -> id) */
    function famActivePackHandle() {
      try {
        var r = famRoot();
        var ps = r && r._packSelector;
        var bp = ps && typeof ps.getActiveBundlePack === 'function' ? ps.getActiveBundlePack() : null;
        return bp && bp.packHandle ? String(bp.packHandle).toLowerCase() : '';
      } catch (ePH) { return ''; }
    }
    /* Titulo base del chapter segun el casco del pack activo (AURA/NEON Color) */
    function famAdultRetitle() {
      try {
        var r = famRoot(); if (!r) return;
        var g = famAdultActiveColorGroup();
        var h = g ? (g.getAttribute('data-u1-adult-handle') || '') : '';
        if (!h) return;
        var name = h.indexOf('neon') !== -1 ? 'NEON' : (h.indexOf('aura') !== -1 ? 'AURA' : '');
        if (!name) return;
        [['adult_color', ' ' + U1S.color], ['adult_size', ' ' + U1S.size]].forEach(function (pair) {
          var st = r.querySelector('[data-u1-pdp-step="' + pair[0] + '"]');
          if (!st) return;
          st.querySelectorAll('[data-u1-pdp-step-mobile-title]').forEach(function (el) {
            el.dataset.u1PdpMobileBase = name + pair[1];
          });
        });
        famTitleValue(r, 'adult_color', r.dataset.u1AdultColorName);
        famTitleValue(r, 'adult_size', r.dataset.u1AdultSizeName);
      } catch (eRT) { /* noop */ }
    }
    /* Muestra el grupo (swatches + pills) del pack activo y oculta los demas */
    function famAdultShowGroup() {
      var ph = famActivePackHandle();
      var groups = document.querySelectorAll('[data-u1-adult-group]');
      if (!groups.length) return;
      var shown = null;
      groups.forEach(function (g) {
        var on = (g.getAttribute('data-u1-adult-group') || '').toLowerCase() === ph;
        g.hidden = !on;
        if (on && !shown) shown = g;
      });
      window.setTimeout(function () {
        famAdultRetitle();
        famTwoHelmets();
        var rr = famRoot();
        if (rr) { famAdultSizeSeed(rr); famAdultSyncSizes(rr); }
      }, 0);
      return shown;
    }
    /* ── Modo 2 cascos (packs con color+talle del casco principal Y del segundo casco: 2x AURA, AURA + NEON).
       Reutilizable: se prende solo cuando el pack activo muestra size y adult_size. Clase is-two-helmets en el
       customizer (CSS: color y talle del segundo casco juntos, como los del principal) y titulos del segundo casco:
       "Pick your second AURA color" (u1.pdp.two_helmets_*) o, si es otro modelo, "Pick your NEON color" (other_helmet_*). ── */
    function famHelmetName(h) {
      h = String(h || '').toLowerCase();
      var known = ['aura', 'neon', 'faro', 'sparky'];
      for (var i = 0; i < known.length; i++) { if (h.indexOf(known[i]) !== -1) return known[i].toUpperCase(); }
      return h ? h.split('-')[0].toUpperCase() : '';
    }
    function famSetBase(el, base) {
      el.dataset.u1PdpMobileBase = base;
      var val = el.querySelector('.u1-pdp-step__mobile-title-value');
      var pref = el.querySelector('[data-u1-fam-prefix]');
      el.textContent = '';
      if (pref) el.appendChild(pref);
      if (val) { el.appendChild(document.createTextNode(base + ' – ')); el.appendChild(val); }
      else el.appendChild(document.createTextNode(base));
    }
    function famTwoHelmets() {
      try {
        var r = famRoot(); if (!r || !U1S.two_color) return;
        var sz = r.querySelector('[data-u1-pdp-step="size"]');
        var asz = r.querySelector('[data-u1-pdp-step="adult_size"]');
        var g = famAdultActiveColorGroup();
        var on = !!(sz && !sz.hidden && asz && !asz.hidden && asz.classList.contains('is-pack-active') && g && !g.hidden);
        r.classList.toggle('is-two-helmets', on);
        var main = famHelmetName(r.dataset.u1PdpProductHandle);
        var sec = famHelmetName(g ? g.getAttribute('data-u1-adult-handle') : '');
        /* El casco principal queda con sus titulos de siempre (Fermin 28/10). El segundo: mismo modelo ->
           "Pick your second AURA color"; otro modelo -> "Pick your NEON color" (sin numero) */
        var same = !!(sec && sec === main);
        var tc = same ? U1S.two_color : (U1S.other_color || U1S.two_color);
        var ts = same ? U1S.two_size : (U1S.other_size || U1S.two_size);
        [['adult_color', sec, '2', tc], ['adult_size', sec, '2', ts]].forEach(function (t) {
          var st = r.querySelector('[data-u1-pdp-step="' + t[0] + '"]');
          if (!st) return;
          st.querySelectorAll('[data-u1-pdp-step-mobile-title]').forEach(function (el) {
            if (el.dataset.u1TwoOrig === undefined) el.dataset.u1TwoOrig = '';
            if (on && t[1]) {
              /* guarda el titulo original una vez (los adultos lo reescribe famAdultRetitle en cada cambio) */
              if (t[0] === 'color' || t[0] === 'size') { if (!el.dataset.u1TwoOrig) el.dataset.u1TwoOrig = el.dataset.u1PdpMobileBase || el.textContent; }
              famSetBase(el, t[3].replace('__NAME__', t[1]).replace('__N__', t[2]));
            } else if ((t[0] === 'color' || t[0] === 'size') && el.dataset.u1TwoOrig) {
              famSetBase(el, el.dataset.u1TwoOrig);
            }
          });
        });
      } catch (eTH) { /* noop */ }
    }
    function famAdultActiveColorGroup() {
      var ph = famActivePackHandle();
      var sel = '[data-u1-pdp-adult-color-picker] [data-u1-adult-group="' + ph + '"]';
      return document.querySelector(sel);
    }
    function famAdultVariants() {
      try {
        var g = famAdultActiveColorGroup();
        var el = g ? g.querySelector('[data-u1-pdp-adult-variants]') : null;
        return el ? (JSON.parse(el.textContent || '[]') || []) : [];
      } catch (eAV) { return []; }
    }
    /* Preorder real: la variante se puede comprar (available) pero no hay
       inventario (continue selling) y tiene plan de Stoq. Las agotadas con
       policy deny NO son preorder: Shopify las rechaza con 422 */
    function famAdultIsPreorder(v) {
      if (!v) return false;
      return !!(v.available && Number(v.qty || 0) <= 0 && Number(v.sp || 0) > 0);
    }
    function famAdultHit(r) {
      var col = famToken(r.dataset.u1AdultColor || '');
      var sz = famToken(r.dataset.u1AdultSize || '');
      if (!col || !sz) return null;
      return famAdultVariants().filter(function (v) {
        var vals = [v.o1, v.o2, v.o3];
        return vals.indexOf(col) !== -1 && vals.indexOf(sz) !== -1;
      })[0] || null;
    }
    function famResolveAdultVid(r) {
      var hit = famAdultHit(r);
      return hit ? hit.id : 0;
    }
    /* Pill deslizante del talle del adulto (mismo componente que AURA/NEON) */
    function famAdultSizePill() {
      try {
        /* El hidden vive en el wrapper del pack, no en el picker interno: hay que
           partir del wrapper visible o siempre se agarra el primer grupo (AURA) */
        var wrapVis = document.querySelector('[data-u1-pdp-adult-size-picker] [data-u1-adult-group]:not([hidden])');
        var grp = wrapVis ? (wrapVis.querySelector('[data-u1-pdp-adult-size-group]') || wrapVis) : null;
        if (!grp) return;
        var pill = grp.querySelector('[data-u1-pdp-adult-size-pill]');
        var act = grp.querySelector('[data-u1-pdp-adult-size].is-selected');
        if (!pill || !act) return;
        pill.style.width = act.offsetWidth + 'px';
        pill.style.transform = 'translateX(' + act.offsetLeft + 'px)';
        pill.classList.add('is-visible');
      } catch (ePL) { /* noop */ }
    }
    /* Seed: el componente compartido no marca seleccion; elegimos el primer talle */
    function famAdultSizeSeed(r) {
      try {
        var grpWrap = document.querySelector('[data-u1-pdp-adult-size-picker] [data-u1-adult-group]:not([hidden])');
        if (!grpWrap) return;
        var btns = grpWrap.querySelectorAll('[data-u1-pdp-adult-size]');
        if (!btns.length) return;
        var has = grpWrap.querySelector('[data-u1-pdp-adult-size].is-selected');
        if (!has) {
          var first = grpWrap.querySelector('[data-u1-pdp-adult-size]:not([disabled])') || btns[0];
          first.classList.add('is-selected');
          first.setAttribute('aria-pressed', 'true');
          r.dataset.u1AdultSize = first.getAttribute('data-u1-pdp-adult-size') || '';
          r.dataset.u1AdultSizeName = first.getAttribute('data-u1-pdp-adult-size-name') || '';
          famTitleValue(r, 'adult_size', r.dataset.u1AdultSizeName);
        }
        famAdultSizePill();
      } catch (eSS) { /* noop */ }
    }
    /* Texto de envio de preorder para una variante (misma cascada que la PDP:
       config de Stoq por variante/mercado, y si no, el plan) */
    function famAdultShipText(vid) {
      try {
        var cfg = window._RestockRocketConfig;
        if (!cfg || !vid) return '';
        var k = String(vid);
        if (cfg.variantsShippingTextForMarket && cfg.variantsShippingTextForMarket[k]) {
          var mkt = cfg.variantsShippingTextForMarket[k];
          var txt = (typeof mkt === 'string' ? mkt : Object.values(mkt)[0] || '').toString().trim();
          if (txt) return txt;
        }
        if (cfg.variantsShippingText && cfg.variantsShippingText[k]) {
          return String(cfg.variantsShippingText[k]).trim();
        }
        var plans = Array.isArray(cfg.sellingPlans) ? cfg.sellingPlans : [];
        var pl = plans.find(function (x) { return x && x.enabled !== false; });
        return pl && pl.shipping_text ? String(pl.shipping_text).trim() : '';
      } catch (eST) { return ''; }
    }
    /* Aviso de preorder del casco adulto: aparece cuando la combinacion elegida
       no tiene stock pero si plan de preorder */
    function famAdultPreorderNotice(r) {
      try {
        var wrap = document.querySelector('[data-u1-pdp-adult-size-picker] [data-u1-adult-group]:not([hidden]) [data-u1-pdp-adult-preorder-wrap]');
        if (!wrap) return;
        var hit = famAdultHit(r);
        var isPre = famAdultIsPreorder(hit);
        /* El banner colapsa con max-height:0 y se abre con .is-visible */
        wrap.hidden = false;
        wrap.setAttribute('aria-hidden', isPre ? 'false' : 'true');
        wrap.classList.toggle('is-visible', isPre);
        if (isPre) {
          var nmEl = wrap.querySelector('[data-u1-pdp-adult-preorder-name]');
          if (nmEl) {
            var g = famAdultActiveColorGroup();
            var hh = g ? (g.getAttribute('data-u1-adult-handle') || '') : '';
            nmEl.textContent = hh.indexOf('neon') !== -1 ? 'NEON' : (hh.indexOf('aura') !== -1 ? 'AURA' : U1S.adult_helmet);
          }
          var line = wrap.querySelector('[data-u1-pdp-adult-preorder-ship]');
          if (line) {
            var txt = famAdultShipText(hit.id);
            line.textContent = txt ? (U1S.est_shipping + txt.replace(/^estimated shipping:?\s*/i, '')) : '';
            line.hidden = !txt;
          }
        }
      } catch (ePN) { /* noop */ }
    }
    function famAdultSyncSizes(r) {
      try {
        var col = famToken(r.dataset.u1AdultColor || '');
        var szGrpAct = document.querySelector('[data-u1-pdp-adult-size-picker] [data-u1-adult-group]:not([hidden])');
        if (szGrpAct) szGrpAct = szGrpAct.querySelector('[data-u1-pdp-adult-size-group]') || szGrpAct;
        var pills = szGrpAct ? szGrpAct.querySelectorAll('[data-u1-pdp-adult-size]') : [];
        if (!col || !pills.length) return;
        pills.forEach(function (b) {
          var sz = b.getAttribute('data-u1-pdp-adult-size') || '';
          var ok = famAdultVariants().some(function (v) {
            var vals = [v.o1, v.o2, v.o3];
            if (vals.indexOf(col) === -1 || vals.indexOf(sz) === -1) return false;
            /* Solo stock real: las variantes agotadas de AURA/NEON hoy NO son
               preorder comprable (Shopify responde 422 "already sold out" porque
               el inventario esta en deny; en su PDP muestran Notify me). El
               soporte de selling_plan queda latente: si Stoq activa oversell,
               esas variantes pasan a available y se venden con su plan. */
            return v.available;
          });
          b.disabled = !ok;
          b.classList.toggle('is-oos', !ok);
        });
        var cur = szGrpAct ? szGrpAct.querySelector('[data-u1-pdp-adult-size].is-selected') : null;
        if (cur && cur.disabled) {
          var next = szGrpAct.querySelector('[data-u1-pdp-adult-size]:not([disabled])');
          if (next) {
            cur.classList.remove('is-selected'); cur.setAttribute('aria-pressed', 'false');
            next.classList.add('is-selected'); next.setAttribute('aria-pressed', 'true');
            r.dataset.u1AdultSize = next.getAttribute('data-u1-pdp-adult-size') || '';
            r.dataset.u1AdultSizeName = next.getAttribute('data-u1-pdp-adult-size-name') || '';
            famTitleValue(r, 'adult_size', r.dataset.u1AdultSizeName);
          }
        }
        famAdultSizePill();
        famAdultPreorderNotice(r);
      } catch (eAS) { /* noop */ }
    }
    function famCompItem(handle, bundleTag) {
      try {
        var r = famRoot();
        if (!famActive(r)) return null;
        var h = String(handle || '').toLowerCase();
        var props = {};
        if (bundleTag) props._u1_bundle = bundleTag;
        var sw = document.querySelector('[data-u1-pdp-sparky-color-picker]');
        if (sw && (sw.getAttribute('data-u1-sparky-handle') || '').toLowerCase() === h) {
          var vid = Number(r.dataset.u1SparkyColorVid || 0);
          if (!vid) return null;
          return { id: vid, quantity: 1, _u1_label: 'SPARKY ' + (r.dataset.u1SparkyColorName || ''), properties: props };
        }
        var aw = famAdultActiveColorGroup();
        if (aw && (aw.getAttribute('data-u1-adult-handle') || '').toLowerCase() === h) {
          var hitA = famAdultHit(r);
          if (!hitA || !hitA.id) return null;
          var nmA = [r.dataset.u1AdultColorName, r.dataset.u1AdultSizeName].filter(Boolean).join(' / ');
          var itemA = { id: hitA.id, quantity: 1, _u1_label: nmA, properties: props };
          /* Preorder (Stoq): solo si la variante es preorder real (vendible sin
             inventario). Con stock, compra normal — mandar el plan convertiria
             una venta inmediata en preorder */
          if (famAdultIsPreorder(hitA)) itemA.selling_plan = Number(hitA.sp);
          return itemA;
        }
        var tw = document.querySelector('[data-u1-pdp-torch-color-picker]');
        if (tw && (tw.getAttribute('data-u1-torch-handle') || '').toLowerCase() === h) {
          var vidT = Number(r.dataset.u1TorchColorVid || 0);
          if (!vidT) return null;
          return { id: vidT, quantity: 1, _u1_label: 'TORCH ' + (r.dataset.u1TorchColorName || ''), properties: props };
        }
        var iw = document.querySelector('[data-u1-pdp-sparky-inserts-picker]');
        if (iw && (iw.getAttribute('data-u1-inserts-handle') || '').toLowerCase() === h) {
          var vid2 = Number(r.dataset.u1SparkyInsertVid || 0);
          if (!vid2) return null;
          /* Sin opcion real de modelo (fallback CSV): el diseno viaja como property */
          if (iw.getAttribute('data-u1-fam-ins-has-model-opt') !== '1' && r.dataset.u1SparkyInsertDesignName) {
            props.Design = r.dataset.u1SparkyInsertDesignName;
          }
          return { id: vid2, quantity: 1, _u1_label: 'Silicone Inserts', properties: props };
        }
        return null;
      } catch (eCI) { return null; }
    }
    /* Sufijo para el breakdown: "SPARKY Junior Smart Helmet" → "... Soft Pink" */
    function famCompSuffix(handle) {
      try {
        var r = famRoot();
        if (!famActive(r)) return '';
        var h = String(handle || '').toLowerCase();
        var sw = document.querySelector('[data-u1-pdp-sparky-color-picker]');
        if (sw && (sw.getAttribute('data-u1-sparky-handle') || '').toLowerCase() === h) {
          return r.dataset.u1SparkyColorName ? ' ' + r.dataset.u1SparkyColorName : '';
        }
        var awS = famAdultActiveColorGroup();
        if (awS && (awS.getAttribute('data-u1-adult-handle') || '').toLowerCase() === h) {
          var pa = [r.dataset.u1AdultColorName, r.dataset.u1AdultSizeName].filter(Boolean);
          return pa.length ? ' ' + pa.join(' ') : '';
        }
        var tw = document.querySelector('[data-u1-pdp-torch-color-picker]');
        if (tw && (tw.getAttribute('data-u1-torch-handle') || '').toLowerCase() === h) {
          return r.dataset.u1TorchColorName ? ' ' + r.dataset.u1TorchColorName : '';
        }
        var iw = document.querySelector('[data-u1-pdp-sparky-inserts-picker]');
        if (iw && (iw.getAttribute('data-u1-inserts-handle') || '').toLowerCase() === h) {
          var parts = [];
          if (r.dataset.u1SparkyInsertDesignName) parts.push(r.dataset.u1SparkyInsertDesignName);
          if (r.dataset.u1SparkyInsertColorName) parts.push(r.dataset.u1SparkyInsertColorName);
          return parts.length ? ' ' + parts.join(' ') : '';
        }
        return '';
      } catch (eCS) { return ''; }
    }

    /* ── ETAPA 2 (galeria): el hero del pack (todos los productos juntos) cambia con
       CADA seleccion. Este hook le agrega al builder generico de candidatos las
       variantes mas especificas, en orden especifico → general; el preload existente
       cae solo al siguiente si la foto no esta subida:
         pdp-{prod}-family-pack-{aura}-{sparky}-{model}-{insertcolor}.jpg
         pdp-{prod}-family-pack-{aura}-{sparky}.jpg
         (y sigue con las genericas del sistema: -{aura}.jpg → base.jpg) ── */
    function famToken(v) { return (v || '').toLowerCase().replace(/\s+/g, '-'); }
    /* Assets versionados: primero el nombre pelado (set nuevo, oct 2026, sin -vN) →
       -v3 → -v2 (sets anteriores, mientras no se rehagan). En cada nivel se prueban
       las tres versiones; los duplicados con los candidatos genericos son inofensivos. */
    var FAM_IMG_VERSIONS = ['', '-v3', '-v2'];
    /* Packs con TORCH (capitulo torch_color, ej. All-In): color de TORCH si todavia no se eligio */
    var FAM_TORCH_FALLBACK = 'charcoal-black';
    function famPushLevel(out, base, sz) {
      FAM_IMG_VERSIONS.forEach(function (v) { out.push(base + v + '.jpg' + sz); });
    }
    function famImgCands(prefix, col, sz, out, chapters) {
      try {
        var r = famRoot();
        if (!r) return;
        /* SPARKY Everyday Pack: candidato mas especifico con el combo de inserts
           pdp-sparky-everyday-pack-{color}-{modelo}-{colorinsert}.jpg
           (el builder generico agrega despues -{color} y el base como fallbacks) */
        /* Packs con TORCH (capitulo torch_color, ej. All-In de AURA/NEON): candidato con el color de TORCH elegido
           pdp-{prod}-{pack}-{colorcasco}-{colortorch}.jpg
           (el builder generico agrega -{colorcasco} y base como fallbacks) */
        /* Family invertido (PDP de sparky): reusa las fotos EXISTENTES del pack
           en su version original (pdp-aura-family-pack-*), que ya estan subidas.
           prefix llega como pdp-sparky-{pack}; lo reescribimos a pdp-{pack}. */
        if (/-family-pack$/.test(prefix) && /^.*pdp-sparky-/.test(prefix)) {
          var fbase = prefix.replace(/pdp-sparky-/, 'pdp-');
          /* Pack del prefix (no el activo): en hover el grupo esta hidden */
          var fpm = fbase.match(/pdp-([a-z0-9-]+-family-pack)$/);
          var fpack = fpm ? fpm[1] : '';
          var fgrp = fpack ? document.querySelector('[data-u1-pdp-adult-color-picker] [data-u1-adult-group="' + fpack + '"]') : null;
          var fsel = fgrp ? fgrp.querySelector('[data-u1-pdp-adult-color].is-selected') : null;
          var fac = famToken(fsel ? (fsel.getAttribute('data-u1-pdp-adult-color-name') || '') : r.dataset.u1AdultColorName);
          var fsc = famToken(r.dataset.u1SparkyColorName) || famToken(r.dataset.u1SparkyColorName);
          var fim = famToken(r.dataset.u1SparkyInsertDesign);
          var fic = famToken(r.dataset.u1SparkyInsertColorName);
          if (!fsc) {
            var mainSel = r.querySelector('[data-u1-pdp-color].is-selected');
            if (mainSel) fsc = famToken(mainSel.getAttribute('data-u1-pdp-value-handle') || mainSel.getAttribute('data-u1-pdp-value') || '');
          }
          /* Defaults para que el hero tenga foto desde el hover de la card,
             antes de que el cliente elija nada */
          if (!fsc) fsc = 'slate-gray';
          if (!fim) fim = 'dino';
          if (!fic) fic = 'tangerine-orange';
          if (!fac) {
            var acDef = document.querySelector('[data-u1-pdp-adult-color-picker] [data-u1-adult-group]:not([hidden]) [data-u1-pdp-adult-color].is-selected');
            if (acDef) fac = famToken(acDef.getAttribute('data-u1-pdp-adult-color-name') || '');
          }
          if (fac && fsc && fim && fic) famPushLevel(out, fbase + '-' + fac + '-' + fsc + '-' + fim + '-' + fic, sz);
          if (fac && fsc) famPushLevel(out, fbase + '-' + fac + '-' + fsc, sz);
          if (fac) famPushLevel(out, fbase + '-' + fac, sz);
          famPushLevel(out, fbase, sz);
          return;
        }
        if (String(chapters || '').indexOf('torch_color') !== -1) {
          /* Se lee el pill directo (en hover el dataset puede no estar seedeado) y,
             si todavia no se eligio, se usa el TORCH Charcoal Black: sin esto la
             galeria no tenia candidato (los genericos -{color}/base no existen). */
          var ctcSel = document.querySelector('[data-u1-pdp-torch-color-picker] [data-u1-pdp-torch-color].is-selected');
          var ctc = famToken(ctcSel ? (ctcSel.getAttribute('data-u1-pdp-torch-color-name') || '') : r.dataset.u1TorchColorName);
          var ccol = col;
          if (!ccol) {
            var cSel = r.querySelector('[data-u1-pdp-color].is-selected');
            if (cSel) ccol = famToken(cSel.getAttribute('data-u1-pdp-value-handle') || cSel.getAttribute('data-u1-pdp-value') || '');
          }
          if (ccol && ctc) famPushLevel(out, prefix + '-' + ccol + '-' + ctc, sz);
          if (ccol && ctc !== FAM_TORCH_FALLBACK) famPushLevel(out, prefix + '-' + ccol + '-' + FAM_TORCH_FALLBACK, sz);
          return;
        }
        /* Packs de 2 cascos con segundo casco elegible (2x AURA, AURA + NEON, 2x NEON):
           pdp-{prod}-{pack}-{colorcasco1}-{colorcasco2}.jpg (Figma "Campaign Bundles"). El color del segundo
           sale del grupo de ese pack (sirve tambien en hover, con el grupo oculto); sin eleccion, su primer color */
        if (String(chapters || '').indexOf('adult_color') !== -1 && !/-family-pack$/.test(prefix)) {
          var tpm = prefix.match(/pdp-([a-z0-9]+)-([a-z0-9-]+)$/);
          var tgrp = tpm ? (document.querySelector('[data-u1-pdp-adult-color-picker] [data-u1-adult-group="' + tpm[1] + '-' + tpm[2] + '"]')
            || document.querySelector('[data-u1-pdp-adult-color-picker] [data-u1-adult-group="' + tpm[2] + '"]')) : null;
          var tsel = tgrp ? (tgrp.querySelector('[data-u1-pdp-adult-color].is-selected') || tgrp.querySelector('[data-u1-pdp-adult-color]')) : null;
          var t2 = famToken(tsel ? (tsel.getAttribute('data-u1-pdp-adult-color-name') || '') : '');
          var t1 = col;
          if (!t1) {
            var tm = r.querySelector('[data-u1-pdp-color].is-selected');
            if (tm) t1 = famToken(tm.getAttribute('data-u1-pdp-value-handle') || tm.getAttribute('data-u1-pdp-value') || '');
          }
          if (t1 && t2) famPushLevel(out, prefix + '-' + t1 + '-' + t2, sz);
          /* Pack mixto desde la otra PDP (NEON + AURA): si no hay foto propia (NEON primero), la del pack espejo
             pdp-aura-neon-pack-{aura}-{neon} */
          var tmix = tpm ? tpm[2].match(/^([a-z0-9]+)-pack$/) : null;
          var tbase = prefix.slice(0, prefix.lastIndexOf('pdp-')); /* URL de Files que trae el prefix */
          if (t1 && t2 && tmix && tmix[1] !== tpm[1] && tmix[1] !== '2x') famPushLevel(out, tbase + 'pdp-' + tmix[1] + '-' + tpm[1] + '-pack-' + t2 + '-' + t1, sz);
          return;
        }
        if (/-everyday-pack$/.test(prefix)) {
          var eim = famToken(r.dataset.u1SparkyInsertDesign);
          var eic = famToken(r.dataset.u1SparkyInsertColorName);
          /* Versionado -v3/-v2/pelado (mismo esquema que family): permite
             renovar fotos subiendo -v2 sin pisar los nombres viejos */
          if (col && eim && eic) famPushLevel(out, prefix + '-' + col + '-' + eim + '-' + eic, sz);
          return;
        }
        /* Vale para el pack Family este seleccionado O en hover (preview de la card):
           se gatea por el nombre del pack, no por el estado. Los defaults de sparky/
           inserts ya estan seedeados al init, asi que el combo se resuelve igual. */
        if (!/-family-pack$/.test(prefix)) return;
        var sc = famToken(r.dataset.u1SparkyColorName);
        var im = famToken(r.dataset.u1SparkyInsertDesign);
        var ic = famToken(r.dataset.u1SparkyInsertColorName);
        if (col && sc && im && ic) famPushLevel(out, prefix + '-' + col + '-' + sc + '-' + im + '-' + ic, sz);
        if (col && sc) famPushLevel(out, prefix + '-' + col + '-' + sc, sz);
        if (col) famPushLevel(out, prefix + '-' + col, sz);
        famPushLevel(out, prefix, sz);
      } catch (eIC) { /* noop */ }
    }
    /* Cualquier seleccion family re-dispara el update generico del hero */
    function famGalleryRefresh(r) {
      try { if (r && r._u1UpdateBundleGallery) r._u1UpdateBundleGallery(); } catch (eGR) { /* noop */ }
    }

    /* ── Mini-galerias mobile de los chapters SPARKY: espejan el hero del pack
       (la imagen de la combinacion actual). El overlay de desktop ya se actualiza
       con cada seleccion aunque este oculto en mobile; aca solo copiamos su src.
       Reintentos: el preload del hero es asincronico. ── */
    function famHandleize(x) {
      return String(x || '').toLowerCase().trim().replace(/['\u2019]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    }
    function famSparkyColorH(r) {
      var h = famHandleize(r.dataset.u1SparkyColorName || '');
      if (!h) {
        var first = document.querySelector('[data-u1-pdp-sparky-color-picker] [data-u1-pdp-sparky-color]');
        if (first) h = famHandleize(first.getAttribute('data-u1-pdp-sparky-color-name') || '');
      }
      if (!h && !document.querySelector('[data-u1-pdp-sparky-color-picker]')) {
        /* PDP de SPARKY (Everyday Pack): no hay picker de sparky aparte, el
           color del sparky ES el color principal seleccionado */
        var mainSel = r.querySelector('[data-u1-pdp-color].is-selected') || r.querySelector('[data-u1-pdp-color][aria-pressed="true"]');
        if (mainSel) h = famHandleize(mainSel.getAttribute('data-u1-pdp-value-handle') || mainSel.getAttribute('data-u1-pdp-value') || '');
      }
      return h;
    }
    /* Mini galleries sparky: MISMO componente que los chapters de AURA
       (media + flechas + dots de renderMobileGalleries), con estado local
       porque las slides son de sparky, no de la galeria principal. */
    function famBuildGallery(host) {
      if (host.dataset.u1FamInit) return;
      host.dataset.u1FamInit = '1';
      host.dataset.u1Kind = 'render';
      host.dataset.u1Fixed = '0';
      host.innerHTML = '<div class="u1-pdp-mobile-gallery__media">' +
        '<img class="u1-pdp-mobile-gallery__img" alt="SPARKY" width="2000" height="2000">' +
        '<button type="button" class="u1-pdp-mobile-gallery__hit u1-pdp-mobile-gallery__hit--prev" aria-label="' + CFG.i18n.previous + '"></button>' +
        '<button type="button" class="u1-pdp-mobile-gallery__hit u1-pdp-mobile-gallery__hit--next" aria-label="' + CFG.i18n.next + '"></button>' +
        '</div>' +
        '<div class="u1-pdp-mobile-gallery__dots" data-u1-dots aria-hidden="true"></div>';
      var bp = host.querySelector('.u1-pdp-mobile-gallery__hit--prev');
      var bn = host.querySelector('.u1-pdp-mobile-gallery__hit--next');
      if (bp) bp.addEventListener('click', function () { famGalleryGo(host, (host._famIdx || 0) - 1); });
      if (bn) bn.addEventListener('click', function () { famGalleryGo(host, (host._famIdx || 0) + 1); });
      host.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('button[data-u1-idx]') : null;
        if (b) famGalleryGo(host, Number(b.dataset.u1Idx || 0) || 0);
      });
    }
    function famGalleryGo(host, idx) {
      var srcs = host._famSrcs || [];
      var n = srcs.length;
      if (!n) return;
      idx = Math.max(0, Math.min(n - 1, Number(idx || 0) || 0));
      host._famIdx = idx;
      var img = host.querySelector('.u1-pdp-mobile-gallery__img');
      if (img && img.getAttribute('src') !== srcs[idx]) img.setAttribute('src', srcs[idx]);
      var bp = host.querySelector('.u1-pdp-mobile-gallery__hit--prev');
      var bn = host.querySelector('.u1-pdp-mobile-gallery__hit--next');
      if (bp) bp.setAttribute('aria-disabled', idx <= 0 ? 'true' : 'false');
      if (bn) bn.setAttribute('aria-disabled', idx >= n - 1 ? 'true' : 'false');
      var dots = host.querySelector('[data-u1-dots]');
      if (!dots) return;
      if ((Number(dots.dataset.u1Count || 0) || 0) !== n) {
        dots.dataset.u1Count = String(n);
        var html = '';
        for (var i = 0; i < n; i++) {
          html += '<button type="button" class="u1-pdp-gallery-dot" data-u1-idx="' + i + '" aria-current="' + (i === idx ? 'true' : 'false') + '" aria-label="' + U1S.slide_n.replace('__N__', i + 1) + '"></button>';
        }
        dots.innerHTML = html;
      } else {
        dots.querySelectorAll('button[data-u1-idx]').forEach(function (b, i) {
          b.setAttribute('aria-current', i === idx ? 'true' : 'false');
        });
      }
      dots.setAttribute('aria-hidden', n > 1 ? 'false' : 'true');
    }
    function famSetSlides(host, srcs, resetKey) {
      if (host.dataset.u1FamKey === resetKey) return;
      host.dataset.u1FamKey = resetKey;
      host._famSrcs = srcs;
      host._famIdx = 0;
      famGalleryGo(host, 0);
    }
    /* Chapters de color de los packs (Campus AURA/NEON y Family invertido en SPARKY):
       UNA sola slide con la foto del pack en la combinacion elegida. Se espeja el src
       que ya resolvio el hero, asi nunca se desincroniza. */
    /* OJO: 'color' NO va aca — ese chapter es el color del producto principal y
       tiene que seguir mostrando la galeria del casco (SPARKY en su PDP, etc). */
    var FAM_PACK_MG_STEPS = ['adult_color', 'adult_size', 'torch_color'];
    function famPackMobileSync(r) {
      try {
        var ov = r.querySelector('.u1-bundle-gallery-overlay');
        var src = ov ? (ov.currentSrc || ov.src || '') : '';
        if (!src) return;
        FAM_PACK_MG_STEPS.forEach(function (st) {
          var host = r.querySelector('[data-u1-pdp-step="' + st + '"] [data-u1-pdp-mobile-gallery]');
          if (!host) return;
          famBuildGallery(host);
          famSetSlides(host, [src], 'p:' + st + ':' + src);
        });
      } catch (ePM) { /* noop */ }
    }
    function famMobileSync() {
      try {
        var r = famRoot();
        if (!r || !famActive(r)) return;
        famPackMobileSync(r);
        var base = r.getAttribute('data-u1-pdp-files-base') || '';
        var colorH = famSparkyColorH(r);
        if (!base || !colorH) return;

        var host1 = r.querySelector('[data-u1-pdp-step="sparky_color"] [data-u1-pdp-mobile-gallery]');
        if (host1) {
          famBuildGallery(host1);
          var srcs1 = ['side', 'front-side', 'rear', 'rear-side'].map(function (v) {
            return base + 'pdp-sparky-' + colorH + '-' + v + '.jpg';
          });
          famSetSlides(host1, srcs1, 'c:' + colorH);
        }

        var host2 = r.querySelector('[data-u1-pdp-step="sparky_inserts"] [data-u1-pdp-mobile-gallery]');
        if (host2) {
          famBuildGallery(host2);
          var design = famHandleize(r.dataset.u1SparkyInsertDesign || '');
          var insCol = famHandleize(r.dataset.u1SparkyInsertColor || '');
          var file = (design && insCol)
            ? 'pdp-insert-' + design + '-' + insCol + '-sparky-' + colorH + '.jpg'
            : 'pdp-insert-none-sparky-' + colorH + '.jpg';
          famSetSlides(host2, [base + file], 'i:' + file);
        }
      } catch (eMS) { /* noop */ }
    }
    function famMobileSyncSoon() {
      [250, 900, 2000].forEach(function (ms) { window.setTimeout(famMobileSync, ms); });
    }

    /* ── Titulos: prefijo "AURA " server-rendered oculto; aca solo se togglea ── */
    function famRetitle() {
      try {
        var r = famRoot();
        if (!r) return;
        var active = !!r.querySelector('.u1-pdp-step--pack-only.is-pack-active');
        r.querySelectorAll('[data-u1-fam-prefix]').forEach(function (sp) { sp.hidden = !active; });
        famMobileSyncSoon();
      } catch (e1) { /* noop */ }
    }

    /* ── Delegacion en document: sobrevive a cualquier re-render/timing ── */
    document.addEventListener('click', function (e) {
      try {
        var t = e.target && e.target.closest ? e.target : null;
        if (!t) return;
        var r;
        var sc = t.closest('[data-u1-pdp-sparky-color]');
        if (sc) {
          r = famRoot(); if (!r) return;
          pick('[data-u1-pdp-sparky-color-picker]', sc);
          r.dataset.u1SparkyColorVid = sc.getAttribute('data-u1-pdp-sparky-variant-id') || '';
          r.dataset.u1SparkyColorName = sc.getAttribute('data-u1-pdp-sparky-color-name') || '';
          famTitleValue(r, 'sparky_color', r.dataset.u1SparkyColorName);
          famGalleryRefresh(r);
          famMobileSyncSoon();
          return;
        }
        var ac = t.closest('[data-u1-pdp-adult-color]');
        if (ac) {
          r = famRoot(); if (!r) return;
          pick('[data-u1-adult-group]', ac);
          r.dataset.u1AdultColor = ac.getAttribute('data-u1-pdp-adult-color') || '';
          r.dataset.u1AdultColorName = ac.getAttribute('data-u1-pdp-adult-color-name') || '';
          famTitleValue(r, 'adult_color', r.dataset.u1AdultColorName);
          famAdultSyncSizes(r);
          famAdultPreorderNotice(r);
          if (r._u1BSyncAdultThumbs) r._u1BSyncAdultThumbs();
          famGalleryRefresh(r);
          famMobileSyncSoon();
          return;
        }
        var asz = t.closest('[data-u1-pdp-adult-size]');
        if (asz) {
          r = famRoot(); if (!r) return;
          var szGrp = asz.closest('[data-u1-pdp-adult-size-picker]');
          if (szGrp) szGrp.querySelectorAll('[data-u1-pdp-adult-size]').forEach(function (b) {
            var on = b === asz;
            b.classList.toggle('is-selected', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          r.dataset.u1AdultSize = asz.getAttribute('data-u1-pdp-adult-size') || '';
          r.dataset.u1AdultSizeName = asz.getAttribute('data-u1-pdp-adult-size-name') || '';
          famTitleValue(r, 'adult_size', r.dataset.u1AdultSizeName);
          famAdultSizePill();
          famAdultPreorderNotice(r);
          return;
        }
        var tc = t.closest('[data-u1-pdp-torch-color]');
        if (tc) {
          r = famRoot(); if (!r) return;
          pick('[data-u1-pdp-torch-color-picker]', tc);
          r.dataset.u1TorchColorVid = tc.getAttribute('data-u1-pdp-torch-variant-id') || '';
          r.dataset.u1TorchColorName = tc.getAttribute('data-u1-pdp-torch-color-name') || '';
          famTitleValue(r, 'torch_color', r.dataset.u1TorchColorName);
          famGalleryRefresh(r);
          famMobileSyncSoon();
          return;
        }
        var ic = t.closest('[data-u1-pdp-sparky-insert-color]');
        if (ic) {
          r = famRoot(); if (!r) return;
          /* Solo deselecciona otros SWATCHES DE COLOR: la pill de modelo vive
             en el mismo picker y pick() generico la barria tambien */
          var icGrp = ic.closest('[data-u1-pdp-sparky-inserts-picker]');
          if (icGrp) icGrp.querySelectorAll('[data-u1-pdp-sparky-insert-color][aria-pressed="true"]').forEach(function (b) {
            if (b !== ic) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); }
          });
          ic.classList.add('is-selected');
          ic.setAttribute('aria-pressed', 'true');
          r.dataset.u1SparkyInsertColor = ic.getAttribute('data-u1-pdp-sparky-insert-color') || '';
          r.dataset.u1SparkyInsertColorName = ic.getAttribute('data-u1-pdp-sparky-insert-color-name') || '';
          famSetLabel(r, '[data-u1-fam-ins-color-label]', r.dataset.u1SparkyInsertColorName);
          resolveInsertVariant(r);
          syncInsAvail(r);
          famGalleryRefresh(r);
          famMobileSyncSoon();
          return;
        }
        var dp = t.closest('[data-u1-pdp-sparky-insert-design]');
        if (dp) {
          r = famRoot(); if (!r) return;
          var wrap = dp.closest('.u1-pdp-insert-models');
          if (wrap) wrap.querySelectorAll('.u1-pdp-insert-pill').forEach(function (b) {
            var on = b === dp;
            b.classList.toggle('is-selected', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          r.dataset.u1SparkyInsertDesign = dp.getAttribute('data-u1-pdp-sparky-insert-design') || '';
          r.dataset.u1SparkyInsertDesignName = dp.getAttribute('data-u1-pdp-sparky-insert-design-name') || '';
          famSetLabel(r, '[data-u1-fam-ins-model-label]', r.dataset.u1SparkyInsertDesignName);
          resolveInsertVariant(r);
          syncInsAvail(r);
          famGalleryRefresh(r);
          famMobileSyncSoon();
          return;
        }
        /* Color principal: en la PDP de sparky alimenta la mini gallery de inserts */
        if (t.closest('[data-u1-pdp-color]')) {
          famMobileSyncSoon();
        }
        /* Cambio de pack: re-sincronizar prefijos y el grupo del casco adulto */
        if (t.closest('[data-u1-pdp-bundle-card]')) famPackResync();
      } catch (eC) { /* noop: jamas romper otros clicks */ }
    });
    /* Pack elegido sin click (deep link ?bundle=, pack recordado o la card Flash Deal): mismo re-sincronizado.
       Sin esto el grupo del casco adulto quedaba oculto porque famInit corre antes de que el pack este activo */
    document.addEventListener('u1:pdp:pack-change', function () { famPackResync(); });
    /* El pack del deep link se restaura antes de que exista este listener: una pasada al cargar */
    famPackResync();
    window.addEventListener('load', function () { famPackResync(); });
    function famPackResync() {
          [150, 600].forEach(function (ms) {
            window.setTimeout(function () {
              famRetitle();
              try {
                famAdultShowGroup();
                var rr = famRoot(); if (!rr) return;
                var g = famAdultActiveColorGroup();
                var cs = g ? g.querySelector('[data-u1-pdp-adult-color].is-selected') : null;
                if (cs) {
                  rr.dataset.u1AdultColor = cs.getAttribute('data-u1-pdp-adult-color') || '';
                  rr.dataset.u1AdultColorName = cs.getAttribute('data-u1-pdp-adult-color-name') || '';
                  famTitleValue(rr, 'adult_color', rr.dataset.u1AdultColorName);
                }
                var sg = document.querySelector('[data-u1-pdp-adult-size-picker] [data-u1-adult-group]:not([hidden])');
                var ss = sg ? sg.querySelector('[data-u1-pdp-adult-size].is-selected') : null;
                if (ss) {
                  rr.dataset.u1AdultSize = ss.getAttribute('data-u1-pdp-adult-size') || '';
                  rr.dataset.u1AdultSizeName = ss.getAttribute('data-u1-pdp-adult-size-name') || '';
                  famTitleValue(rr, 'adult_size', rr.dataset.u1AdultSizeName);
                }
                famAdultSyncSizes(rr);
                famGalleryRefresh(rr);
              } catch (ePK) { /* noop */ }
            }, ms);
          });
    }

    /* ── Init con reintentos: seed de defaults + retitle + marcador ── */
    function famInit() {
      try {
        var r = famRoot();
        if (!r || !r.querySelector(FAM_SEL_STEP)) return false;
        r.dataset.u1FamJs = 'v3';
        r._u1FamRetitle = famRetitle;
        r._u1FamCompItem = famCompItem;
        r._u1FamCompSuffix = famCompSuffix;
        r._u1FamImgCands = famImgCands;
        famAdultShowGroup();
        var aGrp = famAdultActiveColorGroup();
        var aSel = aGrp ? aGrp.querySelector('[data-u1-pdp-adult-color].is-selected') : null;
        if (aSel) {
          r.dataset.u1AdultColor = aSel.getAttribute('data-u1-pdp-adult-color') || '';
          r.dataset.u1AdultColorName = aSel.getAttribute('data-u1-pdp-adult-color-name') || '';
          famTitleValue(r, 'adult_color', r.dataset.u1AdultColorName);
        }
        var aSzGrp = document.querySelector('[data-u1-pdp-adult-size-picker] [data-u1-adult-group]:not([hidden])');
        var aSzSel = aSzGrp ? aSzGrp.querySelector('[data-u1-pdp-adult-size].is-selected') : null;
        if (aSzSel) {
          r.dataset.u1AdultSize = aSzSel.getAttribute('data-u1-pdp-adult-size') || '';
          r.dataset.u1AdultSizeName = aSzSel.getAttribute('data-u1-pdp-adult-size-name') || '';
          famTitleValue(r, 'adult_size', r.dataset.u1AdultSizeName);
        }
        if (r.dataset.u1AdultColor) famAdultSyncSizes(r);
        var tSel = r.querySelector('[data-u1-pdp-torch-color].is-selected');
        if (tSel) {
          r.dataset.u1TorchColorVid = tSel.getAttribute('data-u1-pdp-torch-variant-id') || '';
          r.dataset.u1TorchColorName = tSel.getAttribute('data-u1-pdp-torch-color-name') || '';
        }
        var c = r.querySelector('[data-u1-pdp-sparky-color].is-selected');
        if (c) {
          r.dataset.u1SparkyColorVid = c.getAttribute('data-u1-pdp-sparky-variant-id') || '';
          r.dataset.u1SparkyColorName = c.getAttribute('data-u1-pdp-sparky-color-name') || '';
        }
        var i = r.querySelector('[data-u1-pdp-sparky-insert-color].is-selected');
        if (i) {
          r.dataset.u1SparkyInsertColor = i.getAttribute('data-u1-pdp-sparky-insert-color') || '';
          r.dataset.u1SparkyInsertColorName = i.getAttribute('data-u1-pdp-sparky-insert-color-name') || '';
        }
        var d = r.querySelector('[data-u1-pdp-sparky-insert-design].is-selected');
        if (d) {
          r.dataset.u1SparkyInsertDesign = d.getAttribute('data-u1-pdp-sparky-insert-design') || '';
          r.dataset.u1SparkyInsertDesignName = d.getAttribute('data-u1-pdp-sparky-insert-design-name') || '';
        }
        resolveInsertVariant(r);
        famTitleValue(r, 'sparky_color', r.dataset.u1SparkyColorName);
        famRetitle();
        /* Recien ahora el estado del secundario esta sembrado: el hero del pack se
           pide de nuevo (con deep link ?bundle=x el primer intento cae antes de esto
           y por eso a veces quedaba la foto del producto solo). */
        famGalleryRefresh(r);
        famMobileSyncSoon();
        return true;
      } catch (eI) { return false; }
    }
    /* Los hooks se instalan SIEMPRE, incluso en PDPs sin steps de sparky (AURA/NEON
       con Campus Pack): ahi famInit devuelve false y quedaban sin candidatos de
       imagen (galeria vacia) y sin _u1FamCompItem, asi que el TORCH entraba al
       carrito con su variante default (siempre Charcoal Black). */
    function famInstallHooks() {
      try {
        var r = famRoot();
        if (!r) return false;
        r._u1FamImgCands = famImgCands;
        r._u1FamCompItem = famCompItem;
        r._u1FamCompSuffix = famCompSuffix;
        r._u1FamRetitle = famRetitle;
        /* Seed del color de TORCH (el pill ya viene marcado desde Liquid) */
        var tS = document.querySelector('[data-u1-pdp-torch-color-picker] [data-u1-pdp-torch-color].is-selected');
        if (tS && !r.dataset.u1TorchColorVid) {
          r.dataset.u1TorchColorVid = tS.getAttribute('data-u1-pdp-torch-variant-id') || '';
          r.dataset.u1TorchColorName = tS.getAttribute('data-u1-pdp-torch-color-name') || '';
          famTitleValue(r, 'torch_color', r.dataset.u1TorchColorName);
        }
        try { if (r._u1UpdateBundleGallery) r._u1UpdateBundleGallery(); } catch (eU) { /* noop */ }
        try { if (r._u1WarmBundleGallery) r._u1WarmBundleGallery(); } catch (eW) { /* noop */ }
        return true;
      } catch (eH) { return false; }
    }
    if (!famInstallHooks()) {
      [200, 800, 2000].forEach(function (ms) {
        window.setTimeout(function () { famInstallHooks(); }, ms);
      });
    }
    if (!famInit()) {
      [400, 1200, 3000].forEach(function (ms) {
        window.setTimeout(function () { famInit(); }, ms);
      });
    }
  } catch (eTop) {
    try { console.error('[u1-family-js] init error:', eTop); } catch (e2) { /* noop */ }
  }
})();

};
document.querySelectorAll('script[data-u1-pdp-b-config]').forEach((el) => {
  if (el.dataset.u1PdpBooted) return;
  el.dataset.u1PdpBooted = '1';
  let CFG;
  try { CFG = JSON.parse(el.textContent); } catch (e) { console.error('[u1-pdp] config invalida', e); return; }
  u1PdpBoot(CFG);
});
})();
